var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");

/*! For license information please see wds-charts.js.LICENSE.txt */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.wds = t(require("react")) : e.wds = t(e.react);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var a = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) {
        n.d(r, a, function (t) {
          return e[t];
        }.bind(null, a));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 84);
  }([function (e, t, n) {
    e.exports = n(48)();
  }, function (t, n) {
    t.exports = e;
  }, function (e, t) {
    e.exports = function (e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    };
  }, function (e, t, n) {
    var r = n(47);

    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          a,
          o = r(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (a = 0; a < i.length; a++) {
          n = i[a], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
        }
      }

      return o;
    };
  }, function (e, t, n) {
    var r;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function a() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var o = _typeof(r);

            if ("string" === o || "number" === o) e.push(r);else if (Array.isArray(r) && r.length) {
              var i = a.apply(null, r);
              i && e.push(i);
            } else if ("object" === o) for (var u in r) {
              n.call(r, u) && r[u] && e.push(u);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (a["default"] = a, e.exports = a) : void 0 === (r = function () {
        return a;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t, n) {
    var r = n(50),
        a = n(51);

    e.exports = function (e, t, n) {
      var o = t && n || 0;
      "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
      var i = (e = e || {}).random || (e.rng || r)();
      if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, t) for (var u = 0; u < 16; ++u) {
        t[o + u] = i[u];
      }
      return t || a(i);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t, n) {
    var r = n(44),
        a = n(45),
        o = n(46);

    e.exports = function (e, t) {
      return r(e) || a(e, t) || o();
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return l;
      }), n.d(t, "b", function () {
        return f;
      });

      var r = n(1),
          a = function (e, t) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return function (e, t) {
          var n = [],
              r = !0,
              a = !1,
              o = void 0;

          try {
            for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            a = !0, o = e;
          } finally {
            try {
              !r && u["return"] && u["return"]();
            } finally {
              if (a) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }(n.n(r).a.version.split("."), 2),
          o = a[0],
          i = a[1],
          u = Number(i) > 13 || Number(o) > 13,
          l = function l(e) {
        return u ? e : e && e.getDOMNode();
      },
          s = {},
          c = !0;

      function f(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        e.process && c || n && s[t] || (console.warn(t), s[t] = !0);
      }
    }).call(this, n(13));
  },, function (e, t) {
    function n(t) {
      return e.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, n(t);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e["default"] : e;
    }

    t.__esModule = !0;
    var a = n(53);
    t.Motion = r(a);
    var o = n(55);
    t.StaggeredMotion = r(o);
    var i = n(56);
    t.TransitionMotion = r(i);
    var u = n(58);
    t.spring = r(u);
    var l = n(35);
    t.presets = r(l);
    var s = n(22);
    t.stripStyle = r(s);
    var c = n(59);
    t.reorderKeys = r(c);
  },, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
    }

    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    e.exports = function (e, t, r) {
      return t && n(e.prototype, t), r && n(e, r), e;
    };
  }, function (e, t, n) {
    var r = n(78);

    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && r(e, t);
    };
  }, function (e, t, n) {
    var r = n(79),
        a = n(6);

    e.exports = function (e, t) {
      return !t || "object" !== r(t) && "function" != typeof t ? a(e) : t;
    };
  }, function (e, t, n) {
    (function (t) {
      var n;
      n = "undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {}, e.exports = n;
    }).call(this, n(13));
  },,,, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e) {
      var t = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = "number" == typeof e[n] ? e[n] : e[n].val);
      }

      return t;
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(1);

      function a(t) {
        var n;
        n = "undefined" != typeof window ? window : "undefined" != typeof self ? self : e;
        var r,
            a,
            o = "undefined" != typeof document && document.attachEvent;

        if (!o) {
          var i = (a = n.requestAnimationFrame || n.mozRequestAnimationFrame || n.webkitRequestAnimationFrame || function (e) {
            return n.setTimeout(e, 20);
          }, function (e) {
            return a(e);
          }),
              u = (r = n.cancelAnimationFrame || n.mozCancelAnimationFrame || n.webkitCancelAnimationFrame || n.clearTimeout, function (e) {
            return r(e);
          }),
              l = function l(e) {
            var t = e.__resizeTriggers__,
                n = t.firstElementChild,
                r = t.lastElementChild,
                a = n.firstElementChild;
            r.scrollLeft = r.scrollWidth, r.scrollTop = r.scrollHeight, a.style.width = n.offsetWidth + 1 + "px", a.style.height = n.offsetHeight + 1 + "px", n.scrollLeft = n.scrollWidth, n.scrollTop = n.scrollHeight;
          },
              s = function s(e) {
            if (!(e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0)) {
              var t = this;
              l(this), this.__resizeRAF__ && u(this.__resizeRAF__), this.__resizeRAF__ = i(function () {
                (function (e) {
                  return e.offsetWidth != e.__resizeLast__.width || e.offsetHeight != e.__resizeLast__.height;
                })(t) && (t.__resizeLast__.width = t.offsetWidth, t.__resizeLast__.height = t.offsetHeight, t.__resizeListeners__.forEach(function (n) {
                  n.call(t, e);
                }));
              });
            }
          },
              c = !1,
              f = "",
              p = "animationstart",
              h = "Webkit Moz O ms".split(" "),
              d = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),
              y = document.createElement("fakeelement");

          if (void 0 !== y.style.animationName && (c = !0), !1 === c) for (var m = 0; m < h.length; m++) {
            if (void 0 !== y.style[h[m] + "AnimationName"]) {
              f = "-" + h[m].toLowerCase() + "-", p = d[m], c = !0;
              break;
            }
          }
          var g = "resizeanim",
              v = "@" + f + "keyframes " + g + " { from { opacity: 0; } to { opacity: 0; } } ",
              b = f + "animation: 1ms " + g + "; ";
        }

        return {
          addResizeListener: function addResizeListener(e, r) {
            if (o) e.attachEvent("onresize", r);else {
              if (!e.__resizeTriggers__) {
                var a = e.ownerDocument,
                    i = n.getComputedStyle(e);
                i && "static" == i.position && (e.style.position = "relative"), function (e) {
                  if (!e.getElementById("detectElementResize")) {
                    var n = (v || "") + ".resize-triggers { " + (b || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
                        r = e.head || e.getElementsByTagName("head")[0],
                        a = e.createElement("style");
                    a.id = "detectElementResize", a.type = "text/css", null != t && a.setAttribute("nonce", t), a.styleSheet ? a.styleSheet.cssText = n : a.appendChild(e.createTextNode(n)), r.appendChild(a);
                  }
                }(a), e.__resizeLast__ = {}, e.__resizeListeners__ = [], (e.__resizeTriggers__ = a.createElement("div")).className = "resize-triggers", e.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>', e.appendChild(e.__resizeTriggers__), l(e), e.addEventListener("scroll", s, !0), p && (e.__resizeTriggers__.__animationListener__ = function (t) {
                  t.animationName == g && l(e);
                }, e.__resizeTriggers__.addEventListener(p, e.__resizeTriggers__.__animationListener__));
              }

              e.__resizeListeners__.push(r);
            }
          },
          removeResizeListener: function removeResizeListener(e, t) {
            if (o) e.detachEvent("onresize", t);else if (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t), 1), !e.__resizeListeners__.length) {
              e.removeEventListener("scroll", s, !0), e.__resizeTriggers__.__animationListener__ && (e.__resizeTriggers__.removeEventListener(p, e.__resizeTriggers__.__animationListener__), e.__resizeTriggers__.__animationListener__ = null);

              try {
                e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__);
              } catch (e) {}
            }
          }
        };
      }

      var o = function o(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      },
          i = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
          u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      },
          l = function l(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
      },
          s = function (e) {
        function t() {
          var e, n, r;
          o(this, t);

          for (var a = arguments.length, i = Array(a), u = 0; u < a; u++) {
            i[u] = arguments[u];
          }

          return n = r = l(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(i))), r.state = {
            height: r.props.defaultHeight || 0,
            width: r.props.defaultWidth || 0
          }, r._onResize = function () {
            var e = r.props,
                t = e.disableHeight,
                n = e.disableWidth,
                a = e.onResize;

            if (r._parentNode) {
              var o = r._parentNode.offsetHeight || 0,
                  i = r._parentNode.offsetWidth || 0,
                  u = window.getComputedStyle(r._parentNode) || {},
                  l = parseInt(u.paddingLeft, 10) || 0,
                  s = parseInt(u.paddingRight, 10) || 0,
                  c = parseInt(u.paddingTop, 10) || 0,
                  f = parseInt(u.paddingBottom, 10) || 0,
                  p = o - c - f,
                  h = i - l - s;
              (!t && r.state.height !== p || !n && r.state.width !== h) && (r.setState({
                height: o - c - f,
                width: i - l - s
              }), a({
                height: o,
                width: i
              }));
            }
          }, r._setRef = function (e) {
            r._autoSizer = e;
          }, l(r, n);
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), i(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = this.props.nonce;
            this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement && (this._parentNode = this._autoSizer.parentNode, this._detectElementResize = a(e), this._detectElementResize.addResizeListener(this._parentNode, this._onResize), this._onResize());
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this._detectElementResize && this._parentNode && this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.children,
                n = e.className,
                a = e.disableHeight,
                o = e.disableWidth,
                i = e.style,
                l = this.state,
                s = l.height,
                c = l.width,
                f = {
              overflow: "visible"
            },
                p = {},
                h = !1;
            return a || (0 === s && (h = !0), f.height = 0, p.height = s), o || (0 === c && (h = !0), f.width = 0, p.width = c), Object(r.createElement)("div", {
              className: n,
              ref: this._setRef,
              style: u({}, f, i)
            }, !h && t(p));
          }
        }]), t;
      }(r.PureComponent);

      s.defaultProps = {
        onResize: function onResize() {},
        disableHeight: !1,
        disableWidth: !1,
        style: {}
      }, t.a = s;
    }).call(this, n(13));
  }, function (e, t, n) {
    var r = n(75),
        a = n(76),
        o = n(77);

    e.exports = function (e) {
      return r(e) || a(e) || o();
    };
  }, function (e) {
    e.exports = JSON.parse('{"font-file":{"assets--font-version":"2","assets--font-path":"/fonts/National2Web","assets--font-name":"\'National 2\'","__META__":{"public":false}},"icon-font-file":{"assets--icon-version":"4","assets--icon-path":"/icons/Mateo","assets--icon-name":"Mateo","__META__":{"public":false}},"brand-color":{"color--sabaeus":"#00BF6F","color--midnight":"#05467E","color--link":"#007FAA","color--arctic":"#2DCCD3","color--concord":"#671E75","color--raspberry":"#AC145A","color--bengal":"#F05B24","color--bumblebee":"#F9BE00","color--black":"#000000","color--charcoal":"#333E48","color--slate":"#6B787F","color--stone":"#9DA5AA","color--flint":"#D0D2D3","color--pebble":"#EDEEEE","color--canvas":"#F7F8FA","color--white":"#FFFFFF","__META__":{"public":true,"type":"color","level":"Primitive","themable":false,"title":"Brand Colors"}},"data-vis-color":{"color--data-midnight":"#507CB6","color--data-sabaeus":"#00BF6F","color--data-arctic":"#6BC8CD","color--data-bumblebee":"#F9BE00","color--data-concord":"#7D5E90","color--data-cherry":"#DB4D5C","color--data-slate":"#768086","color--data-raspberry":"#D25F90","color--data-gold":"#A38364","color--data-bengal":"#FF8B4F","__META__":{"public":true,"type":"color","level":"Primitive","themable":true,"title":"Data Viz Colors"}},"semantic-color":{"color--primary":"#00BF6F","color--success":"#00BF6F","color--info":"#2DCCD3","color--warning":"#F05B24","color--upgrade":"#F9BE00","color--secondary":"#6B787F","color--muted":"#D0D2D3","__META__":{"public":true,"type":"color","level":"Alias","themable":true,"title":"Semantic Colors"}},"type-color":{"color--type-dark":"#333E48","color--type-dark-muted":"#6B787F","color--type-light-muted":"#D0D2D3","color--type-light":"#FFFFFF","color--type-link":"#007FAA","color--type-on-muted":"#333E48","color--type-on-upgrade":"#333E48","color--type-on-info":"#333E48","color--type-on-primary":"#FFFFFF","color--type-on-secondary":"#FFFFFF","color--type-on-success":"#FFFFFF","color--type-on-warning":"#FFFFFF","color--type-on-link":"#FFFFFF","color--type-on-black":"#FFFFFF","color--type-on-charcoal":"#FFFFFF","color--type-on-stone":"#FFFFFF","color--type-on-flint":"#333E48","color--type-on-pebble":"#333E48","color--type-on-canvas":"#333E48","color--type-on-white":"#333E48","color--type-on-midnight":"#FFFFFF","color--type-on-sabaeus":"#FFFFFF","color--type-on-arctic":"#333E48","color--type-on-bumblebee":"#333E48","color--type-on-concord":"#FFFFFF","color--type-on-cherry":"#FFFFFF","color--type-on-slate":"#FFFFFF","color--type-on-raspberry":"#FFFFFF","color--type-on-gold":"#FFFFFF","color--type-on-bengal":"#FFFFFF","__META__":{"public":true,"type":"text-color","level":"Alias","themable":true,"title":"Typography Colors"}},"bg-color":{"color--bg-dark":"#333E48","color--bg-overlay":"rgba(107, 120, 127, .86)","color--bg":"#F7F8FA","color--bg-accent":"#EDEEEE","color--bg-light":"#FFFFFF","__META__":{"public":true,"type":"color","level":"Alias","themable":true,"title":"Background Colors"}},"border-color":{"color--border-active":"#00BF6F","color--border-hover":"#9DA5AA","color--border":"#D0D2D3","color--border-muted":"#EDEEEE","__META__":{"public":true,"type":"color","level":"Alias","themable":true,"title":"Border Colors"}},"border":{"border":"1px solid #D0D2D3","border--hover":"1px solid #9DA5AA","border--active":"1px solid #00BF6F","border--muted":"1px solid #EDEEEE","__META__":{"public":true,"type":"border","level":"Alias","themable":true,"title":"Borders"}},"space":{"space--0":"0","space--1":"4px","space--2":"8px","space--3":"12px","space--4":"16px","space--5":"24px","space--6":"32px","space--7":"64px","space--8":"96px","space--9":"128px","__META__":{"public":true,"type":"space","level":"Primitive","themable":true,"title":"Spacing"}},"border-radius":{"r--0":"0","r--sm":"2px","r--md":"24px","r--lg":"50%","__META__":{"public":true,"type":"radius","level":"Primitive","themable":true,"title":"Radius"}},"elevation":{"shadow--none":"none","shadow--sky":"0 2px 4px 0 rgba(0, 0, 0, 0.14)","shadow--space":"0 2px 8px 0 rgba(0,0,0,0.14)","__META__":{"public":true,"type":"shadow","level":"Primitive","themable":true,"title":"Shadows"}},"z-index":{"z--none":"0","z--sky":"999","z--space":"9999","__META__":{"public":false}},"font-size":{"fs--hero-1":"50px","fs--hero-2":"40px","fs--page-title":"34px","fs--section-title":"26px","fs--card-title":"16px","fs--body":"15px","fs--body-sm":"13px","__META__":{"public":true,"type":"font-size","level":"Alias","themable":true,"title":"Font Sizes"}},"line-height":{"__META__":{"public":false}},"font-weight":{"fw":{"Light":"300","Regular":"400","Medium":"500"},"fw--light":"300","fw--regular":"400","fw--medium":"500","__META__":{"public":false}},"font-family":{"ff--base":"\'National 2\', \'Helvetica Neue\', Helvetica, Arial, \'Hiragino Sans\', \'Hiragino Kaku Gothic Pro\', \'游ゴシック\', \'游ゴシック体\', YuGothic, \'Yu Gothic\', \'ＭＳ ゴシック\', \'MS Gothic\', sans-serif","ff--icon":"Mateo","__META__":{"public":false}},"icon-size":{"icon--sm":"13px","icon--md":"16px","icon--lg":"26px","icon--xl":"34px","__META__":{"public":true,"type":"space","level":"Alias","themable":true,"title":"Icon Sizes"}},"motion":{"motion-curve--enter":"cubic-bezier(0, 0, 0, 1)","motion-curve--exit":"cubic-bezier(1, 0, 1, 1)","motion-curve--ease":"cubic-bezier(.2, 0, .1, 1)","motion-curve--ease-reverse":"cubic-bezier(.9, 0, .8, 1)","motion-curve--bounce-start":"cubic-bezier(0, 0, .1, 1)","motion-curve--bounce-end":"cubic-bezier(.2, 0, 0, 1)","__META__":{"public":false}},"breakpoints":{"breakpoints":{"xs":"0","sm":"576px","md":"768px","lg":"992px","xl":"1200px"},"bp--xs":"0","bp--sm":"576px","bp--md":"768px","bp--lg":"992px","bp--xl":"1200px","__META__":{"public":false}},"grid":{"grid-cols":"12","grid-order-elements":"12","grid-gutter--xs":"16px","grid-gutter--sm":"24px","grid-gutter--md":"24px","grid-gutter--lg":"24px","grid-gutter--xl":"24px","grid-bleed--xs":"16px","grid-bleed--sm":"32px","grid-bleed--md":"32px","grid-bleed--lg":"32px","grid-bleed--xl":"32px","grid-max-width--xs":"none","grid-max-width--sm":"576px","grid-max-width--md":"768px","grid-max-width--lg":"992px","grid-max-width--xl":"1400px","__META__":{"public":false}},"button":{"button__height--sm":"30px","button__height--md":"40px","button__height--lg":"50px","button__font-size--sm":"13px","button__font-size--md":"15px","button__font-size--lg":"15px","button__padding--sm":"12px","button__padding--md":"24px","button__padding--lg":"32px + 4px","button__border-radius":"2px","button__box-shadow":"none","__META__":{"public":true,"level":"Component"}},"alert":{"alert__box-shadow":"none","alert__bg-color":"#333E48","alert__type-color":"#FFFFFF","alert__padding--y":"16px","alert__link-color":"#FFFFFF","__META__":{"public":true,"level":"Component"}},"avatar":{"avatar__border":"2px solid #FFFFFF","avatar__border-radius--default":"50%","avatar__border-radius--square":"0","avatar__size--sm":"24px","avatar__size--md":"32px","avatar__size--lg":"64px","avatar__size--xl":"96px","__META__":{"public":true,"level":"Component"}},"banner":{"banner__border-radius":"2px","banner__bg-color":"#FFFFFF","banner__type-color":"#333E48","banner__mark-width":"8px","banner__border-size":"1px","__META__":{"public":true,"level":"Component"}},"coachmark":{"coachmark__bg-color":"#2DCCD3","__META__":{"public":true,"level":"Component"}},"table":{"table__th-type-color":"#333E48","table__th-bg-color":"transparent","table__th-divider-line-color":"transparent","table__td-type-color":"#333E48","table__td-bg-color":"transparent","table__cell-min-height":"50px","table__cell-padding":"16px 24px","table__font-size":"15px","__META__":{"public":true,"level":"Component"}},"input":{"input__height--sm":"30px","input__height--md":"40px","input__height--lg":"50px","input__font-size":"15px","input__padding--sm":"8px","input__padding--md":"12px","input__padding--lg":"16px","input__border-radius":"2px","__META__":{"public":true,"level":"Component"}},"input-group":{"input-group__height--sm":"30px","input-group__height--md":"40px","input-group__height--lg":"50px","input-group__border-radius":"2px","input-group__icon-color":"#333E48","__META__":{"public":true,"level":"Component"}},"textarea":{"textarea__font-size":"15px","textarea__padding--sm":"4px 8px 4px","textarea__padding--md":"8px 12px 8px","textarea__padding--lg":"12px 16px 12px","textarea__border-radius":"2px","__META__":{"public":true,"level":"Component"}},"select":{"select__height--sm":"30px","select__height--md":"40px","select__height--lg":"50px","select__padding--sm":"8px","select__padding--md":"12px","select__padding--lg":"16px","select__border-radius":"2px","select__icon-color":"#333E48","select__font-size":"15px","__META__":{"public":true,"level":"Component"}},"multiselect":{"multiselect__border-radius":"2px","__META__":{"public":true,"level":"Component"}},"list":{"list__addon-icon-color":"#333E48","list__affordance-icon-color":"#6B787F","list__label-font-size":"13px","list__item-height":"52px","list__mark-width":"4px","__META__":{"public":true,"level":"Component"}},"card":{"card__border-radius":"2px","card__box-shadow":"none","card__border":"1px solid #EDEEEE","card__padding":"24px","__META__":{"public":true,"level":"Component"}},"badge":{"badge__border-radius":"24px","badge__font-size--sm":"13px","badge__font-size--md":"13px","badge__font-size--lg":"15px","badge__height--sm":"22px","badge__height--md":"26px","badge__height--lg":"30px","badge__padding-x":"1em","__META__":{"public":true,"level":"Component"}},"slider":{"slider__handle-bg-color":"#333E48","slider__track-bg-color":"#D0D2D3","slider__fill-bg-color":"#00BF6F","slider__border-radius":"24px","slider__height":"16px","__META__":{"public":true,"level":"Component"}},"switch":{"switch__thumb-bg-color--on":"#00BF6F","switch__track-bg-color--on":"#333E48","switch__thumb-bg-color--off":"#FFFFFF","switch__thumb-border--off":"1px solid #D0D2D3","switch__track-bg-color--off":"#D0D2D3","switch__border-radius":"24px","switch__height":"16px","switch__width":"40px","__META__":{"public":true,"level":"Component"}},"checkbox":{"checkbox__bg-color--on":"#00BF6F","checkbox__icon-color--on":"#FFFFFF","__META__":{"public":true,"level":"Component"}},"radio":{"radio__bg-color--on":"#00BF6F","radio__icon-color--on":"#FFFFFF","__META__":{"public":true,"level":"Component"}},"modal":{"modal__border-radius":"0","modal__head-bg-color":"#FFFFFF","modal__head-type-color":"#333E48","modal__body-bg-color":"#EDEEEE","modal__body-type-color":"#333E48","modal__foot-bg-color":"#FFFFFF","modal__foot-type-color":"#333E48","modal__border":"1px solid #333E48","modal__box-shadow":"none","__META__":{"public":true,"level":"Component"}},"pane":{"pane__padding":"24px","pane__bg-color":"#EDEEEE","__META__":{"public":true,"level":"Component"}},"popout":{"popout__width--sm":"275px","popout__width--md":"360px","popout__width--lg":"445px","popout__box-shadow":"0 2px 8px 0 rgba(0,0,0,0.14)","popout__pip-size":"12px","popout__border-radius":"2px","popout__border":"none","popout__body-font-size":"13px","__META__":{"public":true,"level":"Component"}},"tab":{"tab__border-radius":"none","tab__indicator-height":"3px","tab__indicator-color":"#00BF6F","tab__type-color":"#6B787F","tab__font-size":"13px","tab__font-weight":"500","tab__padding-y":"12px","tab__padding-x":" 2px","__META__":{"public":false,"level":"Component"}},"progress-bar":{"progress-bar__border-radius":"none","progress-bar__height--sm":"4px","progress-bar__height--md":"8px","progress-bar__height--lg":"16px","progress-bar__fill-color":"#00BF6F","progress-bar__track-color":"#D0D2D3","__META__":{"public":true,"level":"Component"}},"menu":{"menu__box-shadow":"0 2px 8px 0 rgba(0,0,0,0.14)","menu__max-width":"300px","menu__min-width":"175px","menu__max-height":"325px","__META__":{"public":true,"level":"Component"}},"progress-spinner":{"progress-spinner__fill-color":"#00BF6F","progress-spinner__track-color":"#D0D2D3","__META__":{"public":true,"level":"Component"}},"toast":{"toast__padding":"24px","toast__bg-color":"#333E48","toast__type-color":"#FFFFFF","toast__border-radius":"2px","toast__width":"350px","toast__title-font-size":"16px","toast__body-type-size":"13px","toast__link-color":"#FFFFFF","toast__box-shadow":"none","__META__":{"public":true,"level":"Component"}},"tooltip":{"tooltip__bg-color":"#333E48","tooltip__type-color":"#FFFFFF","tooltip__border-radius":"2px","tooltip__pip-size":"12px","tooltip__font-size":"13px","tooltip__padding":"12px 16px","tooltip__font-weight":"400","tooltip__box-shadow":"none","__META__":{"public":true,"level":"Component"}},"form-group":{"form-group__space-between":"8px","__META__":{"public":true,"level":"Component"}},"sheet":{"sheet__width--sm":"320px","sheet__width--md":"50%","sheet__width--lg":"75%","__META__":{"public":true,"level":"Component"}}}');
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e) {
      var t = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = 0);
      }

      return t;
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e, t, n, a, o, i, u) {
      var l = n + (-o * (t - a) + -i * n) * e,
          s = t + l * e;
      if (Math.abs(l) < u && Math.abs(s - a) < u) return r[0] = a, r[1] = 0, r;
      return r[0] = s, r[1] = l, r;
    };
    var r = [0, 0];
    e.exports = t["default"];
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, r, a;
        "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : null != t && t.hrtime ? (e.exports = function () {
          return (n() - a) / 1e6;
        }, r = t.hrtime, a = (n = function n() {
          var e;
          return 1e9 * (e = r())[0] + e[1];
        })()) : Date.now ? (e.exports = function () {
          return Date.now() - a;
        }, a = Date.now()) : (e.exports = function () {
          return new Date().getTime() - a;
        }, a = new Date().getTime());
      }).call(this);
    }).call(this, n(34));
  }, function (e, t, n) {
    (function (t) {
      for (var r = n(54), a = "undefined" == typeof window ? t : window, o = ["moz", "webkit"], i = "AnimationFrame", u = a["request" + i], l = a["cancel" + i] || a["cancelRequest" + i], s = 0; !u && s < o.length; s++) {
        u = a[o[s] + "Request" + i], l = a[o[s] + "Cancel" + i] || a[o[s] + "CancelRequest" + i];
      }

      if (!u || !l) {
        var c = 0,
            f = 0,
            p = [];
        u = function u(e) {
          if (0 === p.length) {
            var t = r(),
                n = Math.max(0, 1e3 / 60 - (t - c));
            c = n + t, setTimeout(function () {
              var e = p.slice(0);
              p.length = 0;

              for (var t = 0; t < e.length; t++) {
                if (!e[t].cancelled) try {
                  e[t].callback(c);
                } catch (e) {
                  setTimeout(function () {
                    throw e;
                  }, 0);
                }
              }
            }, Math.round(n));
          }

          return p.push({
            handle: ++f,
            callback: e,
            cancelled: !1
          }), f;
        }, l = function l(e) {
          for (var t = 0; t < p.length; t++) {
            p[t].handle === e && (p[t].cancelled = !0);
          }
        };
      }

      e.exports = function (e) {
        return u.call(a, e);
      }, e.exports.cancel = function () {
        l.apply(a, arguments);
      }, e.exports.polyfill = function (e) {
        e || (e = a), e.requestAnimationFrame = u, e.cancelAnimationFrame = l;
      };
    }).call(this, n(13));
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e, t, n) {
      for (var r in t) {
        if (Object.prototype.hasOwnProperty.call(t, r)) {
          if (0 !== n[r]) return !1;
          var a = "number" == typeof t[r] ? t[r] : t[r].val;
          if (e[r] !== a) return !1;
        }
      }

      return !0;
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    var r = n(65);
    e.exports = Function.prototype.bind || r;
  }, function (e, t, n) {
    "use strict";

    var r = n(36),
        a = "function" == typeof Symbol && "symbol" == _typeof(Symbol("foo")),
        o = Object.prototype.toString,
        i = Array.prototype.concat,
        u = Object.defineProperty,
        l = u && function () {
      var e = {};

      try {
        for (var t in u(e, "x", {
          enumerable: !1,
          value: e
        }), e) {
          return !1;
        }

        return e.x === e;
      } catch (e) {
        return !1;
      }
    }(),
        s = function s(e, t, n, r) {
      var a;
      (!(t in e) || "function" == typeof (a = r) && "[object Function]" === o.call(a) && r()) && (l ? u(e, t, {
        configurable: !0,
        enumerable: !1,
        value: n,
        writable: !0
      }) : e[t] = n);
    },
        c = function c(e, t) {
      var n = arguments.length > 2 ? arguments[2] : {},
          o = r(t);
      a && (o = i.call(o, Object.getOwnPropertySymbols(t)));

      for (var u = 0; u < o.length; u += 1) {
        s(e, o[u], t[o[u]], n[o[u]]);
      }
    };

    c.supportsDescriptors = !!l, e.exports = c;
  },, function (e, t) {
    var n,
        r,
        a = e.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function i() {
      throw new Error("clearTimeout has not been defined");
    }

    function u(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        n = o;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : i;
      } catch (e) {
        r = i;
      }
    }();
    var l,
        s = [],
        c = !1,
        f = -1;

    function p() {
      c && l && (c = !1, l.length ? s = l.concat(s) : f = -1, s.length && h());
    }

    function h() {
      if (!c) {
        var e = u(p);
        c = !0;

        for (var t = s.length; t;) {
          for (l = s, s = []; ++f < t;) {
            l && l[f].run();
          }

          f = -1, t = s.length;
        }

        l = null, c = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === i || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function d(e, t) {
      this.fun = e, this.array = t;
    }

    function y() {}

    a.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      s.push(new d(e, t)), 1 !== s.length || c || u(h);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = y, a.addListener = y, a.once = y, a.off = y, a.removeListener = y, a.removeAllListeners = y, a.emit = y, a.prependListener = y, a.prependOnceListener = y, a.listeners = function (e) {
      return [];
    }, a.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, a.cwd = function () {
      return "/";
    }, a.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, a.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = {
      noWobble: {
        stiffness: 170,
        damping: 26
      },
      gentle: {
        stiffness: 120,
        damping: 14
      },
      wobbly: {
        stiffness: 180,
        damping: 12
      },
      stiff: {
        stiffness: 210,
        damping: 20
      }
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    var r = Array.prototype.slice,
        a = n(37),
        o = Object.keys,
        i = o ? function (e) {
      return o(e);
    } : n(60),
        u = Object.keys;
    i.shim = function () {
      Object.keys ? function () {
        var e = Object.keys(arguments);
        return e && e.length === arguments.length;
      }(1, 2) || (Object.keys = function (e) {
        return a(e) ? u(r.call(e)) : u(e);
      }) : Object.keys = i;
      return Object.keys || i;
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var r = Object.prototype.toString;

    e.exports = function (e) {
      var t = r.call(e),
          n = "[object Arguments]" === t;
      return n || (n = "[object Array]" !== t && null !== e && "object" == _typeof(e) && "number" == typeof e.length && e.length >= 0 && "[object Function]" === r.call(e.callee)), n;
    };
  }, function (e, t, n) {
    "use strict";

    var r = Object,
        a = TypeError;

    e.exports = function () {
      if (null != this && this !== r(this)) throw new a("RegExp.prototype.flags getter called on non-object");
      var e = "";
      return this.global && (e += "g"), this.ignoreCase && (e += "i"), this.multiline && (e += "m"), this.dotAll && (e += "s"), this.unicode && (e += "u"), this.sticky && (e += "y"), e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(38),
        a = n(32).supportsDescriptors,
        o = Object.getOwnPropertyDescriptor,
        i = TypeError;

    e.exports = function () {
      if (!a) throw new i("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");

      if ("gim" === /a/gim.flags) {
        var e = o(RegExp.prototype, "flags");
        if (e && "function" == typeof e.get && "boolean" == typeof /a/.dotAll) return e.get;
      }

      return r;
    };
  }, function (e, t, n) {
    var r = n(36),
        a = n(61),
        o = n(62),
        i = n(63),
        u = n(66),
        l = n(72),
        s = Date.prototype.getTime;

    function c(e, t, n) {
      var h = n || {};
      return !!(h.strict ? o(e, t) : e === t) || (!e || !t || "object" != _typeof(e) && "object" != _typeof(t) ? h.strict ? o(e, t) : e == t : function (e, t, n) {
        var o, h;
        if (_typeof(e) != _typeof(t)) return !1;
        if (f(e) || f(t)) return !1;
        if (e.prototype !== t.prototype) return !1;
        if (a(e) !== a(t)) return !1;
        var d = i(e),
            y = i(t);
        if (d !== y) return !1;
        if (d || y) return e.source === t.source && u(e) === u(t);
        if (l(e) && l(t)) return s.call(e) === s.call(t);
        var m = p(e),
            g = p(t);
        if (m !== g) return !1;

        if (m || g) {
          if (e.length !== t.length) return !1;

          for (o = 0; o < e.length; o++) {
            if (e[o] !== t[o]) return !1;
          }

          return !0;
        }

        if (_typeof(e) != _typeof(t)) return !1;

        try {
          var v = r(e),
              b = r(t);
        } catch (e) {
          return !1;
        }

        if (v.length !== b.length) return !1;

        for (v.sort(), b.sort(), o = v.length - 1; o >= 0; o--) {
          if (v[o] != b[o]) return !1;
        }

        for (o = v.length - 1; o >= 0; o--) {
          if (h = v[o], !c(e[h], t[h], n)) return !1;
        }

        return !0;
      }(e, t, h));
    }

    function f(e) {
      return null == e;
    }

    function p(e) {
      return !(!e || "object" != _typeof(e) || "number" != typeof e.length) && "function" == typeof e.copy && "function" == typeof e.slice && !(e.length > 0 && "number" != typeof e[0]);
    }

    e.exports = c;
  }, function (e, t, n) {
    (function (t) {
      var n = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
          r = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
          a = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
          o = "[" + a + "]",
          i = "[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]",
          u = "\\d+",
          l = "[\\u2700-\\u27bf]",
          s = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
          c = "[^\\ud800-\\udfff" + a + u + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
          f = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          p = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          h = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
          d = "(?:" + s + "|" + c + ")",
          y = "(?:" + h + "|" + c + ")",
          m = "(?:[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]|\\ud83c[\\udffb-\\udfff])?",
          g = "[\\ufe0e\\ufe0f]?" + m + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", f, p].join("|") + ")[\\ufe0e\\ufe0f]?" + m + ")*"),
          v = "(?:" + [l, f, p].join("|") + ")" + g,
          b = RegExp("['’]", "g"),
          _ = RegExp(i, "g"),
          x = RegExp([h + "?" + s + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [o, h, "$"].join("|") + ")", y + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [o, h + d, "$"].join("|") + ")", h + "?" + d + "+(?:['’](?:d|ll|m|re|s|t|ve))?", h + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", u, v].join("|"), "g"),
          O = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
          w = "object" == _typeof(t) && t && t.Object === Object && t,
          T = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
          k = w || T || Function("return this")();

      var M,
          E = (M = {
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "ss"
      }, function (e) {
        return null == M ? void 0 : M[e];
      });
      var P = Object.prototype.toString,
          j = k.Symbol,
          S = j ? j.prototype : void 0,
          A = S ? S.toString : void 0;

      function N(e) {
        if ("string" == typeof e) return e;
        if (function (e) {
          return "symbol" == _typeof(e) || function (e) {
            return !!e && "object" == _typeof(e);
          }(e) && "[object Symbol]" == P.call(e);
        }(e)) return A ? A.call(e) : "";
        var t = e + "";
        return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
      }

      function C(e) {
        return null == e ? "" : N(e);
      }

      var F,
          R = (F = function F(e, t, n) {
        return e + (n ? "-" : "") + t.toLowerCase();
      }, function (e) {
        return function (e, t, n, r) {
          var a = -1,
              o = e ? e.length : 0;

          for (r && o && (n = e[++a]); ++a < o;) {
            n = t(n, e[a], a, e);
          }

          return n;
        }(function (e, t, r) {
          return e = C(e), void 0 === (t = r ? void 0 : t) ? function (e) {
            return O.test(e);
          }(e) ? function (e) {
            return e.match(x) || [];
          }(e) : function (e) {
            return e.match(n) || [];
          }(e) : e.match(t) || [];
        }(function (e) {
          return (e = C(e)) && e.replace(r, E).replace(_, "");
        }(e).replace(b, "")), F, "");
      });
      e.exports = R;
    }).call(this, n(13));
  },,, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
        var n = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == u["return"] || u["return"]();
          } finally {
            if (a) throw o;
          }
        }

        return n;
      }
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          a = {},
          o = Object.keys(e);

      for (r = 0; r < o.length; r++) {
        n = o[r], t.indexOf(n) >= 0 || (a[n] = e[n]);
      }

      return a;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(49);

    function a() {}

    function o() {}

    o.resetWarningCache = a, e.exports = function () {
      function e(e, t, n, a, o, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: o,
        resetWarningCache: a
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t) {
    var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (n) {
      var r = new Uint8Array(16);

      e.exports = function () {
        return n(r), r;
      };
    } else {
      var a = new Array(16);

      e.exports = function () {
        for (var e, t = 0; t < 16; t++) {
          0 == (3 & t) && (e = 4294967296 * Math.random()), a[t] = e >>> ((3 & t) << 3) & 255;
        }

        return a;
      };
    }
  }, function (e, t) {
    for (var n = [], r = 0; r < 256; ++r) {
      n[r] = (r + 256).toString(16).substr(1);
    }

    e.exports = function (e, t) {
      var r = t || 0,
          a = n;
      return [a[e[r++]], a[e[r++]], a[e[r++]], a[e[r++]], "-", a[e[r++]], a[e[r++]], "-", a[e[r++]], a[e[r++]], "-", a[e[r++]], a[e[r++]], "-", a[e[r++]], a[e[r++]], a[e[r++]], a[e[r++]], a[e[r++]], a[e[r++]]].join("");
    };
  }, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        a = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var i = o(n(26)),
        u = o(n(22)),
        l = o(n(27)),
        s = o(n(28)),
        c = o(n(29)),
        f = o(n(30)),
        p = o(n(1)),
        h = o(n(0)),
        d = function (e) {
      function t(n) {
        var a = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (e) {
          var t = !1,
              n = a.state,
              o = n.currentStyle,
              i = n.currentVelocity,
              u = n.lastIdealStyle,
              l = n.lastIdealVelocity;

          for (var s in e) {
            if (Object.prototype.hasOwnProperty.call(e, s)) {
              var c = e[s];
              "number" == typeof c && (t || (t = !0, o = r({}, o), i = r({}, i), u = r({}, u), l = r({}, l)), o[s] = c, i[s] = 0, u[s] = c, l[s] = 0);
            }
          }

          t && a.setState({
            currentStyle: o,
            currentVelocity: i,
            lastIdealStyle: u,
            lastIdealVelocity: l
          });
        }, this.startAnimationIfNecessary = function () {
          a.animationID = c["default"](function (e) {
            var t = a.props.style;
            if (f["default"](a.state.currentStyle, t, a.state.currentVelocity)) return a.wasAnimating && a.props.onRest && a.props.onRest(), a.animationID = null, a.wasAnimating = !1, void (a.accumulatedTime = 0);
            a.wasAnimating = !0;
            var n = e || s["default"](),
                r = n - a.prevTime;
            if (a.prevTime = n, a.accumulatedTime = a.accumulatedTime + r, a.accumulatedTime > 1e3 / 60 * 10 && (a.accumulatedTime = 0), 0 === a.accumulatedTime) return a.animationID = null, void a.startAnimationIfNecessary();
            var o = (a.accumulatedTime - Math.floor(a.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60),
                i = Math.floor(a.accumulatedTime / (1e3 / 60)),
                u = {},
                c = {},
                p = {},
                h = {};

            for (var d in t) {
              if (Object.prototype.hasOwnProperty.call(t, d)) {
                var y = t[d];
                if ("number" == typeof y) p[d] = y, h[d] = 0, u[d] = y, c[d] = 0;else {
                  for (var m = a.state.lastIdealStyle[d], g = a.state.lastIdealVelocity[d], v = 0; v < i; v++) {
                    var b = l["default"](1e3 / 60 / 1e3, m, g, y.val, y.stiffness, y.damping, y.precision);
                    m = b[0], g = b[1];
                  }

                  var _ = l["default"](1e3 / 60 / 1e3, m, g, y.val, y.stiffness, y.damping, y.precision),
                      x = _[0],
                      O = _[1];

                  p[d] = m + (x - m) * o, h[d] = g + (O - g) * o, u[d] = m, c[d] = g;
                }
              }
            }

            a.animationID = null, a.accumulatedTime -= i * (1e3 / 60), a.setState({
              currentStyle: p,
              currentVelocity: h,
              lastIdealStyle: u,
              lastIdealVelocity: c
            }), a.unreadPropStyle = null, a.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), a(t, null, [{
        key: "propTypes",
        value: {
          defaultStyle: h["default"].objectOf(h["default"].number),
          style: h["default"].objectOf(h["default"].oneOfType([h["default"].number, h["default"].object])).isRequired,
          children: h["default"].func.isRequired,
          onRest: h["default"].func
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyle,
            n = e.style,
            r = t || u["default"](n),
            a = i["default"](r);
        return {
          currentStyle: r,
          currentVelocity: a,
          lastIdealStyle: r,
          lastIdealVelocity: a
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = s["default"](), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = e.style, null == this.animationID && (this.prevTime = s["default"](), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        null != this.animationID && (c["default"].cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = this.props.children(this.state.currentStyle);
        return e && p["default"].Children.only(e);
      }, t;
    }(p["default"].Component);

    t["default"] = d, e.exports = t["default"];
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, r, a, o, i, u;
        "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : null != t && t.hrtime ? (e.exports = function () {
          return (n() - i) / 1e6;
        }, r = t.hrtime, o = (n = function n() {
          var e;
          return 1e9 * (e = r())[0] + e[1];
        })(), u = 1e9 * t.uptime(), i = o - u) : Date.now ? (e.exports = function () {
          return Date.now() - a;
        }, a = Date.now()) : (e.exports = function () {
          return new Date().getTime() - a;
        }, a = new Date().getTime());
      }).call(this);
    }).call(this, n(34));
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        a = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var i = o(n(26)),
        u = o(n(22)),
        l = o(n(27)),
        s = o(n(28)),
        c = o(n(29)),
        f = o(n(30)),
        p = o(n(1)),
        h = o(n(0));

    var d = function (e) {
      function t(n) {
        var a = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
          for (var t = a.state, n = t.currentStyles, o = t.currentVelocities, i = t.lastIdealStyles, u = t.lastIdealVelocities, l = !1, s = 0; s < e.length; s++) {
            var c = e[s],
                f = !1;

            for (var p in c) {
              if (Object.prototype.hasOwnProperty.call(c, p)) {
                var h = c[p];
                "number" == typeof h && (f || (f = !0, l = !0, n[s] = r({}, n[s]), o[s] = r({}, o[s]), i[s] = r({}, i[s]), u[s] = r({}, u[s])), n[s][p] = h, o[s][p] = 0, i[s][p] = h, u[s][p] = 0);
              }
            }
          }

          l && a.setState({
            currentStyles: n,
            currentVelocities: o,
            lastIdealStyles: i,
            lastIdealVelocities: u
          });
        }, this.startAnimationIfNecessary = function () {
          a.animationID = c["default"](function (e) {
            var t = a.props.styles(a.state.lastIdealStyles);
            if (function (e, t, n) {
              for (var r = 0; r < e.length; r++) {
                if (!f["default"](e[r], t[r], n[r])) return !1;
              }

              return !0;
            }(a.state.currentStyles, t, a.state.currentVelocities)) return a.animationID = null, void (a.accumulatedTime = 0);
            var n = e || s["default"](),
                r = n - a.prevTime;
            if (a.prevTime = n, a.accumulatedTime = a.accumulatedTime + r, a.accumulatedTime > 1e3 / 60 * 10 && (a.accumulatedTime = 0), 0 === a.accumulatedTime) return a.animationID = null, void a.startAnimationIfNecessary();

            for (var o = (a.accumulatedTime - Math.floor(a.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60), i = Math.floor(a.accumulatedTime / (1e3 / 60)), u = [], c = [], p = [], h = [], d = 0; d < t.length; d++) {
              var y = t[d],
                  m = {},
                  g = {},
                  v = {},
                  b = {};

              for (var _ in y) {
                if (Object.prototype.hasOwnProperty.call(y, _)) {
                  var x = y[_];
                  if ("number" == typeof x) m[_] = x, g[_] = 0, v[_] = x, b[_] = 0;else {
                    for (var O = a.state.lastIdealStyles[d][_], w = a.state.lastIdealVelocities[d][_], T = 0; T < i; T++) {
                      var k = l["default"](1e3 / 60 / 1e3, O, w, x.val, x.stiffness, x.damping, x.precision);
                      O = k[0], w = k[1];
                    }

                    var M = l["default"](1e3 / 60 / 1e3, O, w, x.val, x.stiffness, x.damping, x.precision),
                        E = M[0],
                        P = M[1];
                    m[_] = O + (E - O) * o, g[_] = w + (P - w) * o, v[_] = O, b[_] = w;
                  }
                }
              }

              p[d] = m, h[d] = g, u[d] = v, c[d] = b;
            }

            a.animationID = null, a.accumulatedTime -= i * (1e3 / 60), a.setState({
              currentStyles: p,
              currentVelocities: h,
              lastIdealStyles: u,
              lastIdealVelocities: c
            }), a.unreadPropStyles = null, a.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), a(t, null, [{
        key: "propTypes",
        value: {
          defaultStyles: h["default"].arrayOf(h["default"].objectOf(h["default"].number)),
          styles: h["default"].func.isRequired,
          children: h["default"].func.isRequired
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            r = t || n().map(u["default"]),
            a = r.map(function (e) {
          return i["default"](e);
        });
        return {
          currentStyles: r,
          currentVelocities: a,
          lastIdealStyles: r,
          lastIdealVelocities: a
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = s["default"](), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = e.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = s["default"](), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        null != this.animationID && (c["default"].cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = this.props.children(this.state.currentStyles);
        return e && p["default"].Children.only(e);
      }, t;
    }(p["default"].Component);

    t["default"] = d, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        a = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var i = o(n(26)),
        u = o(n(22)),
        l = o(n(27)),
        s = o(n(57)),
        c = o(n(28)),
        f = o(n(29)),
        p = o(n(30)),
        h = o(n(1)),
        d = o(n(0));

    function y(e, t, n) {
      var r = t;
      return null == r ? e.map(function (e, t) {
        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      }) : e.map(function (e, t) {
        for (var a = 0; a < r.length; a++) {
          if (r[a].key === e.key) return {
            key: r[a].key,
            data: r[a].data,
            style: n[t]
          };
        }

        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      });
    }

    function m(e, t, n, r, a, o, u, l, c) {
      for (var f = s["default"](r, a, function (e, r) {
        var a = t(r);
        return null == a || p["default"](o[e], a, u[e]) ? (n({
          key: r.key,
          data: r.data
        }), null) : {
          key: r.key,
          data: r.data,
          style: a
        };
      }), h = [], d = [], y = [], m = [], g = 0; g < f.length; g++) {
        for (var v = f[g], b = null, _ = 0; _ < r.length; _++) {
          if (r[_].key === v.key) {
            b = _;
            break;
          }
        }

        if (null == b) {
          var x = e(v);
          h[g] = x, y[g] = x;
          var O = i["default"](v.style);
          d[g] = O, m[g] = O;
        } else h[g] = o[b], y[g] = l[b], d[g] = u[b], m[g] = c[b];
      }

      return [f, h, d, y, m];
    }

    var g = function (e) {
      function t(n) {
        var a = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
          for (var t = m(a.props.willEnter, a.props.willLeave, a.props.didLeave, a.state.mergedPropsStyles, e, a.state.currentStyles, a.state.currentVelocities, a.state.lastIdealStyles, a.state.lastIdealVelocities), n = t[0], o = t[1], i = t[2], u = t[3], l = t[4], s = 0; s < e.length; s++) {
            var c = e[s].style,
                f = !1;

            for (var p in c) {
              if (Object.prototype.hasOwnProperty.call(c, p)) {
                var h = c[p];
                "number" == typeof h && (f || (f = !0, o[s] = r({}, o[s]), i[s] = r({}, i[s]), u[s] = r({}, u[s]), l[s] = r({}, l[s]), n[s] = {
                  key: n[s].key,
                  data: n[s].data,
                  style: r({}, n[s].style)
                }), o[s][p] = h, i[s][p] = 0, u[s][p] = h, l[s][p] = 0, n[s].style[p] = h);
              }
            }
          }

          a.setState({
            currentStyles: o,
            currentVelocities: i,
            mergedPropsStyles: n,
            lastIdealStyles: u,
            lastIdealVelocities: l
          });
        }, this.startAnimationIfNecessary = function () {
          a.unmounting || (a.animationID = f["default"](function (e) {
            if (!a.unmounting) {
              var t = a.props.styles,
                  n = "function" == typeof t ? t(y(a.state.mergedPropsStyles, a.unreadPropStyles, a.state.lastIdealStyles)) : t;
              if (function (e, t, n, r) {
                if (r.length !== t.length) return !1;

                for (var a = 0; a < r.length; a++) {
                  if (r[a].key !== t[a].key) return !1;
                }

                for (a = 0; a < r.length; a++) {
                  if (!p["default"](e[a], t[a].style, n[a])) return !1;
                }

                return !0;
              }(a.state.currentStyles, n, a.state.currentVelocities, a.state.mergedPropsStyles)) return a.animationID = null, void (a.accumulatedTime = 0);
              var r = e || c["default"](),
                  o = r - a.prevTime;
              if (a.prevTime = r, a.accumulatedTime = a.accumulatedTime + o, a.accumulatedTime > 1e3 / 60 * 10 && (a.accumulatedTime = 0), 0 === a.accumulatedTime) return a.animationID = null, void a.startAnimationIfNecessary();

              for (var i = (a.accumulatedTime - Math.floor(a.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60), u = Math.floor(a.accumulatedTime / (1e3 / 60)), s = m(a.props.willEnter, a.props.willLeave, a.props.didLeave, a.state.mergedPropsStyles, n, a.state.currentStyles, a.state.currentVelocities, a.state.lastIdealStyles, a.state.lastIdealVelocities), f = s[0], h = s[1], d = s[2], g = s[3], v = s[4], b = 0; b < f.length; b++) {
                var _ = f[b].style,
                    x = {},
                    O = {},
                    w = {},
                    T = {};

                for (var k in _) {
                  if (Object.prototype.hasOwnProperty.call(_, k)) {
                    var M = _[k];
                    if ("number" == typeof M) x[k] = M, O[k] = 0, w[k] = M, T[k] = 0;else {
                      for (var E = g[b][k], P = v[b][k], j = 0; j < u; j++) {
                        var S = l["default"](1e3 / 60 / 1e3, E, P, M.val, M.stiffness, M.damping, M.precision);
                        E = S[0], P = S[1];
                      }

                      var A = l["default"](1e3 / 60 / 1e3, E, P, M.val, M.stiffness, M.damping, M.precision),
                          N = A[0],
                          C = A[1];
                      x[k] = E + (N - E) * i, O[k] = P + (C - P) * i, w[k] = E, T[k] = P;
                    }
                  }
                }

                g[b] = w, v[b] = T, h[b] = x, d[b] = O;
              }

              a.animationID = null, a.accumulatedTime -= u * (1e3 / 60), a.setState({
                currentStyles: h,
                currentVelocities: d,
                lastIdealStyles: g,
                lastIdealVelocities: v,
                mergedPropsStyles: f
              }), a.unreadPropStyles = null, a.startAnimationIfNecessary();
            }
          }));
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), a(t, null, [{
        key: "propTypes",
        value: {
          defaultStyles: d["default"].arrayOf(d["default"].shape({
            key: d["default"].string.isRequired,
            data: d["default"].any,
            style: d["default"].objectOf(d["default"].number).isRequired
          })),
          styles: d["default"].oneOfType([d["default"].func, d["default"].arrayOf(d["default"].shape({
            key: d["default"].string.isRequired,
            data: d["default"].any,
            style: d["default"].objectOf(d["default"].oneOfType([d["default"].number, d["default"].object])).isRequired
          }))]).isRequired,
          children: d["default"].func.isRequired,
          willEnter: d["default"].func,
          willLeave: d["default"].func,
          didLeave: d["default"].func
        },
        enumerable: !0
      }, {
        key: "defaultProps",
        value: {
          willEnter: function willEnter(e) {
            return u["default"](e.style);
          },
          willLeave: function willLeave() {
            return null;
          },
          didLeave: function didLeave() {}
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            r = e.willEnter,
            a = e.willLeave,
            o = e.didLeave,
            l = "function" == typeof n ? n(t) : n,
            s = void 0;
        s = null == t ? l : t.map(function (e) {
          for (var t = 0; t < l.length; t++) {
            if (l[t].key === e.key) return l[t];
          }

          return e;
        });
        var c = null == t ? l.map(function (e) {
          return u["default"](e.style);
        }) : t.map(function (e) {
          return u["default"](e.style);
        }),
            f = null == t ? l.map(function (e) {
          return i["default"](e.style);
        }) : t.map(function (e) {
          return i["default"](e.style);
        }),
            p = m(r, a, o, s, l, c, f, c, f),
            h = p[0];
        return {
          currentStyles: p[1],
          currentVelocities: p[2],
          lastIdealStyles: p[3],
          lastIdealVelocities: p[4],
          mergedPropsStyles: h
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = c["default"](), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
        var t = e.styles;
        this.unreadPropStyles = "function" == typeof t ? t(y(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : t, null == this.animationID && (this.prevTime = c["default"](), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        this.unmounting = !0, null != this.animationID && (f["default"].cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = y(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
            t = this.props.children(e);
        return t && h["default"].Children.only(t);
      }, t;
    }(h["default"].Component);

    t["default"] = g, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e, t, n) {
      for (var r = {}, a = 0; a < e.length; a++) {
        r[e[a].key] = a;
      }

      var o = {};

      for (a = 0; a < t.length; a++) {
        o[t[a].key] = a;
      }

      var i = [];

      for (a = 0; a < t.length; a++) {
        i[a] = t[a];
      }

      for (a = 0; a < e.length; a++) {
        if (!Object.prototype.hasOwnProperty.call(o, e[a].key)) {
          var u = n(a, e[a]);
          null != u && i.push(u);
        }
      }

      return i.sort(function (e, n) {
        var a = o[e.key],
            i = o[n.key],
            u = r[e.key],
            l = r[n.key];
        if (null != a && null != i) return o[e.key] - o[n.key];
        if (null != u && null != l) return r[e.key] - r[n.key];

        if (null != a) {
          for (var s = 0; s < t.length; s++) {
            var c = t[s].key;

            if (Object.prototype.hasOwnProperty.call(r, c)) {
              if (a < o[c] && l > r[c]) return -1;
              if (a > o[c] && l < r[c]) return 1;
            }
          }

          return 1;
        }

        for (s = 0; s < t.length; s++) {
          c = t[s].key;

          if (Object.prototype.hasOwnProperty.call(r, c)) {
            if (i < o[c] && u > r[c]) return 1;
            if (i > o[c] && u < r[c]) return -1;
          }
        }

        return -1;
      });
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    t["default"] = function (e, t) {
      return r({}, u, t, {
        val: e
      });
    };

    var a,
        o = n(35),
        i = (a = o) && a.__esModule ? a : {
      "default": a
    },
        u = r({}, i["default"].noWobble, {
      precision: .01
    });
    e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function () {
      0;
    };
    e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    var r;

    if (!Object.keys) {
      var a = Object.prototype.hasOwnProperty,
          o = Object.prototype.toString,
          i = n(37),
          u = Object.prototype.propertyIsEnumerable,
          l = !u.call({
        toString: null
      }, "toString"),
          s = u.call(function () {}, "prototype"),
          c = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
          f = function f(e) {
        var t = e.constructor;
        return t && t.prototype === e;
      },
          p = {
        $applicationCache: !0,
        $console: !0,
        $external: !0,
        $frame: !0,
        $frameElement: !0,
        $frames: !0,
        $innerHeight: !0,
        $innerWidth: !0,
        $onmozfullscreenchange: !0,
        $onmozfullscreenerror: !0,
        $outerHeight: !0,
        $outerWidth: !0,
        $pageXOffset: !0,
        $pageYOffset: !0,
        $parent: !0,
        $scrollLeft: !0,
        $scrollTop: !0,
        $scrollX: !0,
        $scrollY: !0,
        $self: !0,
        $webkitIndexedDB: !0,
        $webkitStorageInfo: !0,
        $window: !0
      },
          h = function () {
        if ("undefined" == typeof window) return !1;

        for (var e in window) {
          try {
            if (!p["$" + e] && a.call(window, e) && null !== window[e] && "object" == _typeof(window[e])) try {
              f(window[e]);
            } catch (e) {
              return !0;
            }
          } catch (e) {
            return !0;
          }
        }

        return !1;
      }();

      r = function r(e) {
        var t = null !== e && "object" == _typeof(e),
            n = "[object Function]" === o.call(e),
            r = i(e),
            u = t && "[object String]" === o.call(e),
            p = [];

        if (!t && !n && !r) throw new TypeError("Object.keys called on a non-object");
        var d = s && n;
        if (u && e.length > 0 && !a.call(e, 0)) for (var y = 0; y < e.length; ++y) {
          p.push(String(y));
        }
        if (r && e.length > 0) for (var m = 0; m < e.length; ++m) {
          p.push(String(m));
        } else for (var g in e) {
          d && "prototype" === g || !a.call(e, g) || p.push(String(g));
        }
        if (l) for (var v = function (e) {
          if ("undefined" == typeof window || !h) return f(e);

          try {
            return f(e);
          } catch (e) {
            return !1;
          }
        }(e), b = 0; b < c.length; ++b) {
          v && "constructor" === c[b] || !a.call(e, c[b]) || p.push(c[b]);
        }
        return p;
      };
    }

    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    var r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.toStringTag),
        a = Object.prototype.toString,
        o = function o(e) {
      return !(r && e && "object" == _typeof(e) && Symbol.toStringTag in e) && "[object Arguments]" === a.call(e);
    },
        i = function i(e) {
      return !!o(e) || null !== e && "object" == _typeof(e) && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== a.call(e) && "[object Function]" === a.call(e.callee);
    },
        u = function () {
      return o(arguments);
    }();

    o.isLegacyArguments = i, e.exports = u ? o : i;
  }, function (e, t, n) {
    "use strict";

    var r = function r(e) {
      return e != e;
    };

    e.exports = function (e, t) {
      return 0 === e && 0 === t ? 1 / e == 1 / t : e === t || !(!r(e) || !r(t));
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(64),
        a = RegExp.prototype.exec,
        o = Object.getOwnPropertyDescriptor,
        i = Object.prototype.toString,
        u = "function" == typeof Symbol && "symbol" == _typeof(Symbol.toStringTag);

    e.exports = function (e) {
      if (!e || "object" != _typeof(e)) return !1;
      if (!u) return "[object RegExp]" === i.call(e);
      var t = o(e, "lastIndex");
      return !(!t || !r(t, "value")) && function (e) {
        try {
          var t = e.lastIndex;
          return e.lastIndex = 0, a.call(e), !0;
        } catch (e) {
          return !1;
        } finally {
          e.lastIndex = t;
        }
      }(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(31);
    e.exports = r.call(Function.call, Object.prototype.hasOwnProperty);
  }, function (e, t, n) {
    "use strict";

    var r = "Function.prototype.bind called on incompatible ",
        a = Array.prototype.slice,
        o = Object.prototype.toString;

    e.exports = function (e) {
      var t = this;
      if ("function" != typeof t || "[object Function]" !== o.call(t)) throw new TypeError(r + t);

      for (var n, i = a.call(arguments, 1), u = function u() {
        if (this instanceof n) {
          var r = t.apply(this, i.concat(a.call(arguments)));
          return Object(r) === r ? r : this;
        }

        return t.apply(e, i.concat(a.call(arguments)));
      }, l = Math.max(0, t.length - i.length), s = [], c = 0; c < l; c++) {
        s.push("$" + c);
      }

      if (n = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(u), t.prototype) {
        var f = function f() {};

        f.prototype = t.prototype, n.prototype = new f(), f.prototype = null;
      }

      return n;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(32),
        a = n(67),
        o = n(38),
        i = n(39),
        u = n(71),
        l = a(o);
    r(l, {
      getPolyfill: i,
      implementation: o,
      shim: u
    }), e.exports = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(31),
        a = n(68)("%Function%"),
        o = a.apply,
        i = a.call;
    e.exports = function () {
      return r.apply(i, arguments);
    }, e.exports.apply = function () {
      return r.apply(o, arguments);
    };
  }, function (e, t, n) {
    "use strict";

    var r = TypeError,
        a = Object.getOwnPropertyDescriptor;
    if (a) try {
      a({}, "");
    } catch (e) {
      a = null;
    }

    var o = function o() {
      throw new r();
    },
        i = a ? function () {
      try {
        return arguments.callee, o;
      } catch (e) {
        try {
          return a(arguments, "callee").get;
        } catch (e) {
          return o;
        }
      }
    }() : o,
        u = n(69)(),
        l = Object.getPrototypeOf || function (e) {
      return e.__proto__;
    },
        s = void 0,
        c = "undefined" == typeof Uint8Array ? void 0 : l(Uint8Array),
        f = {
      "%Array%": Array,
      "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
      "%ArrayBufferPrototype%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer.prototype,
      "%ArrayIteratorPrototype%": u ? l([][Symbol.iterator]()) : void 0,
      "%ArrayPrototype%": Array.prototype,
      "%ArrayProto_entries%": Array.prototype.entries,
      "%ArrayProto_forEach%": Array.prototype.forEach,
      "%ArrayProto_keys%": Array.prototype.keys,
      "%ArrayProto_values%": Array.prototype.values,
      "%AsyncFromSyncIteratorPrototype%": void 0,
      "%AsyncFunction%": void 0,
      "%AsyncFunctionPrototype%": void 0,
      "%AsyncGenerator%": void 0,
      "%AsyncGeneratorFunction%": void 0,
      "%AsyncGeneratorPrototype%": void 0,
      "%AsyncIteratorPrototype%": s && u && Symbol.asyncIterator ? s[Symbol.asyncIterator]() : void 0,
      "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
      "%Boolean%": Boolean,
      "%BooleanPrototype%": Boolean.prototype,
      "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
      "%DataViewPrototype%": "undefined" == typeof DataView ? void 0 : DataView.prototype,
      "%Date%": Date,
      "%DatePrototype%": Date.prototype,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%ErrorPrototype%": Error.prototype,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%EvalErrorPrototype%": EvalError.prototype,
      "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
      "%Float32ArrayPrototype%": "undefined" == typeof Float32Array ? void 0 : Float32Array.prototype,
      "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
      "%Float64ArrayPrototype%": "undefined" == typeof Float64Array ? void 0 : Float64Array.prototype,
      "%Function%": Function,
      "%FunctionPrototype%": Function.prototype,
      "%Generator%": void 0,
      "%GeneratorFunction%": void 0,
      "%GeneratorPrototype%": void 0,
      "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
      "%Int8ArrayPrototype%": "undefined" == typeof Int8Array ? void 0 : Int8Array.prototype,
      "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
      "%Int16ArrayPrototype%": "undefined" == typeof Int16Array ? void 0 : Int8Array.prototype,
      "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
      "%Int32ArrayPrototype%": "undefined" == typeof Int32Array ? void 0 : Int32Array.prototype,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": u ? l(l([][Symbol.iterator]())) : void 0,
      "%JSON%": "object" == (typeof JSON === "undefined" ? "undefined" : _typeof(JSON)) ? JSON : void 0,
      "%JSONParse%": "object" == (typeof JSON === "undefined" ? "undefined" : _typeof(JSON)) ? JSON.parse : void 0,
      "%Map%": "undefined" == typeof Map ? void 0 : Map,
      "%MapIteratorPrototype%": "undefined" != typeof Map && u ? l(new Map()[Symbol.iterator]()) : void 0,
      "%MapPrototype%": "undefined" == typeof Map ? void 0 : Map.prototype,
      "%Math%": Math,
      "%Number%": Number,
      "%NumberPrototype%": Number.prototype,
      "%Object%": Object,
      "%ObjectPrototype%": Object.prototype,
      "%ObjProto_toString%": Object.prototype.toString,
      "%ObjProto_valueOf%": Object.prototype.valueOf,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
      "%PromisePrototype%": "undefined" == typeof Promise ? void 0 : Promise.prototype,
      "%PromiseProto_then%": "undefined" == typeof Promise ? void 0 : Promise.prototype.then,
      "%Promise_all%": "undefined" == typeof Promise ? void 0 : Promise.all,
      "%Promise_reject%": "undefined" == typeof Promise ? void 0 : Promise.reject,
      "%Promise_resolve%": "undefined" == typeof Promise ? void 0 : Promise.resolve,
      "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
      "%RangeError%": RangeError,
      "%RangeErrorPrototype%": RangeError.prototype,
      "%ReferenceError%": ReferenceError,
      "%ReferenceErrorPrototype%": ReferenceError.prototype,
      "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
      "%RegExp%": RegExp,
      "%RegExpPrototype%": RegExp.prototype,
      "%Set%": "undefined" == typeof Set ? void 0 : Set,
      "%SetIteratorPrototype%": "undefined" != typeof Set && u ? l(new Set()[Symbol.iterator]()) : void 0,
      "%SetPrototype%": "undefined" == typeof Set ? void 0 : Set.prototype,
      "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
      "%SharedArrayBufferPrototype%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer.prototype,
      "%String%": String,
      "%StringIteratorPrototype%": u ? l(""[Symbol.iterator]()) : void 0,
      "%StringPrototype%": String.prototype,
      "%Symbol%": u ? Symbol : void 0,
      "%SymbolPrototype%": u ? Symbol.prototype : void 0,
      "%SyntaxError%": SyntaxError,
      "%SyntaxErrorPrototype%": SyntaxError.prototype,
      "%ThrowTypeError%": i,
      "%TypedArray%": c,
      "%TypedArrayPrototype%": c ? c.prototype : void 0,
      "%TypeError%": r,
      "%TypeErrorPrototype%": r.prototype,
      "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
      "%Uint8ArrayPrototype%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array.prototype,
      "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
      "%Uint8ClampedArrayPrototype%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray.prototype,
      "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
      "%Uint16ArrayPrototype%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array.prototype,
      "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
      "%Uint32ArrayPrototype%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array.prototype,
      "%URIError%": URIError,
      "%URIErrorPrototype%": URIError.prototype,
      "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
      "%WeakMapPrototype%": "undefined" == typeof WeakMap ? void 0 : WeakMap.prototype,
      "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet,
      "%WeakSetPrototype%": "undefined" == typeof WeakSet ? void 0 : WeakSet.prototype
    },
        p = n(31).call(Function.call, String.prototype.replace),
        h = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
        d = /\\(\\)?/g,
        y = function y(e) {
      var t = [];
      return p(e, h, function (e, n, r, a) {
        t[t.length] = r ? p(a, d, "$1") : n || e;
      }), t;
    },
        m = function m(e, t) {
      if (!(e in f)) throw new SyntaxError("intrinsic " + e + " does not exist!");
      if (void 0 === f[e] && !t) throw new r("intrinsic " + e + " exists, but is not available. Please file an issue!");
      return f[e];
    };

    e.exports = function (e, t) {
      if ("string" != typeof e || 0 === e.length) throw new TypeError("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" != typeof t) throw new TypeError('"allowMissing" argument must be a boolean');

      for (var n = y(e), o = m("%" + (n.length > 0 ? n[0] : "") + "%", t), i = 1; i < n.length; i += 1) {
        if (null != o) if (a && i + 1 >= n.length) {
          var u = a(o, n[i]);
          if (!t && !(n[i] in o)) throw new r("base intrinsic for " + e + " exists, but the property is not available.");
          o = u ? u.get || u.value : o[n[i]];
        } else o = o[n[i]];
      }

      return o;
    };
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      var r = t.Symbol,
          a = n(70);

      e.exports = function () {
        return "function" == typeof r && "function" == typeof Symbol && "symbol" == _typeof(r("foo")) && "symbol" == _typeof(Symbol("bar")) && a();
      };
    }).call(this, n(13));
  }, function (e, t, n) {
    "use strict";

    e.exports = function () {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" == _typeof(Symbol.iterator)) return !0;
      var e = {},
          t = Symbol("test"),
          n = Object(t);
      if ("string" == typeof t) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(n)) return !1;

      for (t in e[t] = 42, e) {
        return !1;
      }

      if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
      if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
      var r = Object.getOwnPropertySymbols(e);
      if (1 !== r.length || r[0] !== t) return !1;
      if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;

      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var a = Object.getOwnPropertyDescriptor(e, t);
        if (42 !== a.value || !0 !== a.enumerable) return !1;
      }

      return !0;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(32).supportsDescriptors,
        a = n(39),
        o = Object.getOwnPropertyDescriptor,
        i = Object.defineProperty,
        u = TypeError,
        l = Object.getPrototypeOf,
        s = /a/;

    e.exports = function () {
      if (!r || !l) throw new u("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
      var e = a(),
          t = l(s),
          n = o(t, "flags");
      return n && n.get === e || i(t, "flags", {
        configurable: !0,
        enumerable: !1,
        get: e
      }), e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = Date.prototype.getDay,
        a = Object.prototype.toString,
        o = "function" == typeof Symbol && "symbol" == _typeof(Symbol.toStringTag);

    e.exports = function (e) {
      return "object" == _typeof(e) && null !== e && (o ? function (e) {
        try {
          return r.call(e), !0;
        } catch (e) {
          return !1;
        }
      }(e) : "[object Date]" === a.call(e));
    };
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    };
  }, function (e, t) {
    function n(t, r) {
      return e.exports = n = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, n(t, r);
    }

    e.exports = n;
  }, function (e, t) {
    function n(t) {
      return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? e.exports = n = function n(e) {
        return _typeof(e);
      } : e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, n(t);
    }

    e.exports = n;
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "Chart", function () {
      return _;
    }), n.d(t, "Plot", function () {
      return yv;
    }), n.d(t, "XAxis", function () {
      return wv;
    }), n.d(t, "YAxis", function () {
      return jv;
    }), n.d(t, "XGridLines", function () {
      return Av;
    }), n.d(t, "YGridLines", function () {
      return Cv;
    }), n.d(t, "Legend", function () {
      return Yv;
    }), n.d(t, "BarVertical", function () {
      return ab;
    }), n.d(t, "BarHorizontal", function () {
      return ib;
    }), n.d(t, "Area", function () {
      return _b;
    }), n.d(t, "Line", function () {
      return xb;
    }), n.d(t, "Pie", function () {
      return Ob;
    }), n.d(t, "NPS", function () {
      return Pb;
    });
    var r = {};
    n.r(r), n.d(r, "arc", function () {
      return gi;
    }), n.d(r, "area", function () {
      return Si;
    }), n.d(r, "line", function () {
      return ji;
    }), n.d(r, "pie", function () {
      return Ci;
    }), n.d(r, "areaRadial", function () {
      return Vi;
    }), n.d(r, "radialArea", function () {
      return Vi;
    }), n.d(r, "lineRadial", function () {
      return qi;
    }), n.d(r, "radialLine", function () {
      return qi;
    }), n.d(r, "pointRadial", function () {
      return zi;
    }), n.d(r, "linkHorizontal", function () {
      return Gi;
    }), n.d(r, "linkVertical", function () {
      return $i;
    }), n.d(r, "linkRadial", function () {
      return Zi;
    }), n.d(r, "symbol", function () {
      return du;
    }), n.d(r, "symbols", function () {
      return hu;
    }), n.d(r, "symbolCircle", function () {
      return Ji;
    }), n.d(r, "symbolCross", function () {
      return Qi;
    }), n.d(r, "symbolDiamond", function () {
      return tu;
    }), n.d(r, "symbolSquare", function () {
      return iu;
    }), n.d(r, "symbolStar", function () {
      return ou;
    }), n.d(r, "symbolTriangle", function () {
      return lu;
    }), n.d(r, "symbolWye", function () {
      return pu;
    }), n.d(r, "curveBasisClosed", function () {
      return _u;
    }), n.d(r, "curveBasisOpen", function () {
      return Ou;
    }), n.d(r, "curveBasis", function () {
      return vu;
    }), n.d(r, "curveBundle", function () {
      return Tu;
    }), n.d(r, "curveCardinalClosed", function () {
      return ju;
    }), n.d(r, "curveCardinalOpen", function () {
      return Au;
    }), n.d(r, "curveCardinal", function () {
      return Eu;
    }), n.d(r, "curveCatmullRomClosed", function () {
      return Lu;
    }), n.d(r, "curveCatmullRomOpen", function () {
      return qu;
    }), n.d(r, "curveCatmullRom", function () {
      return Fu;
    }), n.d(r, "curveLinearClosed", function () {
      return zu;
    }), n.d(r, "curveLinear", function () {
      return Mi;
    }), n.d(r, "curveMonotoneX", function () {
      return Gu;
    }), n.d(r, "curveMonotoneY", function () {
      return $u;
    }), n.d(r, "curveNatural", function () {
      return Qu;
    }), n.d(r, "curveStep", function () {
      return el;
    }), n.d(r, "curveStepAfter", function () {
      return nl;
    }), n.d(r, "curveStepBefore", function () {
      return tl;
    }), n.d(r, "stack", function () {
      return il;
    }), n.d(r, "stackOffsetExpand", function () {
      return ul;
    }), n.d(r, "stackOffsetDiverging", function () {
      return ll;
    }), n.d(r, "stackOffsetNone", function () {
      return rl;
    }), n.d(r, "stackOffsetSilhouette", function () {
      return sl;
    }), n.d(r, "stackOffsetWiggle", function () {
      return cl;
    }), n.d(r, "stackOrderAppearance", function () {
      return fl;
    }), n.d(r, "stackOrderAscending", function () {
      return hl;
    }), n.d(r, "stackOrderDescending", function () {
      return yl;
    }), n.d(r, "stackOrderInsideOut", function () {
      return ml;
    }), n.d(r, "stackOrderNone", function () {
      return al;
    }), n.d(r, "stackOrderReverse", function () {
      return gl;
    });

    var a = n(2),
        o = n.n(a),
        i = n(7),
        u = n.n(i),
        l = n(3),
        s = n.n(l),
        c = n(1),
        f = n.n(c),
        p = n(0),
        h = n.n(p),
        d = n(4),
        y = n.n(d),
        m = n(5),
        g = n.n(m),
        v = function v(e, t, n, r, a, o, i, u) {
      var l = 20,
          s = 8,
          c = 24,
          f = Math.floor(7 * e.y),
          p = Math.floor(7 * e.x),
          h = .3 * u;
      return l += f = f > h ? h : f, c += n ? 28 : 0, l += r ? 24 : 0, c += t ? 48 : 0, {
        bottom: c -= a ? 20 : 0,
        left: l -= o ? f + 30 : 0,
        top: 8,
        right: s += "barhorizontal" != i || t ? 0 : p / 2
      };
    },
        b = (n(52), function (e) {
      var t = e.children,
          n = e.className,
          r = e.title,
          a = e.subTitle,
          i = s()(e, ["children", "className", "title", "subTitle"]),
          l = Object(c.useState)(20),
          p = u()(l, 2),
          h = p[0],
          d = p[1],
          m = function m(e) {
        d(e);
      },
          v = !1,
          b = "top",
          _ = f.a.Children.map(t, function (e) {
        if (e) {
          var t = e.props.placement,
              n = "Legend" === e.type.displayName;
          return n && (v = !0, b = t), Object(c.cloneElement)(e, {
            key: g()(),
            hasLegend: n,
            legendPlacement: n ? b : "top",
            getMarginForParent: m,
            marginLeft: n && "right" !== b ? h : null
          });
        }
      }),
          x = y()("wds-chart", {
        "wds-chart--has-legend": v
      }, o()({}, "wds-chart--has-legend-".concat(b), v), n);

      return f.a.createElement("div", Object.assign({
        className: x
      }, i), r && f.a.createElement("div", {
        className: "wds-chart__title"
      }, r), a && f.a.createElement("div", {
        className: "wds-chart__subtitle"
      }, a), _);
    });

    b.displayName = "Chart", b.propTypes = {
      children: h.a.node.isRequired,
      className: h.a.string,
      title: h.a.node,
      subTitle: h.a.node
    }, b.defaultProps = {
      title: null,
      subTitle: null,
      className: null
    }, b.__docgenInfo = {
      description: "@param children\n@param className\n@param title\n@param subTitle\n@param props\n@returns {*}",
      methods: [],
      displayName: "Chart",
      props: {
        title: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        subTitle: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        className: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: ""
        }
      }
    };

    var _ = b,
        x = n(23),
        O = function O(e) {
      return function () {
        return e;
      };
    };

    function w(e) {
      return e[0];
    }

    function T(e) {
      return e[1];
    }

    function k() {
      this._ = null;
    }

    function M(e) {
      e.U = e.C = e.L = e.R = e.P = e.N = null;
    }

    function E(e, t) {
      var n = t,
          r = t.R,
          a = n.U;
      a ? a.L === n ? a.L = r : a.R = r : e._ = r, r.U = a, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
    }

    function P(e, t) {
      var n = t,
          r = t.L,
          a = n.U;
      a ? a.L === n ? a.L = r : a.R = r : e._ = r, r.U = a, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
    }

    function j(e) {
      for (; e.L;) {
        e = e.L;
      }

      return e;
    }

    k.prototype = {
      constructor: k,
      insert: function insert(e, t) {
        var n, r, a;

        if (e) {
          if (t.P = e, t.N = e.N, e.N && (e.N.P = t), e.N = t, e.R) {
            for (e = e.R; e.L;) {
              e = e.L;
            }

            e.L = t;
          } else e.R = t;

          n = e;
        } else this._ ? (e = j(this._), t.P = null, t.N = e, e.P = e.L = t, n = e) : (t.P = t.N = null, this._ = t, n = null);

        for (t.L = t.R = null, t.U = n, t.C = !0, e = t; n && n.C;) {
          n === (r = n.U).L ? (a = r.R) && a.C ? (n.C = a.C = !1, r.C = !0, e = r) : (e === n.R && (E(this, n), n = (e = n).U), n.C = !1, r.C = !0, P(this, r)) : (a = r.L) && a.C ? (n.C = a.C = !1, r.C = !0, e = r) : (e === n.L && (P(this, n), n = (e = n).U), n.C = !1, r.C = !0, E(this, r)), n = e.U;
        }

        this._.C = !1;
      },
      remove: function remove(e) {
        e.N && (e.N.P = e.P), e.P && (e.P.N = e.N), e.N = e.P = null;
        var t,
            n,
            r,
            a = e.U,
            o = e.L,
            i = e.R;
        if (n = o ? i ? j(i) : o : i, a ? a.L === e ? a.L = n : a.R = n : this._ = n, o && i ? (r = n.C, n.C = e.C, n.L = o, o.U = n, n !== i ? (a = n.U, n.U = e.U, e = n.R, a.L = e, n.R = i, i.U = n) : (n.U = a, a = n, e = n.R)) : (r = e.C, e = n), e && (e.U = a), !r) if (e && e.C) e.C = !1;else {
          do {
            if (e === this._) break;

            if (e === a.L) {
              if ((t = a.R).C && (t.C = !1, a.C = !0, E(this, a), t = a.R), t.L && t.L.C || t.R && t.R.C) {
                t.R && t.R.C || (t.L.C = !1, t.C = !0, P(this, t), t = a.R), t.C = a.C, a.C = t.R.C = !1, E(this, a), e = this._;
                break;
              }
            } else if ((t = a.L).C && (t.C = !1, a.C = !0, P(this, a), t = a.L), t.L && t.L.C || t.R && t.R.C) {
              t.L && t.L.C || (t.R.C = !1, t.C = !0, E(this, t), t = a.L), t.C = a.C, a.C = t.L.C = !1, P(this, a), e = this._;
              break;
            }

            t.C = !0, e = a, a = a.U;
          } while (!e.C);

          e && (e.C = !1);
        }
      }
    };
    var S = k;

    function A(e, t, n, r) {
      var a = [null, null],
          o = te.push(a) - 1;
      return a.left = e, a.right = t, n && C(a, e, t, n), r && C(a, t, e, r), K[e.index].halfedges.push(o), K[t.index].halfedges.push(o), a;
    }

    function N(e, t, n) {
      var r = [t, n];
      return r.left = e, r;
    }

    function C(e, t, n, r) {
      e[0] || e[1] ? e.left === n ? e[1] = r : e[0] = r : (e[0] = r, e.left = t, e.right = n);
    }

    function F(e, t, n, r, a) {
      var o,
          i = e[0],
          u = e[1],
          l = i[0],
          s = i[1],
          c = 0,
          f = 1,
          p = u[0] - l,
          h = u[1] - s;

      if (o = t - l, p || !(o > 0)) {
        if (o /= p, p < 0) {
          if (o < c) return;
          o < f && (f = o);
        } else if (p > 0) {
          if (o > f) return;
          o > c && (c = o);
        }

        if (o = r - l, p || !(o < 0)) {
          if (o /= p, p < 0) {
            if (o > f) return;
            o > c && (c = o);
          } else if (p > 0) {
            if (o < c) return;
            o < f && (f = o);
          }

          if (o = n - s, h || !(o > 0)) {
            if (o /= h, h < 0) {
              if (o < c) return;
              o < f && (f = o);
            } else if (h > 0) {
              if (o > f) return;
              o > c && (c = o);
            }

            if (o = a - s, h || !(o < 0)) {
              if (o /= h, h < 0) {
                if (o > f) return;
                o > c && (c = o);
              } else if (h > 0) {
                if (o < c) return;
                o < f && (f = o);
              }

              return !(c > 0 || f < 1) || (c > 0 && (e[0] = [l + c * p, s + c * h]), f < 1 && (e[1] = [l + f * p, s + f * h]), !0);
            }
          }
        }
      }
    }

    function R(e, t, n, r, a) {
      var o = e[1];
      if (o) return !0;
      var i,
          u,
          l = e[0],
          s = e.left,
          c = e.right,
          f = s[0],
          p = s[1],
          h = c[0],
          d = c[1],
          y = (f + h) / 2,
          m = (p + d) / 2;

      if (d === p) {
        if (y < t || y >= r) return;

        if (f > h) {
          if (l) {
            if (l[1] >= a) return;
          } else l = [y, n];

          o = [y, a];
        } else {
          if (l) {
            if (l[1] < n) return;
          } else l = [y, a];

          o = [y, n];
        }
      } else if (u = m - (i = (f - h) / (d - p)) * y, i < -1 || i > 1) {
        if (f > h) {
          if (l) {
            if (l[1] >= a) return;
          } else l = [(n - u) / i, n];

          o = [(a - u) / i, a];
        } else {
          if (l) {
            if (l[1] < n) return;
          } else l = [(a - u) / i, a];

          o = [(n - u) / i, n];
        }
      } else if (p < d) {
        if (l) {
          if (l[0] >= r) return;
        } else l = [t, i * t + u];

        o = [r, i * r + u];
      } else {
        if (l) {
          if (l[0] < t) return;
        } else l = [r, i * r + u];

        o = [t, i * t + u];
      }

      return e[0] = l, e[1] = o, !0;
    }

    function L(e, t) {
      var n = e.site,
          r = t.left,
          a = t.right;
      return n === a && (a = r, r = n), a ? Math.atan2(a[1] - r[1], a[0] - r[0]) : (n === r ? (r = t[1], a = t[0]) : (r = t[0], a = t[1]), Math.atan2(r[0] - a[0], a[1] - r[1]));
    }

    function D(e, t) {
      return t[+(t.left !== e.site)];
    }

    function q(e, t) {
      return t[+(t.left === e.site)];
    }

    var V,
        z = [];

    function I() {
      M(this), this.x = this.y = this.arc = this.site = this.cy = null;
    }

    function H(e) {
      var t = e.P,
          n = e.N;

      if (t && n) {
        var r = t.site,
            a = e.site,
            o = n.site;

        if (r !== o) {
          var i = a[0],
              u = a[1],
              l = r[0] - i,
              s = r[1] - u,
              c = o[0] - i,
              f = o[1] - u,
              p = 2 * (l * f - s * c);

          if (!(p >= -re)) {
            var h = l * l + s * s,
                d = c * c + f * f,
                y = (f * h - s * d) / p,
                m = (l * d - c * h) / p,
                g = z.pop() || new I();
            g.arc = e, g.site = a, g.x = y + i, g.y = (g.cy = m + u) + Math.sqrt(y * y + m * m), e.circle = g;

            for (var v = null, b = ee._; b;) {
              if (g.y < b.y || g.y === b.y && g.x <= b.x) {
                if (!b.L) {
                  v = b.P;
                  break;
                }

                b = b.L;
              } else {
                if (!b.R) {
                  v = b;
                  break;
                }

                b = b.R;
              }
            }

            ee.insert(v, g), v || (V = g);
          }
        }
      }
    }

    function B(e) {
      var t = e.circle;
      t && (t.P || (V = t.N), ee.remove(t), z.push(t), M(t), e.circle = null);
    }

    var U = [];

    function W() {
      M(this), this.edge = this.site = this.circle = null;
    }

    function Y(e) {
      var t = U.pop() || new W();
      return t.site = e, t;
    }

    function X(e) {
      B(e), Q.remove(e), U.push(e), M(e);
    }

    function G(e) {
      var t = e.circle,
          n = t.x,
          r = t.cy,
          a = [n, r],
          o = e.P,
          i = e.N,
          u = [e];
      X(e);

      for (var l = o; l.circle && Math.abs(n - l.circle.x) < ne && Math.abs(r - l.circle.cy) < ne;) {
        o = l.P, u.unshift(l), X(l), l = o;
      }

      u.unshift(l), B(l);

      for (var s = i; s.circle && Math.abs(n - s.circle.x) < ne && Math.abs(r - s.circle.cy) < ne;) {
        i = s.N, u.push(s), X(s), s = i;
      }

      u.push(s), B(s);
      var c,
          f = u.length;

      for (c = 1; c < f; ++c) {
        s = u[c], l = u[c - 1], C(s.edge, l.site, s.site, a);
      }

      l = u[0], (s = u[f - 1]).edge = A(l.site, s.site, null, a), H(l), H(s);
    }

    function $(e) {
      for (var t, n, r, a, o = e[0], i = e[1], u = Q._; u;) {
        if ((r = Z(u, i) - o) > ne) u = u.L;else {
          if (!((a = o - J(u, i)) > ne)) {
            r > -ne ? (t = u.P, n = u) : a > -ne ? (t = u, n = u.N) : t = n = u;
            break;
          }

          if (!u.R) {
            t = u;
            break;
          }

          u = u.R;
        }
      }

      !function (e) {
        K[e.index] = {
          site: e,
          halfedges: []
        };
      }(e);
      var l = Y(e);

      if (Q.insert(t, l), t || n) {
        if (t === n) return B(t), n = Y(t.site), Q.insert(l, n), l.edge = n.edge = A(t.site, l.site), H(t), void H(n);

        if (n) {
          B(t), B(n);
          var s = t.site,
              c = s[0],
              f = s[1],
              p = e[0] - c,
              h = e[1] - f,
              d = n.site,
              y = d[0] - c,
              m = d[1] - f,
              g = 2 * (p * m - h * y),
              v = p * p + h * h,
              b = y * y + m * m,
              _ = [(m * v - h * b) / g + c, (p * b - y * v) / g + f];
          C(n.edge, s, d, _), l.edge = A(s, e, null, _), n.edge = A(e, d, null, _), H(t), H(n);
        } else l.edge = A(t.site, l.site);
      }
    }

    function Z(e, t) {
      var n = e.site,
          r = n[0],
          a = n[1],
          o = a - t;
      if (!o) return r;
      var i = e.P;
      if (!i) return -1 / 0;
      var u = (n = i.site)[0],
          l = n[1],
          s = l - t;
      if (!s) return u;
      var c = u - r,
          f = 1 / o - 1 / s,
          p = c / s;
      return f ? (-p + Math.sqrt(p * p - 2 * f * (c * c / (-2 * s) - l + s / 2 + a - o / 2))) / f + r : (r + u) / 2;
    }

    function J(e, t) {
      var n = e.N;
      if (n) return Z(n, t);
      var r = e.site;
      return r[1] === t ? r[0] : 1 / 0;
    }

    var Q,
        K,
        ee,
        te,
        ne = 1e-6,
        re = 1e-12;

    function ae(e, t) {
      return t[1] - e[1] || t[0] - e[0];
    }

    function oe(e, t) {
      var n,
          r,
          a,
          o = e.sort(ae).pop();

      for (te = [], K = new Array(e.length), Q = new S(), ee = new S();;) {
        if (a = V, o && (!a || o[1] < a.y || o[1] === a.y && o[0] < a.x)) o[0] === n && o[1] === r || ($(o), n = o[0], r = o[1]), o = e.pop();else {
          if (!a) break;
          G(a.arc);
        }
      }

      if (function () {
        for (var e, t, n, r, a = 0, o = K.length; a < o; ++a) {
          if ((e = K[a]) && (r = (t = e.halfedges).length)) {
            var i = new Array(r),
                u = new Array(r);

            for (n = 0; n < r; ++n) {
              i[n] = n, u[n] = L(e, te[t[n]]);
            }

            for (i.sort(function (e, t) {
              return u[t] - u[e];
            }), n = 0; n < r; ++n) {
              u[n] = t[i[n]];
            }

            for (n = 0; n < r; ++n) {
              t[n] = u[n];
            }
          }
        }
      }(), t) {
        var i = +t[0][0],
            u = +t[0][1],
            l = +t[1][0],
            s = +t[1][1];
        !function (e, t, n, r) {
          for (var a, o = te.length; o--;) {
            R(a = te[o], e, t, n, r) && F(a, e, t, n, r) && (Math.abs(a[0][0] - a[1][0]) > ne || Math.abs(a[0][1] - a[1][1]) > ne) || delete te[o];
          }
        }(i, u, l, s), function (e, t, n, r) {
          var a,
              o,
              i,
              u,
              l,
              s,
              c,
              f,
              p,
              h,
              d,
              y,
              m = K.length,
              g = !0;

          for (a = 0; a < m; ++a) {
            if (o = K[a]) {
              for (i = o.site, u = (l = o.halfedges).length; u--;) {
                te[l[u]] || l.splice(u, 1);
              }

              for (u = 0, s = l.length; u < s;) {
                d = (h = q(o, te[l[u]]))[0], y = h[1], f = (c = D(o, te[l[++u % s]]))[0], p = c[1], (Math.abs(d - f) > ne || Math.abs(y - p) > ne) && (l.splice(u, 0, te.push(N(i, h, Math.abs(d - e) < ne && r - y > ne ? [e, Math.abs(f - e) < ne ? p : r] : Math.abs(y - r) < ne && n - d > ne ? [Math.abs(p - r) < ne ? f : n, r] : Math.abs(d - n) < ne && y - t > ne ? [n, Math.abs(f - n) < ne ? p : t] : Math.abs(y - t) < ne && d - e > ne ? [Math.abs(p - t) < ne ? f : e, t] : null)) - 1), ++s);
              }

              s && (g = !1);
            }
          }

          if (g) {
            var v,
                b,
                _,
                x = 1 / 0;

            for (a = 0, g = null; a < m; ++a) {
              (o = K[a]) && (_ = (v = (i = o.site)[0] - e) * v + (b = i[1] - t) * b) < x && (x = _, g = o);
            }

            if (g) {
              var O = [e, t],
                  w = [e, r],
                  T = [n, r],
                  k = [n, t];
              g.halfedges.push(te.push(N(i = g.site, O, w)) - 1, te.push(N(i, w, T)) - 1, te.push(N(i, T, k)) - 1, te.push(N(i, k, O)) - 1);
            }
          }

          for (a = 0; a < m; ++a) {
            (o = K[a]) && (o.halfedges.length || delete K[a]);
          }
        }(i, u, l, s);
      }

      this.edges = te, this.cells = K, Q = ee = te = K = null;
    }

    oe.prototype = {
      constructor: oe,
      polygons: function polygons() {
        var e = this.edges;
        return this.cells.map(function (t) {
          var n = t.halfedges.map(function (n) {
            return D(t, e[n]);
          });
          return n.data = t.site.data, n;
        });
      },
      triangles: function triangles() {
        var e = [],
            t = this.edges;
        return this.cells.forEach(function (n, r) {
          if (o = (a = n.halfedges).length) for (var a, o, i, u, l, s, c = n.site, f = -1, p = t[a[o - 1]], h = p.left === c ? p.right : p.left; ++f < o;) {
            i = h, h = (p = t[a[f]]).left === c ? p.right : p.left, i && h && r < i.index && r < h.index && (l = i, s = h, ((u = c)[0] - s[0]) * (l[1] - u[1]) - (u[0] - l[0]) * (s[1] - u[1]) < 0) && e.push([c.data, i.data, h.data]);
          }
        }), e;
      },
      links: function links() {
        return this.edges.filter(function (e) {
          return e.right;
        }).map(function (e) {
          return {
            source: e.left.data,
            target: e.right.data
          };
        });
      },
      find: function find(e, t, n) {
        for (var r, a, o = this, i = o._found || 0, u = o.cells.length; !(a = o.cells[i]);) {
          if (++i >= u) return null;
        }

        var l = e - a.site[0],
            s = t - a.site[1],
            c = l * l + s * s;

        do {
          a = o.cells[r = i], i = null, a.halfedges.forEach(function (n) {
            var r = o.edges[n],
                u = r.left;

            if (u !== a.site && u || (u = r.right)) {
              var l = e - u[0],
                  s = t - u[1],
                  f = l * l + s * s;
              f < c && (c = f, i = u.index);
            }
          });
        } while (null !== i);

        return o._found = r, null == n || c <= n * n ? a.site : null;
      }
    };

    var ie = function ie() {
      var e = w,
          t = T,
          n = null;

      function r(r) {
        return new oe(r.map(function (n, a) {
          var o = [Math.round(e(n, a, r) / ne) * ne, Math.round(t(n, a, r) / ne) * ne];
          return o.index = a, o.data = n, o;
        }), n);
      }

      return r.polygons = function (e) {
        return r(e).polygons();
      }, r.links = function (e) {
        return r(e).links();
      }, r.triangles = function (e) {
        return r(e).triangles();
      }, r.x = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : O(+t), r) : e;
      }, r.y = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : O(+e), r) : t;
      }, r.extent = function (e) {
        return arguments.length ? (n = null == e ? null : [[+e[0][0], +e[0][1]], [+e[1][0], +e[1][1]]], r) : n && [[n[0][0], n[0][1]], [n[1][0], n[1][1]]];
      }, r.size = function (e) {
        return arguments.length ? (n = null == e ? null : [[0, 0], [+e[0], +e[1]]], r) : n && [n[1][0] - n[0][0], n[1][1] - n[0][1]];
      }, r;
    },
        ue = function ue(e, t, n) {
      e.prototype = t.prototype = n, n.constructor = e;
    };

    function le(e, t) {
      var n = Object.create(e.prototype);

      for (var r in t) {
        n[r] = t[r];
      }

      return n;
    }

    function se() {}

    var ce = "\\s*([+-]?\\d+)\\s*",
        fe = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        pe = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        he = /^#([0-9a-f]{3,8})$/,
        de = new RegExp("^rgb\\(" + [ce, ce, ce] + "\\)$"),
        ye = new RegExp("^rgb\\(" + [pe, pe, pe] + "\\)$"),
        me = new RegExp("^rgba\\(" + [ce, ce, ce, fe] + "\\)$"),
        ge = new RegExp("^rgba\\(" + [pe, pe, pe, fe] + "\\)$"),
        ve = new RegExp("^hsl\\(" + [fe, pe, pe] + "\\)$"),
        be = new RegExp("^hsla\\(" + [fe, pe, pe, fe] + "\\)$"),
        _e = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };

    function xe() {
      return this.rgb().formatHex();
    }

    function Oe() {
      return this.rgb().formatRgb();
    }

    function we(e) {
      var t, n;
      return e = (e + "").trim().toLowerCase(), (t = he.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), 6 === n ? Te(t) : 3 === n ? new Pe(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | 240 & t, (15 & t) << 4 | 15 & t, 1) : 8 === n ? new Pe(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (255 & t) / 255) : 4 === n ? new Pe(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | 240 & t, ((15 & t) << 4 | 15 & t) / 255) : null) : (t = de.exec(e)) ? new Pe(t[1], t[2], t[3], 1) : (t = ye.exec(e)) ? new Pe(255 * t[1] / 100, 255 * t[2] / 100, 255 * t[3] / 100, 1) : (t = me.exec(e)) ? ke(t[1], t[2], t[3], t[4]) : (t = ge.exec(e)) ? ke(255 * t[1] / 100, 255 * t[2] / 100, 255 * t[3] / 100, t[4]) : (t = ve.exec(e)) ? Ne(t[1], t[2] / 100, t[3] / 100, 1) : (t = be.exec(e)) ? Ne(t[1], t[2] / 100, t[3] / 100, t[4]) : _e.hasOwnProperty(e) ? Te(_e[e]) : "transparent" === e ? new Pe(NaN, NaN, NaN, 0) : null;
    }

    function Te(e) {
      return new Pe(e >> 16 & 255, e >> 8 & 255, 255 & e, 1);
    }

    function ke(e, t, n, r) {
      return r <= 0 && (e = t = n = NaN), new Pe(e, t, n, r);
    }

    function Me(e) {
      return e instanceof se || (e = we(e)), e ? new Pe((e = e.rgb()).r, e.g, e.b, e.opacity) : new Pe();
    }

    function Ee(e, t, n, r) {
      return 1 === arguments.length ? Me(e) : new Pe(e, t, n, null == r ? 1 : r);
    }

    function Pe(e, t, n, r) {
      this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
    }

    function je() {
      return "#" + Ae(this.r) + Ae(this.g) + Ae(this.b);
    }

    function Se() {
      var e = this.opacity;
      return (1 === (e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === e ? ")" : ", " + e + ")");
    }

    function Ae(e) {
      return ((e = Math.max(0, Math.min(255, Math.round(e) || 0))) < 16 ? "0" : "") + e.toString(16);
    }

    function Ne(e, t, n, r) {
      return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Re(e, t, n, r);
    }

    function Ce(e) {
      if (e instanceof Re) return new Re(e.h, e.s, e.l, e.opacity);
      if (e instanceof se || (e = we(e)), !e) return new Re();
      if (e instanceof Re) return e;
      var t = (e = e.rgb()).r / 255,
          n = e.g / 255,
          r = e.b / 255,
          a = Math.min(t, n, r),
          o = Math.max(t, n, r),
          i = NaN,
          u = o - a,
          l = (o + a) / 2;
      return u ? (i = t === o ? (n - r) / u + 6 * (n < r) : n === o ? (r - t) / u + 2 : (t - n) / u + 4, u /= l < .5 ? o + a : 2 - o - a, i *= 60) : u = l > 0 && l < 1 ? 0 : i, new Re(i, u, l, e.opacity);
    }

    function Fe(e, t, n, r) {
      return 1 === arguments.length ? Ce(e) : new Re(e, t, n, null == r ? 1 : r);
    }

    function Re(e, t, n, r) {
      this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
    }

    function Le(e, t, n) {
      return 255 * (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t);
    }

    function De(e, t, n, r, a) {
      var o = e * e,
          i = o * e;
      return ((1 - 3 * e + 3 * o - i) * t + (4 - 6 * o + 3 * i) * n + (1 + 3 * e + 3 * o - 3 * i) * r + i * a) / 6;
    }

    ue(se, we, {
      copy: function copy(e) {
        return Object.assign(new this.constructor(), this, e);
      },
      displayable: function displayable() {
        return this.rgb().displayable();
      },
      hex: xe,
      formatHex: xe,
      formatHsl: function formatHsl() {
        return Ce(this).formatHsl();
      },
      formatRgb: Oe,
      toString: Oe
    }), ue(Pe, Ee, le(se, {
      brighter: function brighter(e) {
        return e = null == e ? 1 / .7 : Math.pow(1 / .7, e), new Pe(this.r * e, this.g * e, this.b * e, this.opacity);
      },
      darker: function darker(e) {
        return e = null == e ? .7 : Math.pow(.7, e), new Pe(this.r * e, this.g * e, this.b * e, this.opacity);
      },
      rgb: function rgb() {
        return this;
      },
      displayable: function displayable() {
        return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
      },
      hex: je,
      formatHex: je,
      formatRgb: Se,
      toString: Se
    })), ue(Re, Fe, le(se, {
      brighter: function brighter(e) {
        return e = null == e ? 1 / .7 : Math.pow(1 / .7, e), new Re(this.h, this.s, this.l * e, this.opacity);
      },
      darker: function darker(e) {
        return e = null == e ? .7 : Math.pow(.7, e), new Re(this.h, this.s, this.l * e, this.opacity);
      },
      rgb: function rgb() {
        var e = this.h % 360 + 360 * (this.h < 0),
            t = isNaN(e) || isNaN(this.s) ? 0 : this.s,
            n = this.l,
            r = n + (n < .5 ? n : 1 - n) * t,
            a = 2 * n - r;
        return new Pe(Le(e >= 240 ? e - 240 : e + 120, a, r), Le(e, a, r), Le(e < 120 ? e + 240 : e - 120, a, r), this.opacity);
      },
      displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
      },
      formatHsl: function formatHsl() {
        var e = this.opacity;
        return (1 === (e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === e ? ")" : ", " + e + ")");
      }
    }));

    var qe = function qe(e) {
      return function () {
        return e;
      };
    };

    function Ve(e, t) {
      return function (n) {
        return e + n * t;
      };
    }

    function ze(e) {
      return 1 == (e = +e) ? Ie : function (t, n) {
        return n - t ? function (e, t, n) {
          return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function (r) {
            return Math.pow(e + r * t, n);
          };
        }(t, n, e) : qe(isNaN(t) ? n : t);
      };
    }

    function Ie(e, t) {
      var n = t - e;
      return n ? Ve(e, n) : qe(isNaN(e) ? t : e);
    }

    var He = function e(t) {
      var n = ze(t);

      function r(e, t) {
        var r = n((e = Ee(e)).r, (t = Ee(t)).r),
            a = n(e.g, t.g),
            o = n(e.b, t.b),
            i = Ie(e.opacity, t.opacity);
        return function (t) {
          return e.r = r(t), e.g = a(t), e.b = o(t), e.opacity = i(t), e + "";
        };
      }

      return r.gamma = e, r;
    }(1);

    function Be(e) {
      return function (t) {
        var n,
            r,
            a = t.length,
            o = new Array(a),
            i = new Array(a),
            u = new Array(a);

        for (n = 0; n < a; ++n) {
          r = Ee(t[n]), o[n] = r.r || 0, i[n] = r.g || 0, u[n] = r.b || 0;
        }

        return o = e(o), i = e(i), u = e(u), r.opacity = 1, function (e) {
          return r.r = o(e), r.g = i(e), r.b = u(e), r + "";
        };
      };
    }

    Be(function (e) {
      var t = e.length - 1;
      return function (n) {
        var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t),
            a = e[r],
            o = e[r + 1],
            i = r > 0 ? e[r - 1] : 2 * a - o,
            u = r < t - 1 ? e[r + 2] : 2 * o - a;
        return De((n - r / t) * t, i, a, o, u);
      };
    }), Be(function (e) {
      var t = e.length;
      return function (n) {
        var r = Math.floor(((n %= 1) < 0 ? ++n : n) * t),
            a = e[(r + t - 1) % t],
            o = e[r % t],
            i = e[(r + 1) % t],
            u = e[(r + 2) % t];
        return De((n - r / t) * t, a, o, i, u);
      };
    });

    var Ue = function Ue(e, t) {
      t || (t = []);
      var n,
          r = e ? Math.min(t.length, e.length) : 0,
          a = t.slice();
      return function (o) {
        for (n = 0; n < r; ++n) {
          a[n] = e[n] * (1 - o) + t[n] * o;
        }

        return a;
      };
    };

    function We(e) {
      return ArrayBuffer.isView(e) && !(e instanceof DataView);
    }

    function Ye(e, t) {
      var n,
          r = t ? t.length : 0,
          a = e ? Math.min(r, e.length) : 0,
          o = new Array(a),
          i = new Array(r);

      for (n = 0; n < a; ++n) {
        o[n] = Ke(e[n], t[n]);
      }

      for (; n < r; ++n) {
        i[n] = t[n];
      }

      return function (e) {
        for (n = 0; n < a; ++n) {
          i[n] = o[n](e);
        }

        return i;
      };
    }

    var Xe = function Xe(e, t) {
      var n = new Date();
      return e = +e, t = +t, function (r) {
        return n.setTime(e * (1 - r) + t * r), n;
      };
    },
        Ge = function Ge(e, t) {
      return e = +e, t = +t, function (n) {
        return e * (1 - n) + t * n;
      };
    },
        $e = function $e(e, t) {
      var n,
          r = {},
          a = {};

      for (n in null !== e && "object" == _typeof(e) || (e = {}), null !== t && "object" == _typeof(t) || (t = {}), t) {
        n in e ? r[n] = Ke(e[n], t[n]) : a[n] = t[n];
      }

      return function (e) {
        for (n in r) {
          a[n] = r[n](e);
        }

        return a;
      };
    },
        Ze = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        Je = new RegExp(Ze.source, "g");

    var Qe = function Qe(e, t) {
      var n,
          r,
          a,
          o = Ze.lastIndex = Je.lastIndex = 0,
          i = -1,
          u = [],
          l = [];

      for (e += "", t += ""; (n = Ze.exec(e)) && (r = Je.exec(t));) {
        (a = r.index) > o && (a = t.slice(o, a), u[i] ? u[i] += a : u[++i] = a), (n = n[0]) === (r = r[0]) ? u[i] ? u[i] += r : u[++i] = r : (u[++i] = null, l.push({
          i: i,
          x: Ge(n, r)
        })), o = Je.lastIndex;
      }

      return o < t.length && (a = t.slice(o), u[i] ? u[i] += a : u[++i] = a), u.length < 2 ? l[0] ? function (e) {
        return function (t) {
          return e(t) + "";
        };
      }(l[0].x) : function (e) {
        return function () {
          return e;
        };
      }(t) : (t = l.length, function (e) {
        for (var n, r = 0; r < t; ++r) {
          u[(n = l[r]).i] = n.x(e);
        }

        return u.join("");
      });
    },
        Ke = function Ke(e, t) {
      var n,
          r = _typeof(t);

      return null == t || "boolean" === r ? qe(t) : ("number" === r ? Ge : "string" === r ? (n = we(t)) ? (t = n, He) : Qe : t instanceof we ? He : t instanceof Date ? Xe : We(t) ? Ue : Array.isArray(t) ? Ye : "function" != typeof t.valueOf && "function" != typeof t.toString || isNaN(t) ? $e : Ge)(e, t);
    },
        et = n(11),
        tt = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        nt = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    var rt = h.a.oneOfType([h.a.string, h.a.shape({
      stiffness: h.a.number,
      nonAnimatedProps: h.a.arrayOf(h.a.string),
      damping: h.a.number
    }), h.a.bool]),
        at = {
      animatedProps: h.a.arrayOf(h.a.string).isRequired,
      animation: rt,
      onStart: h.a.func,
      onEnd: h.a.func
    };

    function ot(e) {
      var t = e.animatedProps,
          n = function (e, t) {
        var n = {};

        for (var r in e) {
          t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
        }

        return n;
      }(e, ["animatedProps"]);

      return t.reduce(function (e, t) {
        return n.hasOwnProperty(t) && (e[t] = n[t]), e;
      }, {});
    }

    var it = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return n._motionEndHandler = function () {
          n.props.onEnd && n.props.onEnd();
        }, n._renderChildren = function (e) {
          var t = e.i,
              r = n.props.children,
              a = n._interpolator,
              o = f.a.Children.only(r),
              i = a ? a(t) : a,
              u = i && i.data || null;
          return u && o.props._data && (u = u.map(function (e, t) {
            var n = o.props._data[t];
            return nt({}, e, {
              parent: n.parent,
              children: n.children
            });
          })), f.a.cloneElement(o, nt({}, o.props, i, {
            data: u || o.props.data || null,
            _animation: Math.random()
          }));
        }, n._updateInterpolator(e), n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), tt(t, [{
        key: "componentWillUpdate",
        value: function value(e) {
          this._updateInterpolator(this.props, e), e.onStart && e.onStart();
        }
      }, {
        key: "_updateInterpolator",
        value: function value(e, t) {
          this._interpolator = Ke(ot(e), t ? ot(t) : null);
        }
      }, {
        key: "render",
        value: function value() {
          var e = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : et.presets.noWobble;
            if ("string" == typeof e) return et.presets[e] || et.presets.noWobble;
            var t = e.damping,
                n = e.stiffness;
            return nt({
              damping: t || et.presets.noWobble.damping,
              stiffness: n || et.presets.noWobble.stiffness
            }, e);
          }(this.props.animation),
              t = {
            i: Object(et.spring)(1, e)
          },
              n = Math.random();

          return f.a.createElement(et.Motion, nt({
            defaultStyle: {
              i: 0
            },
            style: t,
            key: n
          }, {
            onRest: this._motionEndHandler
          }), this._renderChildren);
        }
      }]), t;
    }(c.PureComponent);

    it.propTypes = at, it.displayName = "Animation";

    var ut = it,
        lt = rt,
        st = function st(e, t) {
      return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
    },
        ct = function ct(e) {
      var t;
      return 1 === e.length && (t = e, e = function e(_e2, n) {
        return st(t(_e2), n);
      }), {
        left: function left(t, n, r, a) {
          for (null == r && (r = 0), null == a && (a = t.length); r < a;) {
            var o = r + a >>> 1;
            e(t[o], n) < 0 ? r = o + 1 : a = o;
          }

          return r;
        },
        right: function right(t, n, r, a) {
          for (null == r && (r = 0), null == a && (a = t.length); r < a;) {
            var o = r + a >>> 1;
            e(t[o], n) > 0 ? a = o : r = o + 1;
          }

          return r;
        }
      };
    };

    var ft = ct(st),
        pt = ft.right,
        ht = (ft.left, pt);

    var dt = function dt(e, t) {
      var n,
          r,
          a,
          o = e.length,
          i = -1;

      if (null == t) {
        for (; ++i < o;) {
          if (null != (n = e[i]) && n >= n) for (r = a = n; ++i < o;) {
            null != (n = e[i]) && (r > n && (r = n), a < n && (a = n));
          }
        }
      } else for (; ++i < o;) {
        if (null != (n = t(e[i], i, e)) && n >= n) for (r = a = n; ++i < o;) {
          null != (n = t(e[i], i, e)) && (r > n && (r = n), a < n && (a = n));
        }
      }

      return [r, a];
    },
        yt = Array.prototype,
        mt = (yt.slice, yt.map, function (e, t, n) {
      e = +e, t = +t, n = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +n;

      for (var r = -1, a = 0 | Math.max(0, Math.ceil((t - e) / n)), o = new Array(a); ++r < a;) {
        o[r] = e + r * n;
      }

      return o;
    }),
        gt = Math.sqrt(50),
        vt = Math.sqrt(10),
        bt = Math.sqrt(2),
        _t = function _t(e, t, n) {
      var r,
          a,
          o,
          i,
          u = -1;
      if (n = +n, (e = +e) === (t = +t) && n > 0) return [e];
      if ((r = t < e) && (a = e, e = t, t = a), 0 === (i = xt(e, t, n)) || !isFinite(i)) return [];
      if (i > 0) for (e = Math.ceil(e / i), t = Math.floor(t / i), o = new Array(a = Math.ceil(t - e + 1)); ++u < a;) {
        o[u] = (e + u) * i;
      } else for (e = Math.floor(e * i), t = Math.ceil(t * i), o = new Array(a = Math.ceil(e - t + 1)); ++u < a;) {
        o[u] = (e - u) / i;
      }
      return r && o.reverse(), o;
    };

    function xt(e, t, n) {
      var r = (t - e) / Math.max(0, n),
          a = Math.floor(Math.log(r) / Math.LN10),
          o = r / Math.pow(10, a);
      return a >= 0 ? (o >= gt ? 10 : o >= vt ? 5 : o >= bt ? 2 : 1) * Math.pow(10, a) : -Math.pow(10, -a) / (o >= gt ? 10 : o >= vt ? 5 : o >= bt ? 2 : 1);
    }

    function Ot(e, t, n) {
      var r = Math.abs(t - e) / Math.max(0, n),
          a = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
          o = r / a;
      return o >= gt ? a *= 10 : o >= vt ? a *= 5 : o >= bt && (a *= 2), t < e ? -a : a;
    }

    var wt = function wt(e) {
      return Math.ceil(Math.log(e.length) / Math.LN2) + 1;
    },
        Tt = function Tt(e, t) {
      var n,
          r,
          a = e.length,
          o = -1;

      if (null == t) {
        for (; ++o < a;) {
          if (null != (n = e[o]) && n >= n) for (r = n; ++o < a;) {
            null != (n = e[o]) && r > n && (r = n);
          }
        }
      } else for (; ++o < a;) {
        if (null != (n = t(e[o], o, e)) && n >= n) for (r = n; ++o < a;) {
          null != (n = t(e[o], o, e)) && r > n && (r = n);
        }
      }

      return r;
    },
        kt = function kt(e, t) {
      var n,
          r = e.length,
          a = -1,
          o = 0;
      if (null == t) for (; ++a < r;) {
        (n = +e[a]) && (o += n);
      } else for (; ++a < r;) {
        (n = +t(e[a], a, e)) && (o += n);
      }
      return o;
    };

    function Mt() {}

    function Et(e, t) {
      var n = new Mt();
      if (e instanceof Mt) e.each(function (e, t) {
        n.set(t, e);
      });else if (Array.isArray(e)) {
        var r,
            a = -1,
            o = e.length;
        if (null == t) for (; ++a < o;) {
          n.set(a, e[a]);
        } else for (; ++a < o;) {
          n.set(t(r = e[a], a, e), r);
        }
      } else if (e) for (var i in e) {
        n.set(i, e[i]);
      }
      return n;
    }

    Mt.prototype = Et.prototype = {
      constructor: Mt,
      has: function has(e) {
        return "$" + e in this;
      },
      get: function get(e) {
        return this["$" + e];
      },
      set: function set(e, t) {
        return this["$" + e] = t, this;
      },
      remove: function remove(e) {
        var t = "$" + e;
        return t in this && delete this[t];
      },
      clear: function clear() {
        for (var e in this) {
          "$" === e[0] && delete this[e];
        }
      },
      keys: function keys() {
        var e = [];

        for (var t in this) {
          "$" === t[0] && e.push(t.slice(1));
        }

        return e;
      },
      values: function values() {
        var e = [];

        for (var t in this) {
          "$" === t[0] && e.push(this[t]);
        }

        return e;
      },
      entries: function entries() {
        var e = [];

        for (var t in this) {
          "$" === t[0] && e.push({
            key: t.slice(1),
            value: this[t]
          });
        }

        return e;
      },
      size: function size() {
        var e = 0;

        for (var t in this) {
          "$" === t[0] && ++e;
        }

        return e;
      },
      empty: function empty() {
        for (var e in this) {
          if ("$" === e[0]) return !1;
        }

        return !0;
      },
      each: function each(e) {
        for (var t in this) {
          "$" === t[0] && e(this[t], t.slice(1), this);
        }
      }
    };

    var Pt = Et,
        jt = function jt() {
      var e,
          t,
          n,
          r = [],
          a = [];

      function o(n, a, i, u) {
        if (a >= r.length) return null != e && n.sort(e), null != t ? t(n) : n;

        for (var l, s, c, f = -1, p = n.length, h = r[a++], d = Pt(), y = i(); ++f < p;) {
          (c = d.get(l = h(s = n[f]) + "")) ? c.push(s) : d.set(l, [s]);
        }

        return d.each(function (e, t) {
          u(y, t, o(e, a, i, u));
        }), y;
      }

      return n = {
        object: function object(e) {
          return o(e, 0, St, At);
        },
        map: function map(e) {
          return o(e, 0, Nt, Ct);
        },
        entries: function entries(e) {
          return function e(n, o) {
            if (++o > r.length) return n;
            var i,
                u = a[o - 1];
            return null != t && o >= r.length ? i = n.entries() : (i = [], n.each(function (t, n) {
              i.push({
                key: n,
                values: e(t, o)
              });
            })), null != u ? i.sort(function (e, t) {
              return u(e.key, t.key);
            }) : i;
          }(o(e, 0, Nt, Ct), 0);
        },
        key: function key(e) {
          return r.push(e), n;
        },
        sortKeys: function sortKeys(e) {
          return a[r.length - 1] = e, n;
        },
        sortValues: function sortValues(t) {
          return e = t, n;
        },
        rollup: function rollup(e) {
          return t = e, n;
        }
      };
    };

    function St() {
      return {};
    }

    function At(e, t, n) {
      e[t] = n;
    }

    function Nt() {
      return Pt();
    }

    function Ct(e, t, n) {
      e.set(t, n);
    }

    function Ft() {}

    var Rt = Pt.prototype;

    function Lt(e, t) {
      var n = new Ft();
      if (e instanceof Ft) e.each(function (e) {
        n.add(e);
      });else if (e) {
        var r = -1,
            a = e.length;
        if (null == t) for (; ++r < a;) {
          n.add(e[r]);
        } else for (; ++r < a;) {
          n.add(t(e[r], r, e));
        }
      }
      return n;
    }

    Ft.prototype = Lt.prototype = {
      constructor: Ft,
      has: Rt.has,
      add: function add(e) {
        return this["$" + (e += "")] = e, this;
      },
      remove: Rt.remove,
      clear: Rt.clear,
      values: Rt.keys,
      size: Rt.size,
      empty: Rt.empty,
      each: Rt.each
    };
    var Dt = Lt,
        qt = Array.prototype,
        Vt = qt.map,
        zt = qt.slice,
        It = {
      name: "implicit"
    };

    function Ht(e) {
      var t = Pt(),
          n = [],
          r = It;

      function a(a) {
        var o = a + "",
            i = t.get(o);

        if (!i) {
          if (r !== It) return r;
          t.set(o, i = n.push(a));
        }

        return e[(i - 1) % e.length];
      }

      return e = null == e ? [] : zt.call(e), a.domain = function (e) {
        if (!arguments.length) return n.slice();
        n = [], t = Pt();

        for (var r, o, i = -1, u = e.length; ++i < u;) {
          t.has(o = (r = e[i]) + "") || t.set(o, n.push(r));
        }

        return a;
      }, a.range = function (t) {
        return arguments.length ? (e = zt.call(t), a) : e.slice();
      }, a.unknown = function (e) {
        return arguments.length ? (r = e, a) : r;
      }, a.copy = function () {
        return Ht().domain(n).range(e).unknown(r);
      }, a;
    }

    var Bt = function Bt(e, t) {
      return e = +e, t = +t, function (n) {
        return Math.round(e * (1 - n) + t * n);
      };
    },
        Ut = function Ut(e) {
      return function () {
        return e;
      };
    },
        Wt = function Wt(e) {
      return +e;
    },
        Yt = [0, 1];

    function Xt(e, t) {
      return (t -= e = +e) ? function (n) {
        return (n - e) / t;
      } : Ut(t);
    }

    function Gt(e, t, n, r) {
      var a = e[0],
          o = e[1],
          i = t[0],
          u = t[1];
      return o < a ? (a = n(o, a), i = r(u, i)) : (a = n(a, o), i = r(i, u)), function (e) {
        return i(a(e));
      };
    }

    function $t(e, t, n, r) {
      var a = Math.min(e.length, t.length) - 1,
          o = new Array(a),
          i = new Array(a),
          u = -1;

      for (e[a] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++u < a;) {
        o[u] = n(e[u], e[u + 1]), i[u] = r(t[u], t[u + 1]);
      }

      return function (t) {
        var n = ht(e, t, 1, a) - 1;
        return i[n](o[n](t));
      };
    }

    function Zt(e, t) {
      return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp());
    }

    function Jt(e, t) {
      var n,
          r,
          a,
          o = Yt,
          i = Yt,
          u = Ke,
          l = !1;

      function s() {
        return n = Math.min(o.length, i.length) > 2 ? $t : Gt, r = a = null, c;
      }

      function c(t) {
        return (r || (r = n(o, i, l ? function (e) {
          return function (t, n) {
            var r = e(t = +t, n = +n);
            return function (e) {
              return e <= t ? 0 : e >= n ? 1 : r(e);
            };
          };
        }(e) : e, u)))(+t);
      }

      return c.invert = function (e) {
        return (a || (a = n(i, o, Xt, l ? function (e) {
          return function (t, n) {
            var r = e(t = +t, n = +n);
            return function (e) {
              return e <= 0 ? t : e >= 1 ? n : r(e);
            };
          };
        }(t) : t)))(+e);
      }, c.domain = function (e) {
        return arguments.length ? (o = Vt.call(e, Wt), s()) : o.slice();
      }, c.range = function (e) {
        return arguments.length ? (i = zt.call(e), s()) : i.slice();
      }, c.rangeRound = function (e) {
        return i = zt.call(e), u = Bt, s();
      }, c.clamp = function (e) {
        return arguments.length ? (l = !!e, s()) : l;
      }, c.interpolate = function (e) {
        return arguments.length ? (u = e, s()) : u;
      }, s();
    }

    var Qt = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

    function Kt(e) {
      if (!(t = Qt.exec(e))) throw new Error("invalid format: " + e);
      var t;
      return new en({
        fill: t[1],
        align: t[2],
        sign: t[3],
        symbol: t[4],
        zero: t[5],
        width: t[6],
        comma: t[7],
        precision: t[8] && t[8].slice(1),
        trim: t[9],
        type: t[10]
      });
    }

    function en(e) {
      this.fill = void 0 === e.fill ? " " : e.fill + "", this.align = void 0 === e.align ? ">" : e.align + "", this.sign = void 0 === e.sign ? "-" : e.sign + "", this.symbol = void 0 === e.symbol ? "" : e.symbol + "", this.zero = !!e.zero, this.width = void 0 === e.width ? void 0 : +e.width, this.comma = !!e.comma, this.precision = void 0 === e.precision ? void 0 : +e.precision, this.trim = !!e.trim, this.type = void 0 === e.type ? "" : e.type + "";
    }

    Kt.prototype = en.prototype, en.prototype.toString = function () {
      return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
    };

    var tn,
        nn,
        rn,
        an,
        on = function on(e, t) {
      if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
      var n,
          r = e.slice(0, n);
      return [r.length > 1 ? r[0] + r.slice(2) : r, +e.slice(n + 1)];
    },
        un = function un(e) {
      return (e = on(Math.abs(e))) ? e[1] : NaN;
    },
        ln = function ln(e, t) {
      var n = on(e, t);
      if (!n) return e + "";
      var r = n[0],
          a = n[1];
      return a < 0 ? "0." + new Array(-a).join("0") + r : r.length > a + 1 ? r.slice(0, a + 1) + "." + r.slice(a + 1) : r + new Array(a - r.length + 2).join("0");
    },
        sn = {
      "%": function _(e, t) {
        return (100 * e).toFixed(t);
      },
      b: function b(e) {
        return Math.round(e).toString(2);
      },
      c: function c(e) {
        return e + "";
      },
      d: function d(e) {
        return Math.round(e).toString(10);
      },
      e: function e(_e3, t) {
        return _e3.toExponential(t);
      },
      f: function f(e, t) {
        return e.toFixed(t);
      },
      g: function g(e, t) {
        return e.toPrecision(t);
      },
      o: function o(e) {
        return Math.round(e).toString(8);
      },
      p: function p(e, t) {
        return ln(100 * e, t);
      },
      r: ln,
      s: function s(e, t) {
        var n = on(e, t);
        if (!n) return e + "";
        var r = n[0],
            a = n[1],
            o = a - (tn = 3 * Math.max(-8, Math.min(8, Math.floor(a / 3)))) + 1,
            i = r.length;
        return o === i ? r : o > i ? r + new Array(o - i + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + on(e, Math.max(0, t + o - 1))[0];
      },
      X: function X(e) {
        return Math.round(e).toString(16).toUpperCase();
      },
      x: function x(e) {
        return Math.round(e).toString(16);
      }
    },
        cn = function cn(e) {
      return e;
    },
        fn = Array.prototype.map,
        pn = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

    nn = function (e) {
      var t,
          n,
          r = void 0 === e.grouping || void 0 === e.thousands ? cn : (t = fn.call(e.grouping, Number), n = e.thousands + "", function (e, r) {
        for (var a = e.length, o = [], i = 0, u = t[0], l = 0; a > 0 && u > 0 && (l + u + 1 > r && (u = Math.max(1, r - l)), o.push(e.substring(a -= u, a + u)), !((l += u + 1) > r));) {
          u = t[i = (i + 1) % t.length];
        }

        return o.reverse().join(n);
      }),
          a = void 0 === e.currency ? "" : e.currency[0] + "",
          o = void 0 === e.currency ? "" : e.currency[1] + "",
          i = void 0 === e.decimal ? "." : e.decimal + "",
          u = void 0 === e.numerals ? cn : function (e) {
        return function (t) {
          return t.replace(/[0-9]/g, function (t) {
            return e[+t];
          });
        };
      }(fn.call(e.numerals, String)),
          l = void 0 === e.percent ? "%" : e.percent + "",
          s = void 0 === e.minus ? "-" : e.minus + "",
          c = void 0 === e.nan ? "NaN" : e.nan + "";

      function f(e) {
        var t = (e = Kt(e)).fill,
            n = e.align,
            f = e.sign,
            p = e.symbol,
            h = e.zero,
            d = e.width,
            y = e.comma,
            m = e.precision,
            g = e.trim,
            v = e.type;
        "n" === v ? (y = !0, v = "g") : sn[v] || (void 0 === m && (m = 12), g = !0, v = "g"), (h || "0" === t && "=" === n) && (h = !0, t = "0", n = "=");

        var b = "$" === p ? a : "#" === p && /[boxX]/.test(v) ? "0" + v.toLowerCase() : "",
            _ = "$" === p ? o : /[%p]/.test(v) ? l : "",
            x = sn[v],
            O = /[defgprs%]/.test(v);

        function w(e) {
          var a,
              o,
              l,
              p = b,
              w = _;
          if ("c" === v) w = x(e) + w, e = "";else {
            var T = (e = +e) < 0;
            if (e = isNaN(e) ? c : x(Math.abs(e), m), g && (e = function (e) {
              e: for (var t, n = e.length, r = 1, a = -1; r < n; ++r) {
                switch (e[r]) {
                  case ".":
                    a = t = r;
                    break;

                  case "0":
                    0 === a && (a = r), t = r;
                    break;

                  default:
                    if (!+e[r]) break e;
                    a > 0 && (a = 0);
                }
              }

              return a > 0 ? e.slice(0, a) + e.slice(t + 1) : e;
            }(e)), T && 0 == +e && (T = !1), p = (T ? "(" === f ? f : s : "-" === f || "(" === f ? "" : f) + p, w = ("s" === v ? pn[8 + tn / 3] : "") + w + (T && "(" === f ? ")" : ""), O) for (a = -1, o = e.length; ++a < o;) {
              if (48 > (l = e.charCodeAt(a)) || l > 57) {
                w = (46 === l ? i + e.slice(a + 1) : e.slice(a)) + w, e = e.slice(0, a);
                break;
              }
            }
          }
          y && !h && (e = r(e, 1 / 0));
          var k = p.length + e.length + w.length,
              M = k < d ? new Array(d - k + 1).join(t) : "";

          switch (y && h && (e = r(M + e, M.length ? d - w.length : 1 / 0), M = ""), n) {
            case "<":
              e = p + e + w + M;
              break;

            case "=":
              e = p + M + e + w;
              break;

            case "^":
              e = M.slice(0, k = M.length >> 1) + p + e + w + M.slice(k);
              break;

            default:
              e = M + p + e + w;
          }

          return u(e);
        }

        return m = void 0 === m ? 6 : /[gprs]/.test(v) ? Math.max(1, Math.min(21, m)) : Math.max(0, Math.min(20, m)), w.toString = function () {
          return e + "";
        }, w;
      }

      return {
        format: f,
        formatPrefix: function formatPrefix(e, t) {
          var n = f(((e = Kt(e)).type = "f", e)),
              r = 3 * Math.max(-8, Math.min(8, Math.floor(un(t) / 3))),
              a = Math.pow(10, -r),
              o = pn[8 + r / 3];
          return function (e) {
            return n(a * e) + o;
          };
        }
      };
    }({
      decimal: ".",
      thousands: ",",
      grouping: [3],
      currency: ["$", ""],
      minus: "-"
    }), rn = nn.format, an = nn.formatPrefix;

    var hn = function hn(e, t, n) {
      var r,
          a = e[0],
          o = e[e.length - 1],
          i = Ot(a, o, null == t ? 10 : t);

      switch ((n = Kt(null == n ? ",f" : n)).type) {
        case "s":
          var u = Math.max(Math.abs(a), Math.abs(o));
          return null != n.precision || isNaN(r = function (e, t) {
            return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(un(t) / 3))) - un(Math.abs(e)));
          }(i, u)) || (n.precision = r), an(n, u);

        case "":
        case "e":
        case "g":
        case "p":
        case "r":
          null != n.precision || isNaN(r = function (e, t) {
            return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, un(t) - un(e)) + 1;
          }(i, Math.max(Math.abs(a), Math.abs(o)))) || (n.precision = r - ("e" === n.type));
          break;

        case "f":
        case "%":
          null != n.precision || isNaN(r = function (e) {
            return Math.max(0, -un(Math.abs(e)));
          }(i)) || (n.precision = r - 2 * ("%" === n.type));
      }

      return rn(n);
    };

    function dn(e) {
      var t = e.domain;
      return e.ticks = function (e) {
        var n = t();
        return _t(n[0], n[n.length - 1], null == e ? 10 : e);
      }, e.tickFormat = function (e, n) {
        return hn(t(), e, n);
      }, e.nice = function (n) {
        null == n && (n = 10);
        var r,
            a = t(),
            o = 0,
            i = a.length - 1,
            u = a[o],
            l = a[i];
        return l < u && (r = u, u = l, l = r, r = o, o = i, i = r), (r = xt(u, l, n)) > 0 ? r = xt(u = Math.floor(u / r) * r, l = Math.ceil(l / r) * r, n) : r < 0 && (r = xt(u = Math.ceil(u * r) / r, l = Math.floor(l * r) / r, n)), r > 0 ? (a[o] = Math.floor(u / r) * r, a[i] = Math.ceil(l / r) * r, t(a)) : r < 0 && (a[o] = Math.ceil(u * r) / r, a[i] = Math.floor(l * r) / r, t(a)), e;
      }, e;
    }

    function yn() {
      var e = Jt(Xt, Ge);
      return e.copy = function () {
        return Zt(e, yn());
      }, dn(e);
    }

    var mn = function mn(e, t) {
      var n,
          r = 0,
          a = (e = e.slice()).length - 1,
          o = e[r],
          i = e[a];
      return i < o && (n = r, r = a, a = n, n = o, o = i, i = n), e[r] = t.floor(o), e[a] = t.ceil(i), e;
    };

    function gn(e, t) {
      return (t = Math.log(t / e)) ? function (n) {
        return Math.log(n / e) / t;
      } : Ut(t);
    }

    function vn(e, t) {
      return e < 0 ? function (n) {
        return -Math.pow(-t, n) * Math.pow(-e, 1 - n);
      } : function (n) {
        return Math.pow(t, n) * Math.pow(e, 1 - n);
      };
    }

    function bn(e) {
      return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
    }

    function _n(e) {
      return 10 === e ? bn : e === Math.E ? Math.exp : function (t) {
        return Math.pow(e, t);
      };
    }

    function xn(e) {
      return e === Math.E ? Math.log : 10 === e && Math.log10 || 2 === e && Math.log2 || (e = Math.log(e), function (t) {
        return Math.log(t) / e;
      });
    }

    function On(e) {
      return function (t) {
        return -e(-t);
      };
    }

    function wn(e, t) {
      return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
    }

    function Tn() {
      return function e() {
        var t = 1,
            n = Jt(function (e, n) {
          return (n = wn(n, t) - (e = wn(e, t))) ? function (r) {
            return (wn(r, t) - e) / n;
          } : Ut(n);
        }, function (e, n) {
          return n = wn(n, t) - (e = wn(e, t)), function (r) {
            return wn(e + n * r, 1 / t);
          };
        }),
            r = n.domain;
        return n.exponent = function (e) {
          return arguments.length ? (t = +e, r(r())) : t;
        }, n.copy = function () {
          return Zt(n, e().exponent(t));
        }, dn(n);
      }().exponent(.5);
    }

    var kn = new Date(),
        Mn = new Date();

    function En(e, t, n, r) {
      function a(t) {
        return e(t = 0 === arguments.length ? new Date() : new Date(+t)), t;
      }

      return a.floor = function (t) {
        return e(t = new Date(+t)), t;
      }, a.ceil = function (n) {
        return e(n = new Date(n - 1)), t(n, 1), e(n), n;
      }, a.round = function (e) {
        var t = a(e),
            n = a.ceil(e);
        return e - t < n - e ? t : n;
      }, a.offset = function (e, n) {
        return t(e = new Date(+e), null == n ? 1 : Math.floor(n)), e;
      }, a.range = function (n, r, o) {
        var i,
            u = [];
        if (n = a.ceil(n), o = null == o ? 1 : Math.floor(o), !(n < r && o > 0)) return u;

        do {
          u.push(i = new Date(+n)), t(n, o), e(n);
        } while (i < n && n < r);

        return u;
      }, a.filter = function (n) {
        return En(function (t) {
          if (t >= t) for (; e(t), !n(t);) {
            t.setTime(t - 1);
          }
        }, function (e, r) {
          if (e >= e) if (r < 0) for (; ++r <= 0;) {
            for (; t(e, -1), !n(e);) {
              ;
            }
          } else for (; --r >= 0;) {
            for (; t(e, 1), !n(e);) {
              ;
            }
          }
        });
      }, n && (a.count = function (t, r) {
        return kn.setTime(+t), Mn.setTime(+r), e(kn), e(Mn), Math.floor(n(kn, Mn));
      }, a.every = function (e) {
        return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? a.filter(r ? function (t) {
          return r(t) % e == 0;
        } : function (t) {
          return a.count(0, t) % e == 0;
        }) : a : null;
      }), a;
    }

    var Pn = En(function (e) {
      e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
    }, function (e, t) {
      e.setFullYear(e.getFullYear() + t);
    }, function (e, t) {
      return t.getFullYear() - e.getFullYear();
    }, function (e) {
      return e.getFullYear();
    });

    Pn.every = function (e) {
      return isFinite(e = Math.floor(e)) && e > 0 ? En(function (t) {
        t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
      }, function (t, n) {
        t.setFullYear(t.getFullYear() + n * e);
      }) : null;
    };

    var jn = Pn,
        Sn = (Pn.range, En(function (e) {
      e.setDate(1), e.setHours(0, 0, 0, 0);
    }, function (e, t) {
      e.setMonth(e.getMonth() + t);
    }, function (e, t) {
      return t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear());
    }, function (e) {
      return e.getMonth();
    })),
        An = Sn;
    Sn.range;

    function Nn(e) {
      return En(function (t) {
        t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
      }, function (e, t) {
        e.setDate(e.getDate() + 7 * t);
      }, function (e, t) {
        return (t - e - 6e4 * (t.getTimezoneOffset() - e.getTimezoneOffset())) / 6048e5;
      });
    }

    var Cn = Nn(0),
        Fn = Nn(1),
        Rn = Nn(2),
        Ln = Nn(3),
        Dn = Nn(4),
        qn = Nn(5),
        Vn = Nn(6),
        zn = (Cn.range, Fn.range, Rn.range, Ln.range, Dn.range, qn.range, Vn.range, En(function (e) {
      e.setHours(0, 0, 0, 0);
    }, function (e, t) {
      e.setDate(e.getDate() + t);
    }, function (e, t) {
      return (t - e - 6e4 * (t.getTimezoneOffset() - e.getTimezoneOffset())) / 864e5;
    }, function (e) {
      return e.getDate() - 1;
    })),
        In = zn,
        Hn = (zn.range, En(function (e) {
      e.setTime(e - e.getMilliseconds() - 1e3 * e.getSeconds() - 6e4 * e.getMinutes());
    }, function (e, t) {
      e.setTime(+e + 36e5 * t);
    }, function (e, t) {
      return (t - e) / 36e5;
    }, function (e) {
      return e.getHours();
    })),
        Bn = Hn,
        Un = (Hn.range, En(function (e) {
      e.setTime(e - e.getMilliseconds() - 1e3 * e.getSeconds());
    }, function (e, t) {
      e.setTime(+e + 6e4 * t);
    }, function (e, t) {
      return (t - e) / 6e4;
    }, function (e) {
      return e.getMinutes();
    })),
        Wn = Un,
        Yn = (Un.range, En(function (e) {
      e.setTime(e - e.getMilliseconds());
    }, function (e, t) {
      e.setTime(+e + 1e3 * t);
    }, function (e, t) {
      return (t - e) / 1e3;
    }, function (e) {
      return e.getUTCSeconds();
    })),
        Xn = Yn,
        Gn = (Yn.range, En(function () {}, function (e, t) {
      e.setTime(+e + t);
    }, function (e, t) {
      return t - e;
    }));

    Gn.every = function (e) {
      return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? En(function (t) {
        t.setTime(Math.floor(t / e) * e);
      }, function (t, n) {
        t.setTime(+t + n * e);
      }, function (t, n) {
        return (n - t) / e;
      }) : Gn : null;
    };

    var $n = Gn;
    Gn.range;

    function Zn(e) {
      return En(function (t) {
        t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
      }, function (e, t) {
        e.setUTCDate(e.getUTCDate() + 7 * t);
      }, function (e, t) {
        return (t - e) / 6048e5;
      });
    }

    var Jn = Zn(0),
        Qn = Zn(1),
        Kn = Zn(2),
        er = Zn(3),
        tr = Zn(4),
        nr = Zn(5),
        rr = Zn(6),
        ar = (Jn.range, Qn.range, Kn.range, er.range, tr.range, nr.range, rr.range, En(function (e) {
      e.setUTCHours(0, 0, 0, 0);
    }, function (e, t) {
      e.setUTCDate(e.getUTCDate() + t);
    }, function (e, t) {
      return (t - e) / 864e5;
    }, function (e) {
      return e.getUTCDate() - 1;
    })),
        or = ar,
        ir = (ar.range, En(function (e) {
      e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
    }, function (e, t) {
      e.setUTCFullYear(e.getUTCFullYear() + t);
    }, function (e, t) {
      return t.getUTCFullYear() - e.getUTCFullYear();
    }, function (e) {
      return e.getUTCFullYear();
    }));

    ir.every = function (e) {
      return isFinite(e = Math.floor(e)) && e > 0 ? En(function (t) {
        t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
      }, function (t, n) {
        t.setUTCFullYear(t.getUTCFullYear() + n * e);
      }) : null;
    };

    var ur = ir;
    ir.range;

    function lr(e) {
      if (0 <= e.y && e.y < 100) {
        var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
        return t.setFullYear(e.y), t;
      }

      return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
    }

    function sr(e) {
      if (0 <= e.y && e.y < 100) {
        var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
        return t.setUTCFullYear(e.y), t;
      }

      return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
    }

    function cr(e, t, n) {
      return {
        y: e,
        m: t,
        d: n,
        H: 0,
        M: 0,
        S: 0,
        L: 0
      };
    }

    var fr,
        pr,
        hr,
        dr = {
      "-": "",
      _: " ",
      0: "0"
    },
        yr = /^\s*\d+/,
        mr = /^%/,
        gr = /[\\^$*+?|[\]().{}]/g;

    function vr(e, t, n) {
      var r = e < 0 ? "-" : "",
          a = (r ? -e : e) + "",
          o = a.length;
      return r + (o < n ? new Array(n - o + 1).join(t) + a : a);
    }

    function br(e) {
      return e.replace(gr, "\\$&");
    }

    function _r(e) {
      return new RegExp("^(?:" + e.map(br).join("|") + ")", "i");
    }

    function xr(e) {
      for (var t = {}, n = -1, r = e.length; ++n < r;) {
        t[e[n].toLowerCase()] = n;
      }

      return t;
    }

    function Or(e, t, n) {
      var r = yr.exec(t.slice(n, n + 1));
      return r ? (e.w = +r[0], n + r[0].length) : -1;
    }

    function wr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 1));
      return r ? (e.u = +r[0], n + r[0].length) : -1;
    }

    function Tr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.U = +r[0], n + r[0].length) : -1;
    }

    function kr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.V = +r[0], n + r[0].length) : -1;
    }

    function Mr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.W = +r[0], n + r[0].length) : -1;
    }

    function Er(e, t, n) {
      var r = yr.exec(t.slice(n, n + 4));
      return r ? (e.y = +r[0], n + r[0].length) : -1;
    }

    function Pr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
    }

    function jr(e, t, n) {
      var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
      return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
    }

    function Sr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 1));
      return r ? (e.q = 3 * r[0] - 3, n + r[0].length) : -1;
    }

    function Ar(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
    }

    function Nr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.d = +r[0], n + r[0].length) : -1;
    }

    function Cr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 3));
      return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
    }

    function Fr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.H = +r[0], n + r[0].length) : -1;
    }

    function Rr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.M = +r[0], n + r[0].length) : -1;
    }

    function Lr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 2));
      return r ? (e.S = +r[0], n + r[0].length) : -1;
    }

    function Dr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 3));
      return r ? (e.L = +r[0], n + r[0].length) : -1;
    }

    function qr(e, t, n) {
      var r = yr.exec(t.slice(n, n + 6));
      return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
    }

    function Vr(e, t, n) {
      var r = mr.exec(t.slice(n, n + 1));
      return r ? n + r[0].length : -1;
    }

    function zr(e, t, n) {
      var r = yr.exec(t.slice(n));
      return r ? (e.Q = +r[0], n + r[0].length) : -1;
    }

    function Ir(e, t, n) {
      var r = yr.exec(t.slice(n));
      return r ? (e.s = +r[0], n + r[0].length) : -1;
    }

    function Hr(e, t) {
      return vr(e.getDate(), t, 2);
    }

    function Br(e, t) {
      return vr(e.getHours(), t, 2);
    }

    function Ur(e, t) {
      return vr(e.getHours() % 12 || 12, t, 2);
    }

    function Wr(e, t) {
      return vr(1 + In.count(jn(e), e), t, 3);
    }

    function Yr(e, t) {
      return vr(e.getMilliseconds(), t, 3);
    }

    function Xr(e, t) {
      return Yr(e, t) + "000";
    }

    function Gr(e, t) {
      return vr(e.getMonth() + 1, t, 2);
    }

    function $r(e, t) {
      return vr(e.getMinutes(), t, 2);
    }

    function Zr(e, t) {
      return vr(e.getSeconds(), t, 2);
    }

    function Jr(e) {
      var t = e.getDay();
      return 0 === t ? 7 : t;
    }

    function Qr(e, t) {
      return vr(Cn.count(jn(e) - 1, e), t, 2);
    }

    function Kr(e, t) {
      var n = e.getDay();
      return e = n >= 4 || 0 === n ? Dn(e) : Dn.ceil(e), vr(Dn.count(jn(e), e) + (4 === jn(e).getDay()), t, 2);
    }

    function ea(e) {
      return e.getDay();
    }

    function ta(e, t) {
      return vr(Fn.count(jn(e) - 1, e), t, 2);
    }

    function na(e, t) {
      return vr(e.getFullYear() % 100, t, 2);
    }

    function ra(e, t) {
      return vr(e.getFullYear() % 1e4, t, 4);
    }

    function aa(e) {
      var t = e.getTimezoneOffset();
      return (t > 0 ? "-" : (t *= -1, "+")) + vr(t / 60 | 0, "0", 2) + vr(t % 60, "0", 2);
    }

    function oa(e, t) {
      return vr(e.getUTCDate(), t, 2);
    }

    function ia(e, t) {
      return vr(e.getUTCHours(), t, 2);
    }

    function ua(e, t) {
      return vr(e.getUTCHours() % 12 || 12, t, 2);
    }

    function la(e, t) {
      return vr(1 + or.count(ur(e), e), t, 3);
    }

    function sa(e, t) {
      return vr(e.getUTCMilliseconds(), t, 3);
    }

    function ca(e, t) {
      return sa(e, t) + "000";
    }

    function fa(e, t) {
      return vr(e.getUTCMonth() + 1, t, 2);
    }

    function pa(e, t) {
      return vr(e.getUTCMinutes(), t, 2);
    }

    function ha(e, t) {
      return vr(e.getUTCSeconds(), t, 2);
    }

    function da(e) {
      var t = e.getUTCDay();
      return 0 === t ? 7 : t;
    }

    function ya(e, t) {
      return vr(Jn.count(ur(e) - 1, e), t, 2);
    }

    function ma(e, t) {
      var n = e.getUTCDay();
      return e = n >= 4 || 0 === n ? tr(e) : tr.ceil(e), vr(tr.count(ur(e), e) + (4 === ur(e).getUTCDay()), t, 2);
    }

    function ga(e) {
      return e.getUTCDay();
    }

    function va(e, t) {
      return vr(Qn.count(ur(e) - 1, e), t, 2);
    }

    function ba(e, t) {
      return vr(e.getUTCFullYear() % 100, t, 2);
    }

    function _a(e, t) {
      return vr(e.getUTCFullYear() % 1e4, t, 4);
    }

    function xa() {
      return "+0000";
    }

    function Oa() {
      return "%";
    }

    function wa(e) {
      return +e;
    }

    function Ta(e) {
      return Math.floor(+e / 1e3);
    }

    !function (e) {
      fr = function (e) {
        var t = e.dateTime,
            n = e.date,
            r = e.time,
            a = e.periods,
            o = e.days,
            i = e.shortDays,
            u = e.months,
            l = e.shortMonths,
            s = _r(a),
            c = xr(a),
            f = _r(o),
            p = xr(o),
            h = _r(i),
            d = xr(i),
            y = _r(u),
            m = xr(u),
            g = _r(l),
            v = xr(l),
            b = {
          a: function a(e) {
            return i[e.getDay()];
          },
          A: function A(e) {
            return o[e.getDay()];
          },
          b: function b(e) {
            return l[e.getMonth()];
          },
          B: function B(e) {
            return u[e.getMonth()];
          },
          c: null,
          d: Hr,
          e: Hr,
          f: Xr,
          H: Br,
          I: Ur,
          j: Wr,
          L: Yr,
          m: Gr,
          M: $r,
          p: function p(e) {
            return a[+(e.getHours() >= 12)];
          },
          q: function q(e) {
            return 1 + ~~(e.getMonth() / 3);
          },
          Q: wa,
          s: Ta,
          S: Zr,
          u: Jr,
          U: Qr,
          V: Kr,
          w: ea,
          W: ta,
          x: null,
          X: null,
          y: na,
          Y: ra,
          Z: aa,
          "%": Oa
        },
            _ = {
          a: function a(e) {
            return i[e.getUTCDay()];
          },
          A: function A(e) {
            return o[e.getUTCDay()];
          },
          b: function b(e) {
            return l[e.getUTCMonth()];
          },
          B: function B(e) {
            return u[e.getUTCMonth()];
          },
          c: null,
          d: oa,
          e: oa,
          f: ca,
          H: ia,
          I: ua,
          j: la,
          L: sa,
          m: fa,
          M: pa,
          p: function p(e) {
            return a[+(e.getUTCHours() >= 12)];
          },
          q: function q(e) {
            return 1 + ~~(e.getUTCMonth() / 3);
          },
          Q: wa,
          s: Ta,
          S: ha,
          u: da,
          U: ya,
          V: ma,
          w: ga,
          W: va,
          x: null,
          X: null,
          y: ba,
          Y: _a,
          Z: xa,
          "%": Oa
        },
            x = {
          a: function a(e, t, n) {
            var r = h.exec(t.slice(n));
            return r ? (e.w = d[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          A: function A(e, t, n) {
            var r = f.exec(t.slice(n));
            return r ? (e.w = p[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          b: function b(e, t, n) {
            var r = g.exec(t.slice(n));
            return r ? (e.m = v[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          B: function B(e, t, n) {
            var r = y.exec(t.slice(n));
            return r ? (e.m = m[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          c: function c(e, n, r) {
            return T(e, t, n, r);
          },
          d: Nr,
          e: Nr,
          f: qr,
          H: Fr,
          I: Fr,
          j: Cr,
          L: Dr,
          m: Ar,
          M: Rr,
          p: function p(e, t, n) {
            var r = s.exec(t.slice(n));
            return r ? (e.p = c[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          q: Sr,
          Q: zr,
          s: Ir,
          S: Lr,
          u: wr,
          U: Tr,
          V: kr,
          w: Or,
          W: Mr,
          x: function x(e, t, r) {
            return T(e, n, t, r);
          },
          X: function X(e, t, n) {
            return T(e, r, t, n);
          },
          y: Pr,
          Y: Er,
          Z: jr,
          "%": Vr
        };

        function O(e, t) {
          return function (n) {
            var r,
                a,
                o,
                i = [],
                u = -1,
                l = 0,
                s = e.length;

            for (n instanceof Date || (n = new Date(+n)); ++u < s;) {
              37 === e.charCodeAt(u) && (i.push(e.slice(l, u)), null != (a = dr[r = e.charAt(++u)]) ? r = e.charAt(++u) : a = "e" === r ? " " : "0", (o = t[r]) && (r = o(n, a)), i.push(r), l = u + 1);
            }

            return i.push(e.slice(l, u)), i.join("");
          };
        }

        function w(e, t) {
          return function (n) {
            var r,
                a,
                o = cr(1900, void 0, 1);
            if (T(o, e, n += "", 0) != n.length) return null;
            if ("Q" in o) return new Date(o.Q);
            if ("s" in o) return new Date(1e3 * o.s + ("L" in o ? o.L : 0));

            if (t && !("Z" in o) && (o.Z = 0), "p" in o && (o.H = o.H % 12 + 12 * o.p), void 0 === o.m && (o.m = "q" in o ? o.q : 0), "V" in o) {
              if (o.V < 1 || o.V > 53) return null;
              "w" in o || (o.w = 1), "Z" in o ? (a = (r = sr(cr(o.y, 0, 1))).getUTCDay(), r = a > 4 || 0 === a ? Qn.ceil(r) : Qn(r), r = or.offset(r, 7 * (o.V - 1)), o.y = r.getUTCFullYear(), o.m = r.getUTCMonth(), o.d = r.getUTCDate() + (o.w + 6) % 7) : (a = (r = lr(cr(o.y, 0, 1))).getDay(), r = a > 4 || 0 === a ? Fn.ceil(r) : Fn(r), r = In.offset(r, 7 * (o.V - 1)), o.y = r.getFullYear(), o.m = r.getMonth(), o.d = r.getDate() + (o.w + 6) % 7);
            } else ("W" in o || "U" in o) && ("w" in o || (o.w = "u" in o ? o.u % 7 : "W" in o ? 1 : 0), a = "Z" in o ? sr(cr(o.y, 0, 1)).getUTCDay() : lr(cr(o.y, 0, 1)).getDay(), o.m = 0, o.d = "W" in o ? (o.w + 6) % 7 + 7 * o.W - (a + 5) % 7 : o.w + 7 * o.U - (a + 6) % 7);

            return "Z" in o ? (o.H += o.Z / 100 | 0, o.M += o.Z % 100, sr(o)) : lr(o);
          };
        }

        function T(e, t, n, r) {
          for (var a, o, i = 0, u = t.length, l = n.length; i < u;) {
            if (r >= l) return -1;

            if (37 === (a = t.charCodeAt(i++))) {
              if (a = t.charAt(i++), !(o = x[a in dr ? t.charAt(i++) : a]) || (r = o(e, n, r)) < 0) return -1;
            } else if (a != n.charCodeAt(r++)) return -1;
          }

          return r;
        }

        return b.x = O(n, b), b.X = O(r, b), b.c = O(t, b), _.x = O(n, _), _.X = O(r, _), _.c = O(t, _), {
          format: function format(e) {
            var t = O(e += "", b);
            return t.toString = function () {
              return e;
            }, t;
          },
          parse: function parse(e) {
            var t = w(e += "", !1);
            return t.toString = function () {
              return e;
            }, t;
          },
          utcFormat: function utcFormat(e) {
            var t = O(e += "", _);
            return t.toString = function () {
              return e;
            }, t;
          },
          utcParse: function utcParse(e) {
            var t = w(e += "", !0);
            return t.toString = function () {
              return e;
            }, t;
          }
        };
      }(e), pr = fr.format, fr.parse, hr = fr.utcFormat, fr.utcParse;
    }({
      dateTime: "%x, %X",
      date: "%-m/%-d/%Y",
      time: "%-I:%M:%S %p",
      periods: ["AM", "PM"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    });

    function ka(e) {
      return new Date(e);
    }

    function Ma(e) {
      return e instanceof Date ? +e : +new Date(+e);
    }

    function Ea(e, t, n, r, a, o, i, u, l) {
      var s = Jt(Xt, Ge),
          c = s.invert,
          f = s.domain,
          p = l(".%L"),
          h = l(":%S"),
          d = l("%I:%M"),
          y = l("%I %p"),
          m = l("%a %d"),
          g = l("%b %d"),
          v = l("%B"),
          b = l("%Y"),
          _ = [[i, 1, 1e3], [i, 5, 5e3], [i, 15, 15e3], [i, 30, 3e4], [o, 1, 6e4], [o, 5, 3e5], [o, 15, 9e5], [o, 30, 18e5], [a, 1, 36e5], [a, 3, 108e5], [a, 6, 216e5], [a, 12, 432e5], [r, 1, 864e5], [r, 2, 1728e5], [n, 1, 6048e5], [t, 1, 2592e6], [t, 3, 7776e6], [e, 1, 31536e6]];

      function x(u) {
        return (i(u) < u ? p : o(u) < u ? h : a(u) < u ? d : r(u) < u ? y : t(u) < u ? n(u) < u ? m : g : e(u) < u ? v : b)(u);
      }

      function O(t, n, r, a) {
        if (null == t && (t = 10), "number" == typeof t) {
          var o = Math.abs(r - n) / t,
              i = ct(function (e) {
            return e[2];
          }).right(_, o);
          i === _.length ? (a = Ot(n / 31536e6, r / 31536e6, t), t = e) : i ? (a = (i = _[o / _[i - 1][2] < _[i][2] / o ? i - 1 : i])[1], t = i[0]) : (a = Math.max(Ot(n, r, t), 1), t = u);
        }

        return null == a ? t : t.every(a);
      }

      return s.invert = function (e) {
        return new Date(c(e));
      }, s.domain = function (e) {
        return arguments.length ? f(Vt.call(e, Ma)) : f().map(ka);
      }, s.ticks = function (e, t) {
        var n,
            r = f(),
            a = r[0],
            o = r[r.length - 1],
            i = o < a;
        return i && (n = a, a = o, o = n), n = (n = O(e, a, o, t)) ? n.range(a, o + 1) : [], i ? n.reverse() : n;
      }, s.tickFormat = function (e, t) {
        return null == t ? x : l(t);
      }, s.nice = function (e, t) {
        var n = f();
        return (e = O(e, n[0], n[n.length - 1], t)) ? f(mn(n, e)) : s;
      }, s.copy = function () {
        return Zt(s, Ea(e, t, n, r, a, o, i, u, l));
      }, s;
    }

    var Pa = En(function (e) {
      e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
    }, function (e, t) {
      e.setUTCMonth(e.getUTCMonth() + t);
    }, function (e, t) {
      return t.getUTCMonth() - e.getUTCMonth() + 12 * (t.getUTCFullYear() - e.getUTCFullYear());
    }, function (e) {
      return e.getUTCMonth();
    }),
        ja = Pa,
        Sa = (Pa.range, En(function (e) {
      e.setUTCMinutes(0, 0, 0);
    }, function (e, t) {
      e.setTime(+e + 36e5 * t);
    }, function (e, t) {
      return (t - e) / 36e5;
    }, function (e) {
      return e.getUTCHours();
    })),
        Aa = Sa,
        Na = (Sa.range, En(function (e) {
      e.setUTCSeconds(0, 0);
    }, function (e, t) {
      e.setTime(+e + 6e4 * t);
    }, function (e, t) {
      return (t - e) / 6e4;
    }, function (e) {
      return e.getUTCMinutes();
    })),
        Ca = Na,
        Fa = (Na.range, function (e) {
      return e.match(/.{6}/g).map(function (e) {
        return "#" + e;
      });
    }),
        Ra = (Fa("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), Fa("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"), Fa("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"), Fa("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"), Math.PI / 180),
        La = 180 / Math.PI,
        Da = -.14861,
        qa = -.29227,
        Va = 1.97294,
        za = -.90649 * Va,
        Ia = 1.78277 * Va,
        Ha = -.6557636667999999;

    function Ba(e) {
      if (e instanceof Wa) return new Wa(e.h, e.s, e.l, e.opacity);
      e instanceof Pe || (e = Me(e));
      var t = e.r / 255,
          n = e.g / 255,
          r = e.b / 255,
          a = (Ha * r + za * t - Ia * n) / (Ha + za - Ia),
          o = r - a,
          i = (Va * (n - a) - qa * o) / -.90649,
          u = Math.sqrt(i * i + o * o) / (Va * a * (1 - a)),
          l = u ? Math.atan2(i, o) * La - 120 : NaN;
      return new Wa(l < 0 ? l + 360 : l, u, a, e.opacity);
    }

    function Ua(e, t, n, r) {
      return 1 === arguments.length ? Ba(e) : new Wa(e, t, n, null == r ? 1 : r);
    }

    function Wa(e, t, n, r) {
      this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
    }

    function Ya(e) {
      return function t(n) {
        function r(t, r) {
          var a = e((t = Ua(t)).h, (r = Ua(r)).h),
              o = Ie(t.s, r.s),
              i = Ie(t.l, r.l),
              u = Ie(t.opacity, r.opacity);
          return function (e) {
            return t.h = a(e), t.s = o(e), t.l = i(Math.pow(e, n)), t.opacity = u(e), t + "";
          };
        }

        return n = +n, r.gamma = t, r;
      }(1);
    }

    ue(Wa, Ua, le(se, {
      brighter: function brighter(e) {
        return e = null == e ? 1 / .7 : Math.pow(1 / .7, e), new Wa(this.h, this.s, this.l * e, this.opacity);
      },
      darker: function darker(e) {
        return e = null == e ? .7 : Math.pow(.7, e), new Wa(this.h, this.s, this.l * e, this.opacity);
      },
      rgb: function rgb() {
        var e = isNaN(this.h) ? 0 : (this.h + 120) * Ra,
            t = +this.l,
            n = isNaN(this.s) ? 0 : this.s * t * (1 - t),
            r = Math.cos(e),
            a = Math.sin(e);
        return new Pe(255 * (t + n * (Da * r + 1.78277 * a)), 255 * (t + n * (qa * r + -.90649 * a)), 255 * (t + n * (Va * r)), this.opacity);
      }
    }));
    Ya(function (e, t) {
      var n = t - e;
      return n ? Ve(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : qe(isNaN(e) ? t : e);
    });
    var Xa = Ya(Ie);
    Xa(Ua(300, .5, 0), Ua(-240, .5, 1)), Xa(Ua(-100, .75, .35), Ua(80, 1.5, .8)), Xa(Ua(260, .75, .35), Ua(80, 1.5, .8)), Ua();

    function Ga(e) {
      var t = e.length;
      return function (n) {
        return e[Math.max(0, Math.min(t - 1, Math.floor(n * t)))];
      };
    }

    Ga(Fa("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")), Ga(Fa("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), Ga(Fa("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), Ga(Fa("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
    var $a = n(8);

    function Za(e) {
      return "[object Date]" === Object.prototype.toString.call(e) ? e.toDateString() : e;
    }

    var Ja,
        Qa = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Ka = function Ka(e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            !r && u["return"] && u["return"]();
          } finally {
            if (a) throw o;
          }
        }

        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };

    function eo(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      return Array.from(e);
    }

    function to(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var no = (to(Ja = {}, "linear", yn), to(Ja, "ordinal", function () {
      return function e(t) {
        var n = t.copy;
        return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function () {
          return e(n());
        }, t;
      }(function e() {
        var t,
            n,
            r = Ht().unknown(void 0),
            a = r.domain,
            o = r.range,
            i = [0, 1],
            u = !1,
            l = 0,
            s = 0,
            c = .5;

        function f() {
          var e = a().length,
              r = i[1] < i[0],
              f = i[r - 0],
              p = i[1 - r];
          t = (p - f) / Math.max(1, e - l + 2 * s), u && (t = Math.floor(t)), f += (p - f - t * (e - l)) * c, n = t * (1 - l), u && (f = Math.round(f), n = Math.round(n));
          var h = mt(e).map(function (e) {
            return f + t * e;
          });
          return o(r ? h.reverse() : h);
        }

        return delete r.unknown, r.domain = function (e) {
          return arguments.length ? (a(e), f()) : a();
        }, r.range = function (e) {
          return arguments.length ? (i = [+e[0], +e[1]], f()) : i.slice();
        }, r.rangeRound = function (e) {
          return i = [+e[0], +e[1]], u = !0, f();
        }, r.bandwidth = function () {
          return n;
        }, r.step = function () {
          return t;
        }, r.round = function (e) {
          return arguments.length ? (u = !!e, f()) : u;
        }, r.padding = function (e) {
          return arguments.length ? (l = s = Math.max(0, Math.min(1, e)), f()) : l;
        }, r.paddingInner = function (e) {
          return arguments.length ? (l = Math.max(0, Math.min(1, e)), f()) : l;
        }, r.paddingOuter = function (e) {
          return arguments.length ? (s = Math.max(0, Math.min(1, e)), f()) : s;
        }, r.align = function (e) {
          return arguments.length ? (c = Math.max(0, Math.min(1, e)), f()) : c;
        }, r.copy = function () {
          return e().domain(a()).range(i).round(u).paddingInner(l).paddingOuter(s).align(c);
        }, f();
      }().paddingInner(1));
    }), to(Ja, "category", Ht), to(Ja, "literal", _o), to(Ja, "log", function e() {
      var t = Jt(gn, vn).domain([1, 10]),
          n = t.domain,
          r = 10,
          a = xn(10),
          o = _n(10);

      function i() {
        return a = xn(r), o = _n(r), n()[0] < 0 && (a = On(a), o = On(o)), t;
      }

      return t.base = function (e) {
        return arguments.length ? (r = +e, i()) : r;
      }, t.domain = function (e) {
        return arguments.length ? (n(e), i()) : n();
      }, t.ticks = function (e) {
        var t,
            i = n(),
            u = i[0],
            l = i[i.length - 1];
        (t = l < u) && (p = u, u = l, l = p);
        var s,
            c,
            f,
            p = a(u),
            h = a(l),
            d = null == e ? 10 : +e,
            y = [];

        if (!(r % 1) && h - p < d) {
          if (p = Math.round(p) - 1, h = Math.round(h) + 1, u > 0) {
            for (; p < h; ++p) {
              for (c = 1, s = o(p); c < r; ++c) {
                if (!((f = s * c) < u)) {
                  if (f > l) break;
                  y.push(f);
                }
              }
            }
          } else for (; p < h; ++p) {
            for (c = r - 1, s = o(p); c >= 1; --c) {
              if (!((f = s * c) < u)) {
                if (f > l) break;
                y.push(f);
              }
            }
          }
        } else y = _t(p, h, Math.min(h - p, d)).map(o);

        return t ? y.reverse() : y;
      }, t.tickFormat = function (e, n) {
        if (null == n && (n = 10 === r ? ".0e" : ","), "function" != typeof n && (n = rn(n)), e === 1 / 0) return n;
        null == e && (e = 10);
        var i = Math.max(1, r * e / t.ticks().length);
        return function (e) {
          var t = e / o(Math.round(a(e)));
          return t * r < r - .5 && (t *= r), t <= i ? n(e) : "";
        };
      }, t.nice = function () {
        return n(mn(n(), {
          floor: function floor(e) {
            return o(Math.floor(a(e)));
          },
          ceil: function ceil(e) {
            return o(Math.ceil(a(e)));
          }
        }));
      }, t.copy = function () {
        return Zt(t, e().base(r));
      }, t;
    }), to(Ja, "time", function () {
      return Ea(jn, An, Cn, In, Bn, Wn, Xn, $n, pr).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]);
    }), to(Ja, "time-utc", function () {
      return Ea(ur, ja, Jn, or, Aa, Ca, Xn, $n, hr).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]);
    }), Ja),
        ro = ["color", "fill", "opacity", "stroke"];

    function ao(e) {
      return "" + e[0].toUpperCase() + e.slice(1);
    }

    function oo(e) {
      if (!e) return null;
      var t = e.type,
          n = e.domain,
          r = e.range,
          a = n[0] === n[1] ? 0 === n[0] ? [-1, 0] : [-n[0], n[0]] : n;
      if ("literal" === t) return _o(r[0]);
      var o = no[t]().domain(a).range(r);
      return "ordinal" === t && (o.padding(.5), function (e) {
        e.invert || (e.invert = function (t) {
          var n = e.range(),
              r = Ka(n, 2),
              a = r[0],
              o = r[1],
              i = Math.min(a, o),
              u = Math.max(a, o);
          if (t < i + e.padding() * e.step()) return e.domain()[0];
          if (t > u - e.padding() * e.step()) return e.domain()[e.domain().length - 1];
          var l = Math.floor((t - i - e.padding() * e.step()) / e.step());
          return e.domain()[l];
        });
      }(o)), o;
    }

    function io(e, t, n, r) {
      var a = e.reduce(function (e, r) {
        var a = t(r),
            o = n(r);
        return po(a) && e.push(a), po(o) && e.push(o), e;
      }, []);
      return a.length ? "ordinal" !== r && "category" !== r ? dt(a) : Dt(a).values() : [];
    }

    function uo(e, t, n, r, a) {
      return "literal" === n ? {
        type: "literal",
        domain: [],
        range: [t],
        distance: 0,
        attr: e,
        baseValue: void 0,
        isValue: !0,
        accessor: r,
        accessor0: a
      } : void 0 === t ? null : {
        type: "category",
        range: [t],
        domain: [],
        distance: 0,
        attr: e,
        baseValue: void 0,
        isValue: !0,
        accessor: r,
        accessor0: a
      };
    }

    function lo(e, t) {
      var n = t.domain,
          r = t.type,
          a = t.accessor,
          o = t.accessor0,
          i = function (e, t, n, r) {
        return "time" === r && 1 === t.length ? [n(e[0])].concat(eo(t)) : t;
      }(e, function (e, t) {
        var n = new Set(e.map(t));
        return Array.from(n);
      }(e, a), o, r),
          u = function (e, t) {
        var n = oo(t),
            r = 0;
        if (n) for (var a = void 0, o = n(e[0]), i = 1 / 0, u = void 0, l = 1; l < e.length; l++) {
          a = n(e[l]), (u = Math.abs(a - o)) < i && (i = u, r = l), o = a;
        }
        return r;
      }(i, t),
          l = [].concat(n);

      l[0] -= function (e) {
        return e.length > 1 ? (e[1] - e[0]) / 2 : 1 === e.length ? e[0] - .5 : 0;
      }(i), l[n.length - 1] += function (e) {
        return e.length > 1 ? (e[e.length - 1] - e[e.length - 2]) / 2 : 1 === e.length ? e[0] - .5 : 0;
      }(i), "log" === r && n[0] <= 0 && (l[0] = Math.min(n[1] / 10, 1));

      var s = function (e, t, n, r) {
        if (e.length > 1) {
          var a = Math.max(n, 1);
          return Math.abs(r(e[a]) - r(e[a - 1]));
        }

        return 1 === e.length ? Math.abs(r(t[1]) - r(t[0])) : 0;
      }(i, l, u, oo(Qa({}, t, {
        domain: l
      })));

      return {
        domain0: l[0],
        domainN: l[l.length - 1],
        distance: s
      };
    }

    function so(e, t) {
      var n = function (e, t) {
        var n,
            r = e[t],
            a = e["_" + t + "Value"],
            o = e[t + "Range"],
            i = e[t + "Distance"],
            u = void 0 === i ? 0 : i,
            l = e[t + "BaseValue"],
            s = e[t + "Type"],
            c = void 0 === s ? "linear" : s,
            f = e[t + "NoFallBack"],
            p = e["get" + ao(t)],
            h = void 0 === p ? function (e) {
          return e[t];
        } : p,
            d = e["get" + ao(t) + "0"],
            y = void 0 === d ? function (e) {
          return e[t + "0"];
        } : d,
            m = e[t + "Domain"];
        return f || void 0 === r ? (void 0 !== l && (m = function (e, t) {
          var n = [].concat(e);
          return n[0] > t && (n[0] = t), n[n.length - 1] < t && (n[n.length - 1] = t), n;
        }(m, l)), o && m && m.length ? {
          domain: (n = {
            domain: m,
            range: o,
            type: c,
            distance: u,
            attr: t,
            baseValue: l,
            accessor: h,
            accessor0: y
          }).domain,
          range: n.range,
          type: n.type,
          distance: n.distance,
          attr: n.attr,
          baseValue: n.baseValue,
          isValue: !1,
          accessor: n.accessor,
          accessor0: n.accessor0
        } : uo(t, a, e[t + "Type"], h, y)) : uo(t, r, e[t + "Type"], h, y);
      }(e, t);

      if (!n) return null;
      if (!function (e, t) {
        var n = t.attr,
            r = e._adjustBy,
            a = void 0 === r ? [] : r,
            o = e._adjustWhat;
        return (void 0 === o ? [] : o).length && a.length && -1 !== a.indexOf(n);
      }(e, n)) return n;
      var r = n.type;
      return "ordinal" === r || "category" === r ? function (e) {
        var t = oo(e),
            n = e.domain,
            r = e.range;
        return n.length > 1 ? e.distance = Math.abs(t(n[1]) - t(n[0])) : e.distance = Math.abs(r[1] - r[0]), e;
      }(n) : function (e, t) {
        var n = e._allData,
            r = e._adjustWhat,
            a = void 0 === r ? [] : r,
            o = t.domain.length,
            i = t.domain,
            u = i[0],
            l = i[o - 1],
            s = t.distance;
        return n.forEach(function (e, n) {
          if (-1 !== a.indexOf(n) && e && e.length) {
            var r = lo(e, t),
                o = r.domain0,
                i = r.domainN,
                c = r.distance;
            u = Math.min(u, o), l = Math.max(l, i), s = Math.max(s, c);
          }
        }), t.domain = [u].concat(eo(i.slice(1, -1)), [l]), t.distance = s, t;
      }(e, n);
    }

    function co(e, t) {
      return oo(so(e, t));
    }

    function fo(e, t) {
      return t(e.data ? e.data : e);
    }

    function po(e) {
      return void 0 !== e;
    }

    function ho(e, t) {
      var n = so(e, t);

      if (n) {
        var r = oo(n);
        return function (e) {
          return r(fo(e, n.accessor));
        };
      }

      return null;
    }

    function yo(e, t) {
      var n = so(e, t);

      if (n) {
        var r = n.domain,
            a = n.baseValue,
            o = void 0 === a ? r[0] : a,
            i = oo(n);
        return function (e) {
          var t = fo(e, n.accessor0);
          return i(po(t) ? t : o);
        };
      }

      return null;
    }

    function mo(e, t) {
      var n = so(e, t);
      return n ? (n.isValue || void 0 !== e["_" + t + "Value"] || Object($a.b)("[React-vis] Cannot use data defined " + t + " for this series type. Using fallback value instead."), e["_" + t + "Value"] || n.range[0]) : null;
    }

    function go(e) {
      var t;
      return to(t = {}, "_" + e + "Value", h.a.any), to(t, e + "Domain", h.a.array), to(t, "get" + ao(e), h.a.func), to(t, "get" + ao(e) + "0", h.a.func), to(t, e + "Range", h.a.array), to(t, e + "Type", h.a.oneOf(Object.keys(no))), to(t, e + "Distance", h.a.number), to(t, e + "BaseValue", h.a.any), t;
    }

    function vo(e, t) {
      var n = {};
      return Object.keys(e).forEach(function (r) {
        t.find(function (e) {
          var t = 0 === r.indexOf(e),
              n = 0 === r.indexOf("_" + e),
              a = 0 === r.indexOf("get" + ao(e));
          return t || n || a;
        }) && (n[r] = e[r]);
      }), n;
    }

    function bo(e, t, n) {
      var r = {};
      return n.forEach(function (n) {
        e["get" + ao(n)] || (r["get" + ao(n)] = function (e) {
          return e[n];
        }), e["get" + ao(n) + "0"] || (r["get" + ao(n) + "0"] = function (e) {
          return e[n + "0"];
        }), e[n + "Domain"] || (r[n + "Domain"] = io(t, e["get" + ao(n)] || r["get" + ao(n)], e["get" + ao(n) + "0"] || r["get" + ao(n) + "0"], e[n + "Type"]), e[n + "Padding"] && (r[n + "Domain"] = function (e, t) {
          if (!e) return e;
          if (isNaN(parseFloat(e[0])) || isNaN(parseFloat(e[1]))) return e;
          var n = Ka(e, 2),
              r = n[0],
              a = n[1],
              o = .01 * t * (a - r);
          return [r - o, a + o];
        }(r[n + "Domain"], e[n + "Padding"])));
      }), r;
    }

    function _o(e) {
      function t(t) {
        return void 0 === t ? e : t;
      }

      function n() {
        return t;
      }

      return t.domain = n, t.range = n, t.unknown = n, t.copy = n, t;
    }

    function xo(e) {
      return e ? Fe(e).l > .57 ? "#222" : "#fff" : null;
    }

    function Oo(e, t) {
      var n = ro.reduce(function (t, n) {
        var r = e[n + "Domain"],
            a = e[n + "Range"],
            o = e[n + "Type"];
        return r && a && o ? Qa({}, t, to({}, n, no[o]().domain(r).range(a))) : t;
      }, {});
      return t.map(function (e) {
        return ro.reduce(function (t, r) {
          if (e.props && void 0 !== e.props[r]) {
            var a = e.props[r],
                o = n[r],
                i = o ? o(a) : a;
            return Qa({}, t, to({}, "_" + r + "Value", i));
          }

          return t;
        }, {});
      });
    }

    var wo = ["Padding"].map(function (e) {
      return new RegExp(e + "$", "i");
    });

    function To(e) {
      return Object.keys(e).reduce(function (t, n) {
        return wo.every(function (e) {
          return !n.match(e);
        }) || (t[n] = e[n]), t;
      }, {});
    }

    var ko = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Mo(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Eo(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Po = (Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    })({}, go("x"), go("y"), go("size"), go("opacity"), go("color"), {
      width: h.a.number,
      height: h.a.number,
      data: h.a.arrayOf(h.a.oneOfType([h.a.object, h.a.array])),
      onValueMouseOver: h.a.func,
      onValueMouseOut: h.a.func,
      onValueClick: h.a.func,
      onValueRightClick: h.a.func,
      onSeriesMouseOver: h.a.func,
      onSeriesMouseOut: h.a.func,
      onSeriesClick: h.a.func,
      onSeriesRightClick: h.a.func,
      onNearestX: h.a.func,
      onNearestXY: h.a.func,
      style: h.a.object,
      animation: lt,
      stack: h.a.bool
    }),
        jo = function (e) {
      function t() {
        var e, n, r;
        Mo(this, t);

        for (var a = arguments.length, o = Array(a), i = 0; i < a; i++) {
          o[i] = arguments[i];
        }

        return n = r = Eo(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(o))), r._seriesClickHandler = function (e) {
          var t = r.props.onSeriesClick;
          t && t({
            event: e
          });
        }, r._seriesMouseOutHandler = function (e) {
          var t = r.props.onSeriesMouseOut;
          t && t({
            event: e
          });
        }, r._seriesMouseOverHandler = function (e) {
          var t = r.props.onSeriesMouseOver;
          t && t({
            event: e
          });
        }, r._seriesRightClickHandler = function (e) {
          var t = r.props.onSeriesRightClick;
          t && t({
            event: e
          });
        }, r._valueClickHandler = function (e, t) {
          var n = r.props,
              a = n.onValueClick,
              o = n.onSeriesClick;
          a && a(e, {
            event: t
          }), o && o({
            event: t
          });
        }, r._valueMouseOutHandler = function (e, t) {
          var n = r.props,
              a = n.onValueMouseOut,
              o = n.onSeriesMouseOut;
          a && a(e, {
            event: t
          }), o && o({
            event: t
          });
        }, r._valueMouseOverHandler = function (e, t) {
          var n = r.props,
              a = n.onValueMouseOver,
              o = n.onSeriesMouseOver;
          a && a(e, {
            event: t
          }), o && o({
            event: t
          });
        }, r._valueRightClickHandler = function (e, t) {
          var n = r.props,
              a = n.onValueRightClick,
              o = n.onSeriesRightClick;
          a && a(e, {
            event: t
          }), o && o({
            event: t
          });
        }, Eo(r, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), ko(t, [{
        key: "onParentMouseMove",
        value: function value(e) {
          var t = this.props,
              n = t.onNearestX,
              r = t.onNearestXY,
              a = t.data;
          (n || r) && a && (r ? this._handleNearestXY(e) : this._handleNearestX(e));
        }
      }, {
        key: "onParentTouchMove",
        value: function value(e) {
          e.preventDefault(), this.onParentMouseMove(e);
        }
      }, {
        key: "onParentTouchStart",
        value: function value(e) {
          e.preventDefault();
        }
      }, {
        key: "_getAttr0Functor",
        value: function value(e) {
          return yo(this.props, e);
        }
      }, {
        key: "_getAttributeFunctor",
        value: function value(e) {
          return ho(this.props, e);
        }
      }, {
        key: "_getAttributeValue",
        value: function value(e) {
          return mo(this.props, e);
        }
      }, {
        key: "_getScaleDistance",
        value: function value(e) {
          var t = so(this.props, e);
          return t ? t.distance : 0;
        }
      }, {
        key: "_getXYCoordinateInContainer",
        value: function value(e) {
          var t = this.props,
              n = t.marginTop,
              r = void 0 === n ? 0 : n,
              a = t.marginLeft,
              o = void 0 === a ? 0 : a,
              i = e.nativeEvent,
              u = e.currentTarget,
              l = u.getBoundingClientRect(),
              s = i.clientX,
              c = i.clientY;
          return "touchmove" === i.type && (s = i.touches[0].pageX, c = i.touches[0].pageY), {
            x: s - l.left - u.clientLeft - o,
            y: c - l.top - u.clientTop - r
          };
        }
      }, {
        key: "_handleNearestX",
        value: function value(e) {
          var t = this.props,
              n = t.onNearestX,
              r = t.data,
              a = Number.POSITIVE_INFINITY,
              o = null,
              i = null,
              u = this._getXYCoordinateInContainer(e),
              l = this._getAttributeFunctor("x");

          r.forEach(function (e, t) {
            var n = l(e),
                r = Math.abs(u.x - n);
            r < a && (a = r, o = e, i = t);
          }), o && n(o, {
            innerX: l(o),
            index: i,
            event: e.nativeEvent
          });
        }
      }, {
        key: "_handleNearestXY",
        value: function value(e) {
          var t = this.props,
              n = t.onNearestXY,
              r = t.data,
              a = this._getXYCoordinateInContainer(e),
              o = this._getAttributeFunctor("x"),
              i = this._getAttributeFunctor("y"),
              u = ie().x(o).y(i)(r).find(a.x, a.y),
              l = u.data;

          l && n(l, {
            innerX: u[0],
            innerY: u[1],
            index: u.index,
            event: e.nativeEvent
          });
        }
      }], [{
        key: "getParentConfig",
        value: function value() {
          return {};
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !0;
        }
      }]), t;
    }(c.PureComponent);

    jo.displayName = "AbstractSeries", jo.propTypes = Po, jo.defaultProps = {
      className: "",
      stack: !1,
      style: {}
    };

    var So = jo,
        Ao = ["#12939A", "#79C7E3", "#1A3177", "#FF9833", "#EF5D28"],
        No = ["#19CDD7", "#DDB27C", "#88572C", "#FF991F", "#F15C17", "#223F9A", "#DA70BF", "#125C77", "#4DC19C", "#776E57", "#12939A", "#17B8BE", "#F6D18A", "#B7885E", "#FFCB99", "#F89570", "#829AE3", "#E79FD5", "#1E96BE", "#89DAC1", "#B3AD9E"],
        Co = ["#EF5D28", "#FF9833"],
        Fo = [1, 10],
        Ro = Ao[0],
        Lo = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function Do(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function qo(e) {
      return e.type.prototype instanceof So;
    }

    function Vo(e) {
      return f.a.Children.toArray(e).filter(function (e) {
        return e && qo(e);
      });
    }

    function zo(e, t) {
      var n = e.some(function (e) {
        return e && e.props.stack;
      }),
          r = {};
      return e.reduce(function (e, a, o) {
        if (!a) return e.push(null), e;

        var i = a.type.displayName,
            u = a.props,
            l = u.data,
            s = u.cluster,
            c = void 0 === s ? "default" : s,
            f = u.stack,
            p = function (e) {
          return function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            return !!e && e.some(function (e) {
              return e.radius && e.angle;
            });
          }(e) ? e.map(function (e) {
            return Lo({}, e, {
              x: e.radius * Math.cos(e.angle),
              y: e.radius * Math.sin(e.angle)
            });
          }) : e;
        }(l);

        if (!t || !p || !p.length || n && !f) return e.push(p), e;
        var h = t + "0",
            d = "y" === t ? "x" : "y";
        return e.push(p.map(function (e, n) {
          var a, o;
          r[c] || (r[c] = {}), r[c][i] || (r[c][i] = {});
          var u,
              l = r[c][i][e[d]];
          if (!l) return r[c][i][e[d]] = (Do(u = {}, h, e[h]), Do(u, t, e[t]), u), Lo({}, e);
          var s = Lo({}, e, (Do(a = {}, h, l[t]), Do(a, t, l[t] + e[t] - (e[h] || 0)), a));
          return r[c][i][e[d]] = (Do(o = {}, h, s[h]), Do(o, t, s[t]), o), s;
        })), e;
      }, []);
    }

    function Io(e) {
      var t = [],
          n = function (e) {
        var t = {};
        return e.filter(qo).forEach(function (e) {
          var n = e.type.displayName,
              r = e.props.cluster;
          t[n] || (t[n] = {
            sameTypeTotal: 0,
            sameTypeIndex: 0,
            clusters: new Set()
          }), t[n].clusters.add(r), t[n].sameTypeTotal++;
        }), t;
      }(e),
          r = 0;

      return e.forEach(function (e) {
        var a = void 0;

        if (qo(e)) {
          var o = n[e.type.displayName];
          a = Lo({}, o, {
            seriesIndex: r,
            _colorValue: Ao[r % Ao.length],
            _opacityValue: 1
          }), o.sameTypeIndex++, r++, e.props.cluster && (a.cluster = e.props.cluster, a.clusters = Array.from(o.clusters), a.sameTypeTotal = a.clusters.length, a.sameTypeIndex = a.clusters.indexOf(e.props.cluster));
        }

        t.push(a);
      }), t;
    }

    function Ho(e) {
      return e.reduce(function (e, t) {
        return Math.max(t.radius, e);
      }, 0);
    }

    var Bo = ["xRange", "xDomain", "x", "yRange", "yDomain", "y", "colorRange", "colorDomain", "color", "opacityRange", "opacityDomain", "opacity", "strokeRange", "strokeDomain", "stroke", "fillRange", "fillDomain", "fill", "width", "height", "marginLeft", "marginTop", "marginRight", "marginBottom", "data", "angleDomain", "angleRange", "angle", "radiusDomain", "radiusRange", "radius", "innerRadiusDomain", "innerRadiusRange", "innerRadius"];

    function Uo(e) {
      var t = e._stackBy,
          n = e.valuePosAttr,
          r = e.cluster,
          a = e.sameTypeTotal,
          o = void 0 === a ? 1 : a,
          i = e.sameTypeIndex,
          u = void 0 === i ? 0 : i;
      return t !== n || r || (o = 1, u = 0), {
        sameTypeTotal: o,
        sameTypeIndex: u
      };
    }

    var Wo = Math.PI,
        Yo = 2 * Wo,
        Xo = Yo - 1e-6;

    function Go() {
      this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
    }

    function $o() {
      return new Go();
    }

    Go.prototype = $o.prototype = {
      constructor: Go,
      moveTo: function moveTo(e, t) {
        this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t);
      },
      closePath: function closePath() {
        null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
      },
      lineTo: function lineTo(e, t) {
        this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +t);
      },
      quadraticCurveTo: function quadraticCurveTo(e, t, n, r) {
        this._ += "Q" + +e + "," + +t + "," + (this._x1 = +n) + "," + (this._y1 = +r);
      },
      bezierCurveTo: function bezierCurveTo(e, t, n, r, a, o) {
        this._ += "C" + +e + "," + +t + "," + +n + "," + +r + "," + (this._x1 = +a) + "," + (this._y1 = +o);
      },
      arcTo: function arcTo(e, t, n, r, a) {
        e = +e, t = +t, n = +n, r = +r, a = +a;
        var o = this._x1,
            i = this._y1,
            u = n - e,
            l = r - t,
            s = o - e,
            c = i - t,
            f = s * s + c * c;
        if (a < 0) throw new Error("negative radius: " + a);
        if (null === this._x1) this._ += "M" + (this._x1 = e) + "," + (this._y1 = t);else if (f > 1e-6) {
          if (Math.abs(c * u - l * s) > 1e-6 && a) {
            var p = n - o,
                h = r - i,
                d = u * u + l * l,
                y = p * p + h * h,
                m = Math.sqrt(d),
                g = Math.sqrt(f),
                v = a * Math.tan((Wo - Math.acos((d + f - y) / (2 * m * g))) / 2),
                b = v / g,
                _ = v / m;

            Math.abs(b - 1) > 1e-6 && (this._ += "L" + (e + b * s) + "," + (t + b * c)), this._ += "A" + a + "," + a + ",0,0," + +(c * p > s * h) + "," + (this._x1 = e + _ * u) + "," + (this._y1 = t + _ * l);
          } else this._ += "L" + (this._x1 = e) + "," + (this._y1 = t);
        } else ;
      },
      arc: function arc(e, t, n, r, a, o) {
        e = +e, t = +t, o = !!o;
        var i = (n = +n) * Math.cos(r),
            u = n * Math.sin(r),
            l = e + i,
            s = t + u,
            c = 1 ^ o,
            f = o ? r - a : a - r;
        if (n < 0) throw new Error("negative radius: " + n);
        null === this._x1 ? this._ += "M" + l + "," + s : (Math.abs(this._x1 - l) > 1e-6 || Math.abs(this._y1 - s) > 1e-6) && (this._ += "L" + l + "," + s), n && (f < 0 && (f = f % Yo + Yo), f > Xo ? this._ += "A" + n + "," + n + ",0,1," + c + "," + (e - i) + "," + (t - u) + "A" + n + "," + n + ",0,1," + c + "," + (this._x1 = l) + "," + (this._y1 = s) : f > 1e-6 && (this._ += "A" + n + "," + n + ",0," + +(f >= Wo) + "," + c + "," + (this._x1 = e + n * Math.cos(a)) + "," + (this._y1 = t + n * Math.sin(a))));
      },
      rect: function rect(e, t, n, r) {
        this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t) + "h" + +n + "v" + +r + "h" + -n + "Z";
      },
      toString: function toString() {
        return this._;
      }
    };

    var Zo = $o,
        Jo = function Jo(e) {
      return function () {
        return e;
      };
    },
        Qo = Math.abs,
        Ko = Math.atan2,
        ei = Math.cos,
        ti = Math.max,
        ni = Math.min,
        ri = Math.sin,
        ai = Math.sqrt,
        oi = Math.PI,
        ii = oi / 2,
        ui = 2 * oi;

    function li(e) {
      return e > 1 ? 0 : e < -1 ? oi : Math.acos(e);
    }

    function si(e) {
      return e >= 1 ? ii : e <= -1 ? -ii : Math.asin(e);
    }

    function ci(e) {
      return e.innerRadius;
    }

    function fi(e) {
      return e.outerRadius;
    }

    function pi(e) {
      return e.startAngle;
    }

    function hi(e) {
      return e.endAngle;
    }

    function di(e) {
      return e && e.padAngle;
    }

    function yi(e, t, n, r, a, o, i, u) {
      var l = n - e,
          s = r - t,
          c = i - a,
          f = u - o,
          p = f * l - c * s;
      if (!(p * p < 1e-12)) return [e + (p = (c * (t - o) - f * (e - a)) / p) * l, t + p * s];
    }

    function mi(e, t, n, r, a, o, i) {
      var u = e - n,
          l = t - r,
          s = (i ? o : -o) / ai(u * u + l * l),
          c = s * l,
          f = -s * u,
          p = e + c,
          h = t + f,
          d = n + c,
          y = r + f,
          m = (p + d) / 2,
          g = (h + y) / 2,
          v = d - p,
          b = y - h,
          _ = v * v + b * b,
          x = a - o,
          O = p * y - d * h,
          w = (b < 0 ? -1 : 1) * ai(ti(0, x * x * _ - O * O)),
          T = (O * b - v * w) / _,
          k = (-O * v - b * w) / _,
          M = (O * b + v * w) / _,
          E = (-O * v + b * w) / _,
          P = T - m,
          j = k - g,
          S = M - m,
          A = E - g;

      return P * P + j * j > S * S + A * A && (T = M, k = E), {
        cx: T,
        cy: k,
        x01: -c,
        y01: -f,
        x11: T * (a / x - 1),
        y11: k * (a / x - 1)
      };
    }

    var gi = function gi() {
      var e = ci,
          t = fi,
          n = Jo(0),
          r = null,
          a = pi,
          o = hi,
          i = di,
          u = null;

      function l() {
        var l,
            s,
            c = +e.apply(this, arguments),
            f = +t.apply(this, arguments),
            p = a.apply(this, arguments) - ii,
            h = o.apply(this, arguments) - ii,
            d = Qo(h - p),
            y = h > p;
        if (u || (u = l = Zo()), f < c && (s = f, f = c, c = s), f > 1e-12) {
          if (d > ui - 1e-12) u.moveTo(f * ei(p), f * ri(p)), u.arc(0, 0, f, p, h, !y), c > 1e-12 && (u.moveTo(c * ei(h), c * ri(h)), u.arc(0, 0, c, h, p, y));else {
            var m,
                g,
                v = p,
                b = h,
                _ = p,
                x = h,
                O = d,
                w = d,
                T = i.apply(this, arguments) / 2,
                k = T > 1e-12 && (r ? +r.apply(this, arguments) : ai(c * c + f * f)),
                M = ni(Qo(f - c) / 2, +n.apply(this, arguments)),
                E = M,
                P = M;

            if (k > 1e-12) {
              var j = si(k / c * ri(T)),
                  S = si(k / f * ri(T));
              (O -= 2 * j) > 1e-12 ? (_ += j *= y ? 1 : -1, x -= j) : (O = 0, _ = x = (p + h) / 2), (w -= 2 * S) > 1e-12 ? (v += S *= y ? 1 : -1, b -= S) : (w = 0, v = b = (p + h) / 2);
            }

            var A = f * ei(v),
                N = f * ri(v),
                C = c * ei(x),
                F = c * ri(x);

            if (M > 1e-12) {
              var R,
                  L = f * ei(b),
                  D = f * ri(b),
                  q = c * ei(_),
                  V = c * ri(_);

              if (d < oi && (R = yi(A, N, q, V, L, D, C, F))) {
                var z = A - R[0],
                    I = N - R[1],
                    H = L - R[0],
                    B = D - R[1],
                    U = 1 / ri(li((z * H + I * B) / (ai(z * z + I * I) * ai(H * H + B * B))) / 2),
                    W = ai(R[0] * R[0] + R[1] * R[1]);
                E = ni(M, (c - W) / (U - 1)), P = ni(M, (f - W) / (U + 1));
              }
            }

            w > 1e-12 ? P > 1e-12 ? (m = mi(q, V, A, N, f, P, y), g = mi(L, D, C, F, f, P, y), u.moveTo(m.cx + m.x01, m.cy + m.y01), P < M ? u.arc(m.cx, m.cy, P, Ko(m.y01, m.x01), Ko(g.y01, g.x01), !y) : (u.arc(m.cx, m.cy, P, Ko(m.y01, m.x01), Ko(m.y11, m.x11), !y), u.arc(0, 0, f, Ko(m.cy + m.y11, m.cx + m.x11), Ko(g.cy + g.y11, g.cx + g.x11), !y), u.arc(g.cx, g.cy, P, Ko(g.y11, g.x11), Ko(g.y01, g.x01), !y))) : (u.moveTo(A, N), u.arc(0, 0, f, v, b, !y)) : u.moveTo(A, N), c > 1e-12 && O > 1e-12 ? E > 1e-12 ? (m = mi(C, F, L, D, c, -E, y), g = mi(A, N, q, V, c, -E, y), u.lineTo(m.cx + m.x01, m.cy + m.y01), E < M ? u.arc(m.cx, m.cy, E, Ko(m.y01, m.x01), Ko(g.y01, g.x01), !y) : (u.arc(m.cx, m.cy, E, Ko(m.y01, m.x01), Ko(m.y11, m.x11), !y), u.arc(0, 0, c, Ko(m.cy + m.y11, m.cx + m.x11), Ko(g.cy + g.y11, g.cx + g.x11), y), u.arc(g.cx, g.cy, E, Ko(g.y11, g.x11), Ko(g.y01, g.x01), !y))) : u.arc(0, 0, c, x, _, y) : u.lineTo(C, F);
          }
        } else u.moveTo(0, 0);
        if (u.closePath(), l) return u = null, l + "" || null;
      }

      return l.centroid = function () {
        var n = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2,
            r = (+a.apply(this, arguments) + +o.apply(this, arguments)) / 2 - oi / 2;
        return [ei(r) * n, ri(r) * n];
      }, l.innerRadius = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : Jo(+t), l) : e;
      }, l.outerRadius = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Jo(+e), l) : t;
      }, l.cornerRadius = function (e) {
        return arguments.length ? (n = "function" == typeof e ? e : Jo(+e), l) : n;
      }, l.padRadius = function (e) {
        return arguments.length ? (r = null == e ? null : "function" == typeof e ? e : Jo(+e), l) : r;
      }, l.startAngle = function (e) {
        return arguments.length ? (a = "function" == typeof e ? e : Jo(+e), l) : a;
      }, l.endAngle = function (e) {
        return arguments.length ? (o = "function" == typeof e ? e : Jo(+e), l) : o;
      }, l.padAngle = function (e) {
        return arguments.length ? (i = "function" == typeof e ? e : Jo(+e), l) : i;
      }, l.context = function (e) {
        return arguments.length ? (u = null == e ? null : e, l) : u;
      }, l;
    },
        vi = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        bi = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    var _i = ["radius", "angle"],
        xi = bi({}, So.defaultProps, {
      center: {
        x: 0,
        y: 0
      },
      arcClassName: "",
      className: "",
      style: {},
      padAngle: 0
    });

    function Oi(e) {
      var t = e.radius,
          n = e.angle,
          r = e.angle0,
          a = -1 * n + Math.PI / 2,
          o = -1 * r + Math.PI / 2;
      return bi({}, e, {
        x: t * Math.cos(a),
        y: t * Math.sin(a),
        angle: a,
        angle0: o
      });
    }

    var wi = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
            r = n._getAllScaleProps(e);

        return n.state = {
          scaleProps: r
        }, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), vi(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.setState({
            scaleProps: this._getAllScaleProps(e)
          });
        }
      }, {
        key: "_getAllScaleProps",
        value: function value(e) {
          var t = this._getDefaultScaleProps(e),
              n = vo(e, _i),
              r = bo(bi({}, t, n), e.data, _i);

          return bi({}, t, n, r);
        }
      }, {
        key: "_getDefaultScaleProps",
        value: function value(e) {
          var t = e.innerWidth,
              n = e.innerHeight,
              r = Math.min(t / 2, n / 2);
          return {
            radiusRange: [0, r],
            _radiusValue: r,
            angleType: "literal"
          };
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.arcClassName,
              a = n.animation,
              o = n.className,
              i = n.center,
              u = n.data,
              l = n.disableSeries,
              s = n.hideSeries,
              c = n.marginLeft,
              p = n.marginTop,
              h = n.padAngle,
              d = n.style;
          if (!u) return null;

          if (a) {
            var y = u.map(function (e) {
              return bi({}, e);
            });
            return f.a.createElement("g", {
              className: "rv-xy-plot__series--arc__animation-wrapper"
            }, f.a.createElement(ut, bi({}, this.props, {
              animatedProps: Bo,
              data: y
            }), f.a.createElement(t, bi({}, this.props, {
              animation: null,
              disableSeries: !0,
              data: y
            }))), f.a.createElement(t, bi({}, this.props, {
              animation: null,
              hideSeries: !0,
              style: {
                stroke: "red"
              }
            })));
          }

          var m = this.state.scaleProps,
              g = m.radiusDomain,
              v = ho(m, "radius"),
              b = yo(m, "radius"),
              _ = ho(m, "angle"),
              x = yo(m, "angle"),
              O = this._getAttributeFunctor("fill") || this._getAttributeFunctor("color"),
              w = this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color"),
              T = this._getAttributeFunctor("opacity"),
              k = this._getAttributeFunctor("x"),
              M = this._getAttributeFunctor("y");

          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--arc " + o,
            onMouseOver: this._seriesMouseOverHandler,
            onMouseOut: this._seriesMouseOutHandler,
            onClick: this._seriesClickHandler,
            onContextMenu: this._seriesRightClickHandler,
            opacity: s ? 0 : 1,
            pointerEvents: l ? "none" : "all",
            transform: "translate(" + (c + k(i)) + "," + (p + M(i)) + ")"
          }, u.map(function (t, n) {
            var a = {
              innerRadius: g[1] === g[0] ? 0 : b(t),
              outerRadius: v(t),
              startAngle: x(t) || 0,
              endAngle: _(t)
            },
                o = gi().padAngle(h),
                i = t.style || {},
                u = t.className || "";
            return f.a.createElement("path", {
              style: bi({
                opacity: T && T(t),
                stroke: w && w(t),
                fill: O && O(t)
              }, d, i),
              onClick: function onClick(n) {
                return e._valueClickHandler(Oi(t), n);
              },
              onContextMenu: function onContextMenu(n) {
                return e._valueRightClickHandler(Oi(t), n);
              },
              onMouseOver: function onMouseOver(n) {
                return e._valueMouseOverHandler(Oi(t), n);
              },
              onMouseOut: function onMouseOut(n) {
                return e._valueMouseOutHandler(Oi(t), n);
              },
              key: n,
              className: "rv-xy-plot__series rv-xy-plot__series--arc-path " + r + " " + u,
              d: o(a)
            });
          }));
        }
      }]), t;
    }(So);

    wi.propTypes = bi({}, So.propTypes, go("radius"), go("angle"), {
      center: h.a.shape({
        x: h.a.number,
        y: h.a.number
      }),
      arcClassName: h.a.string,
      padAngle: h.a.oneOfType([h.a.func, h.a.number])
    }), wi.defaultProps = xi, wi.displayName = "ArcSeries";
    var Ti = wi;

    function ki(e) {
      this._context = e;
    }

    ki.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(e, t) {
        switch (e = +e, t = +t, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
            break;

          case 1:
            this._point = 2;

          default:
            this._context.lineTo(e, t);

        }
      }
    };

    var Mi = function Mi(e) {
      return new ki(e);
    };

    function Ei(e) {
      return e[0];
    }

    function Pi(e) {
      return e[1];
    }

    var ji = function ji() {
      var e = Ei,
          t = Pi,
          n = Jo(!0),
          r = null,
          a = Mi,
          o = null;

      function i(i) {
        var u,
            l,
            s,
            c = i.length,
            f = !1;

        for (null == r && (o = a(s = Zo())), u = 0; u <= c; ++u) {
          !(u < c && n(l = i[u], u, i)) === f && ((f = !f) ? o.lineStart() : o.lineEnd()), f && o.point(+e(l, u, i), +t(l, u, i));
        }

        if (s) return o = null, s + "" || null;
      }

      return i.x = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : Jo(+t), i) : e;
      }, i.y = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Jo(+e), i) : t;
      }, i.defined = function (e) {
        return arguments.length ? (n = "function" == typeof e ? e : Jo(!!e), i) : n;
      }, i.curve = function (e) {
        return arguments.length ? (a = e, null != r && (o = a(r)), i) : a;
      }, i.context = function (e) {
        return arguments.length ? (null == e ? r = o = null : o = a(r = e), i) : r;
      }, i;
    },
        Si = function Si() {
      var e = Ei,
          t = null,
          n = Jo(0),
          r = Pi,
          a = Jo(!0),
          o = null,
          i = Mi,
          u = null;

      function l(l) {
        var s,
            c,
            f,
            p,
            h,
            d = l.length,
            y = !1,
            m = new Array(d),
            g = new Array(d);

        for (null == o && (u = i(h = Zo())), s = 0; s <= d; ++s) {
          if (!(s < d && a(p = l[s], s, l)) === y) if (y = !y) c = s, u.areaStart(), u.lineStart();else {
            for (u.lineEnd(), u.lineStart(), f = s - 1; f >= c; --f) {
              u.point(m[f], g[f]);
            }

            u.lineEnd(), u.areaEnd();
          }
          y && (m[s] = +e(p, s, l), g[s] = +n(p, s, l), u.point(t ? +t(p, s, l) : m[s], r ? +r(p, s, l) : g[s]));
        }

        if (h) return u = null, h + "" || null;
      }

      function s() {
        return ji().defined(a).curve(i).context(o);
      }

      return l.x = function (n) {
        return arguments.length ? (e = "function" == typeof n ? n : Jo(+n), t = null, l) : e;
      }, l.x0 = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : Jo(+t), l) : e;
      }, l.x1 = function (e) {
        return arguments.length ? (t = null == e ? null : "function" == typeof e ? e : Jo(+e), l) : t;
      }, l.y = function (e) {
        return arguments.length ? (n = "function" == typeof e ? e : Jo(+e), r = null, l) : n;
      }, l.y0 = function (e) {
        return arguments.length ? (n = "function" == typeof e ? e : Jo(+e), l) : n;
      }, l.y1 = function (e) {
        return arguments.length ? (r = null == e ? null : "function" == typeof e ? e : Jo(+e), l) : r;
      }, l.lineX0 = l.lineY0 = function () {
        return s().x(e).y(n);
      }, l.lineY1 = function () {
        return s().x(e).y(r);
      }, l.lineX1 = function () {
        return s().x(t).y(n);
      }, l.defined = function (e) {
        return arguments.length ? (a = "function" == typeof e ? e : Jo(!!e), l) : a;
      }, l.curve = function (e) {
        return arguments.length ? (i = e, null != o && (u = i(o)), l) : i;
      }, l.context = function (e) {
        return arguments.length ? (null == e ? o = u = null : u = i(o = e), l) : o;
      }, l;
    },
        Ai = function Ai(e, t) {
      return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    },
        Ni = function Ni(e) {
      return e;
    },
        Ci = function Ci() {
      var e = Ni,
          t = Ai,
          n = null,
          r = Jo(0),
          a = Jo(ui),
          o = Jo(0);

      function i(i) {
        var u,
            l,
            s,
            c,
            f,
            p = i.length,
            h = 0,
            d = new Array(p),
            y = new Array(p),
            m = +r.apply(this, arguments),
            g = Math.min(ui, Math.max(-ui, a.apply(this, arguments) - m)),
            v = Math.min(Math.abs(g) / p, o.apply(this, arguments)),
            b = v * (g < 0 ? -1 : 1);

        for (u = 0; u < p; ++u) {
          (f = y[d[u] = u] = +e(i[u], u, i)) > 0 && (h += f);
        }

        for (null != t ? d.sort(function (e, n) {
          return t(y[e], y[n]);
        }) : null != n && d.sort(function (e, t) {
          return n(i[e], i[t]);
        }), u = 0, s = h ? (g - p * b) / h : 0; u < p; ++u, m = c) {
          l = d[u], c = m + ((f = y[l]) > 0 ? f * s : 0) + b, y[l] = {
            data: i[l],
            index: u,
            value: f,
            startAngle: m,
            endAngle: c,
            padAngle: v
          };
        }

        return y;
      }

      return i.value = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : Jo(+t), i) : e;
      }, i.sortValues = function (e) {
        return arguments.length ? (t = e, n = null, i) : t;
      }, i.sort = function (e) {
        return arguments.length ? (n = e, t = null, i) : n;
      }, i.startAngle = function (e) {
        return arguments.length ? (r = "function" == typeof e ? e : Jo(+e), i) : r;
      }, i.endAngle = function (e) {
        return arguments.length ? (a = "function" == typeof e ? e : Jo(+e), i) : a;
      }, i.padAngle = function (e) {
        return arguments.length ? (o = "function" == typeof e ? e : Jo(+e), i) : o;
      }, i;
    },
        Fi = Li(Mi);

    function Ri(e) {
      this._curve = e;
    }

    function Li(e) {
      function t(t) {
        return new Ri(e(t));
      }

      return t._curve = e, t;
    }

    function Di(e) {
      var t = e.curve;
      return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e.curve = function (e) {
        return arguments.length ? t(Li(e)) : t()._curve;
      }, e;
    }

    Ri.prototype = {
      areaStart: function areaStart() {
        this._curve.areaStart();
      },
      areaEnd: function areaEnd() {
        this._curve.areaEnd();
      },
      lineStart: function lineStart() {
        this._curve.lineStart();
      },
      lineEnd: function lineEnd() {
        this._curve.lineEnd();
      },
      point: function point(e, t) {
        this._curve.point(t * Math.sin(e), t * -Math.cos(e));
      }
    };

    var qi = function qi() {
      return Di(ji().curve(Fi));
    },
        Vi = function Vi() {
      var e = Si().curve(Fi),
          t = e.curve,
          n = e.lineX0,
          r = e.lineX1,
          a = e.lineY0,
          o = e.lineY1;
      return e.angle = e.x, delete e.x, e.startAngle = e.x0, delete e.x0, e.endAngle = e.x1, delete e.x1, e.radius = e.y, delete e.y, e.innerRadius = e.y0, delete e.y0, e.outerRadius = e.y1, delete e.y1, e.lineStartAngle = function () {
        return Di(n());
      }, delete e.lineX0, e.lineEndAngle = function () {
        return Di(r());
      }, delete e.lineX1, e.lineInnerRadius = function () {
        return Di(a());
      }, delete e.lineY0, e.lineOuterRadius = function () {
        return Di(o());
      }, delete e.lineY1, e.curve = function (e) {
        return arguments.length ? t(Li(e)) : t()._curve;
      }, e;
    },
        zi = function zi(e, t) {
      return [(t = +t) * Math.cos(e -= Math.PI / 2), t * Math.sin(e)];
    },
        Ii = Array.prototype.slice;

    function Hi(e) {
      return e.source;
    }

    function Bi(e) {
      return e.target;
    }

    function Ui(e) {
      var t = Hi,
          n = Bi,
          r = Ei,
          a = Pi,
          o = null;

      function i() {
        var i,
            u = Ii.call(arguments),
            l = t.apply(this, u),
            s = n.apply(this, u);
        if (o || (o = i = Zo()), e(o, +r.apply(this, (u[0] = l, u)), +a.apply(this, u), +r.apply(this, (u[0] = s, u)), +a.apply(this, u)), i) return o = null, i + "" || null;
      }

      return i.source = function (e) {
        return arguments.length ? (t = e, i) : t;
      }, i.target = function (e) {
        return arguments.length ? (n = e, i) : n;
      }, i.x = function (e) {
        return arguments.length ? (r = "function" == typeof e ? e : Jo(+e), i) : r;
      }, i.y = function (e) {
        return arguments.length ? (a = "function" == typeof e ? e : Jo(+e), i) : a;
      }, i.context = function (e) {
        return arguments.length ? (o = null == e ? null : e, i) : o;
      }, i;
    }

    function Wi(e, t, n, r, a) {
      e.moveTo(t, n), e.bezierCurveTo(t = (t + r) / 2, n, t, a, r, a);
    }

    function Yi(e, t, n, r, a) {
      e.moveTo(t, n), e.bezierCurveTo(t, n = (n + a) / 2, r, n, r, a);
    }

    function Xi(e, t, n, r, a) {
      var o = zi(t, n),
          i = zi(t, n = (n + a) / 2),
          u = zi(r, n),
          l = zi(r, a);
      e.moveTo(o[0], o[1]), e.bezierCurveTo(i[0], i[1], u[0], u[1], l[0], l[1]);
    }

    function Gi() {
      return Ui(Wi);
    }

    function $i() {
      return Ui(Yi);
    }

    function Zi() {
      var e = Ui(Xi);
      return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e;
    }

    var Ji = {
      draw: function draw(e, t) {
        var n = Math.sqrt(t / oi);
        e.moveTo(n, 0), e.arc(0, 0, n, 0, ui);
      }
    },
        Qi = {
      draw: function draw(e, t) {
        var n = Math.sqrt(t / 5) / 2;
        e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
      }
    },
        Ki = Math.sqrt(1 / 3),
        eu = 2 * Ki,
        tu = {
      draw: function draw(e, t) {
        var n = Math.sqrt(t / eu),
            r = n * Ki;
        e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
      }
    },
        nu = Math.sin(oi / 10) / Math.sin(7 * oi / 10),
        ru = Math.sin(ui / 10) * nu,
        au = -Math.cos(ui / 10) * nu,
        ou = {
      draw: function draw(e, t) {
        var n = Math.sqrt(.8908130915292852 * t),
            r = ru * n,
            a = au * n;
        e.moveTo(0, -n), e.lineTo(r, a);

        for (var o = 1; o < 5; ++o) {
          var i = ui * o / 5,
              u = Math.cos(i),
              l = Math.sin(i);
          e.lineTo(l * n, -u * n), e.lineTo(u * r - l * a, l * r + u * a);
        }

        e.closePath();
      }
    },
        iu = {
      draw: function draw(e, t) {
        var n = Math.sqrt(t),
            r = -n / 2;
        e.rect(r, r, n, n);
      }
    },
        uu = Math.sqrt(3),
        lu = {
      draw: function draw(e, t) {
        var n = -Math.sqrt(t / (3 * uu));
        e.moveTo(0, 2 * n), e.lineTo(-uu * n, -n), e.lineTo(uu * n, -n), e.closePath();
      }
    },
        su = Math.sqrt(3) / 2,
        cu = 1 / Math.sqrt(12),
        fu = 3 * (cu / 2 + 1),
        pu = {
      draw: function draw(e, t) {
        var n = Math.sqrt(t / fu),
            r = n / 2,
            a = n * cu,
            o = r,
            i = n * cu + n,
            u = -o,
            l = i;
        e.moveTo(r, a), e.lineTo(o, i), e.lineTo(u, l), e.lineTo(-.5 * r - su * a, su * r + -.5 * a), e.lineTo(-.5 * o - su * i, su * o + -.5 * i), e.lineTo(-.5 * u - su * l, su * u + -.5 * l), e.lineTo(-.5 * r + su * a, -.5 * a - su * r), e.lineTo(-.5 * o + su * i, -.5 * i - su * o), e.lineTo(-.5 * u + su * l, -.5 * l - su * u), e.closePath();
      }
    },
        hu = [Ji, Qi, tu, iu, ou, lu, pu],
        du = function du() {
      var e = Jo(Ji),
          t = Jo(64),
          n = null;

      function r() {
        var r;
        if (n || (n = r = Zo()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), r) return n = null, r + "" || null;
      }

      return r.type = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : Jo(t), r) : e;
      }, r.size = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Jo(+e), r) : t;
      }, r.context = function (e) {
        return arguments.length ? (n = null == e ? null : e, r) : n;
      }, r;
    },
        yu = function yu() {};

    function mu(e, t, n) {
      e._context.bezierCurveTo((2 * e._x0 + e._x1) / 3, (2 * e._y0 + e._y1) / 3, (e._x0 + 2 * e._x1) / 3, (e._y0 + 2 * e._y1) / 3, (e._x0 + 4 * e._x1 + t) / 6, (e._y0 + 4 * e._y1 + n) / 6);
    }

    function gu(e) {
      this._context = e;
    }

    gu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 3:
            mu(this, this._x1, this._y1);

          case 2:
            this._context.lineTo(this._x1, this._y1);

        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(e, t) {
        switch (e = +e, t = +t, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

          default:
            mu(this, e, t);
        }

        this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
      }
    };

    var vu = function vu(e) {
      return new gu(e);
    };

    function bu(e) {
      this._context = e;
    }

    bu.prototype = {
      areaStart: yu,
      areaEnd: yu,
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 1:
            this._context.moveTo(this._x2, this._y2), this._context.closePath();
            break;

          case 2:
            this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
            break;

          case 3:
            this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        }
      },
      point: function point(e, t) {
        switch (e = +e, t = +t, this._point) {
          case 0:
            this._point = 1, this._x2 = e, this._y2 = t;
            break;

          case 1:
            this._point = 2, this._x3 = e, this._y3 = t;
            break;

          case 2:
            this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
            break;

          default:
            mu(this, e, t);
        }

        this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
      }
    };

    var _u = function _u(e) {
      return new bu(e);
    };

    function xu(e) {
      this._context = e;
    }

    xu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(e, t) {
        switch (e = +e, t = +t, this._point) {
          case 0:
            this._point = 1;
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3;
            var n = (this._x0 + 4 * this._x1 + e) / 6,
                r = (this._y0 + 4 * this._y1 + t) / 6;
            this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
            break;

          case 3:
            this._point = 4;

          default:
            mu(this, e, t);
        }

        this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
      }
    };

    var Ou = function Ou(e) {
      return new xu(e);
    };

    function wu(e, t) {
      this._basis = new gu(e), this._beta = t;
    }

    wu.prototype = {
      lineStart: function lineStart() {
        this._x = [], this._y = [], this._basis.lineStart();
      },
      lineEnd: function lineEnd() {
        var e = this._x,
            t = this._y,
            n = e.length - 1;
        if (n > 0) for (var r, a = e[0], o = t[0], i = e[n] - a, u = t[n] - o, l = -1; ++l <= n;) {
          r = l / n, this._basis.point(this._beta * e[l] + (1 - this._beta) * (a + r * i), this._beta * t[l] + (1 - this._beta) * (o + r * u));
        }
        this._x = this._y = null, this._basis.lineEnd();
      },
      point: function point(e, t) {
        this._x.push(+e), this._y.push(+t);
      }
    };

    var Tu = function e(t) {
      function n(e) {
        return 1 === t ? new gu(e) : new wu(e, t);
      }

      return n.beta = function (t) {
        return e(+t);
      }, n;
    }(.85);

    function ku(e, t, n) {
      e._context.bezierCurveTo(e._x1 + e._k * (e._x2 - e._x0), e._y1 + e._k * (e._y2 - e._y0), e._x2 + e._k * (e._x1 - t), e._y2 + e._k * (e._y1 - n), e._x2, e._y2);
    }

    function Mu(e, t) {
      this._context = e, this._k = (1 - t) / 6;
    }

    Mu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x2, this._y2);

            break;

          case 3:
            ku(this, this._x1, this._y1);
        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(e, t) {
        switch (e = +e, t = +t, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
            break;

          case 1:
            this._point = 2, this._x1 = e, this._y1 = t;
            break;

          case 2:
            this._point = 3;

          default:
            ku(this, e, t);
        }

        this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
      }
    };

    var Eu = function e(t) {
      function n(e) {
        return new Mu(e, t);
      }

      return n.tension = function (t) {
        return e(+t);
      }, n;
    }(0);

    function Pu(e, t) {
      this._context = e, this._k = (1 - t) / 6;
    }

    Pu.prototype = {
      areaStart: yu,
      areaEnd: yu,
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 1:
            this._context.moveTo(this._x3, this._y3), this._context.closePath();
            break;

          case 2:
            this._context.lineTo(this._x3, this._y3), this._context.closePath();
            break;

          case 3:
            this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        }
      },
      point: function point(e, t) {
        switch (e = +e, t = +t, this._point) {
          case 0:
            this._point = 1, this._x3 = e, this._y3 = t;
            break;

          case 1:
            this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
            break;

          case 2:
            this._point = 3, this._x5 = e, this._y5 = t;
            break;

          default:
            ku(this, e, t);
        }

        this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
      }
    };

    var ju = function e(t) {
      function n(e) {
        return new Pu(e, t);
      }

      return n.tension = function (t) {
        return e(+t);
      }, n;
    }(0);

    function Su(e, t) {
      this._context = e, this._k = (1 - t) / 6;
    }

    Su.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(e, t) {
        switch (e = +e, t = +t, this._point) {
          case 0:
            this._point = 1;
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
            break;

          case 3:
            this._point = 4;

          default:
            ku(this, e, t);
        }

        this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
      }
    };

    var Au = function e(t) {
      function n(e) {
        return new Su(e, t);
      }

      return n.tension = function (t) {
        return e(+t);
      }, n;
    }(0);

    function Nu(e, t, n) {
      var r = e._x1,
          a = e._y1,
          o = e._x2,
          i = e._y2;

      if (e._l01_a > 1e-12) {
        var u = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a,
            l = 3 * e._l01_a * (e._l01_a + e._l12_a);
        r = (r * u - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / l, a = (a * u - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / l;
      }

      if (e._l23_a > 1e-12) {
        var s = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a,
            c = 3 * e._l23_a * (e._l23_a + e._l12_a);
        o = (o * s + e._x1 * e._l23_2a - t * e._l12_2a) / c, i = (i * s + e._y1 * e._l23_2a - n * e._l12_2a) / c;
      }

      e._context.bezierCurveTo(r, a, o, i, e._x2, e._y2);
    }

    function Cu(e, t) {
      this._context = e, this._alpha = t;
    }

    Cu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x2, this._y2);

            break;

          case 3:
            this.point(this._x2, this._y2);
        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(e, t) {
        if (e = +e, t = +t, this._point) {
          var n = this._x2 - e,
              r = this._y2 - t;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
        }

        switch (this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3;

          default:
            Nu(this, e, t);
        }

        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
      }
    };

    var Fu = function e(t) {
      function n(e) {
        return t ? new Cu(e, t) : new Mu(e, 0);
      }

      return n.alpha = function (t) {
        return e(+t);
      }, n;
    }(.5);

    function Ru(e, t) {
      this._context = e, this._alpha = t;
    }

    Ru.prototype = {
      areaStart: yu,
      areaEnd: yu,
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 1:
            this._context.moveTo(this._x3, this._y3), this._context.closePath();
            break;

          case 2:
            this._context.lineTo(this._x3, this._y3), this._context.closePath();
            break;

          case 3:
            this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        }
      },
      point: function point(e, t) {
        if (e = +e, t = +t, this._point) {
          var n = this._x2 - e,
              r = this._y2 - t;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
        }

        switch (this._point) {
          case 0:
            this._point = 1, this._x3 = e, this._y3 = t;
            break;

          case 1:
            this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
            break;

          case 2:
            this._point = 3, this._x5 = e, this._y5 = t;
            break;

          default:
            Nu(this, e, t);
        }

        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
      }
    };

    var Lu = function e(t) {
      function n(e) {
        return t ? new Ru(e, t) : new Pu(e, 0);
      }

      return n.alpha = function (t) {
        return e(+t);
      }, n;
    }(.5);

    function Du(e, t) {
      this._context = e, this._alpha = t;
    }

    Du.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
      },
      lineEnd: function lineEnd() {
        (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(e, t) {
        if (e = +e, t = +t, this._point) {
          var n = this._x2 - e,
              r = this._y2 - t;
          this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
        }

        switch (this._point) {
          case 0:
            this._point = 1;
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
            break;

          case 3:
            this._point = 4;

          default:
            Nu(this, e, t);
        }

        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
      }
    };

    var qu = function e(t) {
      function n(e) {
        return t ? new Du(e, t) : new Su(e, 0);
      }

      return n.alpha = function (t) {
        return e(+t);
      }, n;
    }(.5);

    function Vu(e) {
      this._context = e;
    }

    Vu.prototype = {
      areaStart: yu,
      areaEnd: yu,
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        this._point && this._context.closePath();
      },
      point: function point(e, t) {
        e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
      }
    };

    var zu = function zu(e) {
      return new Vu(e);
    };

    function Iu(e) {
      return e < 0 ? -1 : 1;
    }

    function Hu(e, t, n) {
      var r = e._x1 - e._x0,
          a = t - e._x1,
          o = (e._y1 - e._y0) / (r || a < 0 && -0),
          i = (n - e._y1) / (a || r < 0 && -0),
          u = (o * a + i * r) / (r + a);
      return (Iu(o) + Iu(i)) * Math.min(Math.abs(o), Math.abs(i), .5 * Math.abs(u)) || 0;
    }

    function Bu(e, t) {
      var n = e._x1 - e._x0;
      return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
    }

    function Uu(e, t, n) {
      var r = e._x0,
          a = e._y0,
          o = e._x1,
          i = e._y1,
          u = (o - r) / 3;

      e._context.bezierCurveTo(r + u, a + u * t, o - u, i - u * n, o, i);
    }

    function Wu(e) {
      this._context = e;
    }

    function Yu(e) {
      this._context = new Xu(e);
    }

    function Xu(e) {
      this._context = e;
    }

    function Gu(e) {
      return new Wu(e);
    }

    function $u(e) {
      return new Yu(e);
    }

    function Zu(e) {
      this._context = e;
    }

    function Ju(e) {
      var t,
          n,
          r = e.length - 1,
          a = new Array(r),
          o = new Array(r),
          i = new Array(r);

      for (a[0] = 0, o[0] = 2, i[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) {
        a[t] = 1, o[t] = 4, i[t] = 4 * e[t] + 2 * e[t + 1];
      }

      for (a[r - 1] = 2, o[r - 1] = 7, i[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) {
        n = a[t] / o[t - 1], o[t] -= n, i[t] -= n * i[t - 1];
      }

      for (a[r - 1] = i[r - 1] / o[r - 1], t = r - 2; t >= 0; --t) {
        a[t] = (i[t] - a[t + 1]) / o[t];
      }

      for (o[r - 1] = (e[r] + a[r - 1]) / 2, t = 0; t < r - 1; ++t) {
        o[t] = 2 * e[t + 1] - a[t + 1];
      }

      return [a, o];
    }

    Wu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        switch (this._point) {
          case 2:
            this._context.lineTo(this._x1, this._y1);

            break;

          case 3:
            Uu(this, this._t0, Bu(this, this._t0));
        }

        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
      },
      point: function point(e, t) {
        var n = NaN;

        if (t = +t, (e = +e) !== this._x1 || t !== this._y1) {
          switch (this._point) {
            case 0:
              this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
              break;

            case 1:
              this._point = 2;
              break;

            case 2:
              this._point = 3, Uu(this, Bu(this, n = Hu(this, e, t)), n);
              break;

            default:
              Uu(this, this._t0, n = Hu(this, e, t));
          }

          this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
        }
      }
    }, (Yu.prototype = Object.create(Wu.prototype)).point = function (e, t) {
      Wu.prototype.point.call(this, t, e);
    }, Xu.prototype = {
      moveTo: function moveTo(e, t) {
        this._context.moveTo(t, e);
      },
      closePath: function closePath() {
        this._context.closePath();
      },
      lineTo: function lineTo(e, t) {
        this._context.lineTo(t, e);
      },
      bezierCurveTo: function bezierCurveTo(e, t, n, r, a, o) {
        this._context.bezierCurveTo(t, e, r, n, o, a);
      }
    }, Zu.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x = [], this._y = [];
      },
      lineEnd: function lineEnd() {
        var e = this._x,
            t = this._y,
            n = e.length;
        if (n) if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), 2 === n) this._context.lineTo(e[1], t[1]);else for (var r = Ju(e), a = Ju(t), o = 0, i = 1; i < n; ++o, ++i) {
          this._context.bezierCurveTo(r[0][o], a[0][o], r[1][o], a[1][o], e[i], t[i]);
        }
        (this._line || 0 !== this._line && 1 === n) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
      },
      point: function point(e, t) {
        this._x.push(+e), this._y.push(+t);
      }
    };

    var Qu = function Qu(e) {
      return new Zu(e);
    };

    function Ku(e, t) {
      this._context = e, this._t = t;
    }

    Ku.prototype = {
      areaStart: function areaStart() {
        this._line = 0;
      },
      areaEnd: function areaEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._x = this._y = NaN, this._point = 0;
      },
      lineEnd: function lineEnd() {
        0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
      },
      point: function point(e, t) {
        switch (e = +e, t = +t, this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
            break;

          case 1:
            this._point = 2;

          default:
            if (this._t <= 0) this._context.lineTo(this._x, t), this._context.lineTo(e, t);else {
              var n = this._x * (1 - this._t) + e * this._t;
              this._context.lineTo(n, this._y), this._context.lineTo(n, t);
            }
        }

        this._x = e, this._y = t;
      }
    };

    var el = function el(e) {
      return new Ku(e, .5);
    };

    function tl(e) {
      return new Ku(e, 0);
    }

    function nl(e) {
      return new Ku(e, 1);
    }

    var rl = function rl(e, t) {
      if ((a = e.length) > 1) for (var n, r, a, o = 1, i = e[t[0]], u = i.length; o < a; ++o) {
        for (r = i, i = e[t[o]], n = 0; n < u; ++n) {
          i[n][1] += i[n][0] = isNaN(r[n][1]) ? r[n][0] : r[n][1];
        }
      }
    },
        al = function al(e) {
      for (var t = e.length, n = new Array(t); --t >= 0;) {
        n[t] = t;
      }

      return n;
    };

    function ol(e, t) {
      return e[t];
    }

    var il = function il() {
      var e = Jo([]),
          t = al,
          n = rl,
          r = ol;

      function a(a) {
        var o,
            i,
            u = e.apply(this, arguments),
            l = a.length,
            s = u.length,
            c = new Array(s);

        for (o = 0; o < s; ++o) {
          for (var f, p = u[o], h = c[o] = new Array(l), d = 0; d < l; ++d) {
            h[d] = f = [0, +r(a[d], p, d, a)], f.data = a[d];
          }

          h.key = p;
        }

        for (o = 0, i = t(c); o < s; ++o) {
          c[i[o]].index = o;
        }

        return n(c, i), c;
      }

      return a.keys = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : Jo(Ii.call(t)), a) : e;
      }, a.value = function (e) {
        return arguments.length ? (r = "function" == typeof e ? e : Jo(+e), a) : r;
      }, a.order = function (e) {
        return arguments.length ? (t = null == e ? al : "function" == typeof e ? e : Jo(Ii.call(e)), a) : t;
      }, a.offset = function (e) {
        return arguments.length ? (n = null == e ? rl : e, a) : n;
      }, a;
    },
        ul = function ul(e, t) {
      if ((r = e.length) > 0) {
        for (var n, r, a, o = 0, i = e[0].length; o < i; ++o) {
          for (a = n = 0; n < r; ++n) {
            a += e[n][o][1] || 0;
          }

          if (a) for (n = 0; n < r; ++n) {
            e[n][o][1] /= a;
          }
        }

        rl(e, t);
      }
    },
        ll = function ll(e, t) {
      if ((u = e.length) > 0) for (var n, r, a, o, i, u, l = 0, s = e[t[0]].length; l < s; ++l) {
        for (o = i = 0, n = 0; n < u; ++n) {
          (a = (r = e[t[n]][l])[1] - r[0]) > 0 ? (r[0] = o, r[1] = o += a) : a < 0 ? (r[1] = i, r[0] = i += a) : (r[0] = 0, r[1] = a);
        }
      }
    },
        sl = function sl(e, t) {
      if ((n = e.length) > 0) {
        for (var n, r = 0, a = e[t[0]], o = a.length; r < o; ++r) {
          for (var i = 0, u = 0; i < n; ++i) {
            u += e[i][r][1] || 0;
          }

          a[r][1] += a[r][0] = -u / 2;
        }

        rl(e, t);
      }
    },
        cl = function cl(e, t) {
      if ((a = e.length) > 0 && (r = (n = e[t[0]]).length) > 0) {
        for (var n, r, a, o = 0, i = 1; i < r; ++i) {
          for (var u = 0, l = 0, s = 0; u < a; ++u) {
            for (var c = e[t[u]], f = c[i][1] || 0, p = (f - (c[i - 1][1] || 0)) / 2, h = 0; h < u; ++h) {
              var d = e[t[h]];
              p += (d[i][1] || 0) - (d[i - 1][1] || 0);
            }

            l += f, s += p * f;
          }

          n[i - 1][1] += n[i - 1][0] = o, l && (o -= s / l);
        }

        n[i - 1][1] += n[i - 1][0] = o, rl(e, t);
      }
    },
        fl = function fl(e) {
      var t = e.map(pl);
      return al(e).sort(function (e, n) {
        return t[e] - t[n];
      });
    };

    function pl(e) {
      for (var t, n = -1, r = 0, a = e.length, o = -1 / 0; ++n < a;) {
        (t = +e[n][1]) > o && (o = t, r = n);
      }

      return r;
    }

    var hl = function hl(e) {
      var t = e.map(dl);
      return al(e).sort(function (e, n) {
        return t[e] - t[n];
      });
    };

    function dl(e) {
      for (var t, n = 0, r = -1, a = e.length; ++r < a;) {
        (t = +e[r][1]) && (n += t);
      }

      return n;
    }

    var yl = function yl(e) {
      return hl(e).reverse();
    },
        ml = function ml(e) {
      var t,
          n,
          r = e.length,
          a = e.map(dl),
          o = fl(e),
          i = 0,
          u = 0,
          l = [],
          s = [];

      for (t = 0; t < r; ++t) {
        n = o[t], i < u ? (i += a[n], l.push(n)) : (u += a[n], s.push(n));
      }

      return s.reverse().concat(l);
    },
        gl = function gl(e) {
      return al(e).reverse();
    },
        vl = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        bl = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function _l(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function xl(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Ol = function (e) {
      function t() {
        return _l(this, t), xl(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), bl(t, [{
        key: "_renderArea",
        value: function value(e, t, n, a, o, i) {
          var u = Si();
          return null !== o && ("string" == typeof o && r[o] ? u = u.curve(r[o]) : "function" == typeof o && (u = u.curve(o))), (u = (u = u.defined(i)).x(t).y0(n).y1(a))(e);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.animation,
              r = e.className,
              a = e.curve,
              o = e.data,
              i = e.marginLeft,
              u = e.marginTop,
              l = e.style;
          if (this.props.nullAccessor && Object($a.b)("nullAccessor has been renamed to getNull", !0), !o) return null;
          if (n) return f.a.createElement(ut, vl({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, vl({}, this.props, {
            animation: null
          })));

          var s = this._getAttributeFunctor("x"),
              c = this._getAttributeFunctor("y"),
              p = this._getAttr0Functor("y"),
              h = this._getAttributeValue("stroke") || this._getAttributeValue("color"),
              d = this._getAttributeValue("fill") || this._getAttributeValue("color"),
              y = this._getAttributeValue("opacity"),
              m = Number.isFinite(y) ? y : 1,
              g = this.props.nullAccessor || this.props.getNull,
              v = this._renderArea(o, s, p, c, a, g);

          return f.a.createElement("path", {
            d: v,
            className: "rv-xy-plot__series rv-xy-plot__series--line " + r,
            transform: "translate(" + i + "," + u + ")",
            onMouseOver: this._seriesMouseOverHandler,
            onMouseOut: this._seriesMouseOutHandler,
            onClick: this._seriesClickHandler,
            onContextMenu: this._seriesRightClickHandler,
            style: vl({
              opacity: m,
              stroke: h,
              fill: d
            }, l)
          });
        }
      }]), t;
    }(So);

    Ol.displayName = "AreaSeries", Ol.propTypes = vl({}, So.propTypes, {
      getNull: h.a.func
    }), Ol.defaultProps = vl({}, So.defaultProps, {
      getNull: function getNull() {
        return !0;
      }
    });

    var wl = Ol,
        Tl = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        kl = {
      style: h.a.shape({
        bottom: h.a.object,
        left: h.a.object,
        right: h.a.object,
        top: h.a.object
      }),
      marginTop: h.a.number,
      marginBottom: h.a.number,
      marginLeft: h.a.number,
      marginRight: h.a.number,
      innerWidth: h.a.number,
      innerHeight: h.a.number
    },
        Ml = "rv-xy-plot__borders-bottom",
        El = "rv-xy-plot__borders",
        Pl = "rv-xy-plot__borders-left",
        jl = "rv-xy-plot__borders-right",
        Sl = "rv-xy-plot__borders-top";

    function Al(e) {
      var t = e.marginTop,
          n = e.marginBottom,
          r = e.marginLeft,
          a = e.marginRight,
          o = e.innerWidth,
          i = e.innerHeight,
          u = e.style,
          l = e.className,
          s = i + t + n,
          c = o + r + a;
      return f.a.createElement("g", {
        className: El + " " + l
      }, f.a.createElement("rect", {
        className: Ml + " " + l + "-bottom",
        style: Tl({}, u.all, u.bottom),
        x: 0,
        y: s - n,
        width: c,
        height: n
      }), f.a.createElement("rect", {
        className: Pl + " " + l + "-left",
        style: Tl({}, u.all, u.left),
        x: 0,
        y: 0,
        width: r,
        height: s
      }), f.a.createElement("rect", {
        className: jl + " " + l + "-right",
        style: Tl({}, u.all, u.right),
        x: c - a,
        y: 0,
        width: a,
        height: s
      }), f.a.createElement("rect", {
        className: Sl + " " + l + "-top",
        style: Tl({}, u.all, u.top),
        x: 0,
        y: 0,
        width: c,
        height: t
      }));
    }

    Al.displayName = "Borders", Al.defaultProps = {
      className: "",
      style: {
        all: {},
        bottom: {},
        left: {},
        right: {},
        top: {}
      }
    }, Al.propTypes = kl, Al.requiresSVG = !0;

    var Nl = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Cl(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Fl(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Rl = function (e) {
      function t() {
        return Cl(this, t), Fl(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Nl(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.innerHeight,
              n = e.innerWidth,
              r = e.marginBottom,
              a = e.marginLeft,
              o = e.marginRight,
              i = e.marginTop,
              u = e.className,
              l = e.includeMargin,
              s = e.style,
              c = e.text,
              p = (n + (l ? a + o : 0)) * e.xPercent + (l ? 0 : a),
              h = (t + (l ? i + r : 0)) * e.yPercent + (l ? a : 0);
          return f.a.createElement("g", {
            transform: "translate(" + p + ", " + h + ")",
            className: "rv-xy-plot__axis__title " + u
          }, f.a.createElement("text", s, c));
        }
      }], [{
        key: "requiresSVG",
        get: function get() {
          return !0;
        }
      }]), t;
    }(f.a.PureComponent);

    Rl.displayName = "ChartLabel", Rl.propTypes = {
      className: h.a.string,
      includeMargin: h.a.bool,
      style: h.a.object,
      text: h.a.string.isRequired,
      xPercent: h.a.number.isRequired,
      yPercent: h.a.number.isRequired
    }, Rl.defaultProps = {
      className: "",
      includeMargin: !0,
      text: "",
      xPercent: 0,
      yPercent: 0,
      style: {}
    };
    var Ll = Rl,
        Dl = {
      TOP: "top",
      LEFT: "left",
      RIGHT: "right",
      BOTTOM: "bottom",
      VERTICAL: "vertical",
      HORIZONTAL: "horizontal"
    },
        ql = {
      VERTICAL: "vertical",
      HORIZONTAL: "horizontal"
    };

    function Vl(e) {
      return e < 700 ? e > 300 ? 10 : 5 : 20;
    }

    function zl(e, t, n) {
      return n || (e.ticks ? e.ticks(t) : e.domain());
    }

    var Il = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Hl = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Bl(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ul(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Wl = ["xRange", "yRange", "xDomain", "yDomain", "width", "height", "marginLeft", "marginTop", "marginRight", "marginBottom", "tickTotal"],
        Yl = function (e) {
      function t() {
        return Bl(this, t), Ul(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Hl(t, [{
        key: "_getDefaultProps",
        value: function value() {
          var e = this.props,
              t = e.innerWidth,
              n = e.innerHeight,
              r = e.marginTop;
          return {
            left: e.marginLeft,
            top: r,
            width: t,
            height: n,
            style: {},
            tickTotal: Vl(Math.min(t, n))
          };
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.animation,
              r = e.centerX,
              a = e.centerY;
          if (n) return f.a.createElement(ut, Il({}, this.props, {
            animatedProps: Wl
          }), f.a.createElement(t, Il({}, this.props, {
            animation: null
          })));
          var o = Il({}, this._getDefaultProps(), this.props),
              i = o.tickTotal,
              u = o.tickValues,
              l = o.marginLeft,
              s = o.marginTop,
              c = o.rRange,
              p = o.style,
              h = co(o, "x"),
              d = co(o, "y"),
              y = zl(h, i, u);
          return f.a.createElement("g", {
            transform: "translate(" + (h(r) + l) + "," + (d(a) + s) + ")",
            className: "rv-xy-plot__circular-grid-lines"
          }, y.reduce(function (e, t, n) {
            var r = h(t);
            return c && (r < c[0] || r > c[1]) ? e : e.concat([f.a.createElement("circle", Il({
              cx: 0,
              cy: 0,
              r: r
            }, {
              key: n,
              className: "rv-xy-plot__circular-grid-lines__line",
              style: p
            }))]);
          }, []));
        }
      }]), t;
    }(c.PureComponent);

    Yl.displayName = "CircularGridLines", Yl.propTypes = {
      centerX: h.a.number,
      centerY: h.a.number,
      width: h.a.number,
      height: h.a.number,
      top: h.a.number,
      left: h.a.number,
      rRange: h.a.arrayOf(h.a.number),
      style: h.a.object,
      tickValues: h.a.arrayOf(h.a.number),
      tickTotal: h.a.number,
      animation: lt,
      marginTop: h.a.number,
      marginBottom: h.a.number,
      marginLeft: h.a.number,
      marginRight: h.a.number,
      innerWidth: h.a.number,
      innerHeight: h.a.number
    }, Yl.defaultProps = {
      centerX: 0,
      centerY: 0
    }, Yl.requiresSVG = !0;

    var Xl = Array.prototype.slice,
        Gl = function Gl(e, t) {
      return e - t;
    },
        $l = function $l(e) {
      return function () {
        return e;
      };
    },
        Zl = function Zl(e, t) {
      for (var n, r = -1, a = t.length; ++r < a;) {
        if (n = Jl(e, t[r])) return n;
      }

      return 0;
    };

    function Jl(e, t) {
      for (var n = t[0], r = t[1], a = -1, o = 0, i = e.length, u = i - 1; o < i; u = o++) {
        var l = e[o],
            s = l[0],
            c = l[1],
            f = e[u],
            p = f[0],
            h = f[1];
        if (Ql(l, f, t)) return 0;
        c > r != h > r && n < (p - s) * (r - c) / (h - c) + s && (a = -a);
      }

      return a;
    }

    function Ql(e, t, n) {
      var r, a, o, i;
      return function (e, t, n) {
        return (t[0] - e[0]) * (n[1] - e[1]) == (n[0] - e[0]) * (t[1] - e[1]);
      }(e, t, n) && (a = e[r = +(e[0] === t[0])], o = n[r], i = t[r], a <= o && o <= i || i <= o && o <= a);
    }

    var Kl = function Kl() {},
        es = [[], [[[1, 1.5], [.5, 1]]], [[[1.5, 1], [1, 1.5]]], [[[1.5, 1], [.5, 1]]], [[[1, .5], [1.5, 1]]], [[[1, 1.5], [.5, 1]], [[1, .5], [1.5, 1]]], [[[1, .5], [1, 1.5]]], [[[1, .5], [.5, 1]]], [[[.5, 1], [1, .5]]], [[[1, 1.5], [1, .5]]], [[[.5, 1], [1, .5]], [[1.5, 1], [1, 1.5]]], [[[1.5, 1], [1, .5]]], [[[.5, 1], [1.5, 1]]], [[[1, 1.5], [1.5, 1]]], [[[.5, 1], [1, 1.5]]], []],
        ts = function ts() {
      var e = 1,
          t = 1,
          n = wt,
          r = u;

      function a(e) {
        var t = n(e);
        if (Array.isArray(t)) t = t.slice().sort(Gl);else {
          var r = dt(e),
              a = r[0],
              i = r[1];
          t = Ot(a, i, t), t = mt(Math.floor(a / t) * t, Math.floor(i / t) * t, t);
        }
        return t.map(function (t) {
          return o(e, t);
        });
      }

      function o(n, a) {
        var o = [],
            u = [];
        return function (n, r, a) {
          var o,
              u,
              l,
              s,
              c,
              f,
              p = new Array(),
              h = new Array();
          o = u = -1, s = n[0] >= r, es[s << 1].forEach(d);

          for (; ++o < e - 1;) {
            l = s, s = n[o + 1] >= r, es[l | s << 1].forEach(d);
          }

          es[s << 0].forEach(d);

          for (; ++u < t - 1;) {
            for (o = -1, s = n[u * e + e] >= r, c = n[u * e] >= r, es[s << 1 | c << 2].forEach(d); ++o < e - 1;) {
              l = s, s = n[u * e + e + o + 1] >= r, f = c, c = n[u * e + o + 1] >= r, es[l | s << 1 | c << 2 | f << 3].forEach(d);
            }

            es[s | c << 3].forEach(d);
          }

          o = -1, c = n[u * e] >= r, es[c << 2].forEach(d);

          for (; ++o < e - 1;) {
            f = c, c = n[u * e + o + 1] >= r, es[c << 2 | f << 3].forEach(d);
          }

          function d(e) {
            var t,
                n,
                r = [e[0][0] + o, e[0][1] + u],
                l = [e[1][0] + o, e[1][1] + u],
                s = i(r),
                c = i(l);
            (t = h[s]) ? (n = p[c]) ? (delete h[t.end], delete p[n.start], t === n ? (t.ring.push(l), a(t.ring)) : p[t.start] = h[n.end] = {
              start: t.start,
              end: n.end,
              ring: t.ring.concat(n.ring)
            }) : (delete h[t.end], t.ring.push(l), h[t.end = c] = t) : (t = p[c]) ? (n = h[s]) ? (delete p[t.start], delete h[n.end], t === n ? (t.ring.push(l), a(t.ring)) : p[n.start] = h[t.end] = {
              start: n.start,
              end: t.end,
              ring: n.ring.concat(t.ring)
            }) : (delete p[t.start], t.ring.unshift(r), p[t.start = s] = t) : p[s] = h[c] = {
              start: s,
              end: c,
              ring: [r, l]
            };
          }

          es[c << 3].forEach(d);
        }(n, a, function (e) {
          r(e, n, a), function (e) {
            for (var t = 0, n = e.length, r = e[n - 1][1] * e[0][0] - e[n - 1][0] * e[0][1]; ++t < n;) {
              r += e[t - 1][1] * e[t][0] - e[t - 1][0] * e[t][1];
            }

            return r;
          }(e) > 0 ? o.push([e]) : u.push(e);
        }), u.forEach(function (e) {
          for (var t, n = 0, r = o.length; n < r; ++n) {
            if (-1 !== Zl((t = o[n])[0], e)) return void t.push(e);
          }
        }), {
          type: "MultiPolygon",
          value: a,
          coordinates: o
        };
      }

      function i(t) {
        return 2 * t[0] + t[1] * (e + 1) * 4;
      }

      function u(n, r, a) {
        n.forEach(function (n) {
          var o,
              i = n[0],
              u = n[1],
              l = 0 | i,
              s = 0 | u,
              c = r[s * e + l];
          i > 0 && i < e && l === i && (o = r[s * e + l - 1], n[0] = i + (a - o) / (c - o) - .5), u > 0 && u < t && s === u && (o = r[(s - 1) * e + l], n[1] = u + (a - o) / (c - o) - .5);
        });
      }

      return a.contour = o, a.size = function (n) {
        if (!arguments.length) return [e, t];
        var r = Math.ceil(n[0]),
            o = Math.ceil(n[1]);
        if (!(r > 0 && o > 0)) throw new Error("invalid size");
        return e = r, t = o, a;
      }, a.thresholds = function (e) {
        return arguments.length ? (n = "function" == typeof e ? e : Array.isArray(e) ? $l(Xl.call(e)) : $l(e), a) : n;
      }, a.smooth = function (e) {
        return arguments.length ? (r = e ? u : Kl, a) : r === u;
      }, a;
    };

    function ns(e, t, n) {
      for (var r = e.width, a = e.height, o = 1 + (n << 1), i = 0; i < a; ++i) {
        for (var u = 0, l = 0; u < r + n; ++u) {
          u < r && (l += e.data[u + i * r]), u >= n && (u >= o && (l -= e.data[u - o + i * r]), t.data[u - n + i * r] = l / Math.min(u + 1, r - 1 + o - u, o));
        }
      }
    }

    function rs(e, t, n) {
      for (var r = e.width, a = e.height, o = 1 + (n << 1), i = 0; i < r; ++i) {
        for (var u = 0, l = 0; u < a + n; ++u) {
          u < a && (l += e.data[i + u * r]), u >= n && (u >= o && (l -= e.data[i + (u - o) * r]), t.data[i + (u - n) * r] = l / Math.min(u + 1, a - 1 + o - u, o));
        }
      }
    }

    function as(e) {
      return e[0];
    }

    function os(e) {
      return e[1];
    }

    function is() {
      return 1;
    }

    var us = function us(e) {
      return e;
    };

    function ls(e, t) {
      e && cs.hasOwnProperty(e.type) && cs[e.type](e, t);
    }

    var ss = {
      Feature: function Feature(e, t) {
        ls(e.geometry, t);
      },
      FeatureCollection: function FeatureCollection(e, t) {
        for (var n = e.features, r = -1, a = n.length; ++r < a;) {
          ls(n[r].geometry, t);
        }
      }
    },
        cs = {
      Sphere: function Sphere(e, t) {
        t.sphere();
      },
      Point: function Point(e, t) {
        e = e.coordinates, t.point(e[0], e[1], e[2]);
      },
      MultiPoint: function MultiPoint(e, t) {
        for (var n = e.coordinates, r = -1, a = n.length; ++r < a;) {
          e = n[r], t.point(e[0], e[1], e[2]);
        }
      },
      LineString: function LineString(e, t) {
        fs(e.coordinates, t, 0);
      },
      MultiLineString: function MultiLineString(e, t) {
        for (var n = e.coordinates, r = -1, a = n.length; ++r < a;) {
          fs(n[r], t, 0);
        }
      },
      Polygon: function Polygon(e, t) {
        ps(e.coordinates, t);
      },
      MultiPolygon: function MultiPolygon(e, t) {
        for (var n = e.coordinates, r = -1, a = n.length; ++r < a;) {
          ps(n[r], t);
        }
      },
      GeometryCollection: function GeometryCollection(e, t) {
        for (var n = e.geometries, r = -1, a = n.length; ++r < a;) {
          ls(n[r], t);
        }
      }
    };

    function fs(e, t, n) {
      var r,
          a = -1,
          o = e.length - n;

      for (t.lineStart(); ++a < o;) {
        r = e[a], t.point(r[0], r[1], r[2]);
      }

      t.lineEnd();
    }

    function ps(e, t) {
      var n = -1,
          r = e.length;

      for (t.polygonStart(); ++n < r;) {
        fs(e[n], t, 1);
      }

      t.polygonEnd();
    }

    var hs = function hs(e, t) {
      e && ss.hasOwnProperty(e.type) ? ss[e.type](e, t) : ls(e, t);
    },
        ds = function ds() {
      return new ys();
    };

    function ys() {
      this.reset();
    }

    ys.prototype = {
      constructor: ys,
      reset: function reset() {
        this.s = this.t = 0;
      },
      add: function add(e) {
        gs(ms, e, this.t), gs(this, ms.s, this.s), this.s ? this.t += ms.t : this.s = ms.t;
      },
      valueOf: function valueOf() {
        return this.s;
      }
    };
    var ms = new ys();

    function gs(e, t, n) {
      var r = e.s = t + n,
          a = r - t,
          o = r - a;
      e.t = t - o + (n - a);
    }

    var vs = Math.PI,
        bs = 2 * vs,
        _s = Math.abs,
        xs = (Math.atan, Math.atan2, Math.cos, Math.ceil, Math.exp, Math.floor, Math.log, Math.pow, Math.sin, Math.sign, Math.sqrt);
    Math.tan;

    function Os() {}

    var ws,
        Ts,
        ks,
        Ms,
        Es = ds(),
        Ps = ds(),
        js = {
      point: Os,
      lineStart: Os,
      lineEnd: Os,
      polygonStart: function polygonStart() {
        js.lineStart = Ss, js.lineEnd = Cs;
      },
      polygonEnd: function polygonEnd() {
        js.lineStart = js.lineEnd = js.point = Os, Es.add(_s(Ps)), Ps.reset();
      },
      result: function result() {
        var e = Es / 2;
        return Es.reset(), e;
      }
    };

    function Ss() {
      js.point = As;
    }

    function As(e, t) {
      js.point = Ns, ws = ks = e, Ts = Ms = t;
    }

    function Ns(e, t) {
      Ps.add(Ms * e - ks * t), ks = e, Ms = t;
    }

    function Cs() {
      Ns(ws, Ts);
    }

    var Fs = js,
        Rs = 1 / 0,
        Ls = Rs,
        Ds = -Rs,
        qs = Ds;
    var Vs,
        zs,
        Is,
        Hs,
        Bs = {
      point: function point(e, t) {
        e < Rs && (Rs = e);
        e > Ds && (Ds = e);
        t < Ls && (Ls = t);
        t > qs && (qs = t);
      },
      lineStart: Os,
      lineEnd: Os,
      polygonStart: Os,
      polygonEnd: Os,
      result: function result() {
        var e = [[Rs, Ls], [Ds, qs]];
        return Ds = qs = -(Ls = Rs = 1 / 0), e;
      }
    },
        Us = 0,
        Ws = 0,
        Ys = 0,
        Xs = 0,
        Gs = 0,
        $s = 0,
        Zs = 0,
        Js = 0,
        Qs = 0,
        Ks = {
      point: ec,
      lineStart: tc,
      lineEnd: ac,
      polygonStart: function polygonStart() {
        Ks.lineStart = oc, Ks.lineEnd = ic;
      },
      polygonEnd: function polygonEnd() {
        Ks.point = ec, Ks.lineStart = tc, Ks.lineEnd = ac;
      },
      result: function result() {
        var e = Qs ? [Zs / Qs, Js / Qs] : $s ? [Xs / $s, Gs / $s] : Ys ? [Us / Ys, Ws / Ys] : [NaN, NaN];
        return Us = Ws = Ys = Xs = Gs = $s = Zs = Js = Qs = 0, e;
      }
    };

    function ec(e, t) {
      Us += e, Ws += t, ++Ys;
    }

    function tc() {
      Ks.point = nc;
    }

    function nc(e, t) {
      Ks.point = rc, ec(Is = e, Hs = t);
    }

    function rc(e, t) {
      var n = e - Is,
          r = t - Hs,
          a = xs(n * n + r * r);
      Xs += a * (Is + e) / 2, Gs += a * (Hs + t) / 2, $s += a, ec(Is = e, Hs = t);
    }

    function ac() {
      Ks.point = ec;
    }

    function oc() {
      Ks.point = uc;
    }

    function ic() {
      lc(Vs, zs);
    }

    function uc(e, t) {
      Ks.point = lc, ec(Vs = Is = e, zs = Hs = t);
    }

    function lc(e, t) {
      var n = e - Is,
          r = t - Hs,
          a = xs(n * n + r * r);
      Xs += a * (Is + e) / 2, Gs += a * (Hs + t) / 2, $s += a, Zs += (a = Hs * e - Is * t) * (Is + e), Js += a * (Hs + t), Qs += 3 * a, ec(Is = e, Hs = t);
    }

    var sc = Ks;

    function cc(e) {
      this._context = e;
    }

    cc.prototype = {
      _radius: 4.5,
      pointRadius: function pointRadius(e) {
        return this._radius = e, this;
      },
      polygonStart: function polygonStart() {
        this._line = 0;
      },
      polygonEnd: function polygonEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        0 === this._line && this._context.closePath(), this._point = NaN;
      },
      point: function point(e, t) {
        switch (this._point) {
          case 0:
            this._context.moveTo(e, t), this._point = 1;
            break;

          case 1:
            this._context.lineTo(e, t);

            break;

          default:
            this._context.moveTo(e + this._radius, t), this._context.arc(e, t, this._radius, 0, bs);
        }
      },
      result: Os
    };
    var fc,
        pc,
        hc,
        dc,
        yc,
        mc = ds(),
        gc = {
      point: Os,
      lineStart: function lineStart() {
        gc.point = vc;
      },
      lineEnd: function lineEnd() {
        fc && bc(pc, hc), gc.point = Os;
      },
      polygonStart: function polygonStart() {
        fc = !0;
      },
      polygonEnd: function polygonEnd() {
        fc = null;
      },
      result: function result() {
        var e = +mc;
        return mc.reset(), e;
      }
    };

    function vc(e, t) {
      gc.point = bc, pc = dc = e, hc = yc = t;
    }

    function bc(e, t) {
      dc -= e, yc -= t, mc.add(xs(dc * dc + yc * yc)), dc = e, yc = t;
    }

    var _c = gc;

    function xc() {
      this._string = [];
    }

    function Oc(e) {
      return "m0," + e + "a" + e + "," + e + " 0 1,1 0," + -2 * e + "a" + e + "," + e + " 0 1,1 0," + 2 * e + "z";
    }

    xc.prototype = {
      _radius: 4.5,
      _circle: Oc(4.5),
      pointRadius: function pointRadius(e) {
        return (e = +e) !== this._radius && (this._radius = e, this._circle = null), this;
      },
      polygonStart: function polygonStart() {
        this._line = 0;
      },
      polygonEnd: function polygonEnd() {
        this._line = NaN;
      },
      lineStart: function lineStart() {
        this._point = 0;
      },
      lineEnd: function lineEnd() {
        0 === this._line && this._string.push("Z"), this._point = NaN;
      },
      point: function point(e, t) {
        switch (this._point) {
          case 0:
            this._string.push("M", e, ",", t), this._point = 1;
            break;

          case 1:
            this._string.push("L", e, ",", t);

            break;

          default:
            null == this._circle && (this._circle = Oc(this._radius)), this._string.push("M", e, ",", t, this._circle);
        }
      },
      result: function result() {
        if (this._string.length) {
          var e = this._string.join("");

          return this._string = [], e;
        }

        return null;
      }
    };

    var wc = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Tc = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function kc(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Mc(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Ec = function (e) {
      function t() {
        return kc(this, t), Mc(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Tc(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.animation,
              r = e.bandwidth,
              a = e.className,
              o = e.colorRange,
              i = e.data,
              u = e.innerHeight,
              l = e.innerWidth,
              s = e.marginLeft,
              c = e.marginTop,
              p = e.style;
          if (!i || !l || !u) return null;
          if (n) return f.a.createElement(ut, wc({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, wc({}, this.props, {
            animation: null
          })));

          var h = this._getAttributeFunctor("x"),
              d = this._getAttributeFunctor("y"),
              y = function () {
            var e = as,
                t = os,
                n = is,
                r = 960,
                a = 500,
                o = 20,
                i = 2,
                u = 3 * o,
                l = r + 2 * u >> i,
                s = a + 2 * u >> i,
                c = $l(20);

            function f(r) {
              var a = new Float32Array(l * s),
                  f = new Float32Array(l * s);
              r.forEach(function (r, o, c) {
                var f = +e(r, o, c) + u >> i,
                    p = +t(r, o, c) + u >> i,
                    h = +n(r, o, c);
                f >= 0 && f < l && p >= 0 && p < s && (a[f + p * l] += h);
              }), ns({
                width: l,
                height: s,
                data: a
              }, {
                width: l,
                height: s,
                data: f
              }, o >> i), rs({
                width: l,
                height: s,
                data: f
              }, {
                width: l,
                height: s,
                data: a
              }, o >> i), ns({
                width: l,
                height: s,
                data: a
              }, {
                width: l,
                height: s,
                data: f
              }, o >> i), rs({
                width: l,
                height: s,
                data: f
              }, {
                width: l,
                height: s,
                data: a
              }, o >> i), ns({
                width: l,
                height: s,
                data: a
              }, {
                width: l,
                height: s,
                data: f
              }, o >> i), rs({
                width: l,
                height: s,
                data: f
              }, {
                width: l,
                height: s,
                data: a
              }, o >> i);
              var h = c(a);

              if (!Array.isArray(h)) {
                var d = function (e, t) {
                  var n,
                      r,
                      a = e.length,
                      o = -1;

                  if (null == t) {
                    for (; ++o < a;) {
                      if (null != (n = e[o]) && n >= n) for (r = n; ++o < a;) {
                        null != (n = e[o]) && n > r && (r = n);
                      }
                    }
                  } else for (; ++o < a;) {
                    if (null != (n = t(e[o], o, e)) && n >= n) for (r = n; ++o < a;) {
                      null != (n = t(e[o], o, e)) && n > r && (r = n);
                    }
                  }

                  return r;
                }(a);

                h = Ot(0, d, h), (h = mt(0, Math.floor(d / h) * h, h)).shift();
              }

              return ts().thresholds(h).size([l, s])(a).map(p);
            }

            function p(e) {
              return e.value *= Math.pow(2, -2 * i), e.coordinates.forEach(h), e;
            }

            function h(e) {
              e.forEach(d);
            }

            function d(e) {
              e.forEach(y);
            }

            function y(e) {
              e[0] = e[0] * Math.pow(2, i) - u, e[1] = e[1] * Math.pow(2, i) - u;
            }

            function m() {
              return l = r + 2 * (u = 3 * o) >> i, s = a + 2 * u >> i, f;
            }

            return f.x = function (t) {
              return arguments.length ? (e = "function" == typeof t ? t : $l(+t), f) : e;
            }, f.y = function (e) {
              return arguments.length ? (t = "function" == typeof e ? e : $l(+e), f) : t;
            }, f.weight = function (e) {
              return arguments.length ? (n = "function" == typeof e ? e : $l(+e), f) : n;
            }, f.size = function (e) {
              if (!arguments.length) return [r, a];
              var t = Math.ceil(e[0]),
                  n = Math.ceil(e[1]);
              if (!(t >= 0 || t >= 0)) throw new Error("invalid size");
              return r = t, a = n, m();
            }, f.cellSize = function (e) {
              if (!arguments.length) return 1 << i;
              if (!((e = +e) >= 1)) throw new Error("invalid cell size");
              return i = Math.floor(Math.log(e) / Math.LN2), m();
            }, f.thresholds = function (e) {
              return arguments.length ? (c = "function" == typeof e ? e : Array.isArray(e) ? $l(Xl.call(e)) : $l(e), f) : c;
            }, f.bandwidth = function (e) {
              if (!arguments.length) return Math.sqrt(o * (o + 1));
              if (!((e = +e) >= 0)) throw new Error("invalid bandwidth");
              return o = Math.round((Math.sqrt(4 * e * e + 1) - 1) / 2), m();
            }, f;
          }().x(function (e) {
            return h(e);
          }).y(function (e) {
            return d(e);
          }).size([l, u]).bandwidth(r)(i),
              m = function (e, t) {
            var n,
                r,
                a = 4.5;

            function o(e) {
              return e && ("function" == typeof a && r.pointRadius(+a.apply(this, arguments)), hs(e, n(r))), r.result();
            }

            return o.area = function (e) {
              return hs(e, n(Fs)), Fs.result();
            }, o.measure = function (e) {
              return hs(e, n(_c)), _c.result();
            }, o.bounds = function (e) {
              return hs(e, n(Bs)), Bs.result();
            }, o.centroid = function (e) {
              return hs(e, n(sc)), sc.result();
            }, o.projection = function (t) {
              return arguments.length ? (n = null == t ? (e = null, us) : (e = t).stream, o) : e;
            }, o.context = function (e) {
              return arguments.length ? (r = null == e ? (t = null, new xc()) : new cc(t = e), "function" != typeof a && r.pointRadius(a), o) : t;
            }, o.pointRadius = function (e) {
              return arguments.length ? (a = "function" == typeof e ? e : (r.pointRadius(+e), +e), o) : a;
            }, o.projection(e).context(t);
          }(),
              g = function (e) {
            return e.reduce(function (e, t) {
              return {
                min: Math.min(e.min, t.value),
                max: Math.max(e.max, t.value)
              };
            }, {
              min: 1 / 0,
              max: -1 / 0
            });
          }(y),
              v = g.min,
              b = g.max,
              _ = yn().domain([v, b]).range(o || Co);

          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--contour " + a,
            transform: "translate(" + s + "," + c + ")"
          }, y.map(function (e, t) {
            return f.a.createElement("path", {
              className: "rv-xy-plot__series--contour-line",
              key: "rv-xy-plot__series--contour-line-" + t,
              d: m(e),
              style: wc({
                fill: _(e.value)
              }, p)
            });
          }));
        }
      }]), t;
    }(So);

    Ec.propTypes = wc({}, So.propTypes, {
      animation: h.a.bool,
      bandwidth: h.a.number,
      className: h.a.string,
      marginLeft: h.a.number,
      marginTop: h.a.number,
      style: h.a.object
    }), Ec.defaultProps = wc({}, So.defaultProps, {
      bandwidth: 40,
      style: {}
    });

    var Pc = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        jc = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Sc(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ac(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function Nc(e) {
      var t = Fc(e);
      if (t) return {
        title: "x",
        value: Za(t.x)
      };
    }

    function Cc(e) {
      return e.map(function (e, t) {
        if (e) return {
          value: e.y,
          title: t
        };
      });
    }

    function Fc(e) {
      return (e || []).find(function (e) {
        return Boolean(e);
      });
    }

    var Rc = function (e) {
      function t() {
        return Sc(this, t), Ac(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), jc(t, [{
        key: "_renderCrosshairItems",
        value: function value() {
          var e = this.props,
              t = e.values,
              n = (0, e.itemsFormat)(t);
          return n ? n.filter(function (e) {
            return e;
          }).map(function (e, t) {
            return f.a.createElement("div", {
              className: "rv-crosshair__item",
              key: "item" + t
            }, f.a.createElement("span", {
              className: "rv-crosshair__item__title"
            }, e.title), ": ", f.a.createElement("span", {
              className: "rv-crosshair__item__value"
            }, e.value));
          }) : null;
        }
      }, {
        key: "_renderCrosshairTitle",
        value: function value() {
          var e = this.props,
              t = e.values,
              n = e.titleFormat,
              r = e.style,
              a = n(t);
          return a ? f.a.createElement("div", {
            className: "rv-crosshair__title",
            key: "title",
            style: r.title
          }, f.a.createElement("span", {
            className: "rv-crosshair__title__title"
          }, a.title), ": ", f.a.createElement("span", {
            className: "rv-crosshair__title__value"
          }, a.value)) : null;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.children,
              n = e.className,
              r = e.values,
              a = e.marginTop,
              o = e.marginLeft,
              i = e.innerWidth,
              u = e.innerHeight,
              l = e.style,
              s = Fc(r);
          if (!s) return null;
          var c = ho(this.props, "x")(s),
              p = this.props.orientation,
              h = o + c,
              d = a,
              y = "rv-crosshair__inner rv-crosshair__inner--" + (void 0 === p ? c > i / 2 ? "left" : "right" : p);
          return f.a.createElement("div", {
            className: "rv-crosshair " + n,
            style: {
              left: h + "px",
              top: d + "px"
            }
          }, f.a.createElement("div", {
            className: "rv-crosshair__line",
            style: Pc({
              height: u + "px"
            }, l.line)
          }), f.a.createElement("div", {
            className: y
          }, t || f.a.createElement("div", {
            className: "rv-crosshair__inner__content",
            style: l.box
          }, f.a.createElement("div", null, this._renderCrosshairTitle(), this._renderCrosshairItems()))));
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            titleFormat: Nc,
            itemsFormat: Cc,
            style: {
              line: {},
              title: {},
              box: {}
            }
          };
        }
      }, {
        key: "propTypes",
        get: function get() {
          return {
            className: h.a.string,
            values: h.a.arrayOf(h.a.oneOfType([h.a.number, h.a.string, h.a.object])),
            series: h.a.object,
            innerWidth: h.a.number,
            innerHeight: h.a.number,
            marginLeft: h.a.number,
            marginTop: h.a.number,
            orientation: h.a.oneOf(["left", "right"]),
            itemsFormat: h.a.func,
            titleFormat: h.a.func,
            style: h.a.shape({
              line: h.a.object,
              title: h.a.object,
              box: h.a.object
            })
          };
        }
      }]), t;
    }(c.PureComponent);

    Rc.displayName = "Crosshair";

    var Lc = Rc,
        Dc = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        qc = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function Vc(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function zc(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function Ic(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      return Array.from(e);
    }

    var Hc = {
      stroke: "blue",
      fill: "blue"
    };

    function Bc(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Hc;

      switch (e) {
        case "diamond":
          return f.a.createElement("polygon", {
            style: n,
            points: "0 0 " + t / 2 + " " + t / 2 + " 0 " + t + " " + -t / 2 + " " + t / 2 + " 0 0"
          });

        case "star":
          var r = [].concat(Ic(new Array(5))).map(function (e, n) {
            var r = n / 5 * Math.PI * 2,
                a = r + Math.PI / 10,
                o = r - Math.PI / 10,
                i = t / 2.61;
            return "\n        " + Math.cos(o) * t + " " + Math.sin(o) * t + "\n        " + Math.cos(a) * i + " " + Math.sin(a) * i + "\n      ";
          }).join(" ");
          return f.a.createElement("polygon", {
            points: r,
            x: "0",
            y: "0",
            height: t,
            width: t,
            style: n
          });

        case "square":
          return f.a.createElement("rect", {
            x: "" + -t / 2,
            y: "" + -t / 2,
            height: t,
            width: t,
            style: n
          });

        default:
        case "circle":
          return f.a.createElement("circle", {
            cx: "0",
            cy: "0",
            r: t / 2,
            style: n
          });
      }
    }

    var Uc = function (e) {
      function t() {
        return Vc(this, t), zc(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Dc(t, [{
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.animation,
              a = n.className,
              o = n.customComponent,
              i = n.data,
              u = n.innerHeight,
              l = n.innerWidth,
              s = n.marginLeft,
              c = n.marginTop,
              p = n.style,
              h = n.size;
          if (!i || !l || !u) return null;
          if (r) return f.a.createElement(ut, qc({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, qc({}, this.props, {
            animation: !1
          })));

          var d = this._getAttributeFunctor("x"),
              y = this._getAttributeFunctor("y"),
              m = i.map(function (t, n) {
            var r = {
              x: d(t),
              y: y(t)
            },
                a = function (e) {
              var t = e.customComponent,
                  n = e.defaultType,
                  r = e.positionInPixels,
                  a = (e.positionFunctions, e.style),
                  o = e.propsSize,
                  i = t.size,
                  u = qc({}, a, t.style || {}),
                  l = t.customComponent;
              return l || "string" != typeof n ? l ? "string" == typeof l ? Bc(l || n, i, u) : l(t, r, u) : n(t, r, u) : Bc(n, i || o, u);
            }({
              customComponent: t,
              positionInPixels: r,
              defaultType: o,
              positionFunctions: {
                x: d,
                y: y
              },
              style: p,
              propsSize: h
            });

            return f.a.createElement("g", {
              className: "rv-xy-plot__series--custom-svg",
              key: "rv-xy-plot__series--custom-svg-" + n,
              transform: "translate(" + r.x + "," + r.y + ")",
              onMouseEnter: function onMouseEnter(n) {
                return e._valueMouseOverHandler(t, n);
              },
              onMouseLeave: function onMouseLeave(n) {
                return e._valueMouseOutHandler(t, n);
              }
            }, a);
          });

          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--custom-svg-wrapper " + a,
            transform: "translate(" + s + "," + c + ")"
          }, m);
        }
      }]), t;
    }(So);

    Uc.propTypes = {
      animation: h.a.bool,
      className: h.a.string,
      customComponent: h.a.oneOfType([h.a.string, h.a.func]),
      data: h.a.arrayOf(h.a.shape({
        x: h.a.oneOfType([h.a.string, h.a.number]).isRequired,
        y: h.a.oneOfType([h.a.string, h.a.number]).isRequired
      })).isRequired,
      marginLeft: h.a.number,
      marginTop: h.a.number,
      style: h.a.object,
      size: h.a.number,
      onValueMouseOver: h.a.func,
      onValueMouseOut: h.a.func
    }, Uc.defaultProps = qc({}, So.defaultProps, {
      animation: !1,
      customComponent: "circle",
      style: {},
      size: 2
    });

    var Wc = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function Yc(e) {
      var t = e.axisDomain,
          n = e.numberOfTicks,
          r = e.axisStart,
          a = e.axisEnd,
          o = e.tickValue,
          i = e.tickSize,
          u = e.style,
          l = function (e) {
        var t = e.axisStart,
            n = e.axisEnd,
            r = e.numberOfTicks,
            a = e.axisDomain,
            o = function (e, t) {
          if (e.x === t.x) return {
            left: e.y,
            right: t.y,
            slope: 0,
            offset: e.x
          };
          var n = (e.y - t.y) / (e.x - t.x);
          return {
            left: e.x,
            right: t.x,
            slope: n,
            offset: e.y - n * e.x
          };
        }(t, n),
            i = o.left,
            u = o.right,
            l = o.slope,
            s = o.offset,
            c = (u - i) / r,
            f = yn().domain([i, u]).range(a),
            p = t.x === n.x;

        return {
          slope: p ? 1 / 0 : l,
          points: mt(i, u + c, c).map(function (e) {
            return p ? {
              y: e,
              x: l * e + s,
              text: f(e)
            } : {
              x: e,
              y: l * e + s,
              text: f(e)
            };
          }).slice(0, r + 1)
        };
      }({
        axisStart: r,
        axisEnd: a,
        numberOfTicks: n,
        axisDomain: t
      }).points,
          s = function (e, t) {
        return e.x === t.x ? t.y > e.y ? Math.PI / 2 : 3 * Math.PI / 2 : Math.atan((t.y - e.y) / (t.x - e.x));
      }(r, a) + Math.PI / 2;

      return l.map(function (e, t) {
        var n = Wc({
          x1: 0,
          y1: 0,
          x2: i * Math.cos(s),
          y2: i * Math.sin(s)
        }, u.ticks),
            r = Wc({
          x: i * Math.cos(s),
          y: i * Math.sin(s),
          textAnchor: "start"
        }, u.text);
        return f.a.createElement("g", {
          key: t,
          transform: "translate(" + e.x + ", " + e.y + ")",
          className: "rv-xy-plot__axis__tick"
        }, f.a.createElement("line", Wc({}, n, {
          className: "rv-xy-plot__axis__tick__line"
        })), f.a.createElement("text", Wc({}, r, {
          className: "rv-xy-plot__axis__tick__text"
        }), o(e.text)));
      });
    }

    var Xc = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Gc = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function $c(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Zc(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Jc = ["xRange", "yRange", "xDomain", "yDomain", "width", "height", "marginLeft", "marginTop", "marginRight", "marginBottom", "tickSize", "tickTotal", "tickSizeInner", "tickSizeOuter"],
        Qc = function (e) {
      function t() {
        return $c(this, t), Zc(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Gc(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.animation,
              r = e.className,
              a = e.marginLeft,
              o = e.marginTop,
              i = e.axisStart,
              u = e.axisEnd,
              l = e.axisDomain,
              s = e.numberOfTicks,
              c = e.tickValue,
              p = e.tickSize,
              h = e.style;
          if (n) return f.a.createElement(ut, Xc({}, this.props, {
            animatedProps: Jc
          }), f.a.createElement(t, Xc({}, this.props, {
            animation: null
          })));

          var d = this._getAttributeFunctor("x"),
              y = this._getAttributeFunctor("y");

          return f.a.createElement("g", {
            className: "rv-xy-manipulable-axis rv-xy-plot__axis " + r,
            transform: "translate(" + a + "," + o + ")"
          }, f.a.createElement("line", Xc({}, Xc({
            x1: d({
              x: i.x
            }),
            x2: d({
              x: u.x
            }),
            y1: y({
              y: i.y
            }),
            y2: y({
              y: u.y
            })
          }, h.line), {
            className: "rv-xy-plot__axis__line"
          })), f.a.createElement("g", {
            className: "rv-xy-manipulable-axis__ticks"
          }, Yc({
            axisDomain: l,
            axisEnd: {
              x: d(u),
              y: y(u)
            },
            axisStart: {
              x: d(i),
              y: y(i)
            },
            numberOfTicks: s,
            tickValue: c,
            tickSize: p,
            style: h
          })));
        }
      }]), t;
    }(So),
        Kc = rn(".2r");

    Qc.defaultProps = {
      className: "",
      numberOfTicks: 10,
      tickValue: function tickValue(e) {
        return Kc(e);
      },
      tickSize: 5,
      style: {
        line: {
          strokeWidth: 1
        },
        ticks: {
          strokeWidth: 2
        },
        text: {}
      }
    }, Qc.propTypes = Xc({}, So.propTypes, {
      axisDomain: h.a.arrayOf(h.a.number).isRequired,
      axisEnd: h.a.shape({
        x: h.a.oneOfType([h.a.number, h.a.string]),
        y: h.a.oneOfType([h.a.number, h.a.string])
      }).isRequired,
      axisStart: h.a.shape({
        x: h.a.oneOfType([h.a.number, h.a.string]),
        y: h.a.oneOfType([h.a.number, h.a.string])
      }).isRequired,
      className: h.a.string,
      numberOfTicks: h.a.number,
      tickValue: h.a.func,
      tickSize: h.a.number,
      style: h.a.shape({
        line: h.a.object,
        ticks: h.a.object,
        text: h.a.object
      })
    }), Qc.displayName = "DecorativeAxis";
    var ef = Qc;

    function tf(e) {
      var t = e.className;
      return f.a.createElement("defs", {
        className: "rv-gradient-defs " + t
      }, e.children);
    }

    tf.displayName = "GradientDefs", tf.requiresSVG = !0, tf.propTypes = {
      className: h.a.string
    }, tf.defaultProps = {
      className: ""
    };

    var nf = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        rf = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function af(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function of(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function uf(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var lf = ql.VERTICAL,
        sf = ql.HORIZONTAL,
        cf = {
      direction: h.a.oneOf([lf, sf]),
      attr: h.a.string.isRequired,
      width: h.a.number,
      height: h.a.number,
      top: h.a.number,
      left: h.a.number,
      style: h.a.object,
      tickValues: h.a.arrayOf(h.a.oneOfType([h.a.number, h.a.string])),
      tickTotal: h.a.number,
      animation: lt,
      marginTop: h.a.number,
      marginBottom: h.a.number,
      marginLeft: h.a.number,
      marginRight: h.a.number,
      innerWidth: h.a.number,
      innerHeight: h.a.number
    },
        ff = {
      direction: lf
    },
        pf = ["xRange", "yRange", "xDomain", "yDomain", "width", "height", "marginLeft", "marginTop", "marginRight", "marginBottom", "tickTotal"],
        hf = function (e) {
      function t() {
        return of(this, t), uf(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), rf(t, [{
        key: "_getDefaultProps",
        value: function value() {
          var e = this.props,
              t = e.innerWidth,
              n = e.innerHeight,
              r = e.marginTop;
          return {
            left: e.marginLeft,
            top: r,
            width: t,
            height: n,
            tickTotal: Vl(e.direction === lf ? t : n)
          };
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.animation,
              r = e.className;
          if (n) return f.a.createElement(ut, nf({}, this.props, {
            animatedProps: pf
          }), f.a.createElement(t, nf({}, this.props, {
            animation: null
          })));

          var a = nf({}, this._getDefaultProps(), this.props),
              o = a.attr,
              i = a.direction,
              u = a.width,
              l = a.height,
              s = a.style,
              c = a.tickTotal,
              p = a.tickValues,
              h = a.top,
              d = a.left,
              y = i === lf,
              m = y ? "y" : "x",
              g = y ? "x" : "y",
              v = y ? l : u,
              b = co(a, o),
              _ = zl(b, c, p);

          return f.a.createElement("g", {
            transform: "translate(" + d + "," + h + ")",
            className: "rv-xy-plot__grid-lines " + r
          }, _.map(function (e, t) {
            var n,
                r = b(e),
                a = (af(n = {}, g + "1", r), af(n, g + "2", r), af(n, m + "1", 0), af(n, m + "2", v), n);
            return f.a.createElement("line", nf({}, a, {
              key: t,
              className: "rv-xy-plot__grid-lines__line",
              style: s
            }));
          }));
        }
      }]), t;
    }(c.PureComponent);

    hf.displayName = "GridLines", hf.defaultProps = ff, hf.propTypes = cf, hf.requiresSVG = !0;

    var df = hf,
        yf = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        mf = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function gf(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function vf(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var bf = function (e) {
      function t() {
        return gf(this, t), vf(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), mf(t, [{
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.animation,
              a = n.className,
              o = n.data,
              i = n.marginLeft,
              u = n.marginTop,
              l = n.style;
          if (!o) return null;
          if (r) return f.a.createElement(ut, yf({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, yf({}, this.props, {
            animation: null
          })));

          var s = yf({
            rectStyle: {}
          }, l).rectStyle,
              c = this._getAttributeFunctor("x"),
              p = this._getAttributeFunctor("y"),
              h = this._getAttributeFunctor("opacity"),
              d = this._getAttributeFunctor("fill") || this._getAttributeFunctor("color"),
              y = this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color"),
              m = this._getScaleDistance("x"),
              g = this._getScaleDistance("y");

          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--heatmap " + a,
            transform: "translate(" + i + "," + u + ")"
          }, o.map(function (t, n) {
            var r = yf({
              style: yf({
                stroke: y && y(t),
                fill: d && d(t),
                opacity: h && h(t)
              }, l)
            }, s, {
              x: c(t) - m / 2,
              y: p(t) - g / 2,
              width: m,
              height: g,
              key: n,
              onClick: function onClick(n) {
                return e._valueClickHandler(t, n);
              },
              onContextMenu: function onContextMenu(n) {
                return e._valueRightClickHandler(t, n);
              },
              onMouseOver: function onMouseOver(n) {
                return e._valueMouseOverHandler(t, n);
              },
              onMouseOut: function onMouseOut(n) {
                return e._valueMouseOutHandler(t, n);
              }
            });
            return f.a.createElement("rect", r);
          }));
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: "x" === e || "y" === e
          };
        }
      }]), t;
    }(So);

    bf.propTypes = yf({}, So.propTypes), bf.displayName = "HeatmapSeries";

    var _f = Math.PI / 3,
        xf = [0, _f, 2 * _f, 3 * _f, 4 * _f, 5 * _f];

    function Of(e) {
      return e[0];
    }

    function wf(e) {
      return e[1];
    }

    var Tf = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        kf = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Mf(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ef(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function Pf(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      return Array.from(e);
    }

    var jf = function (e) {
      function t() {
        return Mf(this, t), Ef(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), kf(t, [{
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.animation,
              a = n.className,
              o = n.colorRange,
              i = n.data,
              u = n.innerHeight,
              l = n.innerWidth,
              s = n.marginLeft,
              c = n.marginTop,
              p = n.radius,
              h = n.sizeHexagonsWithCount,
              d = n.style,
              y = n.xOffset,
              m = n.yOffset;
          if (!i) return null;
          if (r) return f.a.createElement(ut, Tf({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, Tf({}, this.props, {
            animation: null
          })));

          var g = this._getAttributeFunctor("x"),
              v = this._getAttributeFunctor("y"),
              b = function () {
            var e,
                t,
                n,
                r = 0,
                a = 0,
                o = 1,
                i = 1,
                u = Of,
                l = wf;

            function s(e) {
              var r,
                  a = {},
                  o = [],
                  i = e.length;

              for (r = 0; r < i; ++r) {
                if (!isNaN(c = +u.call(null, s = e[r], r, e)) && !isNaN(f = +l.call(null, s, r, e))) {
                  var s,
                      c,
                      f,
                      p = Math.round(f /= n),
                      h = Math.round(c = c / t - (1 & p) / 2),
                      d = f - p;

                  if (3 * Math.abs(d) > 1) {
                    var y = c - h,
                        m = h + (c < h ? -1 : 1) / 2,
                        g = p + (f < p ? -1 : 1),
                        v = c - m,
                        b = f - g;
                    y * y + d * d > v * v + b * b && (h = m + (1 & p ? 1 : -1) / 2, p = g);
                  }

                  var _ = h + "-" + p,
                      x = a[_];

                  x ? x.push(s) : (o.push(x = a[_] = [s]), x.x = (h + (1 & p) / 2) * t, x.y = p * n);
                }
              }

              return o;
            }

            function c(e) {
              var t = 0,
                  n = 0;
              return xf.map(function (r) {
                var a = Math.sin(r) * e,
                    o = -Math.cos(r) * e,
                    i = a - t,
                    u = o - n;
                return t = a, n = o, [i, u];
              });
            }

            return s.hexagon = function (t) {
              return "m" + c(null == t ? e : +t).join("l") + "z";
            }, s.centers = function () {
              for (var u = [], l = Math.round(a / n), s = Math.round(r / t), c = l * n; c < i + e; c += n, ++l) {
                for (var f = s * t + (1 & l) * t / 2; f < o + t / 2; f += t) {
                  u.push([f, c]);
                }
              }

              return u;
            }, s.mesh = function () {
              var t = c(e).slice(0, 4).join("l");
              return s.centers().map(function (e) {
                return "M" + e + "m" + t;
              }).join("");
            }, s.x = function (e) {
              return arguments.length ? (u = e, s) : u;
            }, s.y = function (e) {
              return arguments.length ? (l = e, s) : l;
            }, s.radius = function (r) {
              return arguments.length ? (t = 2 * (e = +r) * Math.sin(_f), n = 1.5 * e, s) : e;
            }, s.size = function (e) {
              return arguments.length ? (r = a = 0, o = +e[0], i = +e[1], s) : [o - r, i - a];
            }, s.extent = function (e) {
              return arguments.length ? (r = +e[0][0], a = +e[0][1], o = +e[1][0], i = +e[1][1], s) : [[r, a], [o, i]];
            }, s.radius(1);
          }().x(function (e) {
            return g(e) + y;
          }).y(function (e) {
            return v(e) + m;
          }).radius(p).size([l, u]),
              _ = b.hexagon(),
              x = b(i),
              O = function (e, t) {
            var n = e.countDomain;
            return n || [0, Math.max.apply(Math, Pf(t.map(function (e) {
              return e.length;
            })))];
          }(this.props, x),
              w = yn().domain(O).range(o),
              T = yn().domain(O).range([0, p]);

          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--hexbin " + a,
            transform: "translate(" + s + "," + c + ")"
          }, x.map(function (t, n) {
            var r = {
              style: d,
              d: h ? b.hexagon(T(t.length)) : _,
              fill: w(t.length),
              transform: "translate(" + t.x + ", " + t.y + ")",
              key: n,
              onClick: function onClick(n) {
                return e._valueClickHandler(t, n);
              },
              onContextMenu: function onContextMenu(n) {
                return e._valueRightClickHandler(t, n);
              },
              onMouseOver: function onMouseOver(n) {
                return e._valueMouseOverHandler(t, n);
              },
              onMouseOut: function onMouseOut(n) {
                return e._valueMouseOutHandler(t, n);
              }
            };
            return f.a.createElement("path", r);
          }));
        }
      }]), t;
    }(So);

    jf.propTypes = Tf({}, So.propTypes, {
      radius: h.a.number
    }), jf.defaultProps = {
      radius: 20,
      colorRange: Co,
      xOffset: 0,
      yOffset: 0
    }, jf.displayName = "HexbinSeries";

    var Sf = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Af = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Nf(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Cf(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function Ff(e) {
      return {
        xLoc: "touchstart" === e.type ? e.pageX : e.offsetX,
        yLoc: "touchstart" === e.type ? e.pageY : e.offsetY
      };
    }

    var Rf = function (e) {
      function t() {
        var e, n, r;
        Nf(this, t);

        for (var a = arguments.length, o = Array(a), i = 0; i < a; i++) {
          o[i] = arguments[i];
        }

        return n = r = Cf(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(o))), r.state = {
          dragging: !1,
          brushArea: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          brushing: !1,
          startLocX: 0,
          startLocY: 0,
          dragArea: null
        }, Cf(r, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Af(t, [{
        key: "_getDrawArea",
        value: function value(e, t) {
          var n = this.state,
              r = n.startLocX,
              a = n.startLocY,
              o = this.props,
              i = o.enableX,
              u = o.enableY,
              l = o.highlightWidth,
              s = o.highlightHeight,
              c = o.innerWidth,
              f = o.innerHeight,
              p = o.marginLeft,
              h = o.marginRight,
              d = o.marginBottom,
              y = o.marginTop,
              m = l || c + p + h,
              g = s || f + y + d;
          return {
            bottom: u ? Math.max(a, t) : g,
            right: i ? Math.max(r, e) : m,
            left: i ? Math.min(e, r) : 0,
            top: u ? Math.min(t, a) : 0
          };
        }
      }, {
        key: "_getDragArea",
        value: function value(e, t) {
          var n = this.props,
              r = n.enableX,
              a = n.enableY,
              o = this.state,
              i = o.startLocX,
              u = o.startLocY,
              l = o.dragArea;
          return {
            bottom: l.bottom + (a ? t - u : 0),
            left: l.left + (r ? e - i : 0),
            right: l.right + (r ? e - i : 0),
            top: l.top + (a ? t - u : 0)
          };
        }
      }, {
        key: "_clickedOutsideDrag",
        value: function value(e, t) {
          var n = this.props,
              r = n.enableX,
              a = n.enableY,
              o = this.state,
              i = o.dragArea,
              u = o.brushArea,
              l = u.left,
              s = u.right,
              c = u.top,
              f = u.bottom,
              p = i && (e < l || e > s),
              h = i && (t < c || t > f);
          return r && a ? p || h : r ? p : !a || h;
        }
      }, {
        key: "_convertAreaToCoordinates",
        value: function value(e) {
          var t = this.props,
              n = t.enableX,
              r = t.enableY,
              a = t.marginLeft,
              o = t.marginTop,
              i = co(this.props, "x"),
              u = co(this.props, "y");
          return n && r ? {
            bottom: u.invert(e.bottom),
            left: i.invert(e.left - a),
            right: i.invert(e.right - a),
            top: u.invert(e.top)
          } : r ? {
            bottom: u.invert(e.bottom - o),
            top: u.invert(e.top - o)
          } : n ? {
            left: i.invert(e.left - a),
            right: i.invert(e.right - a)
          } : {};
        }
      }, {
        key: "startBrushing",
        value: function value(e) {
          var t = this,
              n = this.props,
              r = n.onBrushStart,
              a = n.onDragStart,
              o = n.drag,
              i = this.state.dragArea,
              u = Ff(e.nativeEvent),
              l = u.xLoc,
              s = u.yLoc,
              c = function c(e, n) {
            var r = {
              bottom: s,
              left: l,
              right: l,
              top: s
            };
            t.setState({
              dragging: e,
              brushArea: i && !n ? i : r,
              brushing: !e,
              startLocX: l,
              startLocY: s
            });
          },
              f = this._clickedOutsideDrag(l, s);

          if (o && !i || !o || f) return c(!1, f), void (r && r(e));
          o && i && (c(!0, f), a && a(e));
        }
      }, {
        key: "stopBrushing",
        value: function value(e) {
          var t = this.state,
              n = t.brushing,
              r = t.dragging,
              a = t.brushArea;

          if (n || r) {
            var o = this.props,
                i = o.onBrushEnd,
                u = o.onDragEnd,
                l = o.drag,
                s = Math.abs(a.right - a.left) < 5,
                c = Math.abs(a.top - a.bottom) < 5 || s;
            this.setState({
              brushing: !1,
              dragging: !1,
              brushArea: l ? a : {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              },
              startLocX: 0,
              startLocY: 0,
              dragArea: l && !c && a
            }), n && i && i(c ? null : this._convertAreaToCoordinates(a)), l && u && u(c ? null : this._convertAreaToCoordinates(a));
          }
        }
      }, {
        key: "onBrush",
        value: function value(e) {
          var t = this.props,
              n = t.onBrush,
              r = t.onDrag,
              a = t.drag,
              o = this.state,
              i = o.brushing,
              u = o.dragging,
              l = Ff(e.nativeEvent),
              s = l.xLoc,
              c = l.yLoc;

          if (i) {
            var f = this._getDrawArea(s, c);

            this.setState({
              brushArea: f
            }), n && n(this._convertAreaToCoordinates(f));
          }

          if (a && u) {
            var p = this._getDragArea(s, c);

            this.setState({
              brushArea: p
            }), r && r(this._convertAreaToCoordinates(p));
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.color,
              r = t.className,
              a = t.highlightHeight,
              o = t.highlightWidth,
              i = t.highlightX,
              u = t.highlightY,
              l = t.innerWidth,
              s = t.innerHeight,
              c = t.marginLeft,
              p = t.marginRight,
              h = t.marginTop,
              d = t.marginBottom,
              y = t.opacity,
              m = this.state.brushArea,
              g = m.left,
              v = m.right,
              b = m.top,
              _ = m.bottom,
              x = 0;
          i && (x = co(this.props, "x")(i));
          var O = 0;
          u && (O = co(this.props, "y")(u));
          var w = o || c + p + l,
              T = a || h + d + s;
          return f.a.createElement("g", {
            transform: "translate(" + x + ", " + O + ")",
            className: r + " rv-highlight-container"
          }, f.a.createElement("rect", {
            className: "rv-mouse-target",
            fill: "black",
            opacity: "0",
            x: "0",
            y: "0",
            width: Math.max(w, 0),
            height: Math.max(T, 0),
            onMouseDown: function onMouseDown(t) {
              return e.startBrushing(t);
            },
            onMouseMove: function onMouseMove(t) {
              return e.onBrush(t);
            },
            onMouseUp: function onMouseUp(t) {
              return e.stopBrushing(t);
            },
            onMouseLeave: function onMouseLeave(t) {
              return e.stopBrushing(t);
            },
            onTouchEnd: function onTouchEnd(t) {
              t.preventDefault(), e.stopBrushing(t);
            },
            onTouchCancel: function onTouchCancel(t) {
              t.preventDefault(), e.stopBrushing(t);
            },
            onContextMenu: function onContextMenu(e) {
              return e.preventDefault();
            },
            onContextMenuCapture: function onContextMenuCapture(e) {
              return e.preventDefault();
            }
          }), f.a.createElement("rect", {
            className: "rv-highlight",
            pointerEvents: "none",
            opacity: y,
            fill: n,
            x: g,
            y: b,
            width: Math.min(Math.max(0, v - g), w),
            height: Math.min(Math.max(0, _ - b), T)
          }));
        }
      }]), t;
    }(So);

    Rf.displayName = "HighlightOverlay", Rf.defaultProps = {
      color: "rgb(77, 182, 172)",
      className: "",
      enableX: !0,
      enableY: !0,
      opacity: .3
    }, Rf.propTypes = Sf({}, So.propTypes, {
      enableX: h.a.bool,
      enableY: h.a.bool,
      highlightHeight: h.a.number,
      highlightWidth: h.a.number,
      highlightX: h.a.oneOfType([h.a.string, h.a.number]),
      highlightY: h.a.oneOfType([h.a.string, h.a.number]),
      onBrushStart: h.a.func,
      onDragStart: h.a.func,
      onBrush: h.a.func,
      onDrag: h.a.func,
      onBrushEnd: h.a.func,
      onDragEnd: h.a.func
    });

    var Lf = Rf,
        Df = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        qf = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Vf(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function zf(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var If = {
      AUTO: "auto",
      LEFT: "left",
      RIGHT: "right",
      LEFT_EDGE: "leftEdge",
      RIGHT_EDGE: "rightEdge",
      BOTTOM: "bottom",
      TOP: "top",
      BOTTOM_EDGE: "bottomEdge",
      TOP_EDGE: "topEdge"
    },
        Hf = {
      BOTTOM_LEFT: "bottomleft",
      BOTTOM_RIGHT: "bottomright",
      TOP_LEFT: "topleft",
      TOP_RIGHT: "topright"
    };

    function Bf(e) {
      return Object.keys(e).map(function (t) {
        return {
          title: t,
          value: Za(e[t])
        };
      });
    }

    var Uf = function (e) {
      function t() {
        return Vf(this, t), zf(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), qf(t, [{
        key: "_getAlign",
        value: function value(e, t) {
          var n = this.props,
              r = n.innerWidth,
              a = n.innerHeight,
              o = n.orientation,
              i = n.align,
              u = i.horizontal,
              l = i.vertical,
              s = o ? this._mapOrientationToAlign(o) : {
            horizontal: u,
            vertical: l
          };
          return u === If.AUTO && (s.horizontal = e > r / 2 ? If.LEFT : If.RIGHT), l === If.AUTO && (s.vertical = t > a / 2 ? If.TOP : If.BOTTOM), s;
        }
      }, {
        key: "_getAlignClassNames",
        value: function value(e) {
          var t = this.props.orientation;
          return (t ? "rv-hint--orientation-" + t : "") + " rv-hint--horizontalAlign-" + e.horizontal + "\n     rv-hint--verticalAlign-" + e.vertical;
        }
      }, {
        key: "_getAlignStyle",
        value: function value(e, t, n) {
          return Df({}, this._getXCSS(e.horizontal, t), this._getYCSS(e.vertical, n));
        }
      }, {
        key: "_getCSSBottom",
        value: function value(e) {
          if (null == e) return {
            bottom: 0
          };
          var t = this.props,
              n = t.innerHeight;
          return {
            bottom: t.marginBottom + n - e
          };
        }
      }, {
        key: "_getCSSLeft",
        value: function value(e) {
          return null == e ? {
            left: 0
          } : {
            left: this.props.marginLeft + e
          };
        }
      }, {
        key: "_getCSSRight",
        value: function value(e) {
          if (null == e) return {
            right: 0
          };
          var t = this.props,
              n = t.innerWidth;
          return {
            right: t.marginRight + n - e
          };
        }
      }, {
        key: "_getCSSTop",
        value: function value(e) {
          return null == e ? {
            top: 0
          } : {
            top: this.props.marginTop + e
          };
        }
      }, {
        key: "_getPositionInfo",
        value: function value() {
          var e = this.props,
              t = e.value,
              n = e.getAlignStyle,
              r = ho(this.props, "x")(t),
              a = ho(this.props, "y")(t),
              o = this._getAlign(r, a);

          return {
            position: n ? n(o, r, a) : this._getAlignStyle(o, r, a),
            positionClassName: this._getAlignClassNames(o)
          };
        }
      }, {
        key: "_getXCSS",
        value: function value(e, t) {
          switch (e) {
            case If.LEFT_EDGE:
              return this._getCSSLeft(null);

            case If.RIGHT_EDGE:
              return this._getCSSRight(null);

            case If.LEFT:
              return this._getCSSRight(t);

            case If.RIGHT:
            default:
              return this._getCSSLeft(t);
          }
        }
      }, {
        key: "_getYCSS",
        value: function value(e, t) {
          switch (e) {
            case If.TOP_EDGE:
              return this._getCSSTop(null);

            case If.BOTTOM_EDGE:
              return this._getCSSBottom(null);

            case If.BOTTOM:
              return this._getCSSTop(t);

            case If.TOP:
            default:
              return this._getCSSBottom(t);
          }
        }
      }, {
        key: "_mapOrientationToAlign",
        value: function value(e) {
          switch (e) {
            case Hf.BOTTOM_LEFT:
              return {
                horizontal: If.LEFT,
                vertical: If.BOTTOM
              };

            case Hf.BOTTOM_RIGHT:
              return {
                horizontal: If.RIGHT,
                vertical: If.BOTTOM
              };

            case Hf.TOP_LEFT:
              return {
                horizontal: If.LEFT,
                vertical: If.TOP
              };

            case Hf.TOP_RIGHT:
              return {
                horizontal: If.RIGHT,
                vertical: If.TOP
              };
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.value,
              n = e.format,
              r = e.children,
              a = e.style,
              o = e.className,
              i = this._getPositionInfo(),
              u = i.position,
              l = i.positionClassName;

          return f.a.createElement("div", {
            className: "rv-hint " + l + " " + o,
            style: Df({}, a, u, {
              position: "absolute"
            })
          }, r || f.a.createElement("div", {
            className: "rv-hint__content",
            style: a.content
          }, n(t).map(function (e, t) {
            return f.a.createElement("div", {
              key: "rv-hint" + t,
              style: a.row
            }, f.a.createElement("span", {
              className: "rv-hint__title",
              style: a.title
            }, e.title), ": ", f.a.createElement("span", {
              className: "rv-hint__value",
              style: a.value
            }, e.value));
          })));
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            format: Bf,
            align: {
              horizontal: If.AUTO,
              vertical: If.AUTO
            },
            style: {}
          };
        }
      }, {
        key: "propTypes",
        get: function get() {
          return {
            marginTop: h.a.number,
            marginLeft: h.a.number,
            innerWidth: h.a.number,
            innerHeight: h.a.number,
            scales: h.a.object,
            value: h.a.object,
            format: h.a.func,
            style: h.a.object,
            className: h.a.string,
            align: h.a.shape({
              horizontal: h.a.oneOf([If.AUTO, If.LEFT, If.RIGHT, If.LEFT_EDGE, If.RIGHT_EDGE]),
              vertical: h.a.oneOf([If.AUTO, If.BOTTOM, If.TOP, If.BOTTOM_EDGE, If.TOP_EDGE])
            }),
            getAlignStyle: h.a.func,
            orientation: h.a.oneOf([Hf.BOTTOM_LEFT, Hf.BOTTOM_RIGHT, Hf.TOP_LEFT, Hf.TOP_RIGHT])
          };
        }
      }]), t;
    }(c.PureComponent);

    Uf.displayName = "Hint", Uf.ORIENTATION = Hf, Uf.ALIGN = If;

    var Wf = Uf,
        Yf = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Xf = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Gf(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function $f(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Zf(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Jf = function (e) {
      function t() {
        return $f(this, t), Zf(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Xf(t, [{
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.animation,
              a = n.className,
              o = n.data,
              i = n.linePosAttr,
              u = n.lineSizeAttr,
              l = n.marginLeft,
              s = n.marginTop,
              c = n.style,
              p = n.valuePosAttr,
              h = n.valueSizeAttr,
              d = n.barWidth;
          if (!o) return null;
          if (r) return f.a.createElement(ut, Yf({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, Yf({}, this.props, {
            animation: null
          })));

          var y = Uo(this.props),
              m = y.sameTypeTotal,
              g = y.sameTypeIndex,
              v = this._getScaleDistance(i),
              b = this._getAttributeFunctor(i),
              _ = this._getAttributeFunctor(p),
              x = this._getAttr0Functor(p),
              O = this._getAttributeFunctor("fill") || this._getAttributeFunctor("color"),
              w = this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color"),
              T = this._getAttributeFunctor("opacity"),
              k = v / 2 * d;

          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--bar " + a,
            transform: "translate(" + l + "," + s + ")"
          }, o.map(function (t, n) {
            var r,
                a = 2 * k,
                o = b(t),
                l = a / m - (m - 1) / m,
                s = o - k + l * g + g,
                d = (Gf(r = {
              style: Yf({
                opacity: T && T(t),
                stroke: w && w(t),
                fill: O && O(t)
              }, c)
            }, i, s), Gf(r, u, l), Gf(r, p, Math.min(x(t), _(t))), Gf(r, h, Math.abs(-x(t) + _(t))), Gf(r, "onClick", function (n) {
              return e._valueClickHandler(t, n);
            }), Gf(r, "onContextMenu", function (n) {
              return e._valueRightClickHandler(t, n);
            }), Gf(r, "onMouseOver", function (n) {
              return e._valueMouseOverHandler(t, n);
            }), Gf(r, "onMouseOut", function (n) {
              return e._valueMouseOutHandler(t, n);
            }), Gf(r, "key", n), r);
            return f.a.createElement("rect", d);
          }));
        }
      }], [{
        key: "propTypes",
        get: function get() {
          return Yf({}, So.propTypes, {
            linePosAttr: h.a.string,
            valuePosAttr: h.a.string,
            lineSizeAttr: h.a.string,
            valueSizeAttr: h.a.string,
            cluster: h.a.string,
            barWidth: h.a.number
          });
        }
      }, {
        key: "defaultProps",
        get: function get() {
          return {
            barWidth: .85
          };
        }
      }]), t;
    }(So);

    Jf.displayName = "BarSeries";

    var Qf = Jf,
        Kf = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        ep = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function tp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function np(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var rp = function (e) {
      function t() {
        return tp(this, t), np(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), ep(t, [{
        key: "render",
        value: function value() {
          return f.a.createElement(Qf, Kf({}, this.props, {
            linePosAttr: "y",
            valuePosAttr: "x",
            lineSizeAttr: "height",
            valueSizeAttr: "width"
          }));
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: "y" === e,
            zeroBaseValue: "x" === e
          };
        }
      }]), t;
    }(So);

    rp.displayName = "HorizontalBarSeries";

    var ap = rp,
        op = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        ip = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function up(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function lp(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var sp = function (e) {
      function t() {
        return up(this, t), lp(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), ip(t, [{
        key: "render",
        value: function value() {
          return null;
        }
      }], [{
        key: "renderLayer",
        value: function value(e, t) {
          var n = e.data,
              r = e.linePosAttr,
              a = e.lineSizeAttr,
              o = e.valuePosAttr,
              i = e.marginTop,
              u = e.marginBottom;

          if (n && 0 !== n.length) {
            var l = function (e, t) {
              var n = so(e, t);
              return n ? n.distance : 0;
            }(e, r),
                s = ho(e, r),
                c = ho(e, o),
                f = yo(e, o),
                p = ho(e, "fill") || ho(e, "color"),
                h = ho(e, "stroke") || ho(e, "color"),
                d = ho(e, "opacity"),
                y = l / 2 * .85,
                m = 2 * y,
                g = Uo(e),
                v = g.sameTypeTotal,
                b = g.sameTypeIndex;

            n.forEach(function (e) {
              var n = s(e) - y,
                  r = m / v - (v - 1) / v,
                  l = Ee(p(e)),
                  g = Ee(h(e)),
                  _ = d(e) || 1,
                  x = n + r * b + b,
                  O = Math.min(f(e), c(e)),
                  w = "x" === o ? O : x,
                  T = "y" === o ? O : x,
                  k = Math.abs(-f(e) + c(e)),
                  M = "height" === a ? r : k,
                  E = "width" === a ? r : k;

              t.beginPath(), t.rect(w + u, T + i, E, M), t.fillStyle = "rgba(" + l.r + ", " + l.g + ", " + l.b + ", " + _ + ")", t.fill(), t.strokeStyle = "rgba(" + g.r + ", " + g.g + ", " + g.b + ", " + _ + ")", t.stroke();
            });
          }
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    sp.displayName = "BarSeriesCanvas", sp.defaultProps = op({}, So.defaultProps, {
      linePosAttr: h.a.string.isRequired,
      valuePosAttr: h.a.string.isRequired,
      lineSizeAttr: h.a.string.isRequired,
      valueSizeAttr: h.a.string.isRequired
    }), sp.propTypes = op({}, So.propTypes);

    var cp = sp,
        fp = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        pp = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function hp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function dp(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var yp = function (e) {
      function t() {
        return hp(this, t), dp(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), pp(t, [{
        key: "render",
        value: function value() {
          return null;
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: "y" === e,
            zeroBaseValue: "x" === e
          };
        }
      }, {
        key: "renderLayer",
        value: function value(e, t) {
          cp.renderLayer(fp({}, e, {
            linePosAttr: "y",
            valuePosAttr: "x",
            lineSizeAttr: "height",
            valueSizeAttr: "width"
          }), t);
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    yp.displayName = "HorizontalBarSeriesCanvas", yp.propTypes = fp({}, So.propTypes);

    var mp = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        gp = ql.HORIZONTAL,
        vp = mp({}, df.propTypes, {
      direction: h.a.oneOf([gp])
    }),
        bp = {
      direction: gp,
      attr: "y"
    };

    function _p(e) {
      return f.a.createElement(df, e);
    }

    _p.displayName = "HorizontalGridLines", _p.propTypes = vp, _p.defaultProps = bp, _p.requiresSVG = !0;

    var xp = _p,
        Op = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        wp = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Tp(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function kp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Mp(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Ep = function (e) {
      function t() {
        return kp(this, t), Mp(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), wp(t, [{
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.animation,
              a = n.className,
              o = n.data,
              i = n.linePosAttr,
              u = n.lineSizeAttr,
              l = n.marginLeft,
              s = n.marginTop,
              c = n.style,
              p = n.valuePosAttr,
              h = n.valueSizeAttr;
          if (!o) return null;
          if (r) return f.a.createElement(ut, Op({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, Op({}, this.props, {
            animation: null
          })));

          var d = this._getAttributeFunctor(i),
              y = this._getAttr0Functor(i),
              m = this._getAttributeFunctor(p),
              g = this._getAttr0Functor(p),
              v = this._getAttributeFunctor("fill") || this._getAttributeFunctor("color"),
              b = this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color"),
              _ = this._getAttributeFunctor("opacity");

          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--rect " + a,
            transform: "translate(" + l + "," + s + ")"
          }, o.map(function (t, n) {
            var r,
                a = (Tp(r = {
              style: Op({
                opacity: _ && _(t),
                stroke: b && b(t),
                fill: v && v(t)
              }, c)
            }, i, y(t)), Tp(r, u, Math.abs(d(t) - y(t))), Tp(r, p, Math.min(g(t), m(t))), Tp(r, h, Math.abs(-g(t) + m(t))), Tp(r, "onClick", function (n) {
              return e._valueClickHandler(t, n);
            }), Tp(r, "onContextMenu", function (n) {
              return e._valueRightClickHandler(t, n);
            }), Tp(r, "onMouseOver", function (n) {
              return e._valueMouseOverHandler(t, n);
            }), Tp(r, "onMouseOut", function (n) {
              return e._valueMouseOutHandler(t, n);
            }), Tp(r, "key", n), r);
            return f.a.createElement("rect", a);
          }));
        }
      }], [{
        key: "propTypes",
        get: function get() {
          return Op({}, So.propTypes, {
            linePosAttr: h.a.string,
            valuePosAttr: h.a.string,
            lineSizeAttr: h.a.string,
            valueSizeAttr: h.a.string
          });
        }
      }]), t;
    }(So);

    Ep.displayName = "RectSeries";

    var Pp = Ep,
        jp = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Sp = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Ap(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Np(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Cp = function (e) {
      function t() {
        return Ap(this, t), Np(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Sp(t, [{
        key: "render",
        value: function value() {
          return f.a.createElement(Pp, jp({}, this.props, {
            linePosAttr: "y",
            valuePosAttr: "x",
            lineSizeAttr: "height",
            valueSizeAttr: "width"
          }));
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: !1,
            zeroBaseValue: "x" === e
          };
        }
      }]), t;
    }(So);

    Cp.displayName = "HorizontalRectSeries";

    var Fp = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Rp = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Lp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Dp(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var qp = function (e) {
      function t() {
        return Lp(this, t), Dp(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Rp(t, [{
        key: "render",
        value: function value() {
          return null;
        }
      }], [{
        key: "renderLayer",
        value: function value(e, t) {
          var n = e.data,
              r = e.linePosAttr,
              a = e.lineSizeAttr,
              o = e.marginLeft,
              i = e.marginTop,
              u = e.valuePosAttr;

          if (n && 0 !== n.length) {
            var l = ho(e, r),
                s = yo(e, r),
                c = ho(e, u),
                f = yo(e, u),
                p = ho(e, "fill") || ho(e, "color"),
                h = ho(e, "stroke") || ho(e, "color"),
                d = ho(e, "opacity");
            n.forEach(function (e) {
              var n = Ee(p(e)),
                  r = Ee(h(e)),
                  y = d(e) || 1,
                  m = s(e),
                  g = Math.min(f(e), c(e)),
                  v = "x" === u ? g : m,
                  b = "y" === u ? g : m,
                  _ = Math.abs(l(e) - s(e)),
                  x = Math.abs(-f(e) + c(e)),
                  O = "height" === a ? _ : x,
                  w = "width" === a ? _ : x;

              t.beginPath(), t.rect(v + o, b + i, w, O), t.fillStyle = "rgba(" + n.r + ", " + n.g + ", " + n.b + ", " + y + ")", t.fill(), t.strokeStyle = "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + y + ")", t.stroke();
            });
          }
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    qp.displayName = "RectSeriesCanvas", qp.defaultProps = Fp({}, So.defaultProps, {
      linePosAttr: h.a.string.isRequired,
      valuePosAttr: h.a.string.isRequired,
      lineSizeAttr: h.a.string.isRequired,
      valueSizeAttr: h.a.string.isRequired
    }), qp.propTypes = Fp({}, So.propTypes);

    var Vp = qp,
        zp = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Ip = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Hp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Bp(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Up = function (e) {
      function t() {
        return Hp(this, t), Bp(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Ip(t, [{
        key: "render",
        value: function value() {
          return null;
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: !1,
            zeroBaseValue: "x" === e
          };
        }
      }, {
        key: "renderLayer",
        value: function value(e, t) {
          Vp.renderLayer(zp({}, e, {
            linePosAttr: "y",
            valuePosAttr: "x",
            lineSizeAttr: "height",
            valueSizeAttr: "width"
          }), t);
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    Up.displayName = "HorizontalRectSeriesCanvas", Up.propTypes = zp({}, So.propTypes);

    var Wp = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Yp = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Xp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Gp(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var $p = function $p(e, t) {
      return e || (t ? "start" : "end");
    },
        Zp = function Zp(e, t) {
      return e || (t ? "text-before-edge" : "text-after-edge");
    },
        Jp = function (e) {
      function t() {
        return Xp(this, t), Gp(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Yp(t, [{
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.animation,
              a = n.allowOffsetToBeReversed,
              o = n.className,
              i = n.data,
              u = n._data,
              l = n.getLabel,
              s = n.marginLeft,
              c = n.marginTop,
              p = n.rotation,
              h = n.style,
              d = n.xRange,
              y = n.yRange,
              m = n.labelAnchorX,
              g = n.labelAnchorY;
          if (!i) return null;
          if (r) return f.a.createElement(ut, Wp({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, Wp({}, this.props, {
            animation: null,
            _data: i
          })));

          var v = this._getAttributeFunctor("x"),
              b = this._getAttributeFunctor("y");

          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--label " + o,
            transform: "translate(" + s + "," + c + ")",
            style: h
          }, i.reduce(function (t, n, r) {
            var o = n.style,
                i = n.xOffset,
                s = n.yOffset;
            if (!l(n)) return t;

            var c = v(n),
                h = b(n),
                _ = c < (d[1] - d[0]) / 2,
                x = h < Math.abs(y[1] - y[0]) / 2,
                O = c + (a && _ ? -1 : 1) * (i || 0),
                w = h + (a && x ? -1 : 1) * (s || 0),
                T = 0 === n.rotation || n.rotation ? n.rotation : p,
                k = Wp({
              dominantBaseline: Zp(g, x),
              className: "rv-xy-plot__series--label-text",
              key: r,
              onClick: function onClick(t) {
                return e._valueClickHandler(n, t);
              },
              onContextMenu: function onContextMenu(t) {
                return e._valueRightClickHandler(n, t);
              },
              onMouseOver: function onMouseOver(t) {
                return e._valueMouseOverHandler(n, t);
              },
              onMouseOut: function onMouseOut(t) {
                return e._valueMouseOutHandler(n, t);
              },
              textAnchor: $p(m, _),
              x: O,
              y: w,
              transform: "rotate(" + T + "," + O + "," + w + ")"
            }, o),
                M = l(u ? u[r] : n);

            return t.concat([f.a.createElement("text", k, M)]);
          }, []));
        }
      }]), t;
    }(So);

    Jp.propTypes = {
      animation: h.a.bool,
      allowOffsetToBeReversed: h.a.bool,
      className: h.a.string,
      data: h.a.arrayOf(h.a.shape({
        x: h.a.oneOfType([h.a.number, h.a.string]),
        y: h.a.oneOfType([h.a.number, h.a.string]),
        angle: h.a.number,
        radius: h.a.number,
        label: h.a.string,
        xOffset: h.a.number,
        yOffset: h.a.number,
        style: h.a.object
      })).isRequired,
      marginLeft: h.a.number,
      marginTop: h.a.number,
      rotation: h.a.number,
      style: h.a.object,
      xRange: h.a.arrayOf(h.a.number),
      yRange: h.a.arrayOf(h.a.number),
      labelAnchorX: h.a.string,
      labelAnchorY: h.a.string
    }, Jp.defaultProps = Wp({}, So.defaultProps, {
      animation: !1,
      rotation: 0,
      getLabel: function getLabel(e) {
        return e.label;
      }
    }), Jp.displayName = "LabelSeries";

    var Qp = Jp,
        Kp = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        eh = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function th(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function nh(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var rh = {
      dashed: "6, 2",
      solid: null
    },
        ah = function (e) {
      function t() {
        return th(this, t), nh(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), eh(t, [{
        key: "_renderLine",
        value: function value(e, t, n, a, o) {
          var i = ji();
          return null !== a && ("string" == typeof a && r[a] ? i = i.curve(r[a]) : "function" == typeof a && (i = i.curve(a))), (i = (i = i.defined(o)).x(t).y(n))(e);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.animation,
              r = e.className,
              a = e.data;
          if (this.props.nullAccessor && Object($a.b)("nullAccessor has been renamed to getNull", !0), !a) return null;
          if (n) return f.a.createElement(ut, Kp({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, Kp({}, this.props, {
            animation: null
          })));

          var o = this.props,
              i = o.curve,
              u = o.marginLeft,
              l = o.marginTop,
              s = o.strokeDasharray,
              c = o.strokeStyle,
              p = o.strokeWidth,
              h = o.style,
              d = this._getAttributeFunctor("x"),
              y = this._getAttributeFunctor("y"),
              m = this._getAttributeValue("stroke") || this._getAttributeValue("color"),
              g = this._getAttributeValue("opacity"),
              v = Number.isFinite(g) ? g : 1,
              b = this.props.nullAccessor || this.props.getNull,
              _ = this._renderLine(a, d, y, i, b);

          return f.a.createElement("path", {
            d: _,
            className: "rv-xy-plot__series rv-xy-plot__series--line " + r,
            transform: "translate(" + u + "," + l + ")",
            onMouseOver: this._seriesMouseOverHandler,
            onMouseOut: this._seriesMouseOutHandler,
            onClick: this._seriesClickHandler,
            onContextMenu: this._seriesRightClickHandler,
            style: Kp({
              opacity: v,
              strokeDasharray: rh[c] || s,
              strokeWidth: p,
              stroke: m
            }, h)
          });
        }
      }]), t;
    }(So);

    ah.displayName = "LineSeries", ah.propTypes = Kp({}, So.propTypes, {
      strokeStyle: h.a.oneOf(Object.keys(rh)),
      curve: h.a.oneOfType([h.a.string, h.a.func]),
      getNull: h.a.func
    }), ah.defaultProps = Kp({}, So.defaultProps, {
      strokeStyle: "solid",
      style: {},
      opacity: 1,
      curve: null,
      className: "",
      getNull: function getNull() {
        return !0;
      }
    });

    var oh = ah,
        ih = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        uh = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function lh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function sh(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var ch = function (e) {
      function t() {
        return lh(this, t), sh(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), uh(t, [{
        key: "_renderCircle",
        value: function value(e, t, n, r, a) {
          var o = this,
              i = a.fill,
              u = a.opacity,
              l = a.size,
              s = a.stroke,
              c = a.x,
              p = a.y,
              h = {
            r: l ? l(e) : 5,
            cx: c(e),
            cy: p(e),
            style: ih({
              opacity: u ? u(e) : 1,
              stroke: s && s(e),
              fill: i && i(e),
              strokeWidth: n || 1
            }, r),
            key: t,
            onClick: function onClick(t) {
              return o._valueClickHandler(e, t);
            },
            onContextMenu: function onContextMenu(t) {
              return o._valueRightClickHandler(e, t);
            },
            onMouseOver: function onMouseOver(t) {
              return o._valueMouseOverHandler(e, t);
            },
            onMouseOut: function onMouseOut(t) {
              return o._valueMouseOutHandler(e, t);
            }
          };
          return f.a.createElement("circle", h);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.animation,
              a = n.className,
              o = n.data,
              i = n.marginLeft,
              u = n.marginTop,
              l = n.strokeWidth,
              s = n.style;
          this.props.nullAccessor && Object($a.b)("nullAccessor has been renamed to getNull", !0);
          var c = this.props.nullAccessor || this.props.getNull;
          if (!o) return null;
          if (r) return f.a.createElement(ut, ih({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, ih({}, this.props, {
            animation: null
          })));
          var p = {
            fill: this._getAttributeFunctor("fill") || this._getAttributeFunctor("color"),
            opacity: this._getAttributeFunctor("opacity"),
            size: this._getAttributeFunctor("size"),
            stroke: this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color"),
            x: this._getAttributeFunctor("x"),
            y: this._getAttributeFunctor("y")
          };
          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--mark " + a,
            transform: "translate(" + i + "," + u + ")"
          }, o.map(function (t, n) {
            return c(t) && e._renderCircle(t, n, l, s, p);
          }));
        }
      }]), t;
    }(So);

    ch.displayName = "MarkSeries", ch.propTypes = ih({}, So.propTypes, {
      getNull: h.a.func,
      strokeWidth: h.a.number
    }), ch.defaultProps = {
      getNull: function getNull() {
        return !0;
      }
    };

    var fh = ch,
        ph = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        hh = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function dh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function yh(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var mh = hh({}, oh.propTypes, {
      lineStyle: h.a.object,
      markStyle: h.a.object
    }),
        gh = function (e) {
      function t() {
        return dh(this, t), yh(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), ph(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.lineStyle,
              n = e.markStyle,
              r = e.style;
          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--linemark"
          }, f.a.createElement(oh, hh({}, this.props, {
            style: hh({}, r, t)
          })), f.a.createElement(fh, hh({}, this.props, {
            style: hh({}, r, n)
          })));
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return hh({}, oh.defaultProps, {
            lineStyle: {},
            markStyle: {}
          });
        }
      }]), t;
    }(So);

    gh.displayName = "LineMarkSeries", gh.propTypes = mh;

    var vh = gh,
        bh = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        _h = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function xh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Oh(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var wh = function (e) {
      function t() {
        return xh(this, t), Oh(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), _h(t, [{
        key: "render",
        value: function value() {
          return null;
        }
      }], [{
        key: "renderLayer",
        value: function value(e, t) {
          var n = e.data,
              r = e.marginLeft,
              a = e.marginTop,
              o = ho(e, "x"),
              i = ho(e, "y"),
              u = ho(e, "size") || function (e) {
            return 5;
          },
              l = ho(e, "fill") || ho(e, "color"),
              s = ho(e, "stroke") || ho(e, "color"),
              c = ho(e, "opacity");

          n.forEach(function (e) {
            var n = Ee(l(e)),
                f = Ee(s(e)),
                p = c(e) || 1;
            t.beginPath(), t.arc(o(e) + r, i(e) + a, u(e), 0, 2 * Math.PI), t.fillStyle = "rgba(" + n.r + ", " + n.g + ", " + n.b + ", " + p + ")", t.fill(), t.strokeStyle = "rgba(" + f.r + ", " + f.g + ", " + f.b + ", " + p + ")", t.stroke();
          });
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    wh.displayName = "MarkSeriesCanvas", wh.propTypes = bh({}, So.propTypes);

    var Th = wh,
        kh = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Mh = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Eh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ph(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var jh = function (e) {
      function t() {
        return Eh(this, t), Ph(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Mh(t, [{
        key: "render",
        value: function value() {
          return f.a.createElement("div", null);
        }
      }], [{
        key: "renderLayer",
        value: function value(e, t) {
          var n = e.curve,
              a = e.data,
              o = e.marginLeft,
              i = e.marginTop,
              u = e.strokeWidth,
              l = e.strokeDasharray;

          if (a && 0 !== a.length) {
            var s = ho(e, "x"),
                c = ho(e, "y"),
                f = Ee(mo(e, "stroke") || mo(e, "color")),
                p = mo(e, "opacity"),
                h = Number.isFinite(p) ? p : 1,
                d = ji().x(function (e) {
              return s(e) + o;
            }).y(function (e) {
              return c(e) + i;
            });
            "string" == typeof n && r[n] ? d = d.curve(r[n]) : "function" == typeof n && (d = d.curve(n)), t.beginPath(), t.strokeStyle = "rgba(" + f.r + ", " + f.g + ", " + f.b + ", " + h + ")", t.lineWidth = u, l && t.setLineDash(l), d.context(t)(a), t.stroke(), t.closePath(), t.lineWidth = 1, t.setLineDash([]);
          }
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    jh.displayName = "LineSeriesCanvas", jh.defaultProps = kh({}, So.defaultProps, {
      strokeWidth: 2
    }), jh.propTypes = kh({}, So.propTypes, {
      strokeWidth: h.a.number
    });

    var Sh = jh,
        Ah = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Nh = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Ch(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Fh(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Rh = function (e) {
      function t() {
        return Ch(this, t), Fh(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Nh(t, [{
        key: "render",
        value: function value() {
          return null;
        }
      }], [{
        key: "renderLayer",
        value: function value(e, t) {
          Sh.renderLayer(e, t), Th.renderLayer(e, t);
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    Rh.displayName = "LineMarkSeriesCanvas", Rh.propTypes = Ah({}, So.propTypes);

    var Lh = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Dh = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function qh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Vh(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var zh = function zh(e, t, n) {
      return e.reduce(function (e, r, a) {
        return e + " " + (a ? "L" : "M") + t(r) + " " + n(r);
      }, "") + " Z";
    },
        Ih = function (e) {
      function t() {
        return qh(this, t), Vh(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Dh(t, [{
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              r = n.animation,
              a = n.color,
              o = n.className,
              i = n.data,
              u = n.marginLeft,
              l = n.marginTop,
              s = n.style;
          if (!i) return null;
          if (r) return f.a.createElement(ut, Lh({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, Lh({}, this.props, {
            animation: null
          })));

          var c = this._getAttributeFunctor("x"),
              p = this._getAttributeFunctor("y");

          return f.a.createElement("path", {
            className: "rv-xy-plot__series rv-xy-plot__series--polygon " + o,
            onMouseOver: function onMouseOver(t) {
              return e._seriesMouseOverHandler(i, t);
            },
            onMouseOut: function onMouseOut(t) {
              return e._seriesMouseOutHandler(i, t);
            },
            onClick: this._seriesClickHandler,
            onContextMenu: this._seriesRightClickHandler,
            fill: a || "#12939A",
            style: s,
            d: zh(i, c, p),
            transform: "translate(" + u + "," + l + ")"
          });
        }
      }], [{
        key: "propTypes",
        get: function get() {
          return Lh({}, So.propTypes);
        }
      }]), t;
    }(So);

    Ih.displayName = "PolygonSeries";

    var Hh = Ih,
        Bh = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Uh = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Wh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Yh(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Xh = function (e) {
      function t() {
        return Wh(this, t), Yh(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Uh(t, [{
        key: "render",
        value: function value() {
          return f.a.createElement(Qf, Bh({}, this.props, {
            linePosAttr: "x",
            valuePosAttr: "y",
            lineSizeAttr: "width",
            valueSizeAttr: "height"
          }));
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: "x" === e,
            zeroBaseValue: "y" === e
          };
        }
      }]), t;
    }(So);

    Xh.displayName = "VerticalBarSeries";

    var Gh = Xh,
        $h = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Zh = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Jh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Qh(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Kh = function (e) {
      function t() {
        return Jh(this, t), Qh(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Zh(t, [{
        key: "render",
        value: function value() {
          return null;
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: "x" === e,
            zeroBaseValue: "y" === e
          };
        }
      }, {
        key: "renderLayer",
        value: function value(e, t) {
          cp.renderLayer($h({}, e, {
            linePosAttr: "x",
            valuePosAttr: "y",
            lineSizeAttr: "width",
            valueSizeAttr: "height"
          }), t);
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    Kh.displayName = "HorizontalBarSeriesCanvas", Kh.propTypes = $h({}, So.propTypes);

    var ed = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        td = ql.VERTICAL,
        nd = ed({}, df.propTypes, {
      direction: h.a.oneOf([td])
    }),
        rd = {
      direction: td,
      attr: "x"
    };

    function ad(e) {
      return f.a.createElement(df, e);
    }

    ad.displayName = "VerticalGridLines", ad.propTypes = nd, ad.defaultProps = rd, ad.requiresSVG = !0;

    var od = ad,
        id = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        ud = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function ld(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function sd(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var cd = function (e) {
      function t() {
        return ld(this, t), sd(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), ud(t, [{
        key: "render",
        value: function value() {
          return f.a.createElement(Pp, id({}, this.props, {
            linePosAttr: "x",
            valuePosAttr: "y",
            lineSizeAttr: "width",
            valueSizeAttr: "height"
          }));
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: !1,
            zeroBaseValue: "y" === e
          };
        }
      }]), t;
    }(So);

    cd.displayName = "VerticalRectSeries";

    var fd = cd,
        pd = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        hd = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function dd(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function yd(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var md = function (e) {
      function t() {
        return dd(this, t), yd(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), hd(t, [{
        key: "render",
        value: function value() {
          return null;
        }
      }], [{
        key: "getParentConfig",
        value: function value(e) {
          return {
            isDomainAdjustmentNeeded: !1,
            zeroBaseValue: "y" === e
          };
        }
      }, {
        key: "renderLayer",
        value: function value(e, t) {
          Vp.renderLayer(pd({}, e, {
            linePosAttr: "x",
            valuePosAttr: "y",
            lineSizeAttr: "width",
            valueSizeAttr: "height"
          }), t);
        }
      }, {
        key: "requiresSVG",
        get: function get() {
          return !1;
        }
      }, {
        key: "isCanvas",
        get: function get() {
          return !0;
        }
      }]), t;
    }(So);

    md.displayName = "HorizontalRectSeriesCanvas", md.propTypes = pd({}, So.propTypes);

    var gd = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        vd = function vd(e) {
      return e;
    };

    function bd(e) {
      var t,
          n,
          r,
          a,
          o,
          i = e.className,
          u = e.extent,
          l = e.nodes,
          s = e.onBlur,
          c = e.onClick,
          p = e.onMouseUp,
          h = e.onMouseDown,
          d = e.onHover,
          y = e.polygonStyle,
          m = e.style,
          g = e.x,
          v = e.y,
          b = ie().x(g || ho(e, "x")).y(v || ho(e, "y")).extent(u || (n = (t = e).innerWidth, r = t.innerHeight, a = t.marginLeft, o = t.marginTop, [[a, o], [n + a, r + o]])).polygons(l),
          _ = function _(e) {
        return function (t) {
          t.preventDefault();

          var n = function (e) {
            var t = e.nativeEvent,
                n = t.pageX,
                r = t.pageY,
                a = document.elementFromPoint(n, r);
            if (!a) return -1;
            var o = a.parentNode;
            return Array.prototype.indexOf.call(o.childNodes, a);
          }(t);

          if (n > -1 && n < b.length) {
            var r = b[n];
            e(r.data);
          }
        };
      };

      return f.a.createElement("g", {
        className: i + " rv-voronoi",
        style: m,
        onTouchEnd: _(p),
        onTouchStart: _(h),
        onTouchMove: _(d),
        onTouchCancel: _(s)
      }, b.map(function (e, t) {
        return f.a.createElement("path", {
          className: "rv-voronoi__cell " + (e.data && e.data.className || ""),
          d: "M" + e.join("L") + "Z",
          onClick: function onClick() {
            return c(e.data);
          },
          onMouseUp: function onMouseUp() {
            return p(e.data);
          },
          onMouseDown: function onMouseDown() {
            return h(e.data);
          },
          onMouseOver: function onMouseOver() {
            return d(e.data);
          },
          onMouseOut: function onMouseOut() {
            return s(e.data);
          },
          fill: "none",
          style: gd({
            pointerEvents: "all"
          }, y, e.data && e.data.style),
          key: t
        });
      }));
    }

    bd.requiresSVG = !0, bd.displayName = "Voronoi", bd.defaultProps = {
      className: "",
      onBlur: vd,
      onClick: vd,
      onHover: vd,
      onMouseDown: vd,
      onMouseUp: vd
    }, bd.propTypes = {
      className: h.a.string,
      extent: h.a.arrayOf(h.a.arrayOf(h.a.number)),
      nodes: h.a.arrayOf(h.a.object).isRequired,
      onBlur: h.a.func,
      onClick: h.a.func,
      onHover: h.a.func,
      onMouseDown: h.a.func,
      onMouseUp: h.a.func,
      x: h.a.func,
      y: h.a.func
    };

    var _d = bd,
        xd = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        Od = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function wd(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Td(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var kd = function (e) {
      function t() {
        return wd(this, t), Td(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), xd(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.animation,
              r = e.className,
              a = e.crossBarWidth,
              o = e.data,
              i = e.marginLeft,
              u = e.marginTop,
              l = e.strokeWidth,
              s = e.style;
          if (!o) return null;
          if (n) return f.a.createElement(ut, Od({}, this.props, {
            animatedProps: Bo
          }), f.a.createElement(t, Od({}, this.props, {
            animation: null
          })));
          var c = {
            crossBarWidth: a,
            opacityFunctor: this._getAttributeFunctor("opacity"),
            sizeFunctor: this._getAttributeFunctor("size"),
            strokeFunctor: this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color"),
            strokeWidth: l,
            style: s,
            xFunctor: this._getAttributeFunctor("x"),
            yFunctor: this._getAttributeFunctor("y"),
            valueClickHandler: this._valueClickHandler,
            valueRightClickHandler: this._valueRightClickHandler,
            valueMouseOverHandler: this._valueMouseOverHandler,
            valueMouseOutHandler: this._valueMouseOutHandler
          };
          return f.a.createElement("g", {
            className: "rv-xy-plot__series rv-xy-plot__series--whisker " + r,
            transform: "translate(" + i + "," + u + ")"
          }, o.map(function (e) {
            return function (t, n) {
              var r = e.crossBarWidth,
                  a = e.opacityFunctor,
                  o = e.sizeFunctor,
                  i = e.strokeFunctor,
                  u = e.strokeWidth,
                  l = e.style,
                  s = e.valueClickHandler,
                  c = e.valueMouseOutHandler,
                  p = e.valueMouseOverHandler,
                  h = e.valueRightClickHandler,
                  d = e.xFunctor,
                  y = e.yFunctor,
                  m = o ? o(t) : 0,
                  g = d(t),
                  v = y(t),
                  b = d({
                x: t.x + t.xVariance / 2
              }),
                  _ = d({
                x: t.x - t.xVariance / 2
              }),
                  x = y({
                y: t.y + t.yVariance / 2
              }),
                  O = y({
                y: t.y - t.yVariance / 2
              }),
                  w = b && g + m < b,
                  T = x && v - m > x;

              if (!w && !T) return null;
              var k = Od({
                opacity: a ? a(t) : 1,
                stroke: i && i(t),
                strokeWidth: u || 1
              }, l),
                  M = r / 2,
                  E = {
                x1: g + m,
                y1: v,
                x2: b,
                y2: v,
                style: k
              },
                  P = {
                x1: g - m,
                y1: v,
                x2: _,
                y2: v,
                style: k
              },
                  j = {
                x1: b,
                y1: v - M,
                x2: b,
                y2: v + M,
                style: k
              },
                  S = {
                x1: _,
                y1: v - M,
                x2: _,
                y2: v + M,
                style: k
              },
                  A = {
                x1: g,
                y1: v - m,
                x2: g,
                y2: x,
                style: k
              },
                  N = {
                x1: g,
                y1: v + m,
                x2: g,
                y2: O,
                style: k
              },
                  C = {
                x1: g - M,
                y1: x,
                x2: g + M,
                y2: x,
                style: k
              },
                  F = {
                x1: g - M,
                y1: O,
                x2: g + M,
                y2: O,
                style: k
              };
              return f.a.createElement("g", {
                className: "mark-whiskers",
                key: n,
                onClick: function onClick(e) {
                  return s(t, e);
                },
                onContextMenu: function onContextMenu(e) {
                  return h(t, e);
                },
                onMouseOver: function onMouseOver(e) {
                  return p(t, e);
                },
                onMouseOut: function onMouseOut(e) {
                  return c(t, e);
                }
              }, w ? f.a.createElement("g", {
                className: "x-whiskers"
              }, f.a.createElement("line", E), f.a.createElement("line", P), f.a.createElement("line", j), f.a.createElement("line", S)) : null, T ? f.a.createElement("g", {
                className: "y-whiskers"
              }, f.a.createElement("line", A), f.a.createElement("line", N), f.a.createElement("line", C), f.a.createElement("line", F)) : null);
            };
          }(c)));
        }
      }]), t;
    }(So);

    kd.displayName = "WhiskerSeries", kd.propTypes = Od({}, So.propTypes, {
      strokeWidth: h.a.number
    }), kd.defaultProps = Od({}, So.defaultProps, {
      crossBarWidth: 6,
      size: 0,
      strokeWidth: 1
    });

    var Md = n(40),
        Ed = n.n(Md),
        Pd = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function jd(e, t) {
      var n = e.margin,
          r = e.width,
          a = e.height,
          o = Pd({}, t, "number" == typeof n ? {
        left: n,
        right: n,
        top: n,
        bottom: n
      } : n),
          i = o.left,
          u = void 0 === i ? 0 : i,
          l = o.top,
          s = void 0 === l ? 0 : l,
          c = o.right,
          f = void 0 === c ? 0 : c,
          p = o.bottom,
          h = void 0 === p ? 0 : p;
      return {
        marginLeft: u,
        marginTop: s,
        marginRight: f,
        marginBottom: h,
        innerHeight: a - h - s,
        innerWidth: r - u - f
      };
    }

    function Sd(e, t, n) {
      var r = e / 2 - n,
          a = t / 2 - n;
      return {
        bottom: a,
        left: r,
        right: r,
        top: a
      };
    }

    var Ad = h.a.oneOfType([h.a.shape({
      left: h.a.number,
      top: h.a.number,
      right: h.a.number,
      bottom: h.a.number
    }), h.a.number]),
        Nd = {
      left: 40,
      right: 10,
      top: 10,
      bottom: 40
    },
        Cd = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        Fd = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function Rd(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ld(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function Dd(e, t, n, r, a) {
      e.clearRect(0, 0, n, t), r.forEach(function (t) {
        var n = t.interpolator,
            r = t.newProps,
            o = t.animation ? n ? n(a / 30) : n : function () {
          return {};
        };
        t.renderLayer(Fd({}, r, o), e);
      });
    }

    var qd = function (e) {
      function t() {
        return Rd(this, t), Ld(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Cd(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.canvas.getContext("2d");

          if (e) {
            var t = this.props.pixelRatio;
            e && (e.scale(t, t), this.drawChildren(null, this.props, e));
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          this.drawChildren(e, this.props, this.canvas.getContext("2d"));
        }
      }, {
        key: "drawChildren",
        value: function value(e, t, n) {
          var r = t.children,
              a = t.innerHeight,
              o = t.innerWidth,
              i = t.marginBottom,
              u = t.marginLeft,
              l = t.marginRight,
              s = t.marginTop;

          if (n) {
            var c,
                f,
                p = r.find(function (e) {
              return e.props.animation;
            }),
                h = a + s + i,
                d = o + u + l,
                y = (c = t.children, f = e ? e.children : [], c.map(function (e, t) {
              var n = f[t] ? f[t].props : {},
                  r = e.props,
                  a = ot(Fd({}, n, {
                animatedProps: Bo
              })),
                  o = r ? ot(Fd({}, r, {
                animatedProps: Bo
              })) : null,
                  i = Ke(a, o);
              return {
                renderLayer: e.type.renderLayer,
                newProps: e.props,
                animation: e.props.animation,
                interpolator: i
              };
            }));
            p ? function (e, t, n, r) {
              var a = 0,
                  o = setInterval(function () {
                e ? (Dd(e, t, n, r, a), a > 30 && clearInterval(o), a += 1) : clearInterval(o);
              }, 1);
            }(n, h, d, y) : Dd(n, h, d, y);
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.innerHeight,
              r = t.innerWidth,
              a = t.marginBottom,
              o = t.marginLeft,
              i = t.marginRight,
              u = t.marginTop,
              l = t.pixelRatio,
              s = n + u + a,
              c = r + o + i;
          return f.a.createElement("div", {
            style: {
              left: 0,
              top: 0
            },
            className: "rv-xy-canvas"
          }, f.a.createElement("canvas", {
            className: "rv-xy-canvas-element",
            height: s * l,
            width: c * l,
            style: {
              height: s + "px",
              width: c + "px"
            },
            ref: function ref(t) {
              return e.canvas = t;
            }
          }), this.props.children);
        }
      }], [{
        key: "defaultProps",
        get: function get() {
          return {
            pixelRatio: window && window.devicePixelRatio || 1
          };
        }
      }]), t;
    }(c.Component);

    qd.displayName = "CanvasWrapper", qd.propTypes = {
      marginBottom: h.a.number.isRequired,
      marginLeft: h.a.number.isRequired,
      marginRight: h.a.number.isRequired,
      marginTop: h.a.number.isRequired,
      innerHeight: h.a.number.isRequired,
      innerWidth: h.a.number.isRequired,
      pixelRatio: h.a.number.isRequired
    };

    var Vd = qd,
        zd = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        Id = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    var Hd = ["x", "y", "radius", "angle", "color", "fill", "stroke", "opacity", "size"];

    function Bd(e) {
      return e.map(function (e) {
        return Array.isArray(e) ? e.map(function (e) {
          return Id({}, e, {
            parent: null
          });
        }) : e;
      });
    }

    var Ud = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        Wd.call(n);
        var r = e.stackBy,
            a = zo(Vo(e.children), r);
        return n.state = {
          scaleMixins: n._getScaleMixins(a, e),
          data: a
        }, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), zd(t, null, [{
        key: "defaultProps",
        get: function get() {
          return {
            className: ""
          };
        }
      }, {
        key: "propTypes",
        get: function get() {
          return {
            animation: lt,
            className: h.a.string,
            dontCheckIfEmpty: h.a.bool,
            height: h.a.number.isRequired,
            margin: Ad,
            onClick: h.a.func,
            onDoubleClick: h.a.func,
            onMouseDown: h.a.func,
            onMouseUp: h.a.func,
            onMouseEnter: h.a.func,
            onMouseLeave: h.a.func,
            onMouseMove: h.a.func,
            onTouchStart: h.a.func,
            onTouchMove: h.a.func,
            onTouchEnd: h.a.func,
            onTouchCancel: h.a.func,
            onWheel: h.a.func,
            stackBy: h.a.oneOf(Hd),
            style: h.a.object,
            width: h.a.number.isRequired
          };
        }
      }]), zd(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = zo(Vo(e.children), e.stackBy),
              n = this.state.scaleMixins,
              r = this._getScaleMixins(t, e);

          (function (e, t, n) {
            var r = Id({}, e, {
              _allData: n ? Bd(e._allData) : e._allData
            }),
                a = Id({}, t, {
              _allData: n ? Bd(t._allData) : t._allData
            });
            return Ed()(r, a);
          })(r, n, e.hasTreeStructure) || this.setState({
            scaleMixins: r,
            data: t
          });
        }
      }, {
        key: "_getClonedChildComponents",
        value: function value() {
          var e = this,
              t = this.props,
              n = this.props.animation,
              r = this.state,
              a = r.scaleMixins,
              o = r.data,
              i = jd(this.props, Nd),
              u = f.a.Children.toArray(this.props.children),
              l = Io(u),
              s = Oo(t, u);
          return u.map(function (t, r) {
            var u = null;

            if (l[r]) {
              var c = l[r].seriesIndex;
              u = {
                data: o[c]
              };
            }

            return f.a.cloneElement(t, Id({}, i, {
              animation: n
            }, u && t.type.prototype && t.type.prototype.render ? {
              ref: function ref(t) {
                return e["series" + l[r].seriesIndex] = t;
              }
            } : {}, l[r], a, t.props, s[r], u));
          });
        }
      }, {
        key: "_getDefaultScaleProps",
        value: function value(e) {
          var t = jd(e, Nd),
              n = t.innerWidth,
              r = t.innerHeight,
              a = ["color", "fill", "stroke"].reduce(function (t, n) {
            var r,
                a,
                o,
                i = "category" === e[n + "Type"] ? No : Co;
            return Id({}, t, (o = i, (a = n + "Range") in (r = {}) ? Object.defineProperty(r, a, {
              value: o,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : r[a] = o, r));
          }, {});
          return Id({
            xRange: [0, n],
            yRange: [r, 0]
          }, a, {
            opacityType: "literal",
            sizeRange: Fo
          });
        }
      }, {
        key: "_getScaleMixins",
        value: function value(e, t) {
          var n,
              r = e.filter(function (e) {
            return e;
          }),
              a = (n = []).concat.apply(n, function (e) {
            if (Array.isArray(e)) {
              for (var t = 0, n = Array(e.length); t < e.length; t++) {
                n[t] = e[t];
              }

              return n;
            }

            return Array.from(e);
          }(r)),
              o = this._getDefaultScaleProps(t),
              i = To(t),
              u = vo(t, Hd),
              l = bo(Id({}, o, i, u), a, Hd),
              s = Vo(t.children),
              c = {},
              f = new Set(),
              p = new Set();

          return s.forEach(function (n, r) {
            n && e[r] && Hd.forEach(function (e) {
              var a = n.type.getParentConfig(e, n.props),
                  o = a.isDomainAdjustmentNeeded,
                  i = a.zeroBaseValue;

              if (o && (f.add(e), p.add(r)), i) {
                var u = t[e + "Domain"];
                c[e + "BaseValue"] = u ? u[0] : 0;
              }
            });
          }), Id({}, o, c, u, l, {
            _allData: e,
            _adjustBy: Array.from(f),
            _adjustWhat: Array.from(p),
            _stackBy: t.stackBy
          });
        }
      }, {
        key: "_isPlotEmpty",
        value: function value() {
          var e = this.state.data;
          return !e || !e.length || !e.some(function (e) {
            return e && e.some(function (e) {
              return e;
            });
          });
        }
      }, {
        key: "renderCanvasComponents",
        value: function value(e, t) {
          var n = e.filter(function (e) {
            return e && !e.type.requiresSVG && e.type.isCanvas;
          });
          if (0 === n.length) return null;
          var r = n[0].props,
              a = r.marginLeft,
              o = r.marginTop,
              i = r.marginBottom,
              u = r.marginRight,
              l = r.innerHeight,
              s = r.innerWidth;
          return f.a.createElement(Vd, {
            innerHeight: l,
            innerWidth: s,
            marginLeft: a,
            marginTop: o,
            marginBottom: i,
            marginRight: u
          }, n);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.className,
              n = e.dontCheckIfEmpty,
              r = e.style,
              a = e.width,
              o = e.height;
          if (!n && this._isPlotEmpty()) return f.a.createElement("div", {
            className: "rv-xy-plot " + t,
            style: Id({
              width: a + "px",
              height: o + "px"
            }, this.props.style)
          });

          var i = this._getClonedChildComponents();

          return f.a.createElement("div", {
            style: {
              width: a + "px",
              height: o + "px"
            },
            className: "rv-xy-plot " + t
          }, f.a.createElement("svg", {
            className: "rv-xy-plot__inner",
            width: a,
            height: o,
            style: r,
            onClick: this._clickHandler,
            onDoubleClick: this._doubleClickHandler,
            onMouseDown: this._mouseDownHandler,
            onMouseUp: this._mouseUpHandler,
            onMouseMove: this._mouseMoveHandler,
            onMouseLeave: this._mouseLeaveHandler,
            onMouseEnter: this._mouseEnterHandler,
            onTouchStart: this._mouseDownHandler,
            onTouchMove: this._touchMoveHandler,
            onTouchEnd: this._touchEndHandler,
            onTouchCancel: this._touchCancelHandler,
            onWheel: this._wheelHandler
          }, i.filter(function (e) {
            return e && e.type.requiresSVG;
          })), this.renderCanvasComponents(i, this.props), i.filter(function (e) {
            return e && !e.type.requiresSVG && !e.type.isCanvas;
          }));
        }
      }]), t;
    }(f.a.Component),
        Wd = function Wd() {
      var e = this;
      this._clickHandler = function (t) {
        var n = e.props.onClick;
        n && n(t);
      }, this._doubleClickHandler = function (t) {
        var n = e.props.onDoubleClick;
        n && n(t);
      }, this._mouseDownHandler = function (t) {
        var n = e.props,
            r = n.onMouseDown,
            a = n.children;
        r && r(t), Vo(a).forEach(function (n, r) {
          var a = e["series" + r];
          a && a.onParentMouseDown && a.onParentMouseDown(t);
        });
      }, this._mouseEnterHandler = function (t) {
        var n = e.props,
            r = n.onMouseEnter,
            a = n.children;
        r && r(t), Vo(a).forEach(function (n, r) {
          var a = e["series" + r];
          a && a.onParentMouseEnter && a.onParentMouseEnter(t);
        });
      }, this._mouseLeaveHandler = function (t) {
        var n = e.props,
            r = n.onMouseLeave,
            a = n.children;
        r && r(t), Vo(a).forEach(function (n, r) {
          var a = e["series" + r];
          a && a.onParentMouseLeave && a.onParentMouseLeave(t);
        });
      }, this._mouseMoveHandler = function (t) {
        var n = e.props,
            r = n.onMouseMove,
            a = n.children;
        r && r(t), Vo(a).forEach(function (n, r) {
          var a = e["series" + r];
          a && a.onParentMouseMove && a.onParentMouseMove(t);
        });
      }, this._mouseUpHandler = function (t) {
        var n = e.props,
            r = n.onMouseUp,
            a = n.children;
        r && r(t), Vo(a).forEach(function (n, r) {
          var a = e["series" + r];
          a && a.onParentMouseUp && a.onParentMouseUp(t);
        });
      }, this._touchCancelHandler = function (t) {
        var n = e.props.onTouchCancel;
        n && n(t);
      }, this._touchEndHandler = function (t) {
        var n = e.props.onTouchEnd;
        n && n(t);
      }, this._touchMoveHandler = function (t) {
        var n = e.props,
            r = n.onTouchMove,
            a = n.children;
        r && r(t), Vo(a).forEach(function (n, r) {
          var a = e["series" + r];
          a && a.onParentTouchMove && a.onParentTouchMove(t);
        });
      }, this._touchStartHandler = function (t) {
        var n = e.props,
            r = n.onTouchStart,
            a = n.children;
        r && r(t), Vo(a).forEach(function (n, r) {
          var a = e["series" + r];
          a && a.onParentTouchStart && a.onParentTouchStart(t);
        });
      }, this._wheelHandler = function (t) {
        var n = e.props.onWheel;
        n && n(t);
      };
    };

    Ud.displayName = "XYPlot";

    var Yd = Ud,
        Xd = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Gd = Dl.LEFT,
        $d = Dl.RIGHT,
        Zd = Dl.TOP,
        Jd = Dl.BOTTOM,
        Qd = {
      height: h.a.number.isRequired,
      style: h.a.object,
      orientation: h.a.oneOf([Gd, $d, Zd, Jd]).isRequired,
      width: h.a.number.isRequired
    };

    function Kd(e) {
      var t = e.orientation,
          n = e.width,
          r = e.height,
          a = e.style,
          o = void 0;
      return o = t === Gd ? {
        x1: n,
        x2: n,
        y1: 0,
        y2: r
      } : t === $d ? {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: r
      } : t === Zd ? {
        x1: 0,
        x2: n,
        y1: r,
        y2: r
      } : {
        x1: 0,
        x2: n,
        y1: 0,
        y2: 0
      }, f.a.createElement("line", Xd({}, o, {
        className: "rv-xy-plot__axis__line",
        style: a
      }));
    }

    Kd.defaultProps = {
      style: {}
    }, Kd.displayName = "AxisLine", Kd.propTypes = Qd;

    var ey = Kd,
        ty = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        ny = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function ry(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function ay(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function oy(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var iy = Dl.LEFT,
        uy = Dl.RIGHT,
        ly = Dl.TOP,
        sy = Dl.BOTTOM,
        cy = {
      height: h.a.number.isRequired,
      orientation: h.a.oneOf([iy, uy, ly, sy]).isRequired,
      style: h.a.object,
      width: h.a.number.isRequired
    };

    var fy = function (e) {
      function t() {
        return ay(this, t), oy(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), ny(t, [{
        key: "_areTicksWrapped",
        value: function value() {
          var e = this.props.orientation;
          return e === iy || e === ly;
        }
      }, {
        key: "_getTickContainerPropsGetterFn",
        value: function value() {
          return this._isAxisVertical() ? function (e) {
            return {
              transform: "translate(0, " + e + ")"
            };
          } : function (e) {
            return {
              transform: "translate(" + e + ", 0)"
            };
          };
        }
      }, {
        key: "_getTickLabelProps",
        value: function value() {
          var e = this.props,
              t = e.orientation,
              n = e.tickLabelAngle,
              r = e.tickSize,
              a = e.tickSizeOuter,
              o = void 0 === a ? r : a,
              i = e.tickPadding,
              u = void 0 === i ? r : i,
              l = void 0;
          l = t === iy || t === sy && n ? "end" : t === uy || t === ly && n ? "start" : "middle";

          var s = this._isAxisVertical(),
              c = (this._areTicksWrapped() ? -1 : 1) * (o + u);

          return {
            textAnchor: l,
            dy: t === ly || n ? "0" : t === sy ? "0.72em" : "0.32em",
            transform: (s ? "translate(" + c + ", 0)" : "translate(0, " + c + ")") + (n ? " rotate(" + n + ")" : "")
          };
        }
      }, {
        key: "_getTickLineProps",
        value: function value() {
          var e,
              t = this.props,
              n = t.tickSize,
              r = t.tickSizeOuter,
              a = void 0 === r ? n : r,
              o = t.tickSizeInner,
              i = void 0 === o ? n : o,
              u = this._isAxisVertical(),
              l = u ? "y" : "x",
              s = u ? "x" : "y",
              c = this._areTicksWrapped() ? -1 : 1;

          return ry(e = {}, l + "1", 0), ry(e, l + "2", 0), ry(e, s + "1", -c * i), ry(e, s + "2", c * a), e;
        }
      }, {
        key: "_isAxisVertical",
        value: function value() {
          var e = this.props.orientation;
          return e === iy || e === uy;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.attr,
              n = e.orientation,
              r = e.width,
              a = e.height,
              o = e.style,
              i = e.tickFormat,
              u = e.tickTotal,
              l = e.tickValues,
              s = n === iy ? r : 0,
              c = n === ly ? a : 0,
              p = co(this.props, t),
              h = zl(p, u, l),
              d = function (e, t, n) {
            return n || (e.tickFormat ? e.tickFormat(t) : function (e) {
              return e;
            });
          }(p, u, i),
              y = this._getTickContainerPropsGetterFn(),
              m = this._getTickLineProps(),
              g = this._getTickLabelProps(),
              v = h.map(function (e, t) {
            var n = p(e),
                a = d(e, t, p, u),
                i = f.a.isValidElement(a) && !["tspan", "textPath"].includes(a.type),
                l = a && "string" != typeof a.type;
            return f.a.createElement("g", ty({
              key: t
            }, y(n, 0), {
              className: "rv-xy-plot__axis__tick",
              style: o
            }), f.a.createElement("line", ty({}, m, {
              className: "rv-xy-plot__axis__tick__line",
              style: ty({}, o, o.line)
            })), i ? f.a.cloneElement(a, l ? ty({}, g, {
              containerWidth: r,
              tickCount: h.length
            }) : void 0) : f.a.createElement("text", ty({}, g, {
              className: "rv-xy-plot__axis__tick__text",
              style: ty({}, o, o.text)
            }), a));
          });

          return f.a.createElement("g", {
            transform: "translate(" + s + ", " + c + ")",
            className: "rv-xy-plot__axis__ticks"
          }, v);
        }
      }]), t;
    }(f.a.Component);

    fy.defaultProps = {
      style: {}
    }, fy.displayName = "AxisTicks", fy.propTypes = cy, fy.requiresSVG = !0;

    var py = fy,
        hy = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function dy(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var yy = Dl.LEFT,
        my = Dl.RIGHT,
        gy = Dl.TOP,
        vy = Dl.BOTTOM,
        by = {
      width: h.a.number.isRequired,
      height: h.a.number.isRequired,
      orientation: h.a.oneOf([yy, my, gy, vy]).isRequired,
      style: h.a.object,
      title: h.a.string.isRequired
    };

    function _y(e) {
      var t = e.orientation,
          n = e.position,
          r = e.width,
          a = e.height,
          o = e.style,
          i = e.title,
          u = "translate(" + (t === yy ? r : 0) + ", " + (t === gy ? a : 0) + ")",
          l = function (e, t) {
        var n;
        return dy(n = {}, yy, {
          end: {
            x: 16,
            y: 6,
            rotation: -90,
            textAnchor: "end"
          },
          middle: {
            x: 16,
            y: t / 2 - 6,
            rotation: -90,
            textAnchor: "middle"
          },
          start: {
            x: 16,
            y: t - 6,
            rotation: -90,
            textAnchor: "start"
          }
        }), dy(n, my, {
          end: {
            x: -8,
            y: 6,
            rotation: -90,
            textAnchor: "end"
          },
          middle: {
            x: -8,
            y: t / 2 - 6,
            rotation: -90,
            textAnchor: "middle"
          },
          start: {
            x: -8,
            y: t - 6,
            rotation: -90,
            textAnchor: "start"
          }
        }), dy(n, gy, {
          start: {
            x: 6,
            y: 16,
            rotation: 0,
            textAnchor: "start"
          },
          middle: {
            x: e / 2 - 6,
            y: 16,
            rotation: 0,
            textAnchor: "middle"
          },
          end: {
            x: e - 6,
            y: 16,
            rotation: 0,
            textAnchor: "end"
          }
        }), dy(n, vy, {
          start: {
            x: 6,
            y: -6,
            rotation: 0,
            textAnchor: "start"
          },
          middle: {
            x: e / 2 - 6,
            y: -6,
            rotation: 0,
            textAnchor: "middle"
          },
          end: {
            x: e - 6,
            y: -6,
            rotation: 0,
            textAnchor: "end"
          }
        }), n;
      }(r, a)[t][n],
          s = l.x,
          c = l.y,
          p = l.rotation,
          h = l.textAnchor,
          d = "translate(" + s + ", " + c + ") rotate(" + p + ")";

      return f.a.createElement("g", {
        transform: u,
        className: "rv-xy-plot__axis__title"
      }, f.a.createElement("g", {
        style: hy({
          textAnchor: h
        }, o),
        transform: d
      }, f.a.createElement("text", {
        style: o
      }, i)));
    }

    _y.displayName = "AxisTitle", _y.propTypes = by, _y.defaultProps = {
      position: "end"
    };

    var xy = _y,
        Oy = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        wy = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Ty(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function ky(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var My = ["xRange", "yRange", "xDomain", "yDomain", "width", "height", "marginLeft", "marginTop", "marginRight", "marginBottom", "tickSize", "tickTotal", "tickSizeInner", "tickSizeOuter"],
        Ey = Dl.LEFT,
        Py = Dl.RIGHT,
        jy = Dl.TOP,
        Sy = Dl.BOTTOM,
        Ay = {
      orientation: h.a.oneOf([Ey, Py, jy, Sy]),
      attr: h.a.string.isRequired,
      attrAxis: h.a.string,
      width: h.a.number,
      height: h.a.number,
      top: h.a.number,
      left: h.a.number,
      title: h.a.string,
      style: h.a.object,
      className: h.a.string,
      hideTicks: h.a.bool,
      hideLine: h.a.bool,
      on0: h.a.bool,
      tickLabelAngle: h.a.number,
      tickSize: h.a.number,
      tickSizeInner: h.a.number,
      tickSizeOuter: h.a.number,
      tickPadding: h.a.number,
      tickValues: h.a.arrayOf(h.a.oneOfType([h.a.number, h.a.string])),
      tickFormat: h.a.func,
      tickTotal: h.a.number,
      marginTop: h.a.number,
      marginBottom: h.a.number,
      marginLeft: h.a.number,
      marginRight: h.a.number,
      innerWidth: h.a.number,
      innerHeight: h.a.number
    },
        Ny = {
      className: "",
      on0: !1,
      style: {},
      tickSize: 6,
      tickPadding: 8,
      orientation: Sy
    },
        Cy = function (e) {
      function t() {
        return Ty(this, t), ky(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), wy(t, [{
        key: "_getDefaultAxisProps",
        value: function value() {
          var e = this.props,
              t = e.innerWidth,
              n = e.innerHeight,
              r = e.marginTop,
              a = e.marginBottom,
              o = e.marginLeft,
              i = e.marginRight,
              u = e.orientation;
          return u === Sy ? {
            tickTotal: Vl(t),
            top: n + r,
            left: o,
            width: t,
            height: a
          } : u === jy ? {
            tickTotal: Vl(t),
            top: 0,
            left: o,
            width: t,
            height: r
          } : u === Ey ? {
            tickTotal: Vl(n),
            top: r,
            left: 0,
            width: o,
            height: n
          } : {
            tickTotal: Vl(n),
            top: r,
            left: o + t,
            width: i,
            height: n
          };
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props.animation;

          if (e) {
            var n = e.nonAnimatedProps ? My.filter(function (t) {
              return e.nonAnimatedProps.indexOf(t) < 0;
            }) : My;
            return f.a.createElement(ut, Oy({}, this.props, {
              animatedProps: n
            }), f.a.createElement(t, Oy({}, this.props, {
              animation: null
            })));
          }

          var r = Oy({}, this._getDefaultAxisProps(), this.props),
              a = r.attrAxis,
              o = r.className,
              i = r.height,
              u = r.hideLine,
              l = r.hideTicks,
              s = r.left,
              c = r.marginTop,
              p = r.on0,
              h = r.orientation,
              d = r.position,
              y = r.style,
              m = r.title,
              g = r.top,
              v = r.width,
              b = [Ey, Py].indexOf(h) > -1,
              _ = b ? "rv-xy-plot__axis--vertical" : "rv-xy-plot__axis--horizontal",
              x = s,
              O = g;

          if (p) {
            var w = co(r, a);
            b ? x = w(0) : O = c + w(0);
          }

          return f.a.createElement("g", {
            transform: "translate(" + x + "," + O + ")",
            className: "rv-xy-plot__axis " + _ + " " + o,
            style: y
          }, !u && f.a.createElement(ey, {
            height: i,
            width: v,
            orientation: h,
            style: Oy({}, y, y.line)
          }), !l && f.a.createElement(py, Oy({}, r, {
            style: Oy({}, y, y.ticks)
          })), m ? f.a.createElement(xy, {
            position: d,
            title: m,
            height: i,
            width: v,
            style: Oy({}, y, y.title),
            orientation: h
          }) : null);
        }
      }]), t;
    }(c.PureComponent);

    Cy.displayName = "Axis", Cy.propTypes = Ay, Cy.defaultProps = Ny, Cy.requiresSVG = !0;

    var Fy = Cy,
        Ry = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Ly = Dl.TOP,
        Dy = Dl.BOTTOM,
        qy = Ry({}, Fy.propTypes, {
      orientation: h.a.oneOf([Ly, Dy])
    }),
        Vy = {
      orientation: Dy,
      attr: "x",
      attrAxis: "y"
    };

    function zy(e) {
      return f.a.createElement(Fy, e);
    }

    zy.displayName = "XAxis", zy.propTypes = qy, zy.defaultProps = Vy, zy.requiresSVG = !0;

    var Iy = zy,
        Hy = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        By = Dl.LEFT,
        Uy = Dl.RIGHT,
        Wy = Hy({}, Fy.propTypes, {
      orientation: h.a.oneOf([By, Uy])
    }),
        Yy = {
      orientation: By,
      attr: "y",
      attrAxis: "x"
    };

    function Xy(e) {
      return f.a.createElement(Fy, e);
    }

    Xy.displayName = "YAxis", Xy.propTypes = Wy, Xy.defaultProps = Yy, Xy.requiresSVG = !0;
    var Gy = Xy,
        $y = {
      className: h.a.string,
      height: h.a.number,
      endColor: h.a.string,
      endTitle: h.a.oneOfType([h.a.number, h.a.string]).isRequired,
      midColor: h.a.string,
      midTitle: h.a.oneOfType([h.a.number, h.a.string]),
      startColor: h.a.string,
      startTitle: h.a.oneOfType([h.a.number, h.a.string]).isRequired,
      width: h.a.number
    },
        Zy = {
      className: "",
      startColor: Co[0],
      endColor: Co[1]
    };

    function Jy(e) {
      var t = e.startColor,
          n = e.midColor,
          r = e.endColor,
          a = e.startTitle,
          o = e.midTitle,
          i = e.endTitle,
          u = e.height,
          l = e.width,
          s = e.className,
          c = [t];
      return n && c.push(n), c.push(r), f.a.createElement("div", {
        className: "rv-continuous-color-legend " + s,
        style: {
          width: l,
          height: u
        }
      }, f.a.createElement("div", {
        className: "rv-gradient",
        style: {
          background: "linear-gradient(to right, " + c.join(",") + ")"
        }
      }), f.a.createElement("div", {
        className: "rv-legend-titles"
      }, f.a.createElement("span", {
        className: "rv-legend-titles__left"
      }, a), f.a.createElement("span", {
        className: "rv-legend-titles__right"
      }, i), o ? f.a.createElement("span", {
        className: "rv-legend-titles__center"
      }, o) : null));
    }

    Jy.displayName = "ContinuousColorLegend", Jy.propTypes = $y, Jy.defaultProps = Zy;
    var Qy = {
      className: h.a.string,
      circlesTotal: h.a.number,
      endSize: h.a.number,
      endTitle: h.a.oneOfType([h.a.number, h.a.string]).isRequired,
      height: h.a.number,
      startSize: h.a.number,
      startTitle: h.a.oneOfType([h.a.number, h.a.string]).isRequired,
      width: h.a.number
    };

    function Ky(e) {
      for (var t = e.startTitle, n = e.endTitle, r = e.startSize, a = e.endSize, o = e.circlesTotal, i = e.height, u = e.width, l = e.className, s = [], c = (a - r) / (o - 1), p = 0; p < o; p++) {
        var h = c * p + r;
        s.push(f.a.createElement("div", {
          key: p,
          className: "rv-bubble",
          style: {
            width: h,
            height: h,
            borderRadius: h / 2
          }
        })), s.push(" ");
      }

      return f.a.createElement("div", {
        className: "rv-continuous-size-legend " + l,
        style: {
          width: u,
          height: i
        }
      }, f.a.createElement("div", {
        className: "rv-bubbles",
        style: {
          height: a
        }
      }, s, f.a.createElement("div", {
        className: "rv-spacer"
      })), f.a.createElement("div", {
        className: "rv-legend-titles"
      }, f.a.createElement("span", {
        className: "rv-legend-titles__left"
      }, t), f.a.createElement("span", {
        className: "rv-legend-titles__right"
      }, n)));
    }

    Ky.displayName = "ContinuousSizeLegend", Ky.propTypes = Qy, Ky.defaultProps = {
      circlesTotal: 10,
      className: "",
      endSize: 20,
      startSize: 2
    };

    var em = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        tm = {
      dashed: "6, 2",
      solid: null
    };

    function nm(e) {
      var t = e.color,
          n = e.strokeDasharray,
          r = e.strokeStyle,
          a = e.strokeWidth,
          o = e.disabled,
          i = e.onClick,
          u = e.orientation,
          l = e.onMouseEnter,
          s = e.onMouseLeave,
          c = e.title,
          p = "rv-discrete-color-legend-item " + u;
      o && (p += " disabled"), i && (p += " clickable");
      var h = tm[r] || n;
      return f.a.createElement("div", {
        className: p,
        onClick: i,
        onMouseEnter: l,
        onMouseLeave: s
      }, f.a.createElement("svg", {
        className: "rv-discrete-color-legend-item__color",
        height: 2,
        width: 14
      }, f.a.createElement("path", {
        className: "rv-discrete-color-legend-item__color__path",
        d: "M 0, 1 L 14, 1",
        style: em({}, a ? {
          strokeWidth: a
        } : {}, h ? {
          strokeDasharray: h
        } : {}, {
          stroke: o ? null : t
        })
      })), f.a.createElement("span", {
        className: "rv-discrete-color-legend-item__title"
      }, c));
    }

    nm.propTypes = {
      color: h.a.string.isRequired,
      disabled: h.a.bool,
      title: h.a.oneOfType([h.a.string, h.a.element]).isRequired,
      onClick: h.a.func,
      onMouseEnter: h.a.func,
      onMouseLeave: h.a.func,
      orientation: h.a.oneOf(["vertical", "horizontal"]).isRequired,
      strokeDasharray: h.a.string,
      strokeWidth: h.a.number,
      strokeStyle: h.a.oneOf(Object.keys(tm))
    }, nm.defaultProps = {
      disabled: !1,
      strokeStyle: "solid"
    }, nm.displayName = "DiscreteColorLegendItem";

    var rm = nm,
        am = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function om(e) {
      var t = e.className,
          n = e.colors,
          r = e.height,
          a = e.items,
          o = e.onItemClick,
          i = e.onItemMouseEnter,
          u = e.onItemMouseLeave,
          l = e.orientation,
          s = e.style,
          c = e.width;
      return f.a.createElement("div", {
        className: "rv-discrete-color-legend " + l + " " + t,
        style: am({
          width: c,
          height: r
        }, s)
      }, a.map(function (e, t) {
        return f.a.createElement(rm, {
          title: e.title ? e.title : e,
          color: e.color ? e.color : n[t % n.length],
          strokeDasharray: e.strokeDasharray,
          strokeStyle: e.strokeStyle,
          strokeWidth: e.strokeWidth,
          disabled: Boolean(e.disabled),
          orientation: l,
          key: t,
          onClick: o ? function (n) {
            return o(e, t, n);
          } : null,
          onMouseEnter: i ? function (n) {
            return i(e, t, n);
          } : null,
          onMouseLeave: i ? function (n) {
            return u(e, t, n);
          } : null
        });
      }));
    }

    om.displayName = "DiscreteColorLegendItem", om.propTypes = {
      className: h.a.string,
      items: h.a.arrayOf(h.a.oneOfType([h.a.shape({
        title: h.a.oneOfType([h.a.string, h.a.element]).isRequired,
        color: h.a.string,
        disabled: h.a.bool
      }), h.a.string.isRequired, h.a.element])).isRequired,
      onItemClick: h.a.func,
      onItemMouseEnter: h.a.func,
      onItemMouseLeave: h.a.func,
      height: h.a.number,
      width: h.a.number,
      orientation: h.a.oneOf(["vertical", "horizontal"])
    }, om.defaultProps = {
      className: "",
      colors: Ao,
      orientation: "vertical"
    };

    var im = om,
        um = (Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    })({}, im.propTypes, {
      searchText: h.a.string,
      onSearchChange: h.a.func,
      searchPlaceholder: h.a.string,
      searchFn: h.a.func
    }),
        lm = {
      className: "",
      searchText: "",
      searchFn: function searchFn(e, t) {
        return e.filter(function (e) {
          return -1 !== String(e.title || e).toLowerCase().indexOf(t);
        });
      }
    };

    function sm(e) {
      var t = e.className,
          n = e.colors,
          r = e.height,
          a = e.items,
          o = e.onItemClick,
          i = e.onSearchChange,
          u = e.orientation,
          l = e.searchFn,
          s = e.searchPlaceholder,
          c = e.searchText,
          p = e.width,
          h = i ? function (e) {
        var t = e.target.value;
        return i(t);
      } : null,
          d = l(a, c);
      return f.a.createElement("div", {
        className: "rv-search-wrapper " + t,
        style: {
          width: p,
          height: r
        }
      }, f.a.createElement("form", {
        className: "rv-search-wrapper__form"
      }, f.a.createElement("input", {
        type: "search",
        placeholder: s,
        className: "rv-search-wrapper__form__input",
        value: c,
        onChange: h
      })), f.a.createElement("div", {
        className: "rv-search-wrapper__contents"
      }, f.a.createElement(im, {
        colors: n,
        items: d,
        onItemClick: o,
        orientation: u
      })));
    }

    sm.propTypes = um, sm.defaultProps = lm, sm.displayName = "SearchableDiscreteColorLegend";

    var cm = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        fm = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function pm(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function hm(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var dm = rn(".2r");

    function ym(e) {
      var t = e.domains,
          n = e.style;
      return t.map(function (e, t) {
        return {
          x: e.name,
          y: 1.1,
          label: e.name,
          style: n
        };
      });
    }

    var mm = function (e) {
      function t() {
        var e, n, r;
        pm(this, t);

        for (var a = arguments.length, o = Array(a), i = 0; i < a; i++) {
          o[i] = arguments[i];
        }

        return n = r = hm(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(o))), r.state = {
          brushFilters: {}
        }, hm(r, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), cm(t, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.state.brushFilters,
              n = this.props,
              r = n.animation,
              a = n.brushing,
              o = n.className,
              i = n.children,
              u = n.colorRange,
              l = n.data,
              s = n.domains,
              c = n.height,
              p = n.hideInnerMostValues,
              h = n.margin,
              d = n.onMouseLeave,
              y = n.onMouseEnter,
              m = n.showMarks,
              g = n.style,
              v = n.tickFormat,
              b = n.width,
              _ = function (e) {
            var t = e.animation,
                n = e.domains,
                r = e.style,
                a = e.tickFormat;
            return n.map(function (e, n) {
              var o = e.domain;
              return f.a.createElement(ef, {
                animation: t,
                key: n + "-axis",
                axisStart: {
                  x: e.name,
                  y: 0
                },
                axisEnd: {
                  x: e.name,
                  y: 1
                },
                axisDomain: o,
                numberOfTicks: 5,
                tickValue: function tickValue(t) {
                  return e.tickFormat ? e.tickFormat(t) : a(t);
                },
                style: r.axes
              });
            });
          }({
            domains: s,
            animation: r,
            hideInnerMostValues: p,
            style: g,
            tickFormat: v
          }),
              x = function (e) {
            var t = e.animation,
                n = e.brushFilters,
                r = e.colorRange,
                a = e.domains,
                o = e.data,
                i = e.style,
                u = e.showMarks,
                l = a.reduce(function (e, t) {
              var n = t.domain;
              return e[t.name] = yn().domain(n).range([0, 1]), e;
            }, {});
            return o.map(function (e, o) {
              var s = !0,
                  c = a.map(function (t, r) {
                var a = t.getValue,
                    o = t.name,
                    i = l[o](a ? a(e) : e[o]),
                    u = n[o];
                return u && (i < u.min || i > u.max) && (s = !1), {
                  x: o,
                  y: i
                };
              }),
                  p = {
                animation: t,
                className: s ? "rv-parallel-coordinates-chart-line" : "rv-parallel-coordinates-chart-line rv-parallel-coordinates-chart-line-unselected",
                key: o + "-polygon",
                data: c,
                color: e.color || r[o % r.length],
                style: fm({}, i.lines, e.style || {})
              };
              return s || (p.style = fm({}, p.style, i.deselectedLineStyle)), u ? f.a.createElement(vh, p) : f.a.createElement(oh, p);
            });
          }({
            animation: r,
            brushFilters: t,
            colorRange: u,
            domains: s,
            data: l,
            showMarks: m,
            style: g
          }),
              O = f.a.createElement(Qp, {
            animation: !0,
            key: o,
            className: "rv-parallel-coordinates-chart-label",
            data: ym({
              domains: s,
              style: g.labels
            })
          }),
              w = jd(this.props, Nd),
              T = w.marginLeft,
              k = w.marginRight;

          return f.a.createElement(Yd, {
            height: c,
            width: b,
            margin: h,
            dontCheckIfEmpty: !0,
            className: o + " rv-parallel-coordinates-chart",
            onMouseLeave: d,
            onMouseEnter: y,
            xType: "ordinal",
            yDomain: [0, 1]
          }, i, _.concat(x).concat(O), a && s.map(function (n) {
            var r = function r(_r2) {
              var a, o, i;
              e.setState({
                brushFilters: fm({}, t, (a = {}, o = n.name, i = _r2 ? {
                  min: _r2.bottom,
                  max: _r2.top
                } : null, o in a ? Object.defineProperty(a, o, {
                  value: i,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : a[o] = i, a))
              });
            };

            return f.a.createElement(Lf, {
              key: n.name,
              drag: !0,
              highlightX: n.name,
              onBrushEnd: r,
              onDragEnd: r,
              highlightWidth: (b - T - k) / s.length,
              enableX: !1
            });
          }));
        }
      }]), t;
    }(c.Component);

    mm.displayName = "ParallelCoordinates", mm.propTypes = {
      animation: lt,
      brushing: h.a.bool,
      className: h.a.string,
      colorType: h.a.string,
      colorRange: h.a.arrayOf(h.a.string),
      data: h.a.arrayOf(h.a.object).isRequired,
      domains: h.a.arrayOf(h.a.shape({
        name: h.a.string.isRequired,
        domain: h.a.arrayOf(h.a.number).isRequired,
        tickFormat: h.a.func
      })).isRequired,
      height: h.a.number.isRequired,
      margin: Ad,
      style: h.a.shape({
        axes: h.a.object,
        labels: h.a.object,
        lines: h.a.object
      }),
      showMarks: h.a.bool,
      tickFormat: h.a.func,
      width: h.a.number.isRequired
    }, mm.defaultProps = {
      className: "",
      colorType: "category",
      colorRange: Ao,
      style: {
        axes: {
          line: {},
          ticks: {},
          text: {}
        },
        labels: {
          fontSize: 10,
          textAnchor: "middle"
        },
        lines: {
          strokeWidth: 1,
          strokeOpacity: 1
        },
        deselectedLineStyle: {
          strokeOpacity: .1
        }
      },
      tickFormat: dm
    };

    var gm = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        vm = rn(".2r");

    function bm(e) {
      return Math.abs(e) <= 1e-12 ? e = 0 : e > 0 ? Math.abs(e - .5) <= 1e-12 && (e = .5) : e < 0 && Math.abs(e + .5) <= 1e-12 && (e = -.5), e;
    }

    function _m(e) {
      var t = e.domains,
          n = e.startingAngle,
          r = e.style;
      return t.map(function (e, a) {
        var o = e.name,
            i = a / t.length * Math.PI * 2 + n;
        return {
          x: 1.2 * Math.cos(i),
          y: 1.2 * Math.sin(i),
          label: o,
          style: r
        };
      });
    }

    function xm(e) {
      var t = e.animation,
          n = e.className,
          r = e.children,
          a = e.colorRange,
          o = e.data,
          i = e.domains,
          u = e.height,
          l = e.hideInnerMostValues,
          s = e.margin,
          c = e.onMouseLeave,
          p = e.onMouseEnter,
          h = e.startingAngle,
          d = e.style,
          y = e.tickFormat,
          m = e.width,
          g = e.renderAxesOverPolygons,
          v = e.onValueMouseOver,
          b = e.onValueMouseOut,
          _ = e.onSeriesMouseOver,
          x = e.onSeriesMouseOut,
          O = function (e) {
        var t = e.animation,
            n = e.domains,
            r = e.startingAngle,
            a = e.style,
            o = e.tickFormat,
            i = e.hideInnerMostValues;
        return n.map(function (e, u) {
          var l = u / n.length * Math.PI * 2 + r,
              s = e.domain;
          return f.a.createElement(ef, {
            animation: t,
            key: u + "-axis",
            axisStart: {
              x: 0,
              y: 0
            },
            axisEnd: {
              x: bm(Math.cos(l)),
              y: bm(Math.sin(l))
            },
            axisDomain: s,
            numberOfTicks: 5,
            tickValue: function tickValue(t) {
              return i && t === s[0] ? "" : e.tickFormat ? e.tickFormat(t) : o(t);
            },
            style: a.axes
          });
        });
      }({
        domains: i,
        animation: t,
        hideInnerMostValues: l,
        startingAngle: h,
        style: d,
        tickFormat: y
      }),
          w = function (e) {
        var t = e.animation,
            n = e.colorRange,
            r = e.domains,
            a = e.data,
            o = e.style,
            i = e.startingAngle,
            u = e.onSeriesMouseOver,
            l = e.onSeriesMouseOut,
            s = r.reduce(function (e, t) {
          var n = t.domain;
          return e[t.name] = yn().domain(n).range([0, 1]), e;
        }, {});
        return a.map(function (e, a) {
          var c = r.map(function (t, n) {
            var a = t.name,
                o = t.getValue,
                u = o ? o(e) : e[a],
                l = n / r.length * Math.PI * 2 + i,
                c = Math.max(s[a](u), 0);
            return {
              x: c * Math.cos(l),
              y: c * Math.sin(l),
              name: e.name
            };
          });
          return f.a.createElement(Hh, {
            animation: t,
            className: "rv-radar-chart-polygon",
            key: a + "-polygon",
            data: c,
            style: gm({
              stroke: e.color || e.stroke || n[a % n.length],
              fill: e.color || e.fill || n[a % n.length]
            }, o.polygons),
            onSeriesMouseOver: u,
            onSeriesMouseOut: l
          });
        });
      }({
        animation: t,
        colorRange: a,
        domains: i,
        data: o,
        startingAngle: h,
        style: d,
        onSeriesMouseOver: _,
        onSeriesMouseOut: x
      }),
          T = function (e) {
        var t = e.animation,
            n = e.domains,
            r = e.data,
            a = e.startingAngle,
            o = e.style,
            i = e.onValueMouseOver,
            u = e.onValueMouseOut;

        if (i) {
          var l = n.reduce(function (e, t) {
            var n = t.domain;
            return e[t.name] = yn().domain(n).range([0, 1]), e;
          }, {});
          return r.map(function (e, r) {
            var s = n.map(function (t, r) {
              var o = t.name,
                  i = t.getValue,
                  u = i ? i(e) : e[o],
                  s = r / n.length * Math.PI * 2 + a,
                  c = Math.max(l[o](u), 0);
              return {
                x: c * Math.cos(s),
                y: c * Math.sin(s),
                domain: o,
                value: u,
                dataName: e.name
              };
            });
            return f.a.createElement(fh, {
              animation: t,
              className: "rv-radar-chart-polygonPoint",
              key: r + "-polygonPoint",
              data: s,
              size: 10,
              style: gm({}, o.polygons, {
                fill: "transparent",
                stroke: "transparent"
              }),
              onValueMouseOver: i,
              onValueMouseOut: u
            });
          });
        }
      }({
        animation: t,
        colorRange: a,
        domains: i,
        data: o,
        startingAngle: h,
        style: d,
        onValueMouseOver: v,
        onValueMouseOut: b
      }),
          k = f.a.createElement(Qp, {
        animation: t,
        key: n,
        className: "rv-radar-chart-label",
        data: _m({
          domains: i,
          style: d.labels,
          startingAngle: h
        })
      });

      return f.a.createElement(Yd, {
        height: u,
        width: m,
        margin: s,
        dontCheckIfEmpty: !0,
        className: n + " rv-radar-chart",
        onMouseLeave: c,
        onMouseEnter: p,
        xDomain: [-1, 1],
        yDomain: [-1, 1]
      }, r, !g && O.concat(w).concat(k).concat(T), g && w.concat(k).concat(O).concat(T));
    }

    xm.displayName = "RadarChart", xm.propTypes = {
      animation: lt,
      className: h.a.string,
      colorType: h.a.string,
      colorRange: h.a.arrayOf(h.a.string),
      data: h.a.arrayOf(h.a.object).isRequired,
      domains: h.a.arrayOf(h.a.shape({
        name: h.a.string.isRequired,
        domain: h.a.arrayOf(h.a.number).isRequired,
        tickFormat: h.a.func
      })).isRequired,
      height: h.a.number.isRequired,
      hideInnerMostValues: h.a.bool,
      margin: Ad,
      startingAngle: h.a.number,
      style: h.a.shape({
        axes: h.a.object,
        labels: h.a.object,
        polygons: h.a.object
      }),
      tickFormat: h.a.func,
      width: h.a.number.isRequired,
      renderAxesOverPolygons: h.a.bool,
      onValueMouseOver: h.a.func,
      onValueMouseOut: h.a.func,
      onSeriesMouseOver: h.a.func,
      onSeriesMouseOut: h.a.func
    }, xm.defaultProps = {
      className: "",
      colorType: "category",
      colorRange: Ao,
      hideInnerMostValues: !0,
      startingAngle: Math.PI / 2,
      style: {
        axes: {
          line: {},
          ticks: {},
          text: {}
        },
        labels: {
          fontSize: 10,
          textAnchor: "middle"
        },
        polygons: {
          strokeWidth: .5,
          strokeOpacity: 1,
          fillOpacity: .1
        }
      },
      tickFormat: vm,
      renderAxesOverPolygons: !1
    };

    var Om = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function wm(e) {
      var t = e.animation,
          n = e.className,
          r = e.children,
          a = e.colorType,
          o = e.data,
          i = e.getAngle,
          u = e.getLabel,
          l = e.getSubLabel,
          s = e.height,
          c = e.hideRootNode,
          p = e.innerRadius,
          h = e.labelsAboveChildren,
          d = e.labelsRadiusMultiplier,
          y = e.labelsStyle,
          m = e.margin,
          g = e.onMouseLeave,
          v = e.onMouseEnter,
          b = e.radius,
          _ = e.showLabels,
          x = e.style,
          O = e.width,
          w = function (e) {
        var t = e.data,
            n = e.getAngle;
        return Ci().sort(null).value(n)(t).reverse().map(function (e, t) {
          return Om({}, e.data, {
            angle0: e.startAngle,
            angle: e.endAngle,
            radius0: e.data.innerRadius || 0,
            radius: e.data.radius || 1,
            color: e.data.color || t
          });
        });
      }({
        data: o,
        height: s,
        hideRootNode: c,
        width: O,
        getAngle: i
      }),
          T = Ho(w),
          k = Om({
        colorType: a
      }, e, {
        animation: t,
        radiusDomain: [0, T],
        data: w,
        radiusNoFallBack: !0,
        style: x,
        arcClassName: "rv-radial-chart__series--pie__slice"
      });

      b && (k.radiusDomain = [0, 1], k.radiusRange = [p || 0, b], k.radiusType = "linear");

      var M = Sd(O, s, b || function (e, t) {
        return Math.min(e, t) / 2 - 15;
      }(O, s)),
          E = function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1.1,
            r = t.getLabel,
            a = t.getSubLabel;
        return e.reduce(function (e, t) {
          var o = t.angle,
              i = t.angle0,
              u = t.radius,
              l = -1 * ((o + i) / 2) + Math.PI / 2,
              s = [];
          return r(t) && s.push({
            angle: l,
            radius: u * n,
            label: r(t)
          }), a(t) && s.push({
            angle: l,
            radius: u * n,
            label: a(t),
            style: {
              fontSize: 10
            },
            yOffset: 12
          }), e.concat(s);
        }, []);
      }(w, {
        getLabel: u,
        getSubLabel: l
      }, d);

      return f.a.createElement(Yd, {
        height: s,
        width: O,
        margin: Om({}, m, M),
        className: n + " rv-radial-chart",
        onMouseLeave: g,
        onMouseEnter: v,
        xDomain: [-T, T],
        yDomain: [-T, T]
      }, f.a.createElement(Ti, Om({}, k, {
        getAngle: function getAngle(e) {
          return e.angle;
        }
      })), _ && !h && f.a.createElement(Qp, {
        data: E,
        style: y
      }), r, _ && h && f.a.createElement(Qp, {
        data: E,
        style: y
      }));
    }

    wm.displayName = "RadialChart", wm.propTypes = {
      animation: lt,
      className: h.a.string,
      colorType: h.a.string,
      data: h.a.arrayOf(h.a.shape({
        angle: h.a.number,
        className: h.a.string,
        label: h.a.string,
        radius: h.a.number,
        style: h.a.object
      })).isRequired,
      getAngle: h.a.func,
      getAngle0: h.a.func,
      padAngle: h.a.oneOfType([h.a.func, h.a.number]),
      getRadius: h.a.func,
      getRadius0: h.a.func,
      getLabel: h.a.func,
      height: h.a.number.isRequired,
      labelsAboveChildren: h.a.bool,
      labelsStyle: h.a.object,
      margin: Ad,
      onValueClick: h.a.func,
      onValueMouseOver: h.a.func,
      onValueMouseOut: h.a.func,
      showLabels: h.a.bool,
      style: h.a.object,
      subLabel: h.a.func,
      width: h.a.number.isRequired
    }, wm.defaultProps = {
      className: "",
      colorType: "category",
      colorRange: Ao,
      padAngle: 0,
      getAngle: function getAngle(e) {
        return e.angle;
      },
      getAngle0: function getAngle0(e) {
        return e.angle0;
      },
      getRadius: function getRadius(e) {
        return e.radius;
      },
      getRadius0: function getRadius0(e) {
        return e.radius0;
      },
      getLabel: function getLabel(e) {
        return e.label;
      },
      getSubLabel: function getSubLabel(e) {
        return e.subLabel;
      }
    };
    var Tm = wm;

    function km(e) {
      return e.target.depth;
    }

    function Mm(e, t) {
      return e.sourceLinks.length ? e.depth : t - 1;
    }

    function Em(e) {
      return function () {
        return e;
      };
    }

    function Pm(e, t) {
      return Sm(e.source, t.source) || e.index - t.index;
    }

    function jm(e, t) {
      return Sm(e.target, t.target) || e.index - t.index;
    }

    function Sm(e, t) {
      return e.y0 - t.y0;
    }

    function Am(e) {
      return e.value;
    }

    function Nm(e) {
      return (e.y0 + e.y1) / 2;
    }

    function Cm(e) {
      return Nm(e.source) * e.value;
    }

    function Fm(e) {
      return Nm(e.target) * e.value;
    }

    function Rm(e) {
      return e.index;
    }

    function Lm(e) {
      return e.nodes;
    }

    function Dm(e) {
      return e.links;
    }

    function qm(e, t) {
      var n = e.get(t);
      if (!n) throw new Error("missing: " + t);
      return n;
    }

    function Vm(e) {
      return [e.source.x1, e.y0];
    }

    function zm(e) {
      return [e.target.x0, e.y1];
    }

    var Im = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Hm = Ao[1];

    function Bm(e) {
      var t = e.animation,
          n = e.data,
          r = e.node,
          a = e.opacity,
          o = e.color,
          i = e.strokeWidth,
          u = e.style,
          l = e.onLinkClick,
          s = e.onLinkMouseOver,
          c = e.onLinkMouseOut;
      return t ? f.a.createElement(ut, Im({}, e, {
        animatedProps: Bo
      }), f.a.createElement(Bm, Im({}, e, {
        animation: null
      }))) : f.a.createElement("path", Im({
        d: n
      }, u, {
        className: "rv-sankey__link",
        opacity: Number.isFinite(a) ? a : .7,
        stroke: o || Hm,
        onClick: function onClick(e) {
          return l(r, e);
        },
        onMouseOver: function onMouseOver(e) {
          return s(r, e);
        },
        onMouseOut: function onMouseOut(e) {
          return c(r, e);
        },
        strokeWidth: i,
        fill: "none"
      }));
    }

    Bm.displayName = "SankeyLink", Bm.requiresSVG = !0;

    var Um = Bm,
        Wm = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function Ym(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      return Array.from(e);
    }

    var Xm = function Xm(e) {
      return e;
    },
        Gm = {
      justify: Mm,
      center: function center(e) {
        return e.targetLinks.length ? e.depth : e.sourceLinks.length ? Tt(e.sourceLinks, km) - 1 : 0;
      },
      left: function left(e) {
        return e.depth;
      },
      right: function right(e, t) {
        return t - 1 - e.height;
      }
    },
        $m = {
      top: 20,
      left: 20,
      right: 20,
      bottom: 20
    };

    function Zm(e) {
      var t = e.align,
          n = e.animation,
          r = e.children,
          a = e.className,
          o = e.hasVoronoi,
          i = e.height,
          u = e.hideLabels,
          l = e.labelRotation,
          s = e.layout,
          c = e.links,
          p = e.linkOpacity,
          h = e.margin,
          d = e.nodePadding,
          y = e.nodes,
          m = e.nodeWidth,
          g = e.onValueClick,
          v = e.onValueMouseOver,
          b = e.onValueMouseOut,
          _ = e.onLinkClick,
          x = e.onLinkMouseOver,
          O = e.onLinkMouseOut,
          w = e.style,
          T = e.width,
          k = [].concat(Ym(new Array(y.length))).map(function (e, t) {
        return Wm({}, y[t]);
      }),
          M = [].concat(Ym(new Array(c.length))).map(function (e, t) {
        return Wm({}, c[t]);
      }),
          E = jd({
        margin: h,
        height: i,
        width: T
      }, $m),
          P = E.marginLeft,
          j = E.marginTop,
          S = E.marginRight,
          A = E.marginBottom,
          N = function () {
        var e = 0,
            t = 0,
            n = 1,
            r = 1,
            a = 24,
            o = 8,
            i = Rm,
            u = Mm,
            l = Lm,
            s = Dm,
            c = 32;

        function f() {
          var e = {
            nodes: l.apply(null, arguments),
            links: s.apply(null, arguments)
          };
          return p(e), h(e), d(e), y(e), m(e), e;
        }

        function p(e) {
          e.nodes.forEach(function (e, t) {
            e.index = t, e.sourceLinks = [], e.targetLinks = [];
          });
          var t = Pt(e.nodes, i);
          e.links.forEach(function (e, n) {
            e.index = n;
            var r = e.source,
                a = e.target;
            "object" != _typeof(r) && (r = e.source = qm(t, r)), "object" != _typeof(a) && (a = e.target = qm(t, a)), r.sourceLinks.push(e), a.targetLinks.push(e);
          });
        }

        function h(e) {
          e.nodes.forEach(function (e) {
            e.value = Math.max(kt(e.sourceLinks, Am), kt(e.targetLinks, Am));
          });
        }

        function d(t) {
          var r, o, i;

          for (r = t.nodes, o = [], i = 0; r.length; ++i, r = o, o = []) {
            r.forEach(function (e) {
              e.depth = i, e.sourceLinks.forEach(function (e) {
                o.indexOf(e.target) < 0 && o.push(e.target);
              });
            });
          }

          for (r = t.nodes, o = [], i = 0; r.length; ++i, r = o, o = []) {
            r.forEach(function (e) {
              e.height = i, e.targetLinks.forEach(function (e) {
                o.indexOf(e.source) < 0 && o.push(e.source);
              });
            });
          }

          var l = (n - e - a) / (i - 1);
          t.nodes.forEach(function (t) {
            t.x1 = (t.x0 = e + Math.max(0, Math.min(i - 1, Math.floor(u.call(null, t, i)))) * l) + a;
          });
        }

        function y(e) {
          var n,
              a = jt().key(function (e) {
            return e.x0;
          }).sortKeys(st).entries(e.nodes).map(function (e) {
            return e.values;
          });
          n = Tt(a, function (e) {
            return (r - t - (e.length - 1) * o) / kt(e, Am);
          }), a.forEach(function (e) {
            e.forEach(function (e, t) {
              e.y1 = (e.y0 = t) + e.value * n;
            });
          }), e.links.forEach(function (e) {
            e.width = e.value * n;
          }), f();

          for (var i = 1, u = c; u > 0; --u) {
            s(i *= .99), f(), l(i), f();
          }

          function l(e) {
            a.forEach(function (t) {
              t.forEach(function (t) {
                if (t.targetLinks.length) {
                  var n = (kt(t.targetLinks, Cm) / kt(t.targetLinks, Am) - Nm(t)) * e;
                  t.y0 += n, t.y1 += n;
                }
              });
            });
          }

          function s(e) {
            a.slice().reverse().forEach(function (t) {
              t.forEach(function (t) {
                if (t.sourceLinks.length) {
                  var n = (kt(t.sourceLinks, Fm) / kt(t.sourceLinks, Am) - Nm(t)) * e;
                  t.y0 += n, t.y1 += n;
                }
              });
            });
          }

          function f() {
            a.forEach(function (e) {
              var n,
                  a,
                  i,
                  u = t,
                  l = e.length;

              for (e.sort(Sm), i = 0; i < l; ++i) {
                (a = u - (n = e[i]).y0) > 0 && (n.y0 += a, n.y1 += a), u = n.y1 + o;
              }

              if ((a = u - o - r) > 0) for (u = n.y0 -= a, n.y1 -= a, i = l - 2; i >= 0; --i) {
                (a = (n = e[i]).y1 + o - u) > 0 && (n.y0 -= a, n.y1 -= a), u = n.y0;
              }
            });
          }
        }

        function m(e) {
          e.nodes.forEach(function (e) {
            e.sourceLinks.sort(jm), e.targetLinks.sort(Pm);
          }), e.nodes.forEach(function (e) {
            var t = e.y0,
                n = t;
            e.sourceLinks.forEach(function (e) {
              e.y0 = t + e.width / 2, t += e.width;
            }), e.targetLinks.forEach(function (e) {
              e.y1 = n + e.width / 2, n += e.width;
            });
          });
        }

        return f.update = function (e) {
          return m(e), e;
        }, f.nodeId = function (e) {
          return arguments.length ? (i = "function" == typeof e ? e : Em(e), f) : i;
        }, f.nodeAlign = function (e) {
          return arguments.length ? (u = "function" == typeof e ? e : Em(e), f) : u;
        }, f.nodeWidth = function (e) {
          return arguments.length ? (a = +e, f) : a;
        }, f.nodePadding = function (e) {
          return arguments.length ? (o = +e, f) : o;
        }, f.nodes = function (e) {
          return arguments.length ? (l = "function" == typeof e ? e : Em(e), f) : l;
        }, f.links = function (e) {
          return arguments.length ? (s = "function" == typeof e ? e : Em(e), f) : s;
        }, f.size = function (a) {
          return arguments.length ? (e = t = 0, n = +a[0], r = +a[1], f) : [n - e, r - t];
        }, f.extent = function (a) {
          return arguments.length ? (e = +a[0][0], n = +a[1][0], t = +a[0][1], r = +a[1][1], f) : [[e, t], [n, r]];
        }, f.iterations = function (e) {
          return arguments.length ? (c = +e, f) : c;
        }, f;
      }().extent([[P, j], [T - S, i - A - j]]).nodeWidth(m).nodePadding(d).nodes(k).links(M).nodeAlign(Gm[t]).iterations(s);

      N(k);
      var C = N.nodeWidth(),
          F = Gi().source(Vm).target(zm);
      return f.a.createElement(Yd, Wm({}, e, {
        yType: "literal",
        className: "rv-sankey " + a
      }), M.map(function (e, t) {
        return f.a.createElement(Um, {
          style: w.links,
          data: F(e),
          opacity: e.opacity || p,
          color: e.color,
          onLinkClick: _,
          onLinkMouseOver: x,
          onLinkMouseOut: O,
          strokeWidth: Math.max(e.width, 1),
          node: e,
          nWidth: C,
          key: "link-" + t
        });
      }), f.a.createElement(fd, {
        animation: n,
        className: a + " rv-sankey__node",
        data: k.map(function (e) {
          return Wm({}, e, {
            y: e.y1 - j,
            y0: e.y0 - j,
            x: e.x1,
            x0: e.x0,
            color: e.color || Ao[0],
            sourceLinks: null,
            targetLinks: null
          });
        }),
        style: w.rects,
        onValueClick: g,
        onValueMouseOver: v,
        onValueMouseOut: b,
        colorType: "literal"
      }), !u && f.a.createElement(Qp, {
        animation: n,
        className: a,
        rotation: l,
        labelAnchorY: "text-before-edge",
        data: k.map(function (e, t) {
          return Wm({
            x: e.x0 + (e.x0 < T / 2 ? C + 10 : -10),
            y: (e.y0 + e.y1) / 2 - j,
            label: e.name,
            style: Wm({
              textAnchor: e.x0 < T / 2 ? "start" : "end",
              dy: "-.5em"
            }, w.labels)
          }, y[t]);
        })
      }), o && f.a.createElement(_d, {
        className: "rv-sankey__voronoi",
        extent: [[-P, -j], [T + S, i + A]],
        nodes: k,
        onClick: g,
        onHover: v,
        onBlur: b,
        x: function x(e) {
          return e.x0 + (e.x1 - e.x0) / 2;
        },
        y: function y(e) {
          return e.y0 + (e.y1 - e.y0) / 2;
        }
      }), r);
    }

    Zm.defaultProps = {
      align: "justify",
      className: "",
      hasVoronoi: !1,
      hideLabels: !1,
      labelRotation: 0,
      layout: 50,
      margin: $m,
      nodePadding: 10,
      nodeWidth: 10,
      onValueMouseOver: Xm,
      onValueClick: Xm,
      onValueMouseOut: Xm,
      onLinkClick: Xm,
      onLinkMouseOver: Xm,
      onLinkMouseOut: Xm,
      style: {
        links: {},
        rects: {},
        labels: {}
      }
    }, Zm.propTypes = {
      align: h.a.oneOf(["justify", "left", "right", "center"]),
      className: h.a.string,
      hasVoronoi: h.a.bool,
      height: h.a.number.isRequired,
      hideLabels: h.a.bool,
      labelRotation: h.a.number,
      layout: h.a.number,
      links: h.a.arrayOf(h.a.shape({
        source: h.a.oneOfType([h.a.number, h.a.object]).isRequired,
        target: h.a.oneOfType([h.a.number, h.a.object]).isRequired
      })).isRequired,
      margin: Ad,
      nodePadding: h.a.number,
      nodes: h.a.arrayOf(h.a.object).isRequired,
      nodeWidth: h.a.number,
      onValueMouseOver: h.a.func,
      onValueClick: h.a.func,
      onValueMouseOut: h.a.func,
      onLinkClick: h.a.func,
      onLinkMouseOver: h.a.func,
      onLinkMouseOut: h.a.func,
      style: h.a.shape({
        links: h.a.object,
        rects: h.a.object,
        labels: h.a.object
      }),
      width: h.a.number.isRequired
    };

    var Jm = function Jm(e) {
      e.x0 = Math.round(e.x0), e.y0 = Math.round(e.y0), e.x1 = Math.round(e.x1), e.y1 = Math.round(e.y1);
    },
        Qm = function Qm(e, t, n, r, a) {
      for (var o, i = e.children, u = -1, l = i.length, s = e.value && (r - t) / e.value; ++u < l;) {
        (o = i[u]).y0 = n, o.y1 = a, o.x0 = t, o.x1 = t += o.value * s;
      }
    },
        Km = function Km() {
      var e = 1,
          t = 1,
          n = 0,
          r = !1;

      function a(a) {
        var o = a.height + 1;
        return a.x0 = a.y0 = n, a.x1 = e, a.y1 = t / o, a.eachBefore(function (e, t) {
          return function (r) {
            r.children && Qm(r, r.x0, e * (r.depth + 1) / t, r.x1, e * (r.depth + 2) / t);
            var a = r.x0,
                o = r.y0,
                i = r.x1 - n,
                u = r.y1 - n;
            i < a && (a = i = (a + i) / 2), u < o && (o = u = (o + u) / 2), r.x0 = a, r.y0 = o, r.x1 = i, r.y1 = u;
          };
        }(t, o)), r && a.eachBefore(Jm), a;
      }

      return a.round = function (e) {
        return arguments.length ? (r = !!e, a) : r;
      }, a.size = function (n) {
        return arguments.length ? (e = +n[0], t = +n[1], a) : [e, t];
      }, a.padding = function (e) {
        return arguments.length ? (n = +e, a) : n;
      }, a;
    };

    function eg(e) {
      var t = 0,
          n = e.children,
          r = n && n.length;
      if (r) for (; --r >= 0;) {
        t += n[r].value;
      } else t = 1;
      e.value = t;
    }

    function tg(e, t) {
      var n,
          r,
          a,
          o,
          i,
          u = new og(e),
          l = +e.value && (u.value = e.value),
          s = [u];

      for (null == t && (t = ng); n = s.pop();) {
        if (l && (n.value = +n.data.value), (a = t(n.data)) && (i = a.length)) for (n.children = new Array(i), o = i - 1; o >= 0; --o) {
          s.push(r = n.children[o] = new og(a[o])), r.parent = n, r.depth = n.depth + 1;
        }
      }

      return u.eachBefore(ag);
    }

    function ng(e) {
      return e.children;
    }

    function rg(e) {
      e.data = e.data.data;
    }

    function ag(e) {
      var t = 0;

      do {
        e.height = t;
      } while ((e = e.parent) && e.height < ++t);
    }

    function og(e) {
      this.data = e, this.depth = this.height = 0, this.parent = null;
    }

    og.prototype = tg.prototype = {
      constructor: og,
      count: function count() {
        return this.eachAfter(eg);
      },
      each: function each(e) {
        var t,
            n,
            r,
            a,
            o = this,
            i = [o];

        do {
          for (t = i.reverse(), i = []; o = t.pop();) {
            if (e(o), n = o.children) for (r = 0, a = n.length; r < a; ++r) {
              i.push(n[r]);
            }
          }
        } while (i.length);

        return this;
      },
      eachAfter: function eachAfter(e) {
        for (var t, n, r, a = this, o = [a], i = []; a = o.pop();) {
          if (i.push(a), t = a.children) for (n = 0, r = t.length; n < r; ++n) {
            o.push(t[n]);
          }
        }

        for (; a = i.pop();) {
          e(a);
        }

        return this;
      },
      eachBefore: function eachBefore(e) {
        for (var t, n, r = this, a = [r]; r = a.pop();) {
          if (e(r), t = r.children) for (n = t.length - 1; n >= 0; --n) {
            a.push(t[n]);
          }
        }

        return this;
      },
      sum: function sum(e) {
        return this.eachAfter(function (t) {
          for (var n = +e(t.data) || 0, r = t.children, a = r && r.length; --a >= 0;) {
            n += r[a].value;
          }

          t.value = n;
        });
      },
      sort: function sort(e) {
        return this.eachBefore(function (t) {
          t.children && t.children.sort(e);
        });
      },
      path: function path(e) {
        for (var t = this, n = function (e, t) {
          if (e === t) return e;
          var n = e.ancestors(),
              r = t.ancestors(),
              a = null;
          e = n.pop(), t = r.pop();

          for (; e === t;) {
            a = e, e = n.pop(), t = r.pop();
          }

          return a;
        }(t, e), r = [t]; t !== n;) {
          t = t.parent, r.push(t);
        }

        for (var a = r.length; e !== n;) {
          r.splice(a, 0, e), e = e.parent;
        }

        return r;
      },
      ancestors: function ancestors() {
        for (var e = this, t = [e]; e = e.parent;) {
          t.push(e);
        }

        return t;
      },
      descendants: function descendants() {
        var e = [];
        return this.each(function (t) {
          e.push(t);
        }), e;
      },
      leaves: function leaves() {
        var e = [];
        return this.eachBefore(function (t) {
          t.children || e.push(t);
        }), e;
      },
      links: function links() {
        var e = this,
            t = [];
        return e.each(function (n) {
          n !== e && t.push({
            source: n.parent,
            target: n
          });
        }), t;
      },
      copy: function copy() {
        return tg(this).eachBefore(rg);
      }
    };

    var ig = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        ug = ["onValueMouseOver", "onValueMouseOut", "onValueClick", "onValueRightClick", "onSeriesMouseOver", "onSeriesMouseOut", "onSeriesClick", "onSeriesRightClick"];

    var lg = function lg() {};

    function sg(e) {
      var t = e.getAngle,
          n = e.getAngle0,
          r = e.animation,
          a = e.className,
          o = e.children,
          i = e.data,
          u = e.height,
          l = e.hideRootNode,
          s = e.getLabel,
          c = e.width,
          p = e.getSize,
          h = e.colorType,
          d = function (e) {
        var t = e.data,
            n = e.height,
            r = e.hideRootNode,
            a = e.width,
            o = e.getSize,
            i = Km(),
            u = tg(t).sum(o),
            l = Math.min(a, n) / 2 - 10,
            s = yn().range([0, 2 * Math.PI]),
            c = Tn().range([0, l]);
        return i(u).descendants().reduce(function (e, t, n) {
          return r && 0 === n ? e : e.concat([ig({
            angle0: Math.max(0, Math.min(2 * Math.PI, s(t.x0))),
            angle: Math.max(0, Math.min(2 * Math.PI, s(t.x1))),
            radius0: Math.max(0, c(t.y0)),
            radius: Math.max(0, c(t.y1)),
            depth: t.depth,
            parent: t.parent
          }, t.data)]);
        }, []);
      }({
        data: i,
        height: u,
        hideRootNode: l,
        width: c,
        getSize: p
      }),
          y = Ho(d),
          m = Sd(c, u, y),
          g = function (e, t) {
        var n = t.getAngle,
            r = t.getAngle0,
            a = t.getLabel,
            o = t.getRadius0;
        return e.filter(a).map(function (e) {
          var t = -1 * n(e) + Math.PI / 2,
              a = (-1 * r(e) + Math.PI / 2 + t) / 2,
              i = !e.dontRotateLabel,
              u = -a / (2 * Math.PI) * 360;
          return ig({}, e, {
            children: null,
            angle: null,
            radius: null,
            x: o(e) * Math.cos(a),
            y: o(e) * Math.sin(a),
            style: ig({
              textAnchor: u > 90 ? "end" : "start"
            }, e.labelStyle),
            rotation: i ? u > 90 ? u + 180 : 90 === u ? 90 : u : null
          });
        });
      }(d, {
        getAngle: t,
        getAngle0: n,
        getLabel: s,
        getRadius0: function getRadius0(e) {
          return e.radius0;
        }
      });

      return f.a.createElement(Yd, {
        height: u,
        hasTreeStructure: !0,
        width: c,
        className: "rv-sunburst " + a,
        margin: m,
        xDomain: [-y, y],
        yDomain: [-y, y]
      }, f.a.createElement(Ti, ig({
        colorType: h
      }, e, {
        animation: r,
        radiusDomain: [0, y],
        data: r ? d.map(function (e, t) {
          return ig({}, e, {
            parent: null,
            children: null,
            index: t
          });
        }) : d,
        _data: r ? d : null,
        arcClassName: "rv-sunburst__series--radial__arc"
      }, ug.reduce(function (t, n) {
        var a,
            o = e[n];
        return t[n] = r ? (a = o, function (e, t) {
          return a ? a(d[e.index], t) : lg;
        }) : o, t;
      }, {}))), g.length > 0 && f.a.createElement(Qp, {
        data: g,
        getLabel: s
      }), o);
    }

    sg.displayName = "Sunburst", sg.propTypes = {
      animation: lt,
      getAngle: h.a.func,
      getAngle0: h.a.func,
      className: h.a.string,
      colorType: h.a.string,
      data: h.a.object.isRequired,
      height: h.a.number.isRequired,
      hideRootNode: h.a.bool,
      getLabel: h.a.func,
      onValueClick: h.a.func,
      onValueMouseOver: h.a.func,
      onValueMouseOut: h.a.func,
      getSize: h.a.func,
      width: h.a.number.isRequired,
      padAngle: h.a.oneOfType([h.a.func, h.a.number])
    }, sg.defaultProps = {
      getAngle: function getAngle(e) {
        return e.angle;
      },
      getAngle0: function getAngle0(e) {
        return e.angle0;
      },
      className: "",
      colorType: "literal",
      getColor: function getColor(e) {
        return e.color;
      },
      hideRootNode: !1,
      getLabel: function getLabel(e) {
        return e.label;
      },
      getSize: function getSize(e) {
        return e.size;
      },
      padAngle: 0
    };

    var cg = function cg(e, t, n, r, a) {
      for (var o, i = e.children, u = -1, l = i.length, s = e.value && (a - n) / e.value; ++u < l;) {
        (o = i[u]).x0 = t, o.x1 = r, o.y0 = n, o.y1 = n += o.value * s;
      }
    },
        fg = (1 + Math.sqrt(5)) / 2;

    function pg(e, t, n, r, a, o) {
      for (var i, u, l, s, c, f, p, h, d, y, m, g = [], v = t.children, b = 0, _ = 0, x = v.length, O = t.value; b < x;) {
        l = a - n, s = o - r;

        do {
          c = v[_++].value;
        } while (!c && _ < x);

        for (f = p = c, m = c * c * (y = Math.max(s / l, l / s) / (O * e)), d = Math.max(p / m, m / f); _ < x; ++_) {
          if (c += u = v[_].value, u < f && (f = u), u > p && (p = u), m = c * c * y, (h = Math.max(p / m, m / f)) > d) {
            c -= u;
            break;
          }

          d = h;
        }

        g.push(i = {
          value: c,
          dice: l < s,
          children: v.slice(b, _)
        }), i.dice ? Qm(i, n, r, a, O ? r += s * c / O : o) : cg(i, n, r, O ? n += l * c / O : a, o), O -= c, b = _;
      }

      return g;
    }

    var hg = function e(t) {
      function n(e, n, r, a, o) {
        pg(t, e, n, r, a, o);
      }

      return n.ratio = function (t) {
        return e((t = +t) > 1 ? t : 1);
      }, n;
    }(fg),
        dg = function e(t) {
      function n(e, n, r, a, o) {
        if ((i = e._squarify) && i.ratio === t) for (var i, u, l, s, c, f = -1, p = i.length, h = e.value; ++f < p;) {
          for (l = (u = i[f]).children, s = u.value = 0, c = l.length; s < c; ++s) {
            u.value += l[s].value;
          }

          u.dice ? Qm(u, n, r, a, r += (o - r) * u.value / h) : cg(u, n, r, n += (a - n) * u.value / h, o), h -= u.value;
        } else e._squarify = i = pg(t, e, n, r, a, o), i.ratio = t;
      }

      return n.ratio = function (t) {
        return e((t = +t) > 1 ? t : 1);
      }, n;
    }(fg),
        yg = Array.prototype.slice;

    var mg = function mg(e) {
      for (var t, n, r = 0, a = (e = function (e) {
        for (var t, n, r = e.length; r;) {
          n = Math.random() * r-- | 0, t = e[r], e[r] = e[n], e[n] = t;
        }

        return e;
      }(yg.call(e))).length, o = []; r < a;) {
        t = e[r], n && bg(n, t) ? ++r : (n = xg(o = gg(o, t)), r = 0);
      }

      return n;
    };

    function gg(e, t) {
      var n, r;
      if (_g(t, e)) return [t];

      for (n = 0; n < e.length; ++n) {
        if (vg(t, e[n]) && _g(Og(e[n], t), e)) return [e[n], t];
      }

      for (n = 0; n < e.length - 1; ++n) {
        for (r = n + 1; r < e.length; ++r) {
          if (vg(Og(e[n], e[r]), t) && vg(Og(e[n], t), e[r]) && vg(Og(e[r], t), e[n]) && _g(wg(e[n], e[r], t), e)) return [e[n], e[r], t];
        }
      }

      throw new Error();
    }

    function vg(e, t) {
      var n = e.r - t.r,
          r = t.x - e.x,
          a = t.y - e.y;
      return n < 0 || n * n < r * r + a * a;
    }

    function bg(e, t) {
      var n = e.r - t.r + 1e-6,
          r = t.x - e.x,
          a = t.y - e.y;
      return n > 0 && n * n > r * r + a * a;
    }

    function _g(e, t) {
      for (var n = 0; n < t.length; ++n) {
        if (!bg(e, t[n])) return !1;
      }

      return !0;
    }

    function xg(e) {
      switch (e.length) {
        case 1:
          return {
            x: (t = e[0]).x,
            y: t.y,
            r: t.r
          };

        case 2:
          return Og(e[0], e[1]);

        case 3:
          return wg(e[0], e[1], e[2]);
      }

      var t;
    }

    function Og(e, t) {
      var n = e.x,
          r = e.y,
          a = e.r,
          o = t.x,
          i = t.y,
          u = t.r,
          l = o - n,
          s = i - r,
          c = u - a,
          f = Math.sqrt(l * l + s * s);
      return {
        x: (n + o + l / f * c) / 2,
        y: (r + i + s / f * c) / 2,
        r: (f + a + u) / 2
      };
    }

    function wg(e, t, n) {
      var r = e.x,
          a = e.y,
          o = e.r,
          i = t.x,
          u = t.y,
          l = t.r,
          s = n.x,
          c = n.y,
          f = n.r,
          p = r - i,
          h = r - s,
          d = a - u,
          y = a - c,
          m = l - o,
          g = f - o,
          v = r * r + a * a - o * o,
          b = v - i * i - u * u + l * l,
          _ = v - s * s - c * c + f * f,
          x = h * d - p * y,
          O = (d * _ - y * b) / (2 * x) - r,
          w = (y * m - d * g) / x,
          T = (h * b - p * _) / (2 * x) - a,
          k = (p * g - h * m) / x,
          M = w * w + k * k - 1,
          E = 2 * (o + O * w + T * k),
          P = O * O + T * T - o * o,
          j = -(M ? (E + Math.sqrt(E * E - 4 * M * P)) / (2 * M) : P / E);

      return {
        x: r + O + w * j,
        y: a + T + k * j,
        r: j
      };
    }

    function Tg(e, t, n) {
      var r,
          a,
          o,
          i,
          u = e.x - t.x,
          l = e.y - t.y,
          s = u * u + l * l;
      s ? (a = t.r + n.r, a *= a, i = e.r + n.r, a > (i *= i) ? (r = (s + i - a) / (2 * s), o = Math.sqrt(Math.max(0, i / s - r * r)), n.x = e.x - r * u - o * l, n.y = e.y - r * l + o * u) : (r = (s + a - i) / (2 * s), o = Math.sqrt(Math.max(0, a / s - r * r)), n.x = t.x + r * u - o * l, n.y = t.y + r * l + o * u)) : (n.x = t.x + n.r, n.y = t.y);
    }

    function kg(e, t) {
      var n = e.r + t.r - 1e-6,
          r = t.x - e.x,
          a = t.y - e.y;
      return n > 0 && n * n > r * r + a * a;
    }

    function Mg(e) {
      var t = e._,
          n = e.next._,
          r = t.r + n.r,
          a = (t.x * n.r + n.x * t.r) / r,
          o = (t.y * n.r + n.y * t.r) / r;
      return a * a + o * o;
    }

    function Eg(e) {
      this._ = e, this.next = null, this.previous = null;
    }

    function Pg(e) {
      if (!(a = e.length)) return 0;
      var t, n, r, a, o, i, u, l, s, c, f;
      if ((t = e[0]).x = 0, t.y = 0, !(a > 1)) return t.r;
      if (n = e[1], t.x = -n.r, n.x = t.r, n.y = 0, !(a > 2)) return t.r + n.r;
      Tg(n, t, r = e[2]), t = new Eg(t), n = new Eg(n), r = new Eg(r), t.next = r.previous = n, n.next = t.previous = r, r.next = n.previous = t;

      e: for (u = 3; u < a; ++u) {
        Tg(t._, n._, r = e[u]), r = new Eg(r), l = n.next, s = t.previous, c = n._.r, f = t._.r;

        do {
          if (c <= f) {
            if (kg(l._, r._)) {
              n = l, t.next = n, n.previous = t, --u;
              continue e;
            }

            c += l._.r, l = l.next;
          } else {
            if (kg(s._, r._)) {
              (t = s).next = n, n.previous = t, --u;
              continue e;
            }

            f += s._.r, s = s.previous;
          }
        } while (l !== s.next);

        for (r.previous = t, r.next = n, t.next = n.previous = n = r, o = Mg(t); (r = r.next) !== n;) {
          (i = Mg(r)) < o && (t = r, o = i);
        }

        n = t.next;
      }

      for (t = [n._], r = n; (r = r.next) !== n;) {
        t.push(r._);
      }

      for (r = mg(t), u = 0; u < a; ++u) {
        (t = e[u]).x -= r.x, t.y -= r.y;
      }

      return r.r;
    }

    function jg(e) {
      return null == e ? null : Sg(e);
    }

    function Sg(e) {
      if ("function" != typeof e) throw new Error();
      return e;
    }

    function Ag() {
      return 0;
    }

    var Ng = function Ng(e) {
      return function () {
        return e;
      };
    };

    function Cg(e) {
      return Math.sqrt(e.value);
    }

    function Fg(e) {
      return function (t) {
        t.children || (t.r = Math.max(0, +e(t) || 0));
      };
    }

    function Rg(e, t) {
      return function (n) {
        if (r = n.children) {
          var r,
              a,
              o,
              i = r.length,
              u = e(n) * t || 0;
          if (u) for (a = 0; a < i; ++a) {
            r[a].r += u;
          }
          if (o = Pg(r), u) for (a = 0; a < i; ++a) {
            r[a].r -= u;
          }
          n.r = o + u;
        }
      };
    }

    function Lg(e) {
      return function (t) {
        var n = t.parent;
        t.r *= e, n && (t.x = n.x + e * t.x, t.y = n.y + e * t.y);
      };
    }

    var Dg = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        qg = ["colorRange", "colorDomain", "color", "opacityRange", "opacityDomain", "opacity", "x0", "x1", "y0", "y1", "r"];

    function Vg(e) {
      var t = e.animation,
          n = e.getLabel,
          r = e.mode,
          a = e.node,
          o = e.onLeafClick,
          i = e.onLeafMouseOver,
          u = e.onLeafMouseOut,
          l = e.r,
          s = e.scales,
          c = e.x0,
          p = e.x1,
          h = e.y0,
          d = e.y1,
          y = e.style;
      if (t) return f.a.createElement(ut, Dg({}, e, {
        animatedProps: qg
      }), f.a.createElement(Vg, Dg({}, e, {
        animation: null
      })));

      var m = "circlePack" === r,
          g = s.color(a),
          v = s.opacity(a),
          b = xo(g),
          _ = n(a.data),
          x = Dg({
        top: m ? h - l : h,
        left: m ? c - l : c,
        width: m ? 2 * l : p - c,
        height: m ? 2 * l : d - h,
        background: g,
        opacity: v,
        color: b
      }, y, a.data.style);

      return f.a.createElement("div", {
        className: "rv-treemap__leaf " + (m ? "rv-treemap__leaf--circle" : ""),
        onMouseEnter: function onMouseEnter(e) {
          return i(a, e);
        },
        onMouseLeave: function onMouseLeave(e) {
          return u(a, e);
        },
        onClick: function onClick(e) {
          return o(a, e);
        },
        style: x
      }, f.a.createElement("div", {
        className: "rv-treemap__leaf__content"
      }, _));
    }

    Vg.propTypes = {
      animation: lt,
      height: h.a.number.isRequired,
      mode: h.a.string,
      node: h.a.object.isRequired,
      onLeafClick: h.a.func,
      onLeafMouseOver: h.a.func,
      onLeafMouseOut: h.a.func,
      scales: h.a.object.isRequired,
      width: h.a.number.isRequired,
      r: h.a.number.isRequired,
      x0: h.a.number.isRequired,
      x1: h.a.number.isRequired,
      y0: h.a.number.isRequired,
      y1: h.a.number.isRequired
    };

    var zg = Vg,
        Ig = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function Hg(e) {
      var t = e.animation,
          n = e.className,
          r = e.height,
          a = e.hideRootNode,
          o = e.getLabel,
          i = e.mode,
          u = e.nodes,
          l = e.width,
          s = e.scales,
          c = e.style,
          p = "circlePack" === i;
      return f.a.createElement("div", {
        className: "rv-treemap " + (p ? "rv-treemap-circle-packed" : "") + " " + n,
        style: {
          height: r,
          width: l
        }
      }, u.map(function (n, r) {
        if (a && !r) return null;
        var i = Ig({
          animation: t,
          node: n,
          getLabel: o
        }, e, {
          x0: p ? n.x : n.x0,
          x1: p ? n.x : n.x1,
          y0: p ? n.y : n.y0,
          y1: p ? n.y : n.y1,
          r: p ? n.r : 1,
          scales: s,
          style: c
        });
        return f.a.createElement(zg, Ig({}, i, {
          key: "leaf-" + r
        }));
      }));
    }

    Hg.displayName = "TreemapDOM";

    var Bg = Hg,
        Ug = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        Wg = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function Yg(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Xg(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    var Gg = function (e) {
      function t() {
        return Yg(this, t), Xg(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Wg(t, [{
        key: "getCircularNodes",
        value: function value() {
          var e = this.props,
              t = e.animation,
              n = e.hideRootNode,
              r = e.nodes,
              a = e.onLeafMouseOver,
              o = e.onLeafMouseOut,
              i = e.onLeafClick,
              u = e.scales,
              l = e.style,
              s = r.reduce(function (e, t, r) {
            if (!r && n) return e;
            var a = t.x,
                o = t.y,
                i = t.r;
            return {
              maxY: Math.max(o + i, e.maxY),
              minY: Math.min(o - i, e.minY),
              maxX: Math.max(a + 1.2 * i, e.maxX),
              minX: Math.min(a - 1.2 * i, e.minX),
              rows: e.rows.concat([{
                x: a,
                y: o,
                size: i,
                color: u.color(t)
              }])
            };
          }, {
            rows: [],
            maxY: -1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            minX: 1 / 0
          }),
              c = s.rows,
              p = s.minY,
              h = s.maxY,
              d = s.minX,
              y = s.maxX;
          return {
            updatedNodes: f.a.createElement(fh, {
              animation: t,
              className: "rv-treemap__leaf rv-treemap__leaf--circle",
              onSeriesMouseEnter: a,
              onSeriesMouseLeave: o,
              onSeriesClick: i,
              data: c,
              colorType: "literal",
              getColor: function getColor(e) {
                return e.color;
              },
              sizeType: "literal",
              getSize: function getSize(e) {
                return e.size;
              },
              style: l
            }),
            minY: p,
            maxY: h,
            minX: d,
            maxX: y
          };
        }
      }, {
        key: "getNonCircularNodes",
        value: function value() {
          var e = this.props,
              t = e.animation,
              n = e.hideRootNode,
              r = e.nodes,
              a = e.onLeafMouseOver,
              o = e.onLeafMouseOut,
              i = e.onLeafClick,
              u = e.scales,
              l = e.style,
              s = u.color;
          return r.reduce(function (e, r, u) {
            if (!u && n) return e;
            var c = r.x0,
                p = r.x1,
                h = r.y1,
                d = r.y0,
                y = c,
                m = d,
                g = h - d,
                v = p - c;
            e.maxY = Math.max(m + g, e.maxY), e.minY = Math.min(m, e.minY), e.maxX = Math.max(y + v, e.maxX), e.minX = Math.min(y, e.minX);
            var b = [{
              x: y,
              y: m
            }, {
              x: y,
              y: m + g
            }, {
              x: y + v,
              y: m + g
            }, {
              x: y + v,
              y: m
            }];
            return e.updatedNodes = e.updatedNodes.concat([f.a.createElement(Hh, {
              animation: t,
              className: "rv-treemap__leaf",
              key: u,
              color: s(r),
              type: "literal",
              onSeriesMouseEnter: a,
              onSeriesMouseLeave: o,
              onSeriesClick: i,
              data: b,
              style: Ug({}, l, r.style)
            })]), e;
          }, {
            updatedNodes: [],
            maxY: -1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            minX: 1 / 0
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.className,
              n = e.height,
              r = e.mode,
              a = e.nodes,
              o = e.width,
              i = "circlePack" === r,
              u = i ? this.getCircularNodes() : this.getNonCircularNodes(),
              l = u.minY,
              s = u.maxY,
              c = u.minX,
              p = u.maxX,
              h = u.updatedNodes,
              d = a.reduce(function (e, t) {
            return t.data.title ? e.concat(Ug({}, t.data, {
              x: t.x0 || t.x,
              y: t.y0 || t.y,
              label: "" + t.data.title
            })) : e;
          }, []);
          return f.a.createElement(Yd, Ug({
            className: "rv-treemap " + (i ? "rv-treemap-circle-packed" : "") + " " + t,
            width: o,
            height: n,
            yDomain: [s, l],
            xDomain: [c, p],
            colorType: "literal",
            hasTreeStructure: !0
          }, this.props), h, f.a.createElement(Qp, {
            data: d
          }));
        }
      }]), t;
    }(f.a.Component);

    Gg.displayName = "TreemapSVG";

    var $g = Gg,
        Zg = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        Jg = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    var Qg = {
      squarify: hg,
      resquarify: dg,
      slice: cg,
      dice: Qm,
      slicedice: function slicedice(e, t, n, r, a) {
        (1 & e.depth ? cg : Qm)(e, t, n, r, a);
      },
      binary: function binary(e, t, n, r, a) {
        var o,
            i,
            u = e.children,
            l = u.length,
            s = new Array(l + 1);

        for (s[0] = i = o = 0; o < l; ++o) {
          s[o + 1] = i += u[o].value;
        }

        !function e(t, n, r, a, o, i, l) {
          if (t >= n - 1) {
            var c = u[t];
            return c.x0 = a, c.y0 = o, c.x1 = i, void (c.y1 = l);
          }

          var f = s[t],
              p = r / 2 + f,
              h = t + 1,
              d = n - 1;

          for (; h < d;) {
            var y = h + d >>> 1;
            s[y] < p ? h = y + 1 : d = y;
          }

          p - s[h - 1] < s[h] - p && t + 1 < h && --h;
          var m = s[h] - f,
              g = r - m;

          if (i - a > l - o) {
            var v = (a * g + i * m) / r;
            e(t, h, m, a, o, v, l), e(h, n, g, v, o, i, l);
          } else {
            var b = (o * g + l * m) / r;
            e(t, h, m, a, o, i, b), e(h, n, g, a, b, i, l);
          }
        }(0, l, e.value, t, n, r, a);
      }
    },
        Kg = function Kg(e) {
      return e;
    },
        ev = ["opacity", "color"];

    function tv(e) {
      var t = e.data.children || [],
          n = Jg({}, e, bo(e, t, ev), {
        _allData: t
      });
      return {
        opacity: ho(n, "opacity"),
        color: ho(n, "color")
      };
    }

    var nv = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return n.state = Jg({
          scales: tv(e)
        }, jd(e, e.margin)), n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), Zg(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.setState(Jg({
            scales: tv(e)
          }, jd(e, e.margin)));
        }
      }, {
        key: "_getNodesToRender",
        value: function value() {
          var e = this.state,
              t = e.innerWidth,
              n = e.innerHeight,
              r = this.props,
              a = r.data,
              o = r.mode,
              i = r.padding,
              u = r.sortFunction,
              l = r.getSize;
          if (!a) return [];

          if ("partition" === o || "partition-pivot" === o) {
            var s = Km().size("partition-pivot" === o ? [n, t] : [t, n]).padding(i)(tg(a).sum(l).sort(function (e, t) {
              return u(e, t, l);
            })).descendants();
            return "partition-pivot" === o ? s.map(function (e) {
              return Jg({}, e, {
                x0: e.y0,
                x1: e.y1,
                y0: e.x0,
                y1: e.x1
              });
            }) : s;
          }

          if ("circlePack" === o) return function () {
            var e = null,
                t = 1,
                n = 1,
                r = Ag;

            function a(a) {
              return a.x = t / 2, a.y = n / 2, e ? a.eachBefore(Fg(e)).eachAfter(Rg(r, .5)).eachBefore(Lg(1)) : a.eachBefore(Fg(Cg)).eachAfter(Rg(Ag, 1)).eachAfter(Rg(r, a.r / Math.min(t, n))).eachBefore(Lg(Math.min(t, n) / (2 * a.r))), a;
            }

            return a.radius = function (t) {
              return arguments.length ? (e = jg(t), a) : e;
            }, a.size = function (e) {
              return arguments.length ? (t = +e[0], n = +e[1], a) : [t, n];
            }, a.padding = function (e) {
              return arguments.length ? (r = "function" == typeof e ? e : Ng(+e), a) : r;
            }, a;
          }().size([t, n]).padding(i)(tg(a).sum(l).sort(function (e, t) {
            return u(e, t, l);
          })).descendants();
          var c = Qg[o];
          return function () {
            var e = hg,
                t = !1,
                n = 1,
                r = 1,
                a = [0],
                o = Ag,
                i = Ag,
                u = Ag,
                l = Ag,
                s = Ag;

            function c(e) {
              return e.x0 = e.y0 = 0, e.x1 = n, e.y1 = r, e.eachBefore(f), a = [0], t && e.eachBefore(Jm), e;
            }

            function f(t) {
              var n = a[t.depth],
                  r = t.x0 + n,
                  c = t.y0 + n,
                  f = t.x1 - n,
                  p = t.y1 - n;
              f < r && (r = f = (r + f) / 2), p < c && (c = p = (c + p) / 2), t.x0 = r, t.y0 = c, t.x1 = f, t.y1 = p, t.children && (n = a[t.depth + 1] = o(t) / 2, r += s(t) - n, c += i(t) - n, (f -= u(t) - n) < r && (r = f = (r + f) / 2), (p -= l(t) - n) < c && (c = p = (c + p) / 2), e(t, r, c, f, p));
            }

            return c.round = function (e) {
              return arguments.length ? (t = !!e, c) : t;
            }, c.size = function (e) {
              return arguments.length ? (n = +e[0], r = +e[1], c) : [n, r];
            }, c.tile = function (t) {
              return arguments.length ? (e = Sg(t), c) : e;
            }, c.padding = function (e) {
              return arguments.length ? c.paddingInner(e).paddingOuter(e) : c.paddingInner();
            }, c.paddingInner = function (e) {
              return arguments.length ? (o = "function" == typeof e ? e : Ng(+e), c) : o;
            }, c.paddingOuter = function (e) {
              return arguments.length ? c.paddingTop(e).paddingRight(e).paddingBottom(e).paddingLeft(e) : c.paddingTop();
            }, c.paddingTop = function (e) {
              return arguments.length ? (i = "function" == typeof e ? e : Ng(+e), c) : i;
            }, c.paddingRight = function (e) {
              return arguments.length ? (u = "function" == typeof e ? e : Ng(+e), c) : u;
            }, c.paddingBottom = function (e) {
              return arguments.length ? (l = "function" == typeof e ? e : Ng(+e), c) : l;
            }, c.paddingLeft = function (e) {
              return arguments.length ? (s = "function" == typeof e ? e : Ng(+e), c) : s;
            }, c;
          }().tile(c).size([t, n]).padding(i)(tg(a).sum(l).sort(function (e, t) {
            return u(e, t, l);
          })).descendants();
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props.renderMode,
              t = this.state.scales,
              n = this._getNodesToRender(),
              r = "SVG" === e ? $g : Bg;

          return f.a.createElement(r, Jg({}, this.props, {
            nodes: n,
            scales: t
          }));
        }
      }]), t;
    }(f.a.Component);

    nv.displayName = "Treemap", nv.propTypes = {
      animation: lt,
      className: h.a.string,
      data: h.a.object.isRequired,
      height: h.a.number.isRequired,
      hideRootNode: h.a.bool,
      margin: Ad,
      mode: h.a.oneOf(Object.keys(Qg).concat(["circlePack", "partition", "partition-pivot"])),
      onLeafClick: h.a.func,
      onLeafMouseOver: h.a.func,
      onLeafMouseOut: h.a.func,
      useCirclePacking: h.a.bool,
      padding: h.a.number.isRequired,
      sortFunction: h.a.func,
      width: h.a.number.isRequired,
      getSize: h.a.func,
      getColor: h.a.func
    }, nv.defaultProps = {
      className: "",
      colorRange: Co,
      _colorValue: Ro,
      data: {
        children: []
      },
      hideRootNode: !1,
      margin: {
        left: 40,
        right: 10,
        top: 10,
        bottom: 40
      },
      mode: "squarify",
      onLeafClick: Kg,
      onLeafMouseOver: Kg,
      onLeafMouseOut: Kg,
      opacityType: "literal",
      _opacityValue: 1,
      padding: 1,
      sortFunction: function sortFunction(e, t, n) {
        return n ? n(e) - n(t) : 0;
      },
      getSize: function getSize(e) {
        return e.size;
      },
      getColor: function getColor(e) {
        return e.color;
      },
      getLabel: function getLabel(e) {
        return e.title;
      }
    };

    var rv = n(18),
        av = n.n(rv),
        ov = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        iv = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    var uv = [],
        lv = null;

    function sv() {
      av.a.clearTimeout(lv), lv = av.a.setTimeout(cv, 100);
    }

    function cv() {
      uv.forEach(function (e) {
        return e();
      });
    }

    function fv(e) {
      return uv.push(e), 1 === uv.length && av.a.addEventListener("resize", sv), function () {
        !function (e) {
          var t = uv.indexOf(e);
          t > -1 && uv.splice(t, 1);
        }(e), 0 === uv.length && (av.a.clearTimeout(lv), av.a.removeEventListener("resize", sv));
      };
    }

    function pv(e, t, n) {
      var r = function (r) {
        function a(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a);

          var t = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
          }(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, e));

          return t._onResize = function () {
            var e = Object($a.a)(t.container),
                n = e.offsetHeight,
                r = e.offsetWidth,
                a = t.state.height === n ? {} : {
              height: n
            },
                o = t.state.width === r ? {} : {
              width: r
            };
            t.setState(ov({}, a, o));
          }, t.state = {
            height: 0,
            width: 0
          }, t;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(a, r), iv(a, null, [{
          key: "propTypes",
          get: function get() {
            var t = e.propTypes;
            t.height, t.width;
            return function (e, t) {
              var n = {};

              for (var r in e) {
                t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
              }

              return n;
            }(t, ["height", "width"]);
          }
        }]), iv(a, [{
          key: "componentDidMount",
          value: function value() {
            this._onResize(), this.cancelSubscription = fv(this._onResize);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value() {
            this._onResize();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.cancelSubscription();
          }
        }, {
          key: "render",
          value: function value() {
            var r = this,
                a = this.state,
                o = a.height,
                i = a.width,
                u = ov({}, this.props, {
              animation: 0 === o && 0 === i ? null : this.props.animation
            }),
                l = ov({}, n ? {
              height: o
            } : {}, t ? {
              width: i
            } : {});
            return f.a.createElement("div", {
              ref: function ref(e) {
                return r.container = e;
              },
              style: {
                width: "100%",
                height: "100%"
              }
            }, f.a.createElement(e, ov({}, l, u)));
          }
        }]), a;
      }(f.a.Component);

      return r.displayName = "Flexible" + function (e) {
        return e.displayName || e.name || "Component";
      }(e), r;
    }

    pv(Yd, !0, !1), function (e) {
      pv(e, !1, !0);
    }(Yd), function (e) {
      pv(e, !0, !0);
    }(Yd);

    var hv = function hv(e, t) {
      var n = 0,
          r = 0,
          a = {
        x: 0,
        y: 0
      };
      e.map(function (e) {
        e.data.map(function (e) {
          var t = ("string" == typeof e.y ? e.y : Math.trunc(e.y).toString()).length;
          n = t > n ? t : n;
          var a = ("string" == typeof e.x ? e.x : Math.trunc(e.x).toString()).length;
          r = a > r ? a : r;
        });
      });
      var o = t ? t.reduce(function (e, t) {
        return e.length > t.length ? e : t;
      }).length : 0;
      return n = o > n ? o : n, a.y = n + 1, a.x = r + 1, a;
    },
        dv = function dv(e) {
      var t = e.data,
          n = e.children,
          r = e.className,
          a = e.chartType,
          o = e.getMarginForParent,
          i = s()(e, ["data", "children", "className", "chartType", "getMarginForParent"]),
          l = Object(c.useState)(null),
          p = u()(l, 2),
          h = p[0],
          d = p[1],
          m = Object(c.useState)(null),
          b = u()(m, 2),
          _ = b[0],
          O = b[1];
      Object(c.useEffect)(function () {
        h && 20 !== N.left && o(N.left);
      }, [h]);
      var w = t[0] ? t[0].data.length : null,
          T = !1,
          k = !1,
          M = !1,
          E = !1,
          P = !1,
          j = null;
      f.a.Children.forEach(n, function (e) {
        if (e) {
          var t = e.props,
              n = t.title,
              r = t.hideLabels;

          switch (e.type.displayName) {
            case "XAxis":
              T = e.props.labelAngled, k = !!n, E = !!r;
              break;

            case "YAxis":
              j = e.props.labels ? e.props.labels : null, M = !!n, P = !!r;
          }
        }
      });
      var S = hv(t, j),
          A = y()("wds-plot", r),
          N = v(S, T, k, M, E, P, a, h),
          C = f.a.Children.map(n, function (e) {
        if (e) switch (e.type.displayName) {
          case "XAxis":
            return f.a.cloneElement(e, {
              key: g()(),
              labelAngled: T,
              chartWidth: h,
              longestLabel: S.x,
              numDataPoints: w
            });

          case "YAxis":
            return f.a.cloneElement(e, {
              key: g()(),
              chartMargin: N,
              chartHeight: _,
              longestLabel: S.y,
              chartWidth: h
            });

          default:
            return f.a.cloneElement(e, {
              key: g()()
            });
        }
      });
      return f.a.createElement(c.Fragment, null, f.a.createElement(x.a, {
        onResize: function onResize(e) {
          var t = e.width,
              n = e.height;
          d(t), O(n);
        }
      }, function (e) {
        var t = e.height,
            n = e.width;
        return f.a.createElement(Yd, Object.assign({
          width: n,
          height: t,
          className: A,
          margin: N
        }, i), C);
      }));
    };

    dv.displayName = "Plot", dv.propTypes = {
      data: h.a.arrayOf(h.a.shape({
        title: h.a.node,
        data: h.a.arrayOf(h.a.shape({
          x: h.a.oneOfType([h.a.string, h.a.number]).isRequired,
          y: h.a.oneOfType([h.a.string, h.a.number]).isRequired,
          label: h.a.oneOfType([h.a.string, h.a.number])
        }))
      })).isRequired,
      children: h.a.node.isRequired,
      className: h.a.string.isRequired,
      chartType: h.a.string,
      getMarginForParent: h.a.func
    }, dv.defaultProps = {
      chartType: null,
      getMarginForParent: null
    }, dv.__docgenInfo = {
      description: "@param {Array} data\n@param {Node} children\n@param {String} className\n@param {String} chartType\n@param {Object} props\n@returns {*}",
      methods: [],
      displayName: "Plot",
      props: {
        chartType: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        getMarginForParent: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "node",
                  required: !1
                },
                data: {
                  name: "arrayOf",
                  value: {
                    name: "shape",
                    value: {
                      x: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !0
                      },
                      y: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !0
                      },
                      label: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !1
                      }
                    }
                  },
                  required: !1
                }
              }
            }
          },
          required: !0,
          description: ""
        },
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: ""
        },
        className: {
          type: {
            name: "string"
          },
          required: !0,
          description: ""
        }
      }
    };
    var yv = dv;

    var mv = function mv(e, t) {
      var n = Math.floor(t / 8 * .9);
      return e.length > n ? e.substring(0, n) + "..." : e;
    };

    function gv(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    var vv = function vv(e) {
      var t = e.children,
          n = s()(e, ["children"]),
          r = y()("wds-chart__axis-title", "alt-x-label"),
          a = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? gv(Object(n), !0).forEach(function (t) {
            o()(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gv(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }({}, n),
          i = a.marginBottom,
          u = a.chartWidth,
          l = mv(t, u);

      return f.a.createElement(Ll, Object.assign({
        text: l,
        className: r,
        includeMargin: !1,
        xPercent: .5,
        yPercent: .99,
        style: {
          transform: "translate(0, ".concat(i + 8, ")")
        }
      }, n));
    };

    vv.displayName = "XAxisTitle", vv.propTypes = {
      children: h.a.node.isRequired
    }, vv.requiresSVG = !0, vv.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "XAxisTitle",
      props: {
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: ""
        }
      }
    };

    var bv = vv,
        _v = function _v(e, t, n, r, a) {
      return e ? e[a] : r.length > t ? mv(r, n) : r;
    };

    function xv(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    var Ov = function Ov(e) {
      var t = e.title,
          n = (e.hideLabels, e.hideAxisLine),
          r = e.labelAngled,
          a = e.labels,
          i = e.showTicks,
          u = e.labelPrefix,
          l = e.labelSuffix,
          p = s()(e, ["title", "hideLabels", "hideAxisLine", "labelAngled", "labels", "showTicks", "labelPrefix", "labelSuffix"]),
          h = a ? a.length : 6,
          d = r ? -45 : null,
          y = i ? 8 : 0,
          m = i ? 4 : 8,
          g = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? xv(Object(n), !0).forEach(function (t) {
            o()(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xv(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }({}, p).chartWidth / 10,
          v = g / 8;

      return f.a.createElement(c.Fragment, null, !n && f.a.createElement(Iy, Object.assign({
        className: "wds-chart__axis-line",
        tickSizeOuter: 0,
        tickSizeInner: 0,
        hideTicks: !0,
        on0: !0
      }, p)), f.a.createElement(Iy, Object.assign({
        tickSizeOuter: y,
        tickPadding: m,
        tickSizeInner: 0,
        tickTotal: h,
        tickFormat: function tickFormat(e, t) {
          var n = _v(a, v, g, e, t);

          return n = u ? u + n : n, n = l ? n + l : n;
        },
        tickLabelAngle: d,
        hideLine: !0
      }, p)), t && f.a.createElement(bv, p, t));
    };

    Ov.displayName = "XAxis", Ov.propTypes = {
      title: h.a.node,
      hideLabels: h.a.bool,
      hideAxisLine: h.a.bool,
      labelAngled: h.a.bool,
      labels: h.a.arrayOf(h.a.string),
      showTicks: h.a.bool,
      labelPrefix: h.a.string,
      labelSuffix: h.a.string
    }, Ov.defaultProps = {
      title: null,
      hideLabels: !1,
      hideAxisLine: !1,
      labelAngled: !1,
      labels: null,
      showTicks: !1,
      labelPrefix: void 0,
      labelSuffix: void 0
    }, Ov.requiresSVG = !0, Ov.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "XAxis",
      props: {
        title: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        hideLabels: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        hideAxisLine: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        labelAngled: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        labels: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "arrayOf",
            value: {
              name: "string"
            }
          },
          required: !1,
          description: ""
        },
        showTicks: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        labelPrefix: {
          defaultValue: {
            value: "undefined",
            computed: !0
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        labelSuffix: {
          defaultValue: {
            value: "undefined",
            computed: !0
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        }
      }
    };
    var wv = Ov;

    function Tv(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    var kv = function kv(e) {
      var t = e.children,
          n = s()(e, ["children"]),
          r = y()("wds-chart__axis-title", "alt-y-label"),
          a = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Tv(Object(n), !0).forEach(function (t) {
            o()(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Tv(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }({}, n),
          i = a.marginLeft,
          u = a.chartHeight,
          l = mv(t, u);

      return f.a.createElement(Ll, Object.assign({
        text: l,
        className: r,
        includeMargin: !1,
        xPercent: 0,
        yPercent: .5,
        style: {
          transform: "rotate(-90) translate(0, -".concat(i - 16, ")")
        }
      }, n));
    };

    kv.displayName = "YAxisTitle", kv.propTypes = {
      children: h.a.node.isRequired
    }, kv.requiresSVG = !0, kv.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "YAxisTitle",
      props: {
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: ""
        }
      }
    };
    var Mv = kv;

    function Ev(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    var Pv = function Pv(e) {
      var t = e.title,
          n = (e.hideLabels, e.hideAxisLine),
          r = e.labels,
          a = (e.showTicks, e.labelPrefix),
          i = e.labelSuffix,
          u = s()(e, ["title", "hideLabels", "hideAxisLine", "labels", "showTicks", "labelPrefix", "labelSuffix"]),
          l = r ? r.length : 6,
          p = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Ev(Object(n), !0).forEach(function (t) {
            o()(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ev(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }({}, u),
          h = p.longestLabel,
          d = p.chartWidth,
          y = Math.floor(7 * h),
          m = .3 * d,
          g = m / 8,
          v = y > m ? m : y;

      return f.a.createElement(c.Fragment, null, !n && f.a.createElement(Gy, Object.assign({
        className: "wds-chart__axis-line",
        tickSizeOuter: 0,
        tickSizeInner: 0,
        hideTicks: !0,
        on0: !0
      }, u)), f.a.createElement(Gy, Object.assign({
        tickSizeOuter: 0,
        tickSizeInner: 0,
        tickTotal: l,
        tickFormat: function tickFormat(e, t) {
          var n = _v(r, g, v, e, t);

          return n = a ? a + n : n, n = i ? n + i : n;
        },
        hideLine: !0
      }, u)), t && f.a.createElement(Mv, u, t));
    };

    Pv.displayName = "YAxis", Pv.propTypes = {
      title: h.a.node,
      hideLabels: h.a.bool,
      hideAxisLine: h.a.bool,
      labels: h.a.arrayOf(h.a.string),
      showTicks: h.a.bool,
      labelPrefix: h.a.string,
      labelSuffix: h.a.string
    }, Pv.defaultProps = {
      title: null,
      hideLabels: !1,
      hideAxisLine: !1,
      labels: null,
      showTicks: !1,
      labelPrefix: void 0,
      labelSuffix: void 0
    }, Pv.requiresSVG = !0, Pv.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "YAxis",
      props: {
        title: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        hideLabels: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        hideAxisLine: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        labels: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "arrayOf",
            value: {
              name: "string"
            }
          },
          required: !1,
          description: ""
        },
        showTicks: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        labelPrefix: {
          defaultValue: {
            value: "undefined",
            computed: !0
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        labelSuffix: {
          defaultValue: {
            value: "undefined",
            computed: !0
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        }
      }
    };

    var jv = Pv,
        Sv = function Sv(e) {
      var t = e.tickTotal,
          n = s()(e, ["tickTotal"]),
          r = y()("wds-chart__grid-line");
      return f.a.createElement(xp, Object.assign({
        className: r,
        tickTotal: t
      }, n));
    };

    Sv.displayName = "XGridLines", Sv.propTypes = {
      tickTotal: h.a.number
    }, Sv.defaultProps = {
      tickTotal: 6
    }, Sv.requiresSVG = !0, Sv.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "XGridLines",
      props: {
        tickTotal: {
          defaultValue: {
            value: "6",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        }
      }
    };

    var Av = Sv,
        Nv = function Nv(e) {
      var t = e.tickTotal,
          n = s()(e, ["tickTotal"]),
          r = y()("wds-chart__grid-line");
      return f.a.createElement(od, Object.assign({
        className: r,
        tickTotal: t
      }, n));
    };

    Nv.displayName = "YGridLines", Nv.propTypes = {
      tickTotal: h.a.number
    }, Nv.defaultProps = {
      tickTotal: 6
    }, Nv.requiresSVG = !0, Nv.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "YGridLines",
      props: {
        tickTotal: {
          defaultValue: {
            value: "6",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        }
      }
    };
    var Cv = Nv,
        Fv = n(41),
        Rv = n.n(Fv),
        Lv = ["lg", "md", "sm"],
        Dv = (["xl"].concat(Lv), [].concat(Lv, ["xl", "xs"]), [].concat(Lv, ["xl"]), [].concat(Lv, ["xs"]), [].concat(Lv, ["xl"]), ["primary", "secondary", "muted", "success", "warning", "upgrade", "info"]),
        qv = ([].concat(["data-sabaeus", "data-midnight", "data-concord", "data-arctic", "data-bumblebee", "data-bengal", "data-raspberry", "data-slate", "data-gold", "data-cherry"], Dv, ["sabaeus", "midnight", "link", "arctic", "concord", "raspberry", "bengal", "bumblebee", "black", "charcoal", "slate", "stone", "flint", "pebble", "canvas", "white"]), [].concat(Dv), ["alt", "link"].concat(Dv), n(74), Object(c.forwardRef)(function (e, t) {
      var n = e.align,
          r = e.children,
          a = e.className,
          i = e.color,
          u = e.component,
          l = e["data-testid"],
          c = e.variant,
          p = s()(e, ["align", "children", "className", "color", "component", "data-testid", "variant"]),
          h = y()(o()({}, "wds-type--".concat(n), n), o()({}, "wds-type--".concat(i), i), o()({}, "wds-type--".concat(Rv()(c)), c), a),
          d = u;
      return f.a.createElement(d, Object.assign({
        className: h,
        "data-testid": l,
        ref: t
      }, p), r);
    }));
    qv.propTypes = {
      align: h.a.oneOf(["center", "justify", "left", "right"]),
      children: h.a.node.isRequired,
      className: h.a.string,
      color: h.a.oneOf(["light", "dark", "primary", "success", "upgrade", "info", "warning", "link", "light-muted", "dark-muted"]),
      component: h.a.string,
      "data-testid": h.a.string,
      variant: h.a.oneOf(["hero1", "hero2", "pageTitle", "sectionTitle", "cardTitle", "body", "bodySm", "link"])
    }, qv.defaultProps = {
      align: void 0,
      className: void 0,
      color: void 0,
      component: "div",
      "data-testid": void 0,
      variant: "body"
    }, qv.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "Typography",
      props: {
        align: {
          defaultValue: {
            value: "undefined",
            computed: !0
          },
          type: {
            name: "enum",
            computed: !0,
            value: "alignment"
          },
          required: !1,
          description: ""
        },
        className: {
          defaultValue: {
            value: "undefined",
            computed: !0
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        color: {
          defaultValue: {
            value: "undefined",
            computed: !0
          },
          type: {
            name: "enum",
            computed: !0,
            value: "typeColors"
          },
          required: !1,
          description: ""
        },
        component: {
          defaultValue: {
            value: "'div'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        "data-testid": {
          defaultValue: {
            value: "undefined",
            computed: !0
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        variant: {
          defaultValue: {
            value: "'body'",
            computed: !1
          },
          type: {
            name: "enum",
            computed: !0,
            value: "typographyVariants"
          },
          required: !1,
          description: ""
        },
        children: {
          type: {
            name: "node"
          },
          required: !0,
          description: ""
        }
      }
    };

    var Vv = qv,
        zv = n(25),
        Iv = Object.values(zv["data-vis-color"]).filter(function (e) {
      return "string" == typeof e;
    }).map(function (e) {
      return e;
    }),
        Hv = zv["type-color"]["color--type-dark"],
        Bv = zv["type-color"]["color--type-light"],
        Uv = (n(73), function (e, t) {
      return Array.isArray(e) ? e[t % e.length] : null;
    }),
        Wv = function Wv(e) {
      var t = e.className,
          n = e.colorPalette,
          r = e.data,
          a = e.placement,
          o = e.title,
          i = e.marginLeft,
          l = s()(e, ["className", "colorPalette", "data", "placement", "title", "marginLeft"]),
          p = y()("wds-chart__legend", t),
          h = Object(c.useState)(!1),
          d = u()(h, 2),
          m = d[0],
          g = d[1];
      Object(c.useEffect)(function () {
        20 !== i && g(!0);
      }, [i]);

      var v = r.map(function (e, t) {
        var r = e.title,
            a = e.color;
        if (r) return {
          title: r,
          color: a || Uv(n, t)
        };
      }),
          b = "right" === a ? "vertical" : "horizontal",
          _ = i < 0 ? "0px" : i,
          x = m ? "visible" : "hidden";

      return f.a.createElement(c.Fragment, null, f.a.createElement("div", {
        className: p,
        style: {
          marginLeft: _,
          visibility: x
        }
      }, o && f.a.createElement(Vv, {
        className: "wds-chart__legend-title",
        variant: "cardTitle"
      }, o), f.a.createElement(im, Object.assign({
        orientation: b,
        items: v
      }, l))));
    };

    Wv.displayName = "Legend", Wv.propTypes = {
      className: h.a.string,
      colorPalette: h.a.node,
      data: h.a.arrayOf(h.a.shape({
        title: h.a.string.isRequired,
        color: h.a.string
      })).isRequired,
      placement: h.a.oneOf(["top", "right", "bottom"]),
      title: h.a.node,
      marginLeft: h.a.number
    }, Wv.defaultProps = {
      className: null,
      colorPalette: Iv,
      placement: "top",
      title: null,
      marginLeft: null
    }, Wv.__docgenInfo = {
      description: "@param {String} className\n@param {Array}  colorPalette\n@param {Array}  data\n@param {String} placement\n@param {String} title\n@param {Object} props\n@returns {*}",
      methods: [],
      displayName: "Legend",
      props: {
        className: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        colorPalette: {
          defaultValue: {
            value: "dataVisColors",
            computed: !0
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        placement: {
          defaultValue: {
            value: "'top'",
            computed: !1
          },
          type: {
            name: "enum",
            value: [{
              value: "'top'",
              computed: !1
            }, {
              value: "'right'",
              computed: !1
            }, {
              value: "'bottom'",
              computed: !1
            }]
          },
          required: !1,
          description: ""
        },
        title: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        marginLeft: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "string",
                  required: !0
                },
                color: {
                  name: "string",
                  required: !1
                }
              }
            }
          },
          required: !0,
          description: ""
        }
      }
    };
    var Yv = Wv,
        Xv = n(24),
        Gv = n.n(Xv);

    var $v = function $v(e, t) {
      var n = Math.pow(10, t),
          r = e * n;
      return Math[r < 0 ? "ceil" : "floor"](r) / n;
    };

    function Zv(e, t) {
      return e + Math.round(t);
    }

    function Jv(e, t) {
      return e + (t - e % t);
    }

    function Qv(e, t) {
      return e % t == 0 ? e += t : e % t > t / 2 ? (e += t, e = Jv(e = Math.floor(e), t)) : e = Jv(e = Math.floor(e), t), e;
    }

    function Kv(e, t) {
      return t <= 4 ? (e = Math.floor(e), e += .5) : t <= 7 ? (e = Math.floor(e), e += 1) : t <= 12 ? e = Qv(e, 2) : t <= 35 ? e = Qv(e, 5) : t <= 70 ? e = Qv(e, 10) : t <= 179 ? e = Qv(e, 20) : t <= 399 ? e = Qv(e, 50) : t <= 799 ? e = Qv(e, 100) : t <= 1799 ? e = Qv(e, 200) : t <= 3999 ? e = Qv(e, 500) : t <= 7999 ? e = Qv(e, 1e3) : t <= 17999 ? e = Qv(e, 2e3) : t <= 39999 ? e = Qv(e, 5e3) : t <= 79999 ? e = Qv(e, 1e4) : t <= 179999 ? e = Qv(e, 2e4) : t <= 399999 ? e = Qv(e, 5e4) : t <= 799999 && (e = Qv(e, 1e5)), e;
    }

    var eb = function eb(e, t, n) {
      var r = e[0].data.length,
          a = Array.apply(null, Array(r)).map(function (r, a) {
        var o = e.map(function (e) {
          return n && "bar-horizontal" == n ? e.data[a].x : e.data[a].y;
        });
        return t ? {
          max: o.reduce(Zv, 0),
          min: o.reduce(Zv, 0)
        } : {
          max: Math.max.apply(null, o),
          min: Math.min.apply(null, o)
        };
      }).reduce(function (e, t) {
        return {
          max: Math.max(e.max, t.max) < 0 ? 0 : Math.max(e.max, t.max),
          min: Math.min(e.min, t.min) > 0 ? 0 : Math.min(e.min, t.min)
        };
      }, {
        max: -1 / 0,
        min: 1 / 0
      }),
          o = Math.abs(a.min - a.max),
          i = Kv(Math.floor(a.max), o);
      return [a.min < 0 ? -Kv(Math.abs(Math.ceil(a.min)), o) : Math.ceil(a.min), i];
    },
        tb = function tb(e) {
      var t,
          n,
          r = (t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e), n = function n(e) {
        return parseInt(e, 16);
      }, t ? {
        r: n(t[1]),
        g: n(t[2]),
        b: n(t[3])
      } : null);
      return .299 * r.r + .587 * r.g + .114 * r.b > 150 ? "dark" : "light";
    },
        nb = function nb(e) {
      for (var t = [], n = 0; n <= e; n++) {
        t.push(n - Math.floor(e / 2));
      }

      return t;
    },
        rb = function rb(e) {
      var t = e.children,
          n = e.data,
          r = e.colorPalette,
          a = e.stacked,
          o = e.annotated,
          i = e.className,
          l = e.tooltips,
          p = e.animation,
          h = e.height,
          d = e.width,
          m = e.displayDecimalPlaces,
          v = e.yMinMax,
          b = e.getMarginForParent,
          _ = e.sortDirection,
          x = s()(e, ["children", "data", "colorPalette", "stacked", "annotated", "className", "tooltips", "animation", "height", "width", "displayDecimalPlaces", "yMinMax", "getMarginForParent", "sortDirection"]),
          O = Object(c.useState)(!1),
          w = u()(O, 2),
          T = w[0],
          k = w[1],
          M = Object(c.useState)(0),
          E = u()(M, 2),
          P = E[0],
          j = E[1],
          S = Object(c.useState)(0),
          A = u()(S, 2),
          N = A[0],
          C = A[1],
          F = Object(c.useState)(0),
          R = u()(F, 2),
          L = R[0],
          D = R[1];

      function q() {
        j(V.current ? V.current.offsetWidth : 0);
      }

      var V = Object(c.useRef)(null);
      Object(c.useEffect)(function () {
        o && (window.addEventListener("resize", q), q());
      }, [V.current]);

      var z = function z(e) {
        var t = V.current.getBoundingClientRect(),
            n = e.x - t.left - N + 20,
            r = e.y - t.top - L;
        C(N + n), D(L + r);
      },
          I = function I() {
        k(!1), V.current.removeEventListener("mousemove", z);
      },
          H = function H(e) {
        e.y = $v(e.y, m), T || k(e), V && null !== V.current && V.current.addEventListener("mousemove", z);
      },
          B = y()("wds-chart--bar", "wds-chart--vertical", l && "wds-chart--interactive", i);

      v = v || eb(n, a, "bar-vertical");
      var U = f.a.Children.map(t, function (e) {
        if (e) return "YAxis" === e.type.displayName ? f.a.cloneElement(e, {
          key: g()(),
          hideAxisLine: !0
        }) : f.a.cloneElement(e, {
          key: g()()
        });
      }),
          W = n.length,
          Y = W > 1,
          X = n[0] ? n[0].data.length : 1,
          G = JSON.parse(JSON.stringify(n));

      if (Y && !a) {
        var $ = Gv()(Array(X)).map(function () {
          return Array(W);
        });
        n.map(function (e, t) {
          e.data.map(function (e, n) {
            $[n][t] = {
              value: e.y,
              color: r[t],
              label: e.label ? e.label : null
            };
          });
        }), null != _ && $.map(function (e) {
          e.sort(function (e, t) {
            return "desc" === _ ? e.value <= t.value ? 1 : -1 : e.value >= t.value ? 1 : -1;
          });
        }), n.map(function (e, t) {
          e.data.map(function (e, n) {
            G[t].data[n].y = $[n][t].value, G[t].data[n].color = $[n][t].color, void 0 !== $[n][t].label && (G[t].data[n].label = $[n][t].label);
          });
        });
      }

      var Z,
          J,
          Q,
          K,
          ee = G.map(function (e, t) {
        if (e) return f.a.createElement(Gh, {
          key: g()(),
          data: e.data,
          color: Uv(r, t),
          yBaseValue: 0,
          barWidth: .66,
          onValueMouseOver: l && H,
          onValueMouseOut: I,
          stack: !0,
          stroke: Y && !a ? "#fff" : void 0
        });
      }),
          te = l && T && f.a.createElement(Wf, {
        value: T,
        style: {
          left: N,
          top: L
        },
        getAlignStyle: function getAlignStyle() {
          return null;
        }
      }, "function" == typeof l && f.a.createElement("div", {
        className: "rv-hint__content"
      }, l(T)));
      return f.a.createElement("div", {
        style: {
          height: h,
          width: d
        },
        ref: V
      }, f.a.createElement(yv, Object.assign({
        data: n,
        xType: "ordinal",
        stackBy: a ? "y" : null,
        className: B,
        animation: p,
        yDomain: v,
        chartType: "barvertical",
        getMarginForParent: b,
        colorType: "literal"
      }, x), ee, o && (Z = P / X / W * .66, J = nb(W), Q = JSON.parse(JSON.stringify(G)), K = [], Q.map(function (e, t) {
        if (e) {
          var n = J[t],
              o = W % 2 == 0 ? n * Z + Z / 2 : n * Z;
          e.data.map(function (e, n) {
            var i = e.y;

            if (a) {
              K[n] = K[n] ? K[n] : 0;
              var u = K[n],
                  l = (i + K[n] - u) / 2 + u;
              e.y = l, K[n] += i;
              var s = Uv(r, t),
                  c = "dark" == tb(s) ? Hv : Bv;
              e.style = {
                fill: c
              };
            }

            e.label = e.label ? e.label : $v(i, m).toString(), !a && Y && (e.xOffset = o);
          });
          var i = y()("wds-chart__annotation", "wds-chart__annotation--vertical", {
            "wds-chart__annotation--stacked": a
          }),
              u = a ? "middle" : "text-after-edge";
          return f.a.createElement(Qp, {
            className: i,
            key: g()(),
            data: e.data,
            labelAnchorY: u,
            labelAnchorX: "middle"
          });
        }
      })), te, U));
    };

    rb.displayName = "BarVertical", rb.propTypes = {
      children: h.a.node,
      data: h.a.arrayOf(h.a.shape({
        title: h.a.node,
        data: h.a.arrayOf(h.a.shape({
          x: h.a.oneOfType([h.a.string, h.a.number]).isRequired,
          y: h.a.number.isRequired,
          label: h.a.oneOfType([h.a.string, h.a.number])
        }))
      })).isRequired,
      colorPalette: h.a.node,
      stacked: h.a.bool,
      annotated: h.a.bool,
      className: h.a.string,
      tooltips: h.a.oneOfType([h.a.bool, h.a.func]),
      animation: h.a.bool,
      yMinMax: h.a.arrayOf(h.a.number),
      height: h.a.string,
      width: h.a.string,
      displayDecimalPlaces: h.a.number,
      getMarginForParent: h.a.func,
      sortDirection: h.a.oneOf(["asc", "desc"])
    }, rb.defaultProps = {
      children: null,
      colorPalette: Iv,
      stacked: !1,
      annotated: !1,
      className: "",
      tooltips: null,
      animation: !1,
      yMinMax: null,
      height: "320px",
      width: "100%",
      displayDecimalPlaces: 2,
      getMarginForParent: null,
      sortDirection: null
    }, rb.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "BarVertical",
      props: {
        children: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        colorPalette: {
          defaultValue: {
            value: "dataVisColors",
            computed: !0
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        stacked: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        annotated: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        className: {
          defaultValue: {
            value: "''",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        tooltips: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "union",
            value: [{
              name: "bool"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: ""
        },
        animation: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        yMinMax: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "arrayOf",
            value: {
              name: "number"
            }
          },
          required: !1,
          description: ""
        },
        height: {
          defaultValue: {
            value: "'320px'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        width: {
          defaultValue: {
            value: "'100%'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        displayDecimalPlaces: {
          defaultValue: {
            value: "2",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        },
        getMarginForParent: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        },
        sortDirection: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "enum",
            value: [{
              value: "'asc'",
              computed: !1
            }, {
              value: "'desc'",
              computed: !1
            }]
          },
          required: !1,
          description: ""
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "node",
                  required: !1
                },
                data: {
                  name: "arrayOf",
                  value: {
                    name: "shape",
                    value: {
                      x: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !0
                      },
                      y: {
                        name: "number",
                        required: !0
                      },
                      label: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !1
                      }
                    }
                  },
                  required: !1
                }
              }
            }
          },
          required: !0,
          description: ""
        }
      }
    };

    var ab = rb,
        ob = function ob(e) {
      var t = e.children,
          n = e.data,
          r = e.colorPalette,
          a = e.stacked,
          o = e.annotated,
          i = e.className,
          l = e.tooltips,
          p = e.animation,
          h = e.height,
          d = e.width,
          m = e.displayDecimalPlaces,
          v = e.xMinMax,
          b = e.getMarginForParent,
          _ = e.sortDirection,
          x = s()(e, ["children", "data", "colorPalette", "stacked", "annotated", "className", "tooltips", "animation", "height", "width", "displayDecimalPlaces", "xMinMax", "getMarginForParent", "sortDirection"]),
          O = Object(c.useState)(!1),
          w = u()(O, 2),
          T = w[0],
          k = w[1],
          M = Object(c.useState)(0),
          E = u()(M, 2),
          P = E[0],
          j = E[1],
          S = Object(c.useState)(0),
          A = u()(S, 2),
          N = A[0],
          C = A[1],
          F = Object(c.useRef)(null),
          R = function R(e) {
        var t = F.current.getBoundingClientRect(),
            n = e.x - t.left - P + 20,
            r = e.y - t.top - N;
        j(P + n), C(N + r);
      },
          L = function L() {
        k(!1), F.current.removeEventListener("mousemove", R);
      },
          D = function D(e) {
        e.x = $v(e.x, m), T || k(e), F && null !== F.current && F.current.addEventListener("mousemove", R);
      },
          q = y()("wds-chart--bar", "wds-chart--horizontal", l && "wds-chart--interactive", i);

      v = v || eb(n, a, "bar-horizontal");
      var V = f.a.Children.map(t, function (e) {
        if (e) return "XAxis" === e.type.displayName ? f.a.cloneElement(e, {
          key: g()(),
          hideAxisLine: !0
        }) : f.a.cloneElement(e, {
          key: g()()
        });
      }),
          z = n.length,
          I = z > 1,
          H = n[0] ? n[0].data.length : 1,
          B = JSON.parse(JSON.stringify(n));

      if (I && !a) {
        var U = Gv()(Array(H)).map(function () {
          return Array(z);
        });
        n.map(function (e, t) {
          e.data.map(function (e, n) {
            U[n][t] = {
              value: e.x,
              color: r[t],
              label: e.label ? e.label : null
            };
          });
        }), null != _ && U.map(function (e) {
          e.sort(function (e, t) {
            return "desc" === _ ? e.value <= t.value ? 1 : -1 : e.value >= t.value ? 1 : -1;
          });
        }), n.map(function (e, t) {
          e.data.map(function (e, n) {
            B[t].data[n].x = U[n][t].value, B[t].data[n].color = U[n][t].color, void 0 !== U[n][t].label && (B[t].data[n].label = U[n][t].label);
          });
        });
      }

      var W,
          Y,
          X,
          G,
          $ = B.map(function (e, t) {
        if (e) return f.a.createElement(ap, {
          key: g()(),
          data: e.data,
          color: Uv(r, t),
          xBaseValue: 0,
          barWidth: .66,
          onValueMouseOver: l && D,
          onValueMouseOut: L,
          stack: !0,
          stroke: I && !a ? "#fff" : void 0
        });
      }),
          Z = l && T && f.a.createElement(Wf, {
        value: T,
        style: {
          left: P,
          top: N
        },
        getAlignStyle: function getAlignStyle() {
          return null;
        }
      }, "function" == typeof l && f.a.createElement("div", {
        className: "rv-hint__content"
      }, l(T)));
      return f.a.createElement("div", {
        style: {
          height: h,
          width: d
        },
        ref: F
      }, f.a.createElement(yv, Object.assign({
        data: n,
        yType: "ordinal",
        stackBy: a ? "x" : null,
        className: q,
        animation: p,
        xDomain: v,
        chartType: "barhorizontal",
        getMarginForParent: b,
        colorType: "literal"
      }, x), $, o && (W = parseInt(h, 10) / H / z * .66, Y = nb(z), X = JSON.parse(JSON.stringify(B)), G = [], X.map(function (e, t) {
        if (e) {
          var n = Y[t],
              o = z % 2 == 0 ? n * W + W / 2 : n * W;
          e.data.map(function (e, n) {
            var i = e.x;

            if (a) {
              G[n] = G[n] ? G[n] : 0;
              var u = G[n],
                  l = (i + G[n] - u) / 2 + u;
              e.x = l, G[n] += i;
              var s = Uv(r, t),
                  c = "dark" == tb(s) ? Hv : Bv;
              e.style = {
                fill: c
              };
            }

            e.label = e.label ? e.label : $v(i, m).toString(), !a && I && (e.yOffset = o);
          });
          var i = y()("wds-chart__annotation", "wds-chart__annotation--horizontal", {
            "wds-chart__annotation--stacked": a
          }),
              u = a ? "middle" : "text-after-edge";
          return f.a.createElement(Qp, {
            className: i,
            key: g()(),
            data: e.data,
            labelAnchorY: "middle",
            labelAnchorX: u
          });
        }
      })), Z, V));
    };

    ob.displayName = "BarHorizontal", ob.propTypes = {
      children: h.a.node,
      data: h.a.arrayOf(h.a.shape({
        title: h.a.node,
        data: h.a.arrayOf(h.a.shape({
          y: h.a.oneOfType([h.a.string, h.a.number]).isRequired,
          x: h.a.number.isRequired,
          label: h.a.oneOfType([h.a.string, h.a.number])
        }))
      })).isRequired,
      colorPalette: h.a.node,
      stacked: h.a.bool,
      annotated: h.a.bool,
      className: h.a.string,
      tooltips: h.a.oneOfType([h.a.bool, h.a.func]),
      animation: h.a.bool,
      xMinMax: h.a.arrayOf(h.a.number),
      height: h.a.string,
      width: h.a.string,
      displayDecimalPlaces: h.a.number,
      getMarginForParent: h.a.func,
      sortDirection: h.a.oneOf(["asc", "desc"])
    }, ob.defaultProps = {
      children: null,
      colorPalette: Iv,
      stacked: null,
      annotated: !1,
      className: "",
      tooltips: null,
      animation: !1,
      xMinMax: null,
      height: "320px",
      width: "100%",
      displayDecimalPlaces: 2,
      getMarginForParent: null,
      sortDirection: null
    }, ob.__docgenInfo = {
      description: "",
      methods: [],
      displayName: "BarHorizontal",
      props: {
        children: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        colorPalette: {
          defaultValue: {
            value: "dataVisColors",
            computed: !0
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        stacked: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        annotated: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        className: {
          defaultValue: {
            value: "''",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        tooltips: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "union",
            value: [{
              name: "bool"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: ""
        },
        animation: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        xMinMax: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "arrayOf",
            value: {
              name: "number"
            }
          },
          required: !1,
          description: ""
        },
        height: {
          defaultValue: {
            value: "'320px'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        width: {
          defaultValue: {
            value: "'100%'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        displayDecimalPlaces: {
          defaultValue: {
            value: "2",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        },
        getMarginForParent: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        },
        sortDirection: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "enum",
            value: [{
              value: "'asc'",
              computed: !1
            }, {
              value: "'desc'",
              computed: !1
            }]
          },
          required: !1,
          description: ""
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "node",
                  required: !1
                },
                data: {
                  name: "arrayOf",
                  value: {
                    name: "shape",
                    value: {
                      y: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !0
                      },
                      x: {
                        name: "number",
                        required: !0
                      },
                      label: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !1
                      }
                    }
                  },
                  required: !1
                }
              }
            }
          },
          required: !0,
          description: ""
        }
      }
    };

    var ib = ob,
        ub = n(14),
        lb = n.n(ub),
        sb = n(15),
        cb = n.n(sb),
        fb = n(6),
        pb = n.n(fb),
        hb = n(16),
        db = n.n(hb),
        yb = n(17),
        mb = n.n(yb),
        gb = n(10),
        vb = n.n(gb),
        bb = function bb(e) {
      return f.a.Children.map(e, function (e) {
        if (e) {
          var t = e.type.displayName;
          return "YAxis" === t ? f.a.cloneElement(e, {
            key: g()(),
            hideAxisLine: !0
          }) : "XAxis" === t ? f.a.cloneElement(e, {
            key: g()(),
            showTicks: !0
          }) : f.a.cloneElement(e, {
            key: g()()
          });
        }
      });
    };

    n(80);

    var _b = function (e) {
      db()(n, e);

      var t = function (e) {
        function t() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }

        return function () {
          var n,
              r = vb()(e);

          if (t()) {
            var a = vb()(this).constructor;
            n = Reflect.construct(r, arguments, a);
          } else n = r.apply(this, arguments);

          return mb()(this, n);
        };
      }(n);

      function n() {
        var e;
        lb()(this, n);

        for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++) {
          a[i] = arguments[i];
        }

        return e = t.call.apply(t, [this].concat(a)), o()(pb()(e), "state", {
          crosshairValues: []
        }), o()(pb()(e), "onMouseLeave", function () {
          e.setState({
            crosshairValues: []
          });
        }), o()(pb()(e), "onNearestX", function (t, n) {
          var r = n.index,
              a = e.props.data;
          e.setState({
            crosshairValues: a.map(function (e) {
              return e.data[r];
            })
          });
        }), o()(pb()(e), "formatCrosshairTitle", function (e) {
          return {
            title: "X",
            value: e[0].x
          };
        }), o()(pb()(e), "formatCrosshairItems", function (t) {
          var n = e.props,
              r = n.data,
              a = n.displayDecimalPlaces;
          return t.map(function (e, t) {
            return {
              title: r[t].title,
              value: $v(e.y, a)
            };
          });
        }), e;
      }

      return cb()(n, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.children,
              r = t.data,
              a = t.colorPalette,
              o = t.className,
              i = t.animation,
              u = t.smooth,
              l = t.tooltips,
              p = t.height,
              h = t.width,
              d = s()(t, ["children", "data", "colorPalette", "className", "animation", "smooth", "tooltips", "height", "width"]),
              m = this.props.yMinMax,
              v = this.state.crosshairValues,
              b = y()("wds-chart--area", o),
              _ = r.length > 1;

          m = m || eb(r, _, "area");
          var x = bb(n),
              O = r.map(function (t, n) {
            if (t) return f.a.createElement(wl, Object.assign({
              key: g()(),
              data: t.data,
              color: Uv(a, n),
              yBaseValue: 0,
              curve: u ? "curveMonotoneX" : null,
              markStyle: u ? {
                fill: "transparent",
                stroke: "transparent"
              } : null,
              onNearestX: e.onNearestX
            }, d));
          }),
              w = l && v.length > 0 && f.a.createElement(Lc, {
            values: v,
            itemsFormat: this.formatCrosshairItems,
            titleFormat: this.formatCrosshairTitle,
            className: "wds-chart__crosshair"
          }, "function" == typeof l && f.a.createElement("div", {
            className: "rv-hint__content"
          }, l(v)));
          return f.a.createElement(c.Fragment, null, f.a.createElement("div", {
            style: {
              height: p,
              width: h
            }
          }, f.a.createElement(yv, Object.assign({
            data: r,
            xType: "ordinal",
            stackBy: "y",
            className: b,
            animation: i,
            yDomain: m,
            onMouseLeave: this.onMouseLeave,
            chartType: "area"
          }, d), w, O, x)));
        }
      }]), n;
    }(c.Component);

    _b.displayName = "Area", _b.propTypes = {
      children: h.a.node,
      data: h.a.arrayOf(h.a.shape({
        title: h.a.node,
        data: h.a.arrayOf(h.a.shape({
          x: h.a.oneOfType([h.a.string, h.a.number]).isRequired,
          y: h.a.number.isRequired,
          label: h.a.oneOfType([h.a.string, h.a.number])
        }))
      })).isRequired,
      colorPalette: h.a.node,
      className: h.a.string,
      animation: h.a.bool,
      yMinMax: h.a.arrayOf(h.a.number),
      smooth: h.a.bool,
      tooltips: h.a.oneOfType([h.a.bool, h.a.func]),
      height: h.a.string,
      width: h.a.string,
      displayDecimalPlaces: h.a.number
    }, _b.defaultProps = {
      children: null,
      colorPalette: Iv,
      className: "",
      animation: !1,
      yMinMax: null,
      smooth: !1,
      tooltips: null,
      height: "320px",
      width: "100%",
      displayDecimalPlaces: 2
    }, _b.__docgenInfo = {
      description: "",
      methods: [{
        name: "onMouseLeave",
        docblock: null,
        modifiers: [],
        params: [],
        returns: null
      }, {
        name: "onNearestX",
        docblock: null,
        modifiers: [],
        params: [{
          name: "value",
          type: null
        }, {
          name: "{ index }",
          type: null
        }],
        returns: null
      }, {
        name: "formatCrosshairTitle",
        docblock: null,
        modifiers: [],
        params: [{
          name: "values",
          type: null
        }],
        returns: null
      }, {
        name: "formatCrosshairItems",
        docblock: null,
        modifiers: [],
        params: [{
          name: "values",
          type: null
        }],
        returns: null
      }],
      displayName: "Area",
      props: {
        children: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        colorPalette: {
          defaultValue: {
            value: "dataVisColors",
            computed: !0
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        className: {
          defaultValue: {
            value: "''",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        animation: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        yMinMax: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "arrayOf",
            value: {
              name: "number"
            }
          },
          required: !1,
          description: ""
        },
        smooth: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        tooltips: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "union",
            value: [{
              name: "bool"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: ""
        },
        height: {
          defaultValue: {
            value: "'320px'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        width: {
          defaultValue: {
            value: "'100%'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        displayDecimalPlaces: {
          defaultValue: {
            value: "2",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "node",
                  required: !1
                },
                data: {
                  name: "arrayOf",
                  value: {
                    name: "shape",
                    value: {
                      x: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !0
                      },
                      y: {
                        name: "number",
                        required: !0
                      },
                      label: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !1
                      }
                    }
                  },
                  required: !1
                }
              }
            }
          },
          required: !0,
          description: ""
        }
      }
    };
    n(81);

    var xb = function (e) {
      db()(n, e);

      var t = function (e) {
        function t() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }

        return function () {
          var n,
              r = vb()(e);

          if (t()) {
            var a = vb()(this).constructor;
            n = Reflect.construct(r, arguments, a);
          } else n = r.apply(this, arguments);

          return mb()(this, n);
        };
      }(n);

      function n() {
        var e;
        lb()(this, n);

        for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++) {
          a[i] = arguments[i];
        }

        return e = t.call.apply(t, [this].concat(a)), o()(pb()(e), "state", {
          crosshairValues: []
        }), o()(pb()(e), "onMouseLeave", function () {
          e.setState({
            crosshairValues: []
          });
        }), o()(pb()(e), "onNearestX", function (t, n) {
          var r = n.index,
              a = e.props.data;
          e.setState({
            crosshairValues: a.map(function (e) {
              return e.data[r];
            })
          });
        }), o()(pb()(e), "formatCrosshairTitle", function (e) {
          return {
            title: "X",
            value: e[0].x
          };
        }), o()(pb()(e), "formatCrosshairItems", function (t) {
          var n = e.props,
              r = n.data,
              a = n.displayDecimalPlaces;
          return t.map(function (e, t) {
            return {
              title: r[t].title,
              value: $v(e.y, a)
            };
          });
        }), e;
      }

      return cb()(n, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.children,
              r = t.data,
              a = t.colorPalette,
              o = t.className,
              i = t.animation,
              u = t.smooth,
              l = t.tooltips,
              p = t.height,
              h = t.width,
              d = s()(t, ["children", "data", "colorPalette", "className", "animation", "smooth", "tooltips", "height", "width"]),
              m = this.props.yMinMax,
              v = this.state.crosshairValues,
              b = y()("wds-chart--line", o);
          m = m || eb(r, !1, "line");

          var _ = bb(n),
              x = r.map(function (t, n) {
            if (t) return f.a.createElement(vh, Object.assign({
              key: g()(),
              data: t.data,
              color: Uv(a, n),
              yBaseValue: 0,
              curve: u ? "curveMonotoneX" : null,
              markStyle: u ? {
                fill: "transparent",
                stroke: "transparent"
              } : null,
              onNearestX: e.onNearestX,
              size: 4
            }, d));
          }),
              O = l && v.length > 0 && f.a.createElement(Lc, {
            values: v,
            itemsFormat: this.formatCrosshairItems,
            titleFormat: this.formatCrosshairTitle,
            className: "wds-chart__crosshair"
          }, "function" == typeof l && f.a.createElement("div", {
            className: "rv-hint__content"
          }, l(v)));

          return f.a.createElement(c.Fragment, null, f.a.createElement("div", {
            style: {
              height: p,
              width: h
            }
          }, f.a.createElement(yv, Object.assign({
            data: r,
            xType: "ordinal",
            className: b,
            animation: i,
            yDomain: m,
            onMouseLeave: this.onMouseLeave,
            chartType: "line"
          }, d), O, x, _)));
        }
      }]), n;
    }(c.Component);

    xb.displayName = "Line", xb.propTypes = {
      children: h.a.node,
      data: h.a.arrayOf(h.a.shape({
        title: h.a.node,
        data: h.a.arrayOf(h.a.shape({
          x: h.a.oneOfType([h.a.string, h.a.number]).isRequired,
          y: h.a.number.isRequired,
          label: h.a.oneOfType([h.a.string, h.a.number])
        }))
      })).isRequired,
      colorPalette: h.a.node,
      className: h.a.string,
      animation: h.a.bool,
      yMinMax: h.a.arrayOf(h.a.number),
      smooth: h.a.bool,
      tooltips: h.a.oneOfType([h.a.bool, h.a.func]),
      height: h.a.string,
      width: h.a.string,
      displayDecimalPlaces: h.a.number
    }, xb.defaultProps = {
      children: null,
      colorPalette: Iv,
      className: "",
      animation: !1,
      yMinMax: null,
      smooth: !1,
      tooltips: null,
      height: "320px",
      width: "100%",
      displayDecimalPlaces: 2
    }, xb.__docgenInfo = {
      description: "",
      methods: [{
        name: "onMouseLeave",
        docblock: null,
        modifiers: [],
        params: [],
        returns: null
      }, {
        name: "onNearestX",
        docblock: null,
        modifiers: [],
        params: [{
          name: "value",
          type: null
        }, {
          name: "{ index }",
          type: null
        }],
        returns: null
      }, {
        name: "formatCrosshairTitle",
        docblock: null,
        modifiers: [],
        params: [{
          name: "values",
          type: null
        }],
        returns: null
      }, {
        name: "formatCrosshairItems",
        docblock: null,
        modifiers: [],
        params: [{
          name: "values",
          type: null
        }],
        returns: null
      }],
      displayName: "Line",
      props: {
        children: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        colorPalette: {
          defaultValue: {
            value: "dataVisColors",
            computed: !0
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        className: {
          defaultValue: {
            value: "''",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        animation: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        yMinMax: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "arrayOf",
            value: {
              name: "number"
            }
          },
          required: !1,
          description: ""
        },
        smooth: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        tooltips: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "union",
            value: [{
              name: "bool"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: ""
        },
        height: {
          defaultValue: {
            value: "'320px'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        width: {
          defaultValue: {
            value: "'100%'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        displayDecimalPlaces: {
          defaultValue: {
            value: "2",
            computed: !1
          },
          type: {
            name: "number"
          },
          required: !1,
          description: ""
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "node",
                  required: !1
                },
                data: {
                  name: "arrayOf",
                  value: {
                    name: "shape",
                    value: {
                      x: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !0
                      },
                      y: {
                        name: "number",
                        required: !0
                      },
                      label: {
                        name: "union",
                        value: [{
                          name: "string"
                        }, {
                          name: "number"
                        }],
                        required: !1
                      }
                    }
                  },
                  required: !1
                }
              }
            }
          },
          required: !0,
          description: ""
        }
      }
    };
    n(82);

    var Ob = function (e) {
      db()(n, e);

      var t = function (e) {
        function t() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }

        return function () {
          var n,
              r = vb()(e);

          if (t()) {
            var a = vb()(this).constructor;
            n = Reflect.construct(r, arguments, a);
          } else n = r.apply(this, arguments);

          return mb()(this, n);
        };
      }(n);

      function n() {
        var e;
        lb()(this, n);

        for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++) {
          a[i] = arguments[i];
        }

        return e = t.call.apply(t, [this].concat(a)), o()(pb()(e), "state", {
          value: !1
        }), o()(pb()(e), "onMouseLeave", function () {
          e.setState({
            value: !1
          });
        }), o()(pb()(e), "onMouseOver", function (t) {
          e.setState({
            value: t
          });
        }), o()(pb()(e), "contrastTextChecker", function () {
          var e = document.getElementsByClassName("rv-xy-plot__series--label-text"),
              t = document.getElementsByClassName("rv-radial-chart__series--pie__slice"),
              n = Array.from(t).map(function (e) {
            return e.className.baseVal;
          });
          Array.from(e).forEach(function (e, t) {
            n[t].indexOf("text-color-dark") > 0 && (e.style.fill = "#333E48");
          });
        }), e;
      }

      return cb()(n, [{
        key: "componentDidMount",
        value: function value() {
          "undefined" != typeof window && window.addEventListener("load", this.contrastTextChecker);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          "undefined" != typeof window && window.removeEventListener("load", this.contrastTextChecker);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.children,
              r = t.data,
              a = t.className,
              o = t.colorPalette,
              i = t.donut,
              u = t.tooltips,
              l = t.height,
              s = t.width,
              p = this.state.value,
              h = y()({
            "wds-chart__pie": !i
          }, {
            "wds-chart__pie--interactive": u
          }, {
            "wds-chart__donut": i
          }, a),
              d = r.map(function (e, t) {
            var n = Uv(o, t),
                r = tb(n);
            return e.color = n, e.className = "text-color-".concat(r), e;
          }),
              m = u && p && f.a.createElement(Wf, {
            value: p
          }, f.a.createElement("div", {
            className: "rv-hint__content"
          }, "function" == typeof u ? u(p) : f.a.createElement(c.Fragment, null, f.a.createElement("p", {
            className: "wds-m-y--0"
          }, f.a.createElement("strong", null, p.title)), f.a.createElement("p", {
            className: "wds-m-y--0"
          }, p.label))));
          return f.a.createElement(c.Fragment, null, f.a.createElement("div", {
            style: {
              height: l,
              width: s
            }
          }, f.a.createElement(x.a, null, function (t) {
            var n = t.height,
                r = t.width,
                a = i ? Math.min(n, r) / 4 : null,
                o = i ? Math.min(n, r) / 2 - 8 : null;
            return f.a.createElement(Tm, {
              data: d,
              height: n,
              width: r,
              className: h,
              labelsRadiusMultiplier: .9,
              labelsStyle: {
                fill: Bv
              },
              showLabels: !0,
              innerRadius: a,
              radius: o,
              colorType: "literal",
              onValueMouseOver: e.onMouseOver,
              onSeriesMouseOut: e.onMouseLeave
            }, m);
          })), n);
        }
      }]), n;
    }(c.Component);

    Ob.displayName = "Pie", Ob.propTypes = {
      children: h.a.node,
      height: h.a.node,
      data: h.a.arrayOf(h.a.shape({
        title: h.a.node,
        angle: h.a.number.isRequired,
        label: h.a.string
      })).isRequired,
      colorPalette: h.a.arrayOf(h.a.string),
      className: h.a.string,
      donut: h.a.bool,
      tooltips: h.a.oneOfType([h.a.bool, h.a.func]),
      width: h.a.string
    }, Ob.defaultProps = {
      children: null,
      height: "320px",
      colorPalette: Iv,
      className: "",
      donut: !1,
      tooltips: null,
      width: "100%"
    }, Ob.__docgenInfo = {
      description: "",
      methods: [{
        name: "onMouseLeave",
        docblock: null,
        modifiers: [],
        params: [],
        returns: null
      }, {
        name: "onMouseOver",
        docblock: null,
        modifiers: [],
        params: [{
          name: "v",
          type: null
        }],
        returns: null
      }, {
        name: "contrastTextChecker",
        docblock: "Checks the rendered object and forces a label color for a11y",
        modifiers: [],
        params: [],
        returns: null,
        description: "Checks the rendered object and forces a label color for a11y"
      }],
      displayName: "Pie",
      props: {
        children: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        height: {
          defaultValue: {
            value: "'320px'",
            computed: !1
          },
          type: {
            name: "node"
          },
          required: !1,
          description: ""
        },
        colorPalette: {
          defaultValue: {
            value: "dataVisColors",
            computed: !0
          },
          type: {
            name: "arrayOf",
            value: {
              name: "string"
            }
          },
          required: !1,
          description: ""
        },
        className: {
          defaultValue: {
            value: "''",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        donut: {
          defaultValue: {
            value: "false",
            computed: !1
          },
          type: {
            name: "bool"
          },
          required: !1,
          description: ""
        },
        tooltips: {
          defaultValue: {
            value: "null",
            computed: !1
          },
          type: {
            name: "union",
            value: [{
              name: "bool"
            }, {
              name: "func"
            }]
          },
          required: !1,
          description: ""
        },
        width: {
          defaultValue: {
            value: "'100%'",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        data: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "node",
                  required: !1
                },
                angle: {
                  name: "number",
                  required: !0
                },
                label: {
                  name: "string",
                  required: !1
                }
              }
            }
          },
          required: !0,
          description: ""
        }
      }
    };

    var wb = function wb(e, t, n, r) {
      var a = function (e) {
        return (e - 90) * (Math.PI / 180);
      }(r);

      return {
        x: e + n * Math.cos(a),
        y: t + n * Math.sin(a)
      };
    },
        Tb = function Tb(e, t, n, r, a) {
      var o = wb(e, t, n, a),
          i = wb(e, t, n, r),
          u = "0";
      return u = a >= r ? a - r <= 180 ? "0" : "1" : a + 360 - r <= 180 ? "0" : "1", "M".concat(o.x, " ").concat(o.y, " A").concat(n, " ").concat(n, " 0 ").concat(u, " 0 ").concat(i.x, " ").concat(i.y);
    },
        kb = function kb(e) {
      var t,
          n = e.score,
          r = void 0 === n ? "" : n;
      return f.a.createElement("svg", {
        className: "wds-nps-chart--gauge",
        style: {
          overflow: "visible"
        },
        height: "10",
        viewBox: "0 0 40 40",
        x: "0",
        y: "0"
      }, f.a.createElement("g", {
        transform: "rotate(".concat((t = parseFloat(r), Math.round(1.35 * t)), " 30 600) translate(0,0)")
      }, f.a.createElement("polygon", {
        points: "50 15, 100 100, 0 100",
        transform: "translate(-25,120)",
        className: "wds-nps-chart--triangle",
        fill: "#fff"
      }), f.a.createElement("circle", {
        cx: "25",
        cy: "610",
        r: "400",
        fill: "#fff"
      })));
    };

    kb.displayName = "Gauge", kb.propTypes = {
      score: h.a.string.isRequired
    }, kb.__docgenInfo = {
      description: "@param score\n@returns {*}",
      methods: [],
      displayName: "Gauge",
      props: {
        score: {
          defaultValue: {
            value: "''",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        }
      }
    };
    var Mb = kb,
        Eb = (n(83), function (e) {
      var t = e.score,
          n = void 0 === t ? "" : t,
          r = e.color,
          a = void 0 === r ? "" : r,
          o = [-100, -50, 50, 100];
      return f.a.createElement("div", {
        className: "wds-nps-chart"
      }, f.a.createElement("svg", {
        className: "wds-nps-chart--svg",
        height: "250px"
      }, f.a.createElement("defs", null, f.a.createElement("linearGradient", {
        x1: "0%",
        y1: "0%",
        x2: "0%",
        y2: "100%",
        id: "gradient-left-bottom"
      }, f.a.createElement("stop", {
        offset: "0%",
        style: {
          stopColor: "#FF8B4F",
          stopOpacity: 1
        }
      }), f.a.createElement("stop", {
        offset: "100%",
        style: {
          stopColor: "#DB4D5C",
          stopOpacity: 1
        }
      })), f.a.createElement("linearGradient", {
        x1: "0%",
        y1: "0%",
        x2: "0%",
        y2: "100%",
        id: "gradient-left-top"
      }, f.a.createElement("stop", {
        offset: "0%",
        style: {
          stopColor: "#F9BE00",
          stopOpacity: 1
        }
      }), f.a.createElement("stop", {
        offset: "80%",
        style: {
          stopColor: "#FF8B4F",
          stopOpacity: 1
        }
      })), f.a.createElement("linearGradient", {
        x1: "0%",
        y1: "0%",
        x2: "0%",
        y2: "100%",
        id: "gradient-right-top"
      }, f.a.createElement("stop", {
        offset: "50%",
        style: {
          stopColor: "#F9BE00",
          stopOpacity: 1
        }
      }), f.a.createElement("stop", {
        offset: "100%",
        style: {
          stopColor: "#00BF6F",
          stopOpacity: 1
        }
      })), f.a.createElement("linearGradient", {
        x1: "0%",
        y1: "0%",
        x2: "0%",
        y2: "100%",
        id: "gradient-right-bottom"
      }, f.a.createElement("stop", {
        offset: "90%",
        style: {
          stopColor: "#00BF6F",
          stopOpacity: 1
        }
      }), f.a.createElement("stop", {
        offset: "100%",
        style: {
          stopColor: "#6BC8CD",
          stopOpacity: 1
        }
      }))), f.a.createElement("g", null, f.a.createElement("text", {
        className: "wds-type--card-title wds-nps-chart--scale",
        x: "10",
        y: "250"
      }, o[0]), f.a.createElement("path", {
        fill: "none",
        stroke: "gradient" === a ? "url(#gradient-left-bottom)" : a,
        strokeWidth: "20",
        d: Tb(150, 150, 110, 223, 291)
      }), f.a.createElement("text", {
        className: "wds-type--card-title wds-nps-chart--scale",
        x: "0",
        y: "105"
      }, o[1]), f.a.createElement("path", {
        fill: "none",
        stroke: "gradient" === a ? "url(#gradient-left-top)" : a,
        strokeWidth: "20",
        d: Tb(150, 150, 110, 293, 359)
      }), f.a.createElement("text", {
        className: "wds-type--card-title wds-nps-chart--scale",
        x: "145",
        y: "18"
      }, "0"), f.a.createElement("path", {
        fill: "none",
        stroke: "gradient" === a ? "url(#gradient-right-top)" : a,
        strokeWidth: "20",
        d: Tb(150, 150, 110, 1, 67)
      }), f.a.createElement("text", {
        className: "wds-type--card-title wds-nps-chart--scale",
        x: "270",
        y: "105"
      }, o[2]), f.a.createElement("path", {
        fill: "none",
        stroke: "gradient" === a ? "url(#gradient-right-bottom)" : a,
        strokeWidth: "20",
        d: Tb(150, 150, 110, 69, 135)
      }), f.a.createElement("text", {
        className: "wds-type--card-title wds-nps-chart--scale",
        x: "250",
        y: "250"
      }, o[3])), f.a.createElement(Mb, {
        score: n
      }), f.a.createElement("g", null, f.a.createElement("text", {
        x: "150",
        y: "125",
        className: "wds-type--hero-1",
        textAnchor: "middle",
        alignmentBaseline: "central",
        dominantBaseline: "middle"
      }, n), f.a.createElement("text", {
        x: "150",
        y: "175",
        className: "wds-type--section-title",
        textAnchor: "middle",
        alignmentBaseline: "central",
        dominantBaseline: "middle"
      }, "NPS"))));
    });
    Eb.displayName = "NPS", Eb.propTypes = {
      score: h.a.string.isRequired,
      color: h.a.string.isRequired
    }, Eb.__docgenInfo = {
      description: "NPS Chart\n\n@param {String} score\n@param {String} color\n@param {Array} ticks\n@returns {*}",
      methods: [],
      displayName: "NPS",
      props: {
        score: {
          defaultValue: {
            value: "''",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        color: {
          defaultValue: {
            value: "''",
            computed: !1
          },
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        }
      }
    };
    var Pb = Eb;
  }]);
});